import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"notifyOnNetworkStatusChange":true} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  NotificationTypeInput: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddPhoneToMessagingServiceInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type AddPhoneToMessagingServiceResponse = {
  __typename?: 'AddPhoneToMessagingServiceResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  _id: Scalars['MongoID']['output'];
  address_1: Scalars['String']['output'];
  address_2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  type: EnumAddressType;
};

export type AddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

export type AddressInputForProfile = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInputForUser = {
  city?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type AddressPagination = {
  __typename?: 'AddressPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Address>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AnimalConfigurationInput = {
  averageHangingWeight: Scalars['Float']['input'];
  expectedThroughput: Scalars['Float']['input'];
  maxCapacity: Scalars['Float']['input'];
  processingCost: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  species: Scalars['String']['input'];
};

export type AnimalHeadInput = {
  cutsheetInformation?: InputMaybe<Array<InputMaybe<CutsheetInformationInput>>>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type AnimalHeadUpdatesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
};

export type AuditLogActorResult = {
  __typename?: 'AuditLogActorResult';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type AuditLogChangeResult = {
  __typename?: 'AuditLogChangeResult';
  from?: Maybe<Scalars['JSON']['output']>;
  path: Scalars['String']['output'];
  to?: Maybe<Scalars['JSON']['output']>;
};

export type AuditLogResult = {
  __typename?: 'AuditLogResult';
  _id: Scalars['MongoID']['output'];
  actor?: Maybe<AuditLogActorResult>;
  actorId?: Maybe<Scalars['MongoID']['output']>;
  changes?: Maybe<Array<Maybe<AuditLogChangeResult>>>;
  createdAt: Scalars['Date']['output'];
  documentId: Scalars['MongoID']['output'];
  documentType: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AuditLogsResponse = {
  __typename?: 'AuditLogsResponse';
  logs?: Maybe<Array<Maybe<AuditLogResult>>>;
  total: Scalars['Int']['output'];
};

export type AuthCheckUserPayload = {
  __typename?: 'AuthCheckUserPayload';
  authMethod?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  otpSent?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  requiresPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  resetCodeSent?: Maybe<Scalars['Boolean']['output']>;
  resetDestination?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
};

export type AuthConfirmForgotPasswordPayload = {
  __typename?: 'AuthConfirmForgotPasswordPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthForgotPasswordPayload = {
  __typename?: 'AuthForgotPasswordPayload';
  destination?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AuthLoginOAuthPayload = {
  __typename?: 'AuthLoginOAuthPayload';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthLoginPasswordPayload = {
  __typename?: 'AuthLoginPasswordPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  requiresNewPassword?: Maybe<Scalars['Boolean']['output']>;
  session?: Maybe<Scalars['String']['output']>;
};

export type AuthRefreshTokenPayload = {
  __typename?: 'AuthRefreshTokenPayload';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
};

export type AuthSendOtpPayload = {
  __typename?: 'AuthSendOTPPayload';
  message: Scalars['String']['output'];
  session?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuthSetPasswordPayload = {
  __typename?: 'AuthSetPasswordPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type AuthVerifyOtpPayload = {
  __typename?: 'AuthVerifyOTPPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  requiresProfileCompletion?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableColumn = {
  __typename?: 'AvailableColumn';
  aliases: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  validationRules?: Maybe<Scalars['String']['output']>;
};

export type AvailablePhoneNumber = {
  __typename?: 'AvailablePhoneNumber';
  capabilities?: Maybe<AvailablePhoneNumberCapabilities>;
  friendlyName: Scalars['String']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type AvailablePhoneNumberCapabilities = {
  __typename?: 'AvailablePhoneNumberCapabilities';
  mms: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
  voice: Scalars['Boolean']['output'];
};

export type BlockedByInput = {
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

export type CsvImportCancelJobPayload = {
  __typename?: 'CSVImportCancelJobPayload';
  cancelledAt: Scalars['Date']['output'];
  cancelledAtStage: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CsvImportDeleteRecordPayload = {
  __typename?: 'CSVImportDeleteRecordPayload';
  deletedRows: Array<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
};

export type CsvImportExecutePayload = {
  __typename?: 'CSVImportExecutePayload';
  jobId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CsvImportFailure = {
  __typename?: 'CSVImportFailure';
  error: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type CsvImportForceCancelPayload = {
  __typename?: 'CSVImportForceCancelPayload';
  cancelledAt: Scalars['Date']['output'];
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type CsvImportJob = {
  __typename?: 'CSVImportJob';
  _id: Scalars['MongoID']['output'];
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  cancelledAtStage?: Maybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedRows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  failureCount: Scalars['Float']['output'];
  failures?: Maybe<Array<Maybe<CsvImportJobFailures>>>;
  failuresFilePath?: Maybe<Scalars['String']['output']>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  parsedData?: Maybe<Scalars['JSON']['output']>;
  processedCount: Scalars['Float']['output'];
  rawFilePath?: Maybe<Scalars['String']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['output'];
  tenantId: Scalars['MongoID']['output'];
  totalRows: Scalars['Float']['output'];
  type: EnumCsvImportJobType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  uploadedBy: Scalars['MongoID']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Float']['output'];
  validationErrors?: Maybe<Array<Maybe<CsvImportJobValidationErrors>>>;
  vendorId: Scalars['MongoID']['output'];
};

export type CsvImportJobFailures = {
  __typename?: 'CSVImportJobFailures';
  data: Scalars['JSON']['output'];
  error: Scalars['String']['output'];
  row: Scalars['Float']['output'];
};

export type CsvImportJobFailuresInput = {
  data: Scalars['JSON']['input'];
  error: Scalars['String']['input'];
  row: Scalars['Float']['input'];
};

export type CsvImportJobItem = {
  __typename?: 'CSVImportJobItem';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  failureCount?: Maybe<Scalars['Int']['output']>;
  invalidRows?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  processedCount?: Maybe<Scalars['Int']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  validRows?: Maybe<Scalars['Int']['output']>;
};

/** List of items with pagination. */
export type CsvImportJobPagination = {
  __typename?: 'CSVImportJobPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CsvImportJob>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CsvImportJobStatus = {
  __typename?: 'CSVImportJobStatus';
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedRows: Array<Scalars['Int']['output']>;
  failureCount: Scalars['Int']['output'];
  failures: Array<CsvImportFailure>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportJobValidationErrors = {
  __typename?: 'CSVImportJobValidationErrors';
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  row: Scalars['Float']['output'];
  warningMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row: Scalars['Float']['input'];
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CsvImportJobsPayload = {
  __typename?: 'CSVImportJobsPayload';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<CsvImportJobItem>;
  total: Scalars['Int']['output'];
};

export type CsvImportRevalidatePayload = {
  __typename?: 'CSVImportRevalidatePayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportSaveColumnMappingPayload = {
  __typename?: 'CSVImportSaveColumnMappingPayload';
  columns: Array<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  parsedData?: Maybe<Scalars['JSON']['output']>;
  s3Keys?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportUpdateRowsPayload = {
  __typename?: 'CSVImportUpdateRowsPayload';
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvImportUploadPayload = {
  __typename?: 'CSVImportUploadPayload';
  availableColumns: Array<AvailableColumn>;
  detectedColumns: Array<Scalars['String']['output']>;
  invalidFilePath?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  suggestedMapping?: Maybe<Scalars['JSON']['output']>;
  totalRows: Scalars['Int']['output'];
  validFilePath?: Maybe<Scalars['String']['output']>;
  validRows: Scalars['Int']['output'];
  validationErrors: Array<CsvValidationError>;
};

export type CsvValidationError = {
  __typename?: 'CSVValidationError';
  errorMessages: Array<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  warningMessages?: Maybe<Array<Scalars['String']['output']>>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

/** List of items with pagination. */
export type CancellationReasonPagination = {
  __typename?: 'CancellationReasonPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CancellationReason>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CapacityCalculationAllSpeciesResult = {
  __typename?: 'CapacityCalculationAllSpeciesResult';
  bySpecies: Scalars['JSON']['output'];
  hasAvailableSpots: Scalars['Boolean']['output'];
  spotGroups: Scalars['JSON']['output'];
  totalSpots: Scalars['Int']['output'];
};

export type CapacityCalculationResult = {
  __typename?: 'CapacityCalculationResult';
  hasAvailableSpots: Scalars['Boolean']['output'];
  spotGroups: Scalars['JSON']['output'];
  totalSpots: Scalars['Int']['output'];
};

export type CarcassTagsDocumentSettingsInput = {
  title: EnumProcessorSettingsDocumentSettingsCarcassTagTitle;
};

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  _id: Scalars['MongoID']['output'];
  chatRoom?: Maybe<ChatRoom>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isNotification?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<User>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ChatMessagePagination = {
  __typename?: 'ChatMessagePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  lastMessage?: Maybe<ChatMessage>;
  messages: Array<ChatMessage>;
  participants: Array<User>;
  twilioConversationSid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};


export type ChatRoomMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatRoomParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};

/** List of items with pagination. */
export type ChatRoomPagination = {
  __typename?: 'ChatRoomPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatRoom>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  clientSecret: Scalars['String']['output'];
};

export enum ComparisonType {
  /** Compare to the same period in the previous cycle */
  PreviousPeriod = 'PREVIOUS_PERIOD',
  /** Compare to the same period in the previous year */
  PreviousYear = 'PREVIOUS_YEAR'
}

export type ComplexAnimalCapacity = SpeciesComplexAnimalCapacitySchema | SpeciesInspectionComplexAnimalCapacitySchema | WeightedAnimalComplexAnimalCapacitySchema;

export type CreateForSchedulingJobLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
};

export type CreateForSchedulingJobSplitInput = {
  animalHeadId: Scalars['MongoID']['input'];
  splitIndex: Scalars['Int']['input'];
  splitKey: Scalars['String']['input'];
};

export type CreateInvoiceForSchedulingJobInput = {
  animalHeadIds: Array<Scalars['MongoID']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  isPayAtPickup: Scalars['Boolean']['input'];
  lineItems?: InputMaybe<Array<InputMaybe<CreateForSchedulingJobLineItemInput>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
  sendPaymentLink: Scalars['Boolean']['input'];
  splits?: InputMaybe<Array<InputMaybe<CreateForSchedulingJobSplitInput>>>;
  userId: Scalars['MongoID']['input'];
};

export type CreateManyAddressInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

export type CreateManyAddressPayload = {
  __typename?: 'CreateManyAddressPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Address>>;
};

export type CreateManyCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount: Scalars['Float']['input'];
  failures?: InputMaybe<Array<InputMaybe<CsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobId: Scalars['String']['input'];
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['input'];
  tenantId: Scalars['MongoID']['input'];
  totalRows: Scalars['Float']['input'];
  type: EnumCsvImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<CsvImportJobValidationErrorsInput>>>;
  vendorId: Scalars['MongoID']['input'];
};

export type CreateManyCsvImportJobPayload = {
  __typename?: 'CreateManyCSVImportJobPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CsvImportJob>>;
};

export type CreateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateManyCancellationReasonPayload = {
  __typename?: 'CreateManyCancellationReasonPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CancellationReason>>;
};

export type CreateManyChatMessageInput = {
  chatRoom: Scalars['MongoID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyChatMessagePayload = {
  __typename?: 'CreateManyChatMessagePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ChatMessage>>;
};

export type CreateManyChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyChatRoomPayload = {
  __typename?: 'CreateManyChatRoomPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ChatRoom>>;
};

export type CreateManyCutsheetAssignmentRuleSetInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetAssignmentRuleSetPayload = {
  __typename?: 'CreateManyCutsheetAssignmentRuleSetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetAssignmentRuleSet>>;
};

export type CreateManyCutsheetCapabilityGroupInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityGroupPayload = {
  __typename?: 'CreateManyCutsheetCapabilityGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilityGroup>>;
};

export type CreateManyCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name: Scalars['String']['input'];
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityOptionInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Float']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationsInput>>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilityOptionPayload = {
  __typename?: 'CreateManyCutsheetCapabilityOptionPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilityOption>>;
};

export type CreateManyCutsheetCapabilityPayload = {
  __typename?: 'CreateManyCutsheetCapabilityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapability>>;
};

export type CreateManyCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetCapabilitySpecificationPayload = {
  __typename?: 'CreateManyCutsheetCapabilitySpecificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetCapabilitySpecification>>;
};

export type CreateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyCutsheetPayload = {
  __typename?: 'CreateManyCutsheetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Cutsheet>>;
};

export type CreateManyCutsheetQuestionnaireInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetQuestionnairePayload = {
  __typename?: 'CreateManyCutsheetQuestionnairePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetQuestionnaire>>;
};

export type CreateManyCutsheetQuestionnaireResponseInput = {
  capabilitySet: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire: Scalars['MongoID']['input'];
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type: EnumCutsheetQuestionnaireResponseType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyCutsheetQuestionnaireResponsePayload = {
  __typename?: 'CreateManyCutsheetQuestionnaireResponsePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CutsheetQuestionnaireResponse>>;
};

export type CreateManyFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<FinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyFinancialReportingConfigPayload = {
  __typename?: 'CreateManyFinancialReportingConfigPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<FinancialReportingConfig>>;
};

export type CreateManyIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyIntegrationPayload = {
  __typename?: 'CreateManyIntegrationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Integration>>;
};

export type CreateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateManyInvoiceLineItemPayload = {
  __typename?: 'CreateManyInvoiceLineItemPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<InvoiceLineItem>>;
};

export type CreateManyInvoicePayload = {
  __typename?: 'CreateManyInvoicePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Invoice>>;
};

export type CreateManyNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<NoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyNotePayload = {
  __typename?: 'CreateManyNotePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Note>>;
};

export type CreateManyNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<NotificationErrorInput>;
  errorMessage?: InputMaybe<NotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyNotificationPayload = {
  __typename?: 'CreateManyNotificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Notification>>;
};

export type CreateManyNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyNotificationSettingPayload = {
  __typename?: 'CreateManyNotificationSettingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<NotificationSetting>>;
};

export type CreateManyPrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyPrimalCutBlockerPayload = {
  __typename?: 'CreateManyPrimalCutBlockerPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutBlocker>>;
};

export type CreateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutPayload = {
  __typename?: 'CreateManyPrimalCutPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCut>>;
};

export type CreateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutTypePayload = {
  __typename?: 'CreateManyPrimalCutTypePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutType>>;
};

export type CreateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalGroupPayload = {
  __typename?: 'CreateManyPrimalGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalGroup>>;
};

export type CreateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalPayload = {
  __typename?: 'CreateManyPrimalPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Primal>>;
};

export type CreateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyProcessorCapabilityPayload = {
  __typename?: 'CreateManyProcessorCapabilityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapability>>;
};

export type CreateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateManyProcessorCapabilitySpecificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapabilitySpecification>>;
};

export type CreateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorNotificationPayload = {
  __typename?: 'CreateManyProcessorNotificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorNotification>>;
};

export type CreateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorSchedulingPayload = {
  __typename?: 'CreateManyProcessorSchedulingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorScheduling>>;
};

export type CreateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateManyProcessorSettingsCustomCapacityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
};

export type CreateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit: Scalars['Float']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<ProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorSettingsPayload = {
  __typename?: 'CreateManyProcessorSettingsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettings>>;
};

export type CreateManyStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateManyStatePayload = {
  __typename?: 'CreateManyStatePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<State>>;
};

export type CreateManyTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyTenantPayload = {
  __typename?: 'CreateManyTenantPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tenant>>;
};

export type CreateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name: Scalars['String']['input'];
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant: Scalars['MongoID']['input'];
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyUserPayload = {
  __typename?: 'CreateManyUserPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<User>>;
};

export type CreateManyVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory: Scalars['Boolean']['input'];
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  twilioPhoneConfig?: InputMaybe<VendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManyVendorModuleInput = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: EnumVendorModuleModuleType;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyVendorModulePayload = {
  __typename?: 'CreateManyVendorModulePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<VendorModule>>;
};

export type CreateManyVendorPayload = {
  __typename?: 'CreateManyVendorPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Vendor>>;
};

export type CreateManyWaitlistInput = {
  animal: EnumWaitlistAnimal;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyWaitlistPayload = {
  __typename?: 'CreateManyWaitlistPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Waitlist>>;
};

export type CreateOneAddressInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

export type CreateOneAddressPayload = {
  __typename?: 'CreateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount: Scalars['Float']['input'];
  failures?: InputMaybe<Array<InputMaybe<CsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows: Scalars['Float']['input'];
  jobId: Scalars['String']['input'];
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount: Scalars['Float']['input'];
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumCsvImportJobStatus;
  successCount: Scalars['Float']['input'];
  tenantId: Scalars['MongoID']['input'];
  totalRows: Scalars['Float']['input'];
  type: EnumCsvImportJobType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy: Scalars['MongoID']['input'];
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows: Scalars['Float']['input'];
  validationErrors?: InputMaybe<Array<InputMaybe<CsvImportJobValidationErrorsInput>>>;
  vendorId: Scalars['MongoID']['input'];
};

export type CreateOneCsvImportJobPayload = {
  __typename?: 'CreateOneCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateOneCancellationReasonPayload = {
  __typename?: 'CreateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChatMessageInput = {
  chatRoom: Scalars['MongoID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneChatMessagePayload = {
  __typename?: 'CreateOneChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneChatRoomPayload = {
  __typename?: 'CreateOneChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetAssignmentRuleSetInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetAssignmentRuleSetPayload = {
  __typename?: 'CreateOneCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityGroupInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityGroupPayload = {
  __typename?: 'CreateOneCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name: Scalars['String']['input'];
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityOptionInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Float']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationsInput>>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilityOptionPayload = {
  __typename?: 'CreateOneCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilityPayload = {
  __typename?: 'CreateOneCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetCapabilitySpecificationPayload = {
  __typename?: 'CreateOneCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneCutsheetPayload = {
  __typename?: 'CreateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetQuestionnaireInput = {
  capabilityId: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<CutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetQuestionnairePayload = {
  __typename?: 'CreateOneCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetQuestionnaireResponseInput = {
  capabilitySet: Scalars['MongoID']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire: Scalars['MongoID']['input'];
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type: EnumCutsheetQuestionnaireResponseType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneCutsheetQuestionnaireResponsePayload = {
  __typename?: 'CreateOneCutsheetQuestionnaireResponsePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CutsheetQuestionnaireResponse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<FinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFinancialReportingConfigPayload = {
  __typename?: 'CreateOneFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneIntegrationPayload = {
  __typename?: 'CreateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateOneInvoiceLineItemPayload = {
  __typename?: 'CreateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoicePayload = {
  __typename?: 'CreateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<NoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneNotePayload = {
  __typename?: 'CreateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<NotificationErrorInput>;
  errorMessage?: InputMaybe<NotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneNotificationPayload = {
  __typename?: 'CreateOneNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneNotificationSettingPayload = {
  __typename?: 'CreateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOnePrimalCutBlockerPayload = {
  __typename?: 'CreateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutPayload = {
  __typename?: 'CreateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutTypePayload = {
  __typename?: 'CreateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalGroupPayload = {
  __typename?: 'CreateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalPayload = {
  __typename?: 'CreateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneProcessorCapabilityPayload = {
  __typename?: 'CreateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorNotificationPayload = {
  __typename?: 'CreateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorSchedulingPayload = {
  __typename?: 'CreateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit: Scalars['Float']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<ProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorSettingsPayload = {
  __typename?: 'CreateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOneStatePayload = {
  __typename?: 'CreateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTenantPayload = {
  __typename?: 'CreateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name: Scalars['String']['input'];
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant: Scalars['MongoID']['input'];
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneUserPayload = {
  __typename?: 'CreateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory: Scalars['Boolean']['input'];
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  twilioPhoneConfig?: InputMaybe<VendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneVendorModuleInput = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: EnumVendorModuleModuleType;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneVendorModulePayload = {
  __typename?: 'CreateOneVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneVendorPayload = {
  __typename?: 'CreateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWaitlistInput = {
  animal: EnumWaitlistAnimal;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneWaitlistPayload = {
  __typename?: 'CreateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateProcessorScheduleResponse = {
  __typename?: 'CreateProcessorScheduleResponse';
  checkoutSession?: Maybe<CheckoutSessionResponse>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scheduling: ProcessorScheduling;
};

export type CreateProcessorSchedulingInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  animalSpecies: Scalars['String']['input'];
  blockIndex?: InputMaybe<Scalars['Int']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  dropoffDate: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  headCount: Scalars['Int']['input'];
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  requesterContactInformation?: InputMaybe<RequesterContactInformationInput>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateProcessorSettingsCustomCapacityInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProcessorSettingsInvoicingInput = {
  defaultSplitRule?: InputMaybe<Scalars['String']['input']>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProcessorSettingsWithCustomCapacity = {
  __typename?: 'CreateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type CreateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<CreateProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit: Scalars['Float']['input'];
  timeTrackingConfig?: InputMaybe<TimeTrackingConfigInput>;
  vendor: Scalars['MongoID']['input'];
};

export type CustomerJobSummary = {
  __typename?: 'CustomerJobSummary';
  cancelledCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  firstJobDate?: Maybe<Scalars['Date']['output']>;
  inProgressCount: Scalars['Int']['output'];
  lastJobDate?: Maybe<Scalars['Date']['output']>;
  needsApprovalCount: Scalars['Int']['output'];
};

export type CustomerSummaryDetails = {
  __typename?: 'CustomerSummaryDetails';
  customerCount?: Maybe<Scalars['Int']['output']>;
  jobSummary: CustomerJobSummary;
  linkedProducer?: Maybe<User>;
};

export type Cutsheet = {
  __typename?: 'Cutsheet';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: Maybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  extras?: Maybe<Array<Maybe<CutsheetExtras>>>;
  groundMeatSize?: Maybe<Scalars['Float']['output']>;
  inspectionLevels?: Maybe<Array<Maybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Last date this cutsheet was used in a processor scheduling (for user cutsheets) */
  lastUsedDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['JSON']['output']>;
  parentCutsheet?: Maybe<Scalars['MongoID']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalCuts: Array<PrimalCut>;
  roastSize?: Maybe<Scalars['String']['output']>;
  selectedSpecifications?: Maybe<Scalars['JSON']['output']>;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  steakThickness?: Maybe<Scalars['Float']['output']>;
  steaksPerPack?: Maybe<Scalars['Float']['output']>;
  trim?: Maybe<Array<Maybe<CutsheetTrim>>>;
  type: EnumCutsheetType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
};


export type CutsheetPrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};

export type CutsheetAssignmentRuleInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId: Scalars['MongoID']['input'];
  sortOrder: Scalars['Int']['input'];
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CutsheetAssignmentRuleSet = {
  __typename?: 'CutsheetAssignmentRuleSet';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultQuestionnaireId?: Maybe<Scalars['MongoID']['output']>;
  rules?: Maybe<Array<Maybe<CutsheetAssignmentRuleSetRules>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetAssignmentRuleSetPagination = {
  __typename?: 'CutsheetAssignmentRuleSetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetAssignmentRuleSet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetAssignmentRuleSetRules = {
  __typename?: 'CutsheetAssignmentRuleSetRules';
  buyer?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  inspectionLevel?: Maybe<Array<Maybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: Maybe<Scalars['String']['output']>;
  producer?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  questionnaireId: Scalars['MongoID']['output'];
  sortOrder: Scalars['Float']['output'];
  splitIndex?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  splitType?: Maybe<Array<Maybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type CutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId: Scalars['MongoID']['input'];
  sortOrder: Scalars['Float']['input'];
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type CutsheetCapability = {
  __typename?: 'CutsheetCapability';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  legacyInspectionLevelMap?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMap>>>;
  name: Scalars['String']['output'];
  printSettings?: Maybe<CutsheetCapabilityPrintSettings>;
  species: EnumCutsheetCapabilitySpecies;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type CutsheetCapabilityDuplicateResponse = {
  __typename?: 'CutsheetCapabilityDuplicateResponse';
  capability?: Maybe<CutsheetCapability>;
  summary?: Maybe<CutsheetCapabilityDuplicateSummary>;
};

export type CutsheetCapabilityDuplicateSummary = {
  __typename?: 'CutsheetCapabilityDuplicateSummary';
  assignmentRulesCopied: Scalars['Int']['output'];
  groupsCopied: Scalars['Int']['output'];
  optionsCopied: Scalars['Int']['output'];
  questionnairesCopied: Scalars['Int']['output'];
  specificationsCopied: Scalars['Int']['output'];
};

export type CutsheetCapabilityGroup = {
  __typename?: 'CutsheetCapabilityGroup';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilityGroupPagination = {
  __typename?: 'CutsheetCapabilityGroupPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilityGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityLegacyInspectionLevelMap = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap';
  cutMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapCutMappings>>>;
  extraMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapExtraMappings>>>;
  inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel;
  questionnaireId: Scalars['MongoID']['output'];
  specMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapSpecMappings>>>;
  trimMappings?: Maybe<Array<Maybe<CutsheetCapabilityLegacyInspectionLevelMapTrimMappings>>>;
};

export type CutsheetCapabilityLegacyInspectionLevelMapCutMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings';
  newOptionId: Scalars['MongoID']['output'];
  oldCutId: Scalars['MongoID']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldCutId: Scalars['MongoID']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapExtraMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings';
  newOptionValue: Scalars['String']['output'];
  newSpecificationId: Scalars['MongoID']['output'];
  oldExtraName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue: Scalars['String']['input'];
  newSpecificationId: Scalars['MongoID']['input'];
  oldExtraName: Scalars['String']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel;
  questionnaireId: Scalars['MongoID']['input'];
  specMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<CutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type CutsheetCapabilityLegacyInspectionLevelMapSpecMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings';
  newSpecificationId: Scalars['MongoID']['output'];
  oldSpecName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId: Scalars['MongoID']['input'];
  oldSpecName: Scalars['String']['input'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapTrimMappings = {
  __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings';
  newOptionId: Scalars['MongoID']['output'];
  oldTrimName: Scalars['String']['output'];
};

export type CutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldTrimName: Scalars['String']['input'];
};

export type CutsheetCapabilityMigrateLegacyResponse = {
  __typename?: 'CutsheetCapabilityMigrateLegacyResponse';
  capability?: Maybe<CutsheetCapability>;
  summary?: Maybe<CutsheetCapabilityMigrateLegacySummary>;
};

export type CutsheetCapabilityMigrateLegacySummary = {
  __typename?: 'CutsheetCapabilityMigrateLegacySummary';
  assignmentRulesAdded: Scalars['Int']['output'];
  cutsCreated: Scalars['Int']['output'];
  cutsReused: Scalars['Int']['output'];
  groupsCreated: Scalars['Int']['output'];
  groupsReused: Scalars['Int']['output'];
  inspectionLevelsMigrated: Array<Scalars['String']['output']>;
  questionnairesCreated: Scalars['Int']['output'];
  questionnairesReused: Scalars['Int']['output'];
  specificationsCreated: Scalars['Int']['output'];
  specificationsReused: Scalars['Int']['output'];
  trimsCreated: Scalars['Int']['output'];
  trimsReused: Scalars['Int']['output'];
};

export type CutsheetCapabilityOption = {
  __typename?: 'CutsheetCapabilityOption';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['MongoID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  minQty?: Maybe<Scalars['Float']['output']>;
  optionType: EnumCutsheetCapabilityOptionOptionType;
  pricing?: Maybe<CutsheetCapabilityOptionPricing>;
  printedText?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Float']['output'];
  specifications?: Maybe<Array<Maybe<CutsheetCapabilityOptionSpecifications>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilityOptionPagination = {
  __typename?: 'CutsheetCapabilityOptionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilityOption>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityOptionPricing = {
  __typename?: 'CutsheetCapabilityOptionPricing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  model: EnumCutsheetCapabilityOptionPricingModel;
  price: Scalars['Float']['output'];
};

export type CutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: EnumCutsheetCapabilityOptionPricingModel;
  price: Scalars['Float']['input'];
};

export type CutsheetCapabilityOptionSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetCapabilityOptionSpecifications = {
  __typename?: 'CutsheetCapabilityOptionSpecifications';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: EnumCutsheetCapabilityOptionSpecificationsType;
  unit?: Maybe<Scalars['String']['output']>;
};

export type CutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: EnumCutsheetCapabilityOptionSpecificationsType;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type CutsheetCapabilityPagination = {
  __typename?: 'CutsheetCapabilityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapability>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetCapabilityPrintSettings = {
  __typename?: 'CutsheetCapabilityPrintSettings';
  alwaysShowPrimalNotes?: Maybe<Scalars['Boolean']['output']>;
  baseFontSize?: Maybe<Scalars['Float']['output']>;
  checkboxStyle?: Maybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hiddenSpecificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hideUnselectedCuts?: Maybe<Scalars['Boolean']['output']>;
  orientation?: Maybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: Maybe<Scalars['Float']['output']>;
  showPrimalGroup?: Maybe<Scalars['Boolean']['output']>;
  specsLayoutPosition?: Maybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type CutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type CutsheetCapabilitySpecification = {
  __typename?: 'CutsheetCapabilitySpecification';
  _id: Scalars['MongoID']['output'];
  assignedToIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inputType: EnumCutsheetCapabilitySpecificationInputType;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  pricingAdjustments?: Maybe<Scalars['JSON']['output']>;
  printedText?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetCapabilitySpecificationPagination = {
  __typename?: 'CutsheetCapabilitySpecificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetCapabilitySpecification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetChoiceOptionInput = {
  cutIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type CutsheetCutPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetCutSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetDocumentSettingsInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type CutsheetExtraPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetExtraSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetExtras = {
  __typename?: 'CutsheetExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetInformationInput = {
  contactInformation?: InputMaybe<RequesterContactInformationInput>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  splitPart: Scalars['String']['input'];
  type?: InputMaybe<EnumCutsheetType>;
};

export type CutsheetInformationPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  clearContactUser?: InputMaybe<Scalars['Boolean']['input']>;
  contactUser?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CutsheetLegacyCutMappingInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldCutId: Scalars['MongoID']['input'];
};

export type CutsheetLegacyExtraMappingInput = {
  newOptionValue: Scalars['String']['input'];
  newSpecificationId: Scalars['MongoID']['input'];
  oldExtraName: Scalars['String']['input'];
};

export type CutsheetLegacyInspectionLevelEntryInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyCutMappingInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyExtraMappingInput>>>;
  inspectionLevel: Scalars['String']['input'];
  questionnaireId: Scalars['MongoID']['input'];
  specMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacySpecMappingInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<CutsheetLegacyTrimMappingInput>>>;
};

export type CutsheetLegacySpecMappingInput = {
  newSpecificationId: Scalars['MongoID']['input'];
  oldSpecName: Scalars['String']['input'];
};

export type CutsheetLegacyTrimMappingInput = {
  newOptionId: Scalars['MongoID']['input'];
  oldTrimName: Scalars['String']['input'];
};

/** List of items with pagination. */
export type CutsheetPagination = {
  __typename?: 'CutsheetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Cutsheet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  yield?: InputMaybe<Array<InputMaybe<SplitYieldItemInput>>>;
};

export type CutsheetPricingOverrideEntryInput = {
  id: Scalars['String']['input'];
  pricing?: InputMaybe<CutsheetPricingOverrideInput>;
};

export type CutsheetPricingOverrideInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetQuestionInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<Scalars['String']['input']>>;
  availableExtraIds?: InputMaybe<Array<Scalars['String']['input']>>;
  availableTrimIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Int']['input']>;
  minSelections?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<InputMaybe<CutsheetChoiceOptionInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Int']['input'];
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CutsheetQuestionnaire = {
  __typename?: 'CutsheetQuestionnaire';
  _id: Scalars['MongoID']['output'];
  capabilityId: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultSelections?: Maybe<CutsheetQuestionnaireDefaultSelections>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pricingOverrides?: Maybe<Scalars['JSON']['output']>;
  printSettings?: Maybe<CutsheetCapabilityPrintSettings>;
  questions?: Maybe<Array<Maybe<CutsheetQuestionnaireQuestions>>>;
  specOptionPricingOverrides?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useCustomPrintSettings?: Maybe<Scalars['Boolean']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type CutsheetQuestionnaireDefaultSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelections';
  extraSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelections>;
  primalNotes?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotes>>>;
  selectedCuts?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCuts>>>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
  trimNotes?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotes>>>;
  trimSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelections>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections';
  extras?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras';
  optionId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type CutsheetQuestionnaireDefaultSelectionsPrimalNotes = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes';
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type CutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCuts = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts';
  optionId: Scalars['String']['output'];
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId: Scalars['String']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications';
  specification: Scalars['String']['output'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['output'];
};

export type CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelections = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections';
  trim?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim>>>;
  type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim = {
  __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim';
  optionId: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
};

export type CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

/** List of items with pagination. */
export type CutsheetQuestionnairePagination = {
  __typename?: 'CutsheetQuestionnairePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetQuestionnaire>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetQuestionnairePrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<Scalars['String']['input']>;
  hiddenGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenSpecificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetQuestionnaireQuestions = {
  __typename?: 'CutsheetQuestionnaireQuestions';
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  allowSubSelection?: Maybe<Scalars['Boolean']['output']>;
  availableCutIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableExtraIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableTrimIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  maxSelections?: Maybe<Scalars['Float']['output']>;
  minSelections?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Maybe<CutsheetQuestionnaireQuestionsOptions>>>;
  requireExactTotal?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Float']['output'];
  specificationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: EnumCutsheetQuestionnaireQuestionsType;
};

export type CutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<CutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: Scalars['Float']['input'];
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireQuestionsType;
};

export type CutsheetQuestionnaireQuestionsOptions = {
  __typename?: 'CutsheetQuestionnaireQuestionsOptions';
  cutIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type CutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type CutsheetQuestionnaireResponse = {
  __typename?: 'CutsheetQuestionnaireResponse';
  _id: Scalars['MongoID']['output'];
  capabilitySet: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  extraSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsExtraSelections>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  questionnaire: Scalars['MongoID']['output'];
  /** The name of the questionnaire this response was submitted to. */
  questionnaireName?: Maybe<Scalars['String']['output']>;
  selectedCuts?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCuts>>>;
  specifications?: Maybe<Array<Maybe<CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications>>>;
  trimSelections?: Maybe<CutsheetQuestionnaireDefaultSelectionsTrimSelections>;
  type: EnumCutsheetQuestionnaireResponseType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
  /** The response user's first and last name, if any. */
  userFullName?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type CutsheetQuestionnaireResponsePagination = {
  __typename?: 'CutsheetQuestionnaireResponsePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CutsheetQuestionnaireResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetResponseCutOptionInput = {
  optionId: Scalars['String']['input'];
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetResponseExtraResponseInput = {
  extras?: InputMaybe<Array<InputMaybe<CutsheetResponseExtraSelectionInput>>>;
};

export type CutsheetResponseExtraSelectionInput = {
  optionId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetResponseSpecificationSelectionInput = {
  specification: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CutsheetResponseTrimResponseInput = {
  trim?: InputMaybe<Array<InputMaybe<CutsheetResponseTrimSelectionInput>>>;
  type: Scalars['String']['input'];
};

export type CutsheetResponseTrimSelectionInput = {
  optionId: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
};

export type CutsheetSpecOptionPricingEntryInput = {
  options?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingOptionInput>>>;
  specId: Scalars['String']['input'];
};

export type CutsheetSpecOptionPricingOptionInput = {
  optionValue: Scalars['String']['input'];
  pricing?: InputMaybe<CutsheetPricingOverrideInput>;
};

export type CutsheetTrim = {
  __typename?: 'CutsheetTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAllTrim?: Maybe<Scalars['Boolean']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimPricingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type CutsheetTrimSpecificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetTrimTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type DailyCapacity = {
  __typename?: 'DailyCapacity';
  capacitiesByType?: Maybe<Array<Maybe<DailyCapacityCapacitiesByType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DailyCapacityCapacitiesByType = {
  __typename?: 'DailyCapacityCapacitiesByType';
  /** Some Description */
  capacities?: Maybe<Array<Maybe<ComplexAnimalCapacity>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum DateAnchorEnumUpsert {
  CompletedDate = 'completedDate',
  CutDate = 'cutDate',
  DropoffDate = 'dropoffDate',
  KillDate = 'killDate'
}

export type DeleteDuplicatePrimalsPayload = {
  __typename?: 'DeleteDuplicatePrimalsPayload';
  duplicatesDeleted: Scalars['Int']['output'];
  duplicatesFound: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type DocumentSettingsInput = {
  carcassTag?: InputMaybe<CarcassTagsDocumentSettingsInput>;
  cutsheet?: InputMaybe<CutsheetDocumentSettingsInput>;
};

export type EmailPreviewResult = {
  __typename?: 'EmailPreviewResult';
  html: Scalars['String']['output'];
};

export enum EnumAddressType {
  Commercial = 'commercial',
  Residential = 'residential',
  Unknown = 'unknown'
}

export enum EnumCsvImportJobCancelledAtStage {
  ColumnMapping = 'column_mapping',
  DataReview = 'data_review'
}

export enum EnumCsvImportJobStatus {
  AwaitingMapping = 'awaiting_mapping',
  AwaitingReview = 'awaiting_review',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export enum EnumCsvImportJobType {
  Customers = 'customers',
  Jobs = 'jobs'
}

export enum EnumCutsheetAnimalSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumCutsheetAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumCutsheetAssignmentRuleSetRulesInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetAssignmentRuleSetRulesSplitType {
  Half = 'half',
  HalfAndTwoQuarters = 'half_and_two_quarters',
  Quarters = 'quarters',
  Whole = 'whole'
}

export enum EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetCapabilityOptionOptionType {
  Cut = 'cut',
  Extra = 'extra',
  Trim = 'trim'
}

export enum EnumCutsheetCapabilityOptionPricingModel {
  FixedPrice = 'fixed_price',
  PerHangingWeight = 'per_hanging_weight',
  PerItem = 'per_item',
  PerPound = 'per_pound'
}

export enum EnumCutsheetCapabilityOptionSpecificationsType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetCapabilityPrintSettingsCheckboxStyle {
  Check = 'check',
  Cross = 'cross',
  Fill = 'fill'
}

export enum EnumCutsheetCapabilityPrintSettingsOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export enum EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum EnumCutsheetCapabilitySpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumCutsheetCapabilitySpecificationInputType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumCutsheetInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType {
  Multiselect = 'multiselect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType {
  Ranked = 'ranked',
  SelectionByPercentage = 'selection_by_percentage'
}

export enum EnumCutsheetQuestionnaireQuestionsType {
  ChoiceGroup = 'choice_group',
  ExtrasSelection = 'extras_selection',
  FreeSelection = 'free_selection',
  GlobalSpec = 'global_spec',
  InfoSlide = 'info_slide',
  TrimPercentage = 'trim_percentage',
  TrimRanking = 'trim_ranking'
}

export enum EnumCutsheetQuestionnaireResponseType {
  Orphan = 'orphan',
  User = 'user',
  Vendor = 'vendor'
}

export enum EnumCutsheetQuestionnaireStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published'
}

export enum EnumCutsheetTrimTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumCutsheetType {
  Orphan = 'orphan',
  User = 'user',
  Vendor = 'vendor'
}

export enum EnumDailyCapacityCapacitiesByTypeType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumFinancialReportingConfigAnimalConfigurationsSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumFinancialReportingConfigDateAnchor {
  CompletedDate = 'completedDate',
  CutDate = 'cutDate',
  DropoffDate = 'dropoffDate',
  KillDate = 'killDate'
}

export enum EnumFinancialReportingConfigOverheadCostsFrequency {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export enum EnumIntegrationName {
  QuickbooksOnline = 'quickbooks_online',
  Sendgrid = 'sendgrid',
  Stripe = 'stripe'
}

export enum EnumIntegrationType {
  Api = 'api'
}

export enum EnumInvoiceDiscountsType {
  Coupon = 'coupon',
  FixedAmount = 'fixed_amount',
  Percentage = 'percentage'
}

export enum EnumInvoiceLineItemLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead'
}

export enum EnumInvoiceLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorScheduling = 'ProcessorScheduling',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead',
  ProcessorSchedulingAnimalHeadSplit = 'ProcessorSchedulingAnimalHeadSplit'
}

export enum EnumInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesNew_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesPrevious_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceType {
  PartnersShipmentsMonthly = 'partners_shipments_monthly',
  ProcessingFees = 'processing_fees',
  ProcessorSchedulingDeposit = 'processor_scheduling_deposit',
  ProcessorSchedulingInvoice = 'processor_scheduling_invoice'
}

export enum EnumNoteType {
  ProcessorScheduling = 'processor_scheduling',
  User = 'user'
}

export enum EnumNotificationChannel {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationNotificationType {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationSettingTimingsRelation {
  After = 'after',
  At = 'at',
  Before = 'before'
}

export enum EnumNotificationStatusEmail {
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum EnumNotificationStatusSms {
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum EnumNotificationTemplateChannel {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationTemplateType {
  Custom = 'custom',
  System = 'system'
}

export enum EnumParentProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumParentProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumPrimalCutType {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalCutTypeAnimalSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalCutTypeLid {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalGroupAnimalSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalGroupInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilityAnimalSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorCapabilityExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumProcessorCapabilityInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit {
  Inches = 'inches',
  None = 'none',
  Pounds = 'pounds'
}

export enum EnumProcessorCapabilityTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumProcessorNotificationType {
  CutsheetConfirmation = 'cutsheetConfirmation',
  NewJob = 'newJob',
  QuickbooksReconnect = 'quickbooksReconnect',
  WaitlistJoin = 'waitlistJoin'
}

export enum EnumProcessorSchedulingAnimalHeadsInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSchedulingAnimalSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSchedulingAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSchedulingInvoicesPricingType {
  CustomCutsheet = 'customCutsheet',
  KillAndChill = 'killAndChill',
  Killslot = 'killslot'
}

export enum EnumProcessorSchedulingSource {
  BulkUpload = 'bulk_upload',
  Farmshare = 'farmshare',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumProcessorSchedulingStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSchedulingStatusChangesNewStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSchedulingStatusChangesPreviousStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  MissedDropOff = 'Missed_Drop_Off',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimalSettingsInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSettingsAnimalSettingsSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimals {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSettingsAutoSchedulingSettingsSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumProcessorSettingsDocumentSettingsCarcassTagTitle {
  EarTag = 'ear_tag',
  TrackingNumber = 'tracking_number'
}

export enum EnumProcessorSettingsDocumentSettingsCutsheetFormat {
  Bold = 'bold',
  Classic = 'classic'
}

export enum EnumProcessorSettingsInvoicingDefaultSplitRule {
  Single = 'single',
  Split = 'split'
}

export enum EnumProcessorSettingsKillAndChillSettingsSpecies {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumUserAuth_Method {
  GoogleSso = 'google_sso',
  Otp = 'otp',
  Password = 'password'
}

export enum EnumUserRelationshipsType {
  Buyer = 'buyer',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumUserRole {
  Admin = 'admin',
  Basic = 'basic',
  Vendor = 'vendor',
  VendorOwner = 'vendor_owner'
}

export enum EnumUserStatus {
  Complete = 'complete',
  MissingData = 'missing_data',
  PartiallyComplete = 'partially_complete'
}

export enum EnumUserType {
  Buyer = 'buyer',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumVendorModuleModuleType {
  CapabilitiesV1 = 'CAPABILITIES_V1',
  CapabilitiesV2 = 'CAPABILITIES_V2',
  Chat = 'CHAT',
  Exports = 'EXPORTS',
  Integrations = 'INTEGRATIONS',
  Invoices = 'INVOICES',
  Notifications = 'NOTIFICATIONS',
  Reporting = 'REPORTING'
}

export enum EnumVendorTwilioPhoneConfigPhoneNumberStatus {
  Active = 'active',
  CarrierProcessing = 'carrier_processing',
  Failed = 'failed',
  None = 'none',
  PendingLoa = 'pending_loa',
  PendingVerification = 'pending_verification',
  Provisioning = 'provisioning',
  Testing = 'testing'
}

export enum EnumVendorTwilioPhoneConfigPhoneNumberType {
  HostedLandline = 'hosted_landline',
  TwilioProvisioned = 'twilio_provisioned'
}

export enum EnumWaitlistAnimal {
  Alligator = 'alligator',
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Veal = 'veal',
  Venison = 'venison',
  Yak = 'yak'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type FilterCountAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterCountCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterCountCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterCountCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterCountCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterCountCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterCountCsvImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterCountCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterCountCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterCountCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterCountCsvImportJobVendorIdOperatorsInput>;
};

export type FilterCountCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterCountCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterCountCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterCountCancellationReasonIndexOperatorsInput>;
};

export type FilterCountCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountChatMessageInput = {
  AND?: InputMaybe<Array<FilterCountChatMessageInput>>;
  OR?: InputMaybe<Array<FilterCountChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterCountChatMessage_IdOperatorsInput>;
};

export type FilterCountChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountChatRoomInput = {
  AND?: InputMaybe<Array<FilterCountChatRoomInput>>;
  OR?: InputMaybe<Array<FilterCountChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterCountChatRoom_IdOperatorsInput>;
};

export type FilterCountChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterCountCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterCountCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterCountCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterCountCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<FilterCountCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterCountCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterCountCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterCountCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterCountCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterCountCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterCountCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterCountCutsheetInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheet_IdOperatorsInput>;
};

export type FilterCountCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterCountCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetQuestionnaireOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterCountCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterCountCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterCountCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterCountCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterCountCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<FilterCountCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterCountCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterCountCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterCountCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterCountCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterCountCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterCountCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterCountCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterCountCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterCountCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterCountDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterCountFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterCountFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterCountFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterCountFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterCountFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterCountFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterCountFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterCountFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterCountFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterCountFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountIntegrationInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterCountIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterCountIntegrationVendorOperatorsInput>;
};

export type FilterCountIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterCountInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterCountInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoiceLineItem_IdOperatorsInput>;
};

export type FilterCountInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterCountInvoiceStatusOperatorsInput>;
};

export type FilterCountInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterCountInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterCountInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountNoteInput = {
  AND?: InputMaybe<Array<FilterCountNoteInput>>;
  OR?: InputMaybe<Array<FilterCountNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterCountNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNoteOperatorsInput = {
  _id?: InputMaybe<FilterCountNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountNoteUpdatedAtOperatorsInput>;
};

export type FilterCountNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationErrorInput = {
  email?: InputMaybe<FilterCountNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterCountNotificationErrorMessageInput>;
};

export type FilterCountNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountNotificationInput = {
  AND?: InputMaybe<Array<FilterCountNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterCountNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterCountNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterCountNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterCountNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterCountNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterCountNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterCountNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterCountNotificationVendorIdOperatorsInput>;
};

export type FilterCountNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterCountNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterCountNotificationSetting_IdOperatorsInput>;
};

export type FilterCountNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterCountNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterCountNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterCountPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterCountPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterCountPrimalCutPrimalOperatorsInput>;
};

export type FilterCountPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterCountPrimalCutTypeNameOperatorsInput>;
};

export type FilterCountPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterCountPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterCountPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterCountPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalInput = {
  AND?: InputMaybe<Array<FilterCountPrimalInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimal_IdOperatorsInput>;
};

export type FilterCountPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterCountProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorCapabilityVendorOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorNotification_IdOperatorsInput>;
};

export type FilterCountProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterCountProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterCountProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterCountProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterCountProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterCountProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterCountProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterCountProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterCountProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterCountProcessorSchedulingStatusOperatorsInput>;
};

export type FilterCountProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterCountProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterCountProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterCountProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterCountProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterCountProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterCountProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterCountProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterCountProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterCountProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterCountProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorSettingsVendorOperatorsInput>;
};

export type FilterCountProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStateInput = {
  AND?: InputMaybe<Array<FilterCountStateInput>>;
  OR?: InputMaybe<Array<FilterCountStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStateOperatorsInput = {
  _id?: InputMaybe<FilterCountState_IdOperatorsInput>;
};

export type FilterCountState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountTenantInput = {
  AND?: InputMaybe<Array<FilterCountTenantInput>>;
  OR?: InputMaybe<Array<FilterCountTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTenantOperatorsInput = {
  _id?: InputMaybe<FilterCountTenant_IdOperatorsInput>;
};

export type FilterCountTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterCountUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserInput = {
  AND?: InputMaybe<Array<FilterCountUserInput>>;
  OR?: InputMaybe<Array<FilterCountUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterCountUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterCountUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserOperatorsInput = {
  _id?: InputMaybe<FilterCountUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterCountUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterCountUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterCountUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterCountUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterCountUserRelationshipsOperatorsInput>;
};

export type FilterCountUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterCountUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterCountUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountUserSettingsInput = {
  calendar?: InputMaybe<FilterCountUserSettingsCalendarInput>;
};

export type FilterCountUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountVendorInput = {
  AND?: InputMaybe<Array<FilterCountVendorInput>>;
  OR?: InputMaybe<Array<FilterCountVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVendorOperatorsInput>;
  address?: InputMaybe<FilterCountAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterCountVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountVendorModuleInput = {
  AND?: InputMaybe<Array<FilterCountVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterCountVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterCountVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountVendorModuleVendorOperatorsInput>;
};

export type FilterCountVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVendorOperatorsInput = {
  _id?: InputMaybe<FilterCountVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterCountVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterCountVendorTenantOperatorsInput>;
};

export type FilterCountVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterCountVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWaitlistInput = {
  AND?: InputMaybe<Array<FilterCountWaitlistInput>>;
  OR?: InputMaybe<Array<FilterCountWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterCountWaitlist_IdOperatorsInput>;
};

export type FilterCountWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindManyCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterFindManyCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterFindManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyCsvImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindManyCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindManyCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyCsvImportJobVendorIdOperatorsInput>;
};

export type FilterFindManyCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterFindManyCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindManyCancellationReasonIndexOperatorsInput>;
};

export type FilterFindManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChatMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyChatMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChatMessage_IdOperatorsInput>;
};

export type FilterFindManyChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChatRoomInput = {
  AND?: InputMaybe<Array<FilterFindManyChatRoomInput>>;
  OR?: InputMaybe<Array<FilterFindManyChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChatRoom_IdOperatorsInput>;
};

export type FilterFindManyChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterFindManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterFindManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<FilterFindManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindManyCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterFindManyCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterFindManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterFindManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterFindManyCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheet_IdOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindManyCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetQuestionnaireOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterFindManyCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindManyCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterFindManyCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterFindManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<FilterFindManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterFindManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterFindManyCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterFindManyFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterFindManyFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterFindManyFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterFindManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterFindManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterFindManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterFindManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterFindManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterFindManyIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyIntegrationVendorOperatorsInput>;
};

export type FilterFindManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceLineItem_IdOperatorsInput>;
};

export type FilterFindManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterFindManyInvoiceStatusOperatorsInput>;
};

export type FilterFindManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyNoteUpdatedAtOperatorsInput>;
};

export type FilterFindManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationErrorInput = {
  email?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
};

export type FilterFindManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterFindManyNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterFindManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterFindManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterFindManyNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindManyNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterFindManyNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterFindManyNotificationVendorIdOperatorsInput>;
};

export type FilterFindManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNotificationSetting_IdOperatorsInput>;
};

export type FilterFindManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterFindManyNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindManyPrimalCutPrimalOperatorsInput>;
};

export type FilterFindManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterFindManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindManyPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindManyPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterFindManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimal_IdOperatorsInput>;
};

export type FilterFindManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorCapabilityVendorOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorNotification_IdOperatorsInput>;
};

export type FilterFindManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterFindManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyProcessorSchedulingStatusOperatorsInput>;
};

export type FilterFindManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterFindManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterFindManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterFindManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterFindManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterFindManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStateInput = {
  AND?: InputMaybe<Array<FilterFindManyStateInput>>;
  OR?: InputMaybe<Array<FilterFindManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyState_IdOperatorsInput>;
};

export type FilterFindManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTenantInput = {
  AND?: InputMaybe<Array<FilterFindManyTenantInput>>;
  OR?: InputMaybe<Array<FilterFindManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTenant_IdOperatorsInput>;
};

export type FilterFindManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterFindManyUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterFindManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindManyUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterFindManyUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterFindManyUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindManyUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterFindManyUserRelationshipsOperatorsInput>;
};

export type FilterFindManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterFindManyUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterFindManyUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyUserSettingsInput = {
  calendar?: InputMaybe<FilterFindManyUserSettingsCalendarInput>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorDate_CreatedOperatorsInput = {
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lte?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyVendorInput = {
  AND?: InputMaybe<Array<FilterFindManyVendorInput>>;
  OR?: InputMaybe<Array<FilterFindManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVendorOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterFindManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyVendorModuleInput = {
  AND?: InputMaybe<Array<FilterFindManyVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyVendorModuleVendorOperatorsInput>;
};

export type FilterFindManyVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindManyVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterFindManyVendorTenantOperatorsInput>;
};

export type FilterFindManyVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterFindManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWaitlist_IdOperatorsInput>;
};

export type FilterFindManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindOneCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterFindOneCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterFindOneCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterFindOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneCsvImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterFindOneCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterFindOneCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneCsvImportJobVendorIdOperatorsInput>;
};

export type FilterFindOneCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterFindOneCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindOneCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindOneCancellationReasonIndexOperatorsInput>;
};

export type FilterFindOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneChatMessageInput = {
  AND?: InputMaybe<Array<FilterFindOneChatMessageInput>>;
  OR?: InputMaybe<Array<FilterFindOneChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindOneChatMessage_IdOperatorsInput>;
};

export type FilterFindOneChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneChatRoomInput = {
  AND?: InputMaybe<Array<FilterFindOneChatRoomInput>>;
  OR?: InputMaybe<Array<FilterFindOneChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterFindOneChatRoom_IdOperatorsInput>;
};

export type FilterFindOneChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterFindOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterFindOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<FilterFindOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindOneCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterFindOneCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterFindOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterFindOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterFindOneCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheet_IdOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterFindOneCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetQuestionnaireOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterFindOneCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterFindOneCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterFindOneCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterFindOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<FilterFindOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterFindOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterFindOneCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterFindOneFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterFindOneFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterFindOneFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterFindOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterFindOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterFindOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterFindOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterFindOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterFindOneIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneIntegrationVendorOperatorsInput>;
};

export type FilterFindOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoiceLineItem_IdOperatorsInput>;
};

export type FilterFindOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterFindOneInvoiceStatusOperatorsInput>;
};

export type FilterFindOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneNoteInput = {
  AND?: InputMaybe<Array<FilterFindOneNoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneNoteUpdatedAtOperatorsInput>;
};

export type FilterFindOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationErrorInput = {
  email?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
};

export type FilterFindOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterFindOneNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterFindOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterFindOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterFindOneNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterFindOneNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterFindOneNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterFindOneNotificationVendorIdOperatorsInput>;
};

export type FilterFindOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNotificationSetting_IdOperatorsInput>;
};

export type FilterFindOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterFindOneNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindOnePrimalCutPrimalOperatorsInput>;
};

export type FilterFindOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterFindOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindOnePrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindOnePrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterFindOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOnePrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimal_IdOperatorsInput>;
};

export type FilterFindOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorCapabilityVendorOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorNotification_IdOperatorsInput>;
};

export type FilterFindOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterFindOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneProcessorSchedulingStatusOperatorsInput>;
};

export type FilterFindOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterFindOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterFindOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterFindOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterFindOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterFindOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneStateInput = {
  AND?: InputMaybe<Array<FilterFindOneStateInput>>;
  OR?: InputMaybe<Array<FilterFindOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneStateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneState_IdOperatorsInput>;
};

export type FilterFindOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTenantInput = {
  AND?: InputMaybe<Array<FilterFindOneTenantInput>>;
  OR?: InputMaybe<Array<FilterFindOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTenant_IdOperatorsInput>;
};

export type FilterFindOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterFindOneUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterFindOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindOneUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterFindOneUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterFindOneUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindOneUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterFindOneUserRelationshipsOperatorsInput>;
};

export type FilterFindOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterFindOneUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterFindOneUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneUserSettingsInput = {
  calendar?: InputMaybe<FilterFindOneUserSettingsCalendarInput>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneVendorInput = {
  AND?: InputMaybe<Array<FilterFindOneVendorInput>>;
  OR?: InputMaybe<Array<FilterFindOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVendorOperatorsInput>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterFindOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneVendorModuleInput = {
  AND?: InputMaybe<Array<FilterFindOneVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterFindOneVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneVendorModuleVendorOperatorsInput>;
};

export type FilterFindOneVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindOneVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterFindOneVendorTenantOperatorsInput>;
};

export type FilterFindOneVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterFindOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindOneWaitlist_IdOperatorsInput>;
};

export type FilterFindOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateManyCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterUpdateManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyCsvImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateManyCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateManyCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyCsvImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateManyCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterUpdateManyCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateManyCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateManyCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyChatMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateManyChatMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyChatMessage_IdOperatorsInput>;
};

export type FilterUpdateManyChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyChatRoomInput = {
  AND?: InputMaybe<Array<FilterUpdateManyChatRoomInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyChatRoom_IdOperatorsInput>;
};

export type FilterUpdateManyChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterUpdateManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterUpdateManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheet_IdOperatorsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterUpdateManyCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterUpdateManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterUpdateManyCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterUpdateManyFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterUpdateManyFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterUpdateManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterUpdateManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterUpdateManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterUpdateManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateManyFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterUpdateManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterUpdateManyIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyIntegrationVendorOperatorsInput>;
};

export type FilterUpdateManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoiceLineItem_IdOperatorsInput>;
};

export type FilterUpdateManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyInvoiceStatusOperatorsInput>;
};

export type FilterUpdateManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterUpdateManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateManyNoteUpdatedAtOperatorsInput>;
};

export type FilterUpdateManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationErrorInput = {
  email?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
};

export type FilterUpdateManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterUpdateManyNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterUpdateManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterUpdateManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterUpdateManyNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateManyNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterUpdateManyNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateManyNotificationVendorIdOperatorsInput>;
};

export type FilterUpdateManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNotificationSetting_IdOperatorsInput>;
};

export type FilterUpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterUpdateManyNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateManyPrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateManyPrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateManyPrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterUpdateManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyPrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimal_IdOperatorsInput>;
};

export type FilterUpdateManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorCapabilityVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyProcessorSchedulingStatusOperatorsInput>;
};

export type FilterUpdateManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterUpdateManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterUpdateManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterUpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterUpdateManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyStateInput = {
  AND?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyState_IdOperatorsInput>;
};

export type FilterUpdateManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyTenant_IdOperatorsInput>;
};

export type FilterUpdateManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterUpdateManyUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserInput = {
  AND?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterUpdateManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateManyUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterUpdateManyUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterUpdateManyUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterUpdateManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateManyUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterUpdateManyUserRelationshipsOperatorsInput>;
};

export type FilterUpdateManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterUpdateManyUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterUpdateManyUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateManyUserSettingsCalendarInput>;
};

export type FilterUpdateManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterUpdateManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyVendorModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateManyVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyVendorModuleVendorOperatorsInput>;
};

export type FilterUpdateManyVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateManyVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterUpdateManyVendorTenantOperatorsInput>;
};

export type FilterUpdateManyVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterUpdateManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyWaitlist_IdOperatorsInput>;
};

export type FilterUpdateManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateOneCsvImportJobCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneCsvImportJobInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCsvImportJobInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCsvImportJobInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCsvImportJobOperatorsInput>;
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<FilterUpdateOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCsvImportJobJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCsvImportJobOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCsvImportJob_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCsvImportJobCreatedAtOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneCsvImportJobJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneCsvImportJobStatusOperatorsInput>;
  tenantId?: InputMaybe<FilterUpdateOneCsvImportJobTenantIdOperatorsInput>;
  uploadedBy?: InputMaybe<FilterUpdateOneCsvImportJobUploadedByOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneCsvImportJobVendorIdOperatorsInput>;
};

export type FilterUpdateOneCsvImportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCsvImportJobStatus>;
  gte?: InputMaybe<EnumCsvImportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
  lt?: InputMaybe<EnumCsvImportJobStatus>;
  lte?: InputMaybe<EnumCsvImportJobStatus>;
  ne?: InputMaybe<EnumCsvImportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCsvImportJobStatus>>>;
};

export type FilterUpdateOneCsvImportJobTenantIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJobUploadedByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterUpdateOneCsvImportJobVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCsvImportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateOneCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneChatMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateOneChatMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneChatMessage_IdOperatorsInput>;
};

export type FilterUpdateOneChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneChatRoomInput = {
  AND?: InputMaybe<Array<FilterUpdateOneChatRoomInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneChatRoom_IdOperatorsInput>;
};

export type FilterUpdateOneChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetAssignmentRuleSetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetAssignmentRuleSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetAssignmentRuleSetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSet_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetCapabilityIdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSetVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetAssignmentRuleSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroupCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityGroupIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroup_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityGroupVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<FilterUpdateOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapability_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCutsheetCapabilityCreatedAtOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityOptionCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityOptionInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilityOptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilityOptionOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilityOption_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionCapabilityIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionGroupIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionIsActiveOperatorsInput>;
  optionType?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionOptionTypeOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilityOptionOptionTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  gte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
  lt?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  lte?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  ne?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetCapabilityOptionOptionType>>>;
};

export type FilterUpdateOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetCapabilityOptionVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityOption_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationOperatorsInput>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationIsActiveOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecification_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationCapabilityIdOperatorsInput>;
  isActive?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationIsActiveOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetCapabilitySpecificationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheet_IdOperatorsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireCapabilityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireOperatorsInput>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<FilterUpdateOneCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetQuestionnaireOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetQuestionnaire_IdOperatorsInput>;
  capabilityId?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireCapabilityIdOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireCreatedAtOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireStatusOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type FilterUpdateOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireResponseInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetQuestionnaireResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseOperatorsInput>;
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetQuestionnaireResponseOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponse_IdOperatorsInput>;
  capabilitySet?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseCapabilitySetOperatorsInput>;
  createdAt?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseCreatedAtOperatorsInput>;
  isDeleted?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseIsDeletedOperatorsInput>;
  questionnaire?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput>;
  user?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseUserOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseVendorOperatorsInput>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseQuestionnaireOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponseVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  gte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
  lt?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  lte?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  ne?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireStatus>>>;
};

export type FilterUpdateOneCutsheetQuestionnaireVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetQuestionnaire_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type FilterUpdateOneFinancialReportingConfigInput = {
  AND?: InputMaybe<Array<FilterUpdateOneFinancialReportingConfigInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneFinancialReportingConfigInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneFinancialReportingConfigOperatorsInput>;
  animalConfigurations?: InputMaybe<Array<InputMaybe<FilterUpdateOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<FilterUpdateOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<FilterUpdateOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<FilterUpdateOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneFinancialReportingConfigOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneFinancialReportingConfig_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateOneFinancialReportingConfigUpdatedAtOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneFinancialReportingConfigVendorOperatorsInput>;
};

export type FilterUpdateOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneFinancialReportingConfigUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneFinancialReportingConfigVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneFinancialReportingConfig_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterUpdateOneIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneIntegrationVendorOperatorsInput>;
};

export type FilterUpdateOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoiceLineItem_IdOperatorsInput>;
};

export type FilterUpdateOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneInvoiceStatusOperatorsInput>;
};

export type FilterUpdateOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterUpdateOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateOneNoteUpdatedAtOperatorsInput>;
};

export type FilterUpdateOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationChatRoomIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationErrorInput = {
  email?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
  sms?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
};

export type FilterUpdateOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneNotificationGroupIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNotificationOperatorsInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<FilterUpdateOneNotificationErrorInput>;
  errorMessage?: InputMaybe<FilterUpdateOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FilterUpdateOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneNotificationJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNotification_IdOperatorsInput>;
  chatRoomId?: InputMaybe<FilterUpdateOneNotificationChatRoomIdOperatorsInput>;
  groupId?: InputMaybe<FilterUpdateOneNotificationGroupIdOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneNotificationJobIdOperatorsInput>;
  userId?: InputMaybe<FilterUpdateOneNotificationUserIdOperatorsInput>;
  vendorId?: InputMaybe<FilterUpdateOneNotificationVendorIdOperatorsInput>;
};

export type FilterUpdateOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNotificationSetting_IdOperatorsInput>;
};

export type FilterUpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type FilterUpdateOneNotificationUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateOnePrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateOnePrimalGroupOrderOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateOnePrimalGroupProcessorSettingsOperatorsInput>;
};

export type FilterUpdateOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOnePrimalGroupProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimal_IdOperatorsInput>;
};

export type FilterUpdateOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapability_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorCapabilityVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorCapabilityVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneProcessorSchedulingStatusOperatorsInput>;
};

export type FilterUpdateOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type FilterUpdateOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
  processorSettings?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacityProcessorSettingsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterUpdateOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterUpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<FilterUpdateOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneStateInput = {
  AND?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneState_IdOperatorsInput>;
};

export type FilterUpdateOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneTenant_IdOperatorsInput>;
};

export type FilterUpdateOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUserAuth_MethodOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserAuth_Method>;
  gte?: InputMaybe<EnumUserAuth_Method>;
  in?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
  lt?: InputMaybe<EnumUserAuth_Method>;
  lte?: InputMaybe<EnumUserAuth_Method>;
  ne?: InputMaybe<EnumUserAuth_Method>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserAuth_Method>>>;
};

export type FilterUpdateOneUserCognito_UsernameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserInput = {
  AND?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<FilterUpdateOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateOneUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneUser_IdOperatorsInput>;
  auth_method?: InputMaybe<FilterUpdateOneUserAuth_MethodOperatorsInput>;
  cognito_username?: InputMaybe<FilterUpdateOneUserCognito_UsernameOperatorsInput>;
  email?: InputMaybe<FilterUpdateOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateOneUserPhoneOperatorsInput>;
  relationships?: InputMaybe<FilterUpdateOneUserRelationshipsOperatorsInput>;
};

export type FilterUpdateOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneUserRelationshipsOperatorsInput = {
  vendorId?: InputMaybe<FilterUpdateOneUserRelationshipsVendorIdOperatorsInput>;
};

export type FilterUpdateOneUserRelationshipsVendorIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateOneUserSettingsCalendarInput>;
};

export type FilterUpdateOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<FilterUpdateOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneVendorModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateOneVendorModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneVendorModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneVendorModuleOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneVendorModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneVendorModule_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneVendorModuleVendorOperatorsInput>;
};

export type FilterUpdateOneVendorModuleVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateOneVendorDate_CreatedOperatorsInput>;
  tenant?: InputMaybe<FilterUpdateOneVendorTenantOperatorsInput>;
};

export type FilterUpdateOneVendorTenantOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type FilterUpdateOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneWaitlist_IdOperatorsInput>;
};

export type FilterUpdateOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FinancialReportingConfig = {
  __typename?: 'FinancialReportingConfig';
  _id: Scalars['MongoID']['output'];
  animalConfigurations?: Maybe<Array<Maybe<FinancialReportingConfigAnimalConfigurations>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dateAnchor?: Maybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: Maybe<FinancialReportingConfigMonthlyModifiers>;
  overheadCosts?: Maybe<Array<Maybe<FinancialReportingConfigOverheadCosts>>>;
  timeConfiguration?: Maybe<FinancialReportingConfigTimeConfiguration>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type FinancialReportingConfigAnimalConfigurations = {
  __typename?: 'FinancialReportingConfigAnimalConfigurations';
  averageHangingWeight: Scalars['Float']['output'];
  expectedThroughput: Scalars['Float']['output'];
  maxCapacity: Scalars['Float']['output'];
  processingCost: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  species: EnumFinancialReportingConfigAnimalConfigurationsSpecies;
};

export type FinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight: Scalars['Float']['input'];
  expectedThroughput: Scalars['Float']['input'];
  maxCapacity: Scalars['Float']['input'];
  processingCost: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  species: EnumFinancialReportingConfigAnimalConfigurationsSpecies;
};

export type FinancialReportingConfigMonthlyModifiers = {
  __typename?: 'FinancialReportingConfigMonthlyModifiers';
  april: Scalars['Float']['output'];
  august: Scalars['Float']['output'];
  december: Scalars['Float']['output'];
  february: Scalars['Float']['output'];
  january: Scalars['Float']['output'];
  july: Scalars['Float']['output'];
  june: Scalars['Float']['output'];
  march: Scalars['Float']['output'];
  may: Scalars['Float']['output'];
  november: Scalars['Float']['output'];
  october: Scalars['Float']['output'];
  september: Scalars['Float']['output'];
};

export type FinancialReportingConfigMonthlyModifiersInput = {
  april: Scalars['Float']['input'];
  august: Scalars['Float']['input'];
  december: Scalars['Float']['input'];
  february: Scalars['Float']['input'];
  january: Scalars['Float']['input'];
  july: Scalars['Float']['input'];
  june: Scalars['Float']['input'];
  march: Scalars['Float']['input'];
  may: Scalars['Float']['input'];
  november: Scalars['Float']['input'];
  october: Scalars['Float']['input'];
  september: Scalars['Float']['input'];
};

export type FinancialReportingConfigOverheadCosts = {
  __typename?: 'FinancialReportingConfigOverheadCosts';
  amount: Scalars['Float']['output'];
  frequency: EnumFinancialReportingConfigOverheadCostsFrequency;
  name: Scalars['String']['output'];
};

export type FinancialReportingConfigOverheadCostsInput = {
  amount: Scalars['Float']['input'];
  frequency: EnumFinancialReportingConfigOverheadCostsFrequency;
  name: Scalars['String']['input'];
};

/** List of items with pagination. */
export type FinancialReportingConfigPagination = {
  __typename?: 'FinancialReportingConfigPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FinancialReportingConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type FinancialReportingConfigTimeConfiguration = {
  __typename?: 'FinancialReportingConfigTimeConfiguration';
  baseDigitalSavings: Scalars['Float']['output'];
  hourlyRate: Scalars['Float']['output'];
  timePerBooking: Scalars['Float']['output'];
  timePerCutsheet: Scalars['Float']['output'];
  timePerInvoicing: Scalars['Float']['output'];
  timePerNotification: Scalars['Float']['output'];
  timePerProducerBooking: Scalars['Float']['output'];
};

export type FinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerInvoicing: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
  timePerProducerBooking: Scalars['Float']['input'];
};

export type FinancialReportingConfigUpsertInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<AnimalConfigurationInput>>>;
  dateAnchor?: InputMaybe<DateAnchorEnumUpsert>;
  monthlyModifiers?: InputMaybe<MonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<OverheadCostInput>>>;
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
};

export type FixVendorPhoneConfigInput = {
  phoneNumber: Scalars['String']['input'];
  phoneNumberSid: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type FixVendorPhoneConfigResponse = {
  __typename?: 'FixVendorPhoneConfigResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateBillingStatementResponse = {
  __typename?: 'GenerateBillingStatementResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCarcassTagsResponse = {
  __typename?: 'GenerateCarcassTagsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCsvResponse = {
  __typename?: 'GenerateCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateCutsheetResponse = {
  __typename?: 'GenerateCutsheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateHangingWeightCsvResponse = {
  __typename?: 'GenerateHangingWeightCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateInvoicePdfResponse = {
  __typename?: 'GenerateInvoicePdfResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateKillSheetResponse = {
  __typename?: 'GenerateKillSheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GeneratePackingSlipResponse = {
  __typename?: 'GeneratePackingSlipResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateUploadUrlPayload = {
  __typename?: 'GenerateUploadUrlPayload';
  /** Public CDN URL the uploaded file will be accessible at */
  cdnUrl: Scalars['String']['output'];
  /** Presigned S3 PUT URL — expires in expiresIn seconds */
  uploadUrl: Scalars['String']['output'];
};

export type Holiday = {
  __typename?: 'Holiday';
  country: Scalars['String']['output'];
  date: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type HolidaysMeta = {
  __typename?: 'HolidaysMeta';
  count: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  end: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type HolidaysResponse = {
  __typename?: 'HolidaysResponse';
  holidays?: Maybe<Array<Maybe<Holiday>>>;
  meta?: Maybe<HolidaysMeta>;
};

export type Integration = {
  __typename?: 'Integration';
  _id: Scalars['MongoID']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastSynced?: Maybe<Scalars['Date']['output']>;
  name: EnumIntegrationName;
  secret?: Maybe<Scalars['String']['output']>;
  type: EnumIntegrationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};

/** List of items with pagination. */
export type IntegrationPagination = {
  __typename?: 'IntegrationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Integration>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['MongoID']['output'];
  amount_discounted?: Maybe<Scalars['Float']['output']>;
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_refunded?: Maybe<Scalars['Float']['output']>;
  billing_month?: Maybe<Scalars['Float']['output']>;
  billing_year?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  discounts?: Maybe<Array<Maybe<InvoiceDiscounts>>>;
  due_date: Scalars['Date']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceExternal_Links>;
  line_items: Array<InvoiceLineItem>;
  links?: Maybe<Array<Maybe<InvoiceLinks>>>;
  linksWithEntities?: Maybe<Array<Maybe<InvoiceLinks>>>;
  number?: Maybe<Scalars['String']['output']>;
  status: EnumInvoiceStatus;
  status_changes?: Maybe<Array<Maybe<InvoiceStatus_Changes>>>;
  type: EnumInvoiceType;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
};


export type InvoiceLine_ItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};

export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  applied_amount: Scalars['Float']['output'];
  coupon_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['output'];
};

export type InvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount: Scalars['Float']['input'];
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['input'];
};

export type InvoiceExternal_Links = {
  __typename?: 'InvoiceExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceLineItemExternal_Links>;
  invoice?: Maybe<Invoice>;
  links?: Maybe<Array<Maybe<InvoiceLineItemLinks>>>;
  quantity: Scalars['Float']['output'];
};

export type InvoiceLineItemExternal_Links = {
  __typename?: 'InvoiceLineItemExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceLineItemLinks = {
  __typename?: 'InvoiceLineItemLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoiceLineItemPagination = {
  __typename?: 'InvoiceLineItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<InvoiceLineItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceLinks = {
  __typename?: 'InvoiceLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  /** The linked entity (ProcessorScheduling, AnimalHead, or Cutsheet) */
  entity?: Maybe<Scalars['JSON']['output']>;
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoicePagination = {
  __typename?: 'InvoicePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Invoice>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceStatus_Changes = {
  __typename?: 'InvoiceStatus_changes';
  _id?: Maybe<Scalars['MongoID']['output']>;
  date: Scalars['Date']['output'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date: Scalars['Date']['input'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceUpdateLineItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type LegacyCapabilityData = {
  __typename?: 'LegacyCapabilityData';
  cuts: Array<Maybe<LegacyCut>>;
  extras: Array<Maybe<LegacyExtra>>;
  inspectionLevel: Scalars['String']['output'];
  specifications: Array<Maybe<LegacySpecification>>;
  trims: Array<Maybe<LegacyTrim>>;
};

export type LegacyCut = {
  __typename?: 'LegacyCut';
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
  primalName?: Maybe<Scalars['String']['output']>;
};

export type LegacyExtra = {
  __typename?: 'LegacyExtra';
  name: Scalars['String']['output'];
};

export type LegacySpecification = {
  __typename?: 'LegacySpecification';
  name: Scalars['String']['output'];
};

export type LegacyTrim = {
  __typename?: 'LegacyTrim';
  name: Scalars['String']['output'];
};

export type MarkAsPaidInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type MonthlyModifiersInput = {
  april: Scalars['Float']['input'];
  august: Scalars['Float']['input'];
  december: Scalars['Float']['input'];
  february: Scalars['Float']['input'];
  january: Scalars['Float']['input'];
  july: Scalars['Float']['input'];
  june: Scalars['Float']['input'];
  march: Scalars['Float']['input'];
  may: Scalars['Float']['input'];
  november: Scalars['Float']['input'];
  october: Scalars['Float']['input'];
  september: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  CutsheetCapabilityCreateMany?: Maybe<CreateManyCutsheetCapabilityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CutsheetCapabilityCreateOne?: Maybe<CreateOneCutsheetCapabilityPayload>;
  /** Delete cutsheet capabilities */
  CutsheetCapabilityDelete: Scalars['Boolean']['output'];
  /** Copy catalog (groups, cuts/trims/extras, specifications) and optionally questionnaires/assignment rules from one capability set to another. Target must be empty. */
  CutsheetCapabilityDuplicate?: Maybe<CutsheetCapabilityDuplicateResponse>;
  /** Migrate legacy ProcessorCapability data into a cutsheet capability (groups, options, specs, questionnaires, rules) */
  CutsheetCapabilityMigrateLegacy?: Maybe<CutsheetCapabilityMigrateLegacyResponse>;
  /** Save PDF print/layout settings for a cutsheet capability */
  CutsheetCapabilityPrintSettingsUpdate?: Maybe<CutsheetCapability>;
  /** Set the full legacy mapping (questionnaires + item-level mappings) on a capability */
  CutsheetCapabilitySetLegacyMap?: Maybe<CutsheetCapability>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CutsheetCapabilityUpdateById?: Maybe<UpdateByIdCutsheetCapabilityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  CutsheetCapabilityUpdateMany?: Maybe<UpdateManyCutsheetCapabilityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CutsheetCapabilityUpdateOne?: Maybe<UpdateOneCutsheetCapabilityPayload>;
  /** Create or update cutsheet capabilities */
  CutsheetCapabilityUpsert?: Maybe<CutsheetCapability>;
  /** Add a processor phone number to the Twilio Messaging Service for Conversations */
  addPhoneToMessagingService?: Maybe<AddPhoneToMessagingServiceResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addressCreateMany?: Maybe<CreateManyAddressPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addressCreateOne?: Maybe<CreateOneAddressPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateById?: Maybe<UpdateByIdAddressPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  addressUpdateMany?: Maybe<UpdateManyAddressPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateOne?: Maybe<UpdateOneAddressPayload>;
  authCheckUser?: Maybe<AuthCheckUserPayload>;
  authConfirmForgotPassword?: Maybe<AuthConfirmForgotPasswordPayload>;
  authForgotPassword?: Maybe<AuthForgotPasswordPayload>;
  authLoginOAuth?: Maybe<AuthLoginOAuthPayload>;
  authLoginPassword?: Maybe<AuthLoginPasswordPayload>;
  authRefreshToken?: Maybe<AuthRefreshTokenPayload>;
  authSendOTP?: Maybe<AuthSendOtpPayload>;
  authSetPassword?: Maybe<AuthSetPasswordPayload>;
  authVerifyOTP?: Maybe<AuthVerifyOtpPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateMany?: Maybe<CreateManyCancellationReasonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateOne?: Maybe<CreateOneCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateById?: Maybe<UpdateByIdCancellationReasonPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cancellationReasonUpdateMany?: Maybe<UpdateManyCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateOne?: Maybe<UpdateOneCancellationReasonPayload>;
  changePassword?: Maybe<ChangePasswordPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  chatMessageCreateMany?: Maybe<CreateManyChatMessagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  chatMessageCreateOne?: Maybe<CreateOneChatMessagePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatMessageUpdateById?: Maybe<UpdateByIdChatMessagePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  chatMessageUpdateMany?: Maybe<UpdateManyChatMessagePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatMessageUpdateOne?: Maybe<UpdateOneChatMessagePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  chatRoomCreateMany?: Maybe<CreateManyChatRoomPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  chatRoomCreateOne?: Maybe<CreateOneChatRoomPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatRoomUpdateById?: Maybe<UpdateByIdChatRoomPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  chatRoomUpdateMany?: Maybe<UpdateManyChatRoomPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatRoomUpdateOne?: Maybe<UpdateOneChatRoomPayload>;
  /** Cancel a CSV import job before import execution starts (column_mapping or data_review stages only) */
  csvImportCancelJob?: Maybe<CsvImportCancelJobPayload>;
  /** Mark a record as deleted (will not be imported) */
  csvImportDeleteRecord?: Maybe<CsvImportDeleteRecordPayload>;
  /** Start importing validated CSV records */
  csvImportExecute?: Maybe<CsvImportExecutePayload>;
  /** Force cancel a stuck CSV import job (admin only). Use with caution as this may leave partial imports. */
  csvImportForceCancel?: Maybe<CsvImportForceCancelPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  csvImportJobCreateMany?: Maybe<CreateManyCsvImportJobPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  csvImportJobCreateOne?: Maybe<CreateOneCsvImportJobPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  csvImportJobUpdateById?: Maybe<UpdateByIdCsvImportJobPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  csvImportJobUpdateMany?: Maybe<UpdateManyCsvImportJobPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  csvImportJobUpdateOne?: Maybe<UpdateOneCsvImportJobPayload>;
  /** Re-validate edited CSV data for an import job */
  csvImportRevalidate?: Maybe<CsvImportRevalidatePayload>;
  /** Save column mapping for a CSV import job and re-validate data */
  csvImportSaveColumnMapping?: Maybe<CsvImportSaveColumnMappingPayload>;
  /** Update specific rows and re-validate CSV import data */
  csvImportUpdateRows?: Maybe<CsvImportUpdateRowsPayload>;
  /** Upload and validate a CSV file for bulk import */
  csvImportUpload?: Maybe<CsvImportUploadPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetAssignmentRuleSetCreateMany?: Maybe<CreateManyCutsheetAssignmentRuleSetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetAssignmentRuleSetCreateOne?: Maybe<CreateOneCutsheetAssignmentRuleSetPayload>;
  /** Delete the assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetAssignmentRuleSetUpdateById?: Maybe<UpdateByIdCutsheetAssignmentRuleSetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetAssignmentRuleSetUpdateMany?: Maybe<UpdateManyCutsheetAssignmentRuleSetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetAssignmentRuleSetUpdateOne?: Maybe<UpdateOneCutsheetAssignmentRuleSetPayload>;
  /** Create or replace the ordered assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetUpsert?: Maybe<CutsheetAssignmentRuleSet>;
  /** Generates a blank cutsheet PDF from a vendor's CutsheetCapability, showing all available cuts/trim/extras with no selections. */
  cutsheetCapabilityGenerateBlankCutsheet?: Maybe<GenerateCutsheetResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCapabilityOptionCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCapabilityOptionCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a capability option */
  cutsheetCapabilityOptionDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCapabilityOptionUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetCapabilityOptionUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCapabilityOptionUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a capability option (cut, trim, or extra) */
  cutsheetCapabilityOptionUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCreateMany?: Maybe<CreateManyCutsheetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCreateOne?: Maybe<CreateOneCutsheetPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCutCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCutCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet cut */
  cutsheetCutDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCutUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetCutUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetCutUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet cut */
  cutsheetCutUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetExtraCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetExtraCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet extra */
  cutsheetExtraDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetExtraUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetExtraUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetExtraUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet extra */
  cutsheetExtraUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetGroupCreateMany?: Maybe<CreateManyCutsheetCapabilityGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetGroupCreateOne?: Maybe<CreateOneCutsheetCapabilityGroupPayload>;
  /** Delete a cutsheet primal */
  cutsheetGroupDelete: Scalars['Boolean']['output'];
  /** Bulk-update sortOrder for primals in one DB round-trip */
  cutsheetGroupReorder: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetGroupUpdateById?: Maybe<UpdateByIdCutsheetCapabilityGroupPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetGroupUpdateMany?: Maybe<UpdateManyCutsheetCapabilityGroupPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetGroupUpdateOne?: Maybe<UpdateOneCutsheetCapabilityGroupPayload>;
  /** Create or update a cutsheet primal */
  cutsheetGroupUpsert?: Maybe<CutsheetCapabilityGroup>;
  /** Record that a legacy cutsheet has been converted to a new-format CutsheetQuestionnaireResponse. */
  cutsheetMarkConverted?: Maybe<Cutsheet>;
  /** Bulk-update sortOrder for capability options (cuts, trim, extras) */
  cutsheetOptionReorder: Scalars['Boolean']['output'];
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireCreateMany?: Maybe<CreateManyCutsheetQuestionnairePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireCreateOne?: Maybe<CreateOneCutsheetQuestionnairePayload>;
  /** Archive (soft-delete) a cutsheet questionnaire. Sets status to `archived` so responses referencing it remain intact. */
  cutsheetQuestionnaireDelete: Scalars['Boolean']['output'];
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireResponseCreateMany?: Maybe<CreateManyCutsheetQuestionnaireResponsePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetQuestionnaireResponseCreateOne?: Maybe<CreateOneCutsheetQuestionnaireResponsePayload>;
  /** Soft-delete a cutsheet questionnaire response */
  cutsheetQuestionnaireResponseSoftDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireResponseUpdateById?: Maybe<UpdateByIdCutsheetQuestionnaireResponsePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetQuestionnaireResponseUpdateMany?: Maybe<UpdateManyCutsheetQuestionnaireResponsePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireResponseUpdateOne?: Maybe<UpdateOneCutsheetQuestionnaireResponsePayload>;
  /** Create or update a customer cutsheet questionnaire response */
  cutsheetQuestionnaireResponseUpsert?: Maybe<CutsheetQuestionnaireResponse>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireUpdateById?: Maybe<UpdateByIdCutsheetQuestionnairePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetQuestionnaireUpdateMany?: Maybe<UpdateManyCutsheetQuestionnairePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetQuestionnaireUpdateOne?: Maybe<UpdateOneCutsheetQuestionnairePayload>;
  /** Create or update cutsheet questionnaire */
  cutsheetQuestionnaireUpsert?: Maybe<CutsheetQuestionnaire>;
  /** Soft delete of cutsheet */
  cutsheetSoftDelete?: Maybe<Cutsheet>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetSpecificationCreateMany?: Maybe<CreateManyCutsheetCapabilitySpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetSpecificationCreateOne?: Maybe<CreateOneCutsheetCapabilitySpecificationPayload>;
  /** Delete a cutsheet specification */
  cutsheetSpecificationDelete: Scalars['Boolean']['output'];
  /** Bulk-update sortOrder for specifications in one DB round-trip */
  cutsheetSpecificationReorder: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetSpecificationUpdateById?: Maybe<UpdateByIdCutsheetCapabilitySpecificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetSpecificationUpdateMany?: Maybe<UpdateManyCutsheetCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetSpecificationUpdateOne?: Maybe<UpdateOneCutsheetCapabilitySpecificationPayload>;
  /** Create or update a cutsheet specification */
  cutsheetSpecificationUpsert?: Maybe<CutsheetCapabilitySpecification>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetTrimCreateMany?: Maybe<CreateManyCutsheetCapabilityOptionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetTrimCreateOne?: Maybe<CreateOneCutsheetCapabilityOptionPayload>;
  /** Delete a cutsheet trim */
  cutsheetTrimDelete: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetTrimUpdateById?: Maybe<UpdateByIdCutsheetCapabilityOptionPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetTrimUpdateMany?: Maybe<UpdateManyCutsheetCapabilityOptionPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetTrimUpdateOne?: Maybe<UpdateOneCutsheetCapabilityOptionPayload>;
  /** Create or update a cutsheet trim */
  cutsheetTrimUpsert?: Maybe<CutsheetCapabilityOption>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateById?: Maybe<UpdateByIdCutsheetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetUpdateMany?: Maybe<UpdateManyCutsheetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateOne?: Maybe<UpdateOneCutsheetPayload>;
  /** Upsert cutsheet for an animal type. */
  cutsheetUpsert?: Maybe<Cutsheet>;
  deleteDuplicatePrimals?: Maybe<DeleteDuplicatePrimalsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  financialReportingConfigCreateMany?: Maybe<CreateManyFinancialReportingConfigPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  financialReportingConfigCreateOne?: Maybe<CreateOneFinancialReportingConfigPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  financialReportingConfigUpdateById?: Maybe<UpdateByIdFinancialReportingConfigPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  financialReportingConfigUpdateMany?: Maybe<UpdateManyFinancialReportingConfigPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  financialReportingConfigUpdateOne?: Maybe<UpdateOneFinancialReportingConfigPayload>;
  /** Create or update financial reporting configuration for the current vendor. */
  financialReportingConfigUpsert?: Maybe<FinancialReportingConfig>;
  /** Fix vendor phone config that was not saved correctly during provisioning */
  fixVendorPhoneConfig?: Maybe<FixVendorPhoneConfigResponse>;
  /** Generates a PDF for the specified invoice ID. */
  generateInvoicePdf?: Maybe<GenerateInvoicePdfResponse>;
  /** Generate a presigned S3 URL for direct browser uploads. Use the returned uploadUrl with an HTTP PUT request to upload the file. cdnUrl is the public URL the asset will be available at after upload. */
  generateUploadUrl?: Maybe<GenerateUploadUrlPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  integrationCreateMany?: Maybe<CreateManyIntegrationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  integrationCreateOne?: Maybe<CreateOneIntegrationPayload>;
  /** Init integration. */
  integrationInit?: Maybe<Integration>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateById?: Maybe<UpdateByIdIntegrationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  integrationUpdateMany?: Maybe<UpdateManyIntegrationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateOne?: Maybe<UpdateOneIntegrationPayload>;
  /** Create a single invoice for one contact on a processor scheduling job. Handles Stripe and QuickBooks creation based on vendor integrations and isPayAtPickup. */
  invoiceCreateForSchedulingJob?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceCreateMany?: Maybe<CreateManyInvoicePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceCreateOne?: Maybe<CreateOneInvoicePayload>;
  /** Finalize and send an invoice */
  invoiceFinalizeAndSend?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateMany?: Maybe<CreateManyInvoiceLineItemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateOne?: Maybe<CreateOneInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateById?: Maybe<UpdateByIdInvoiceLineItemPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceLineItemUpdateMany?: Maybe<UpdateManyInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateOne?: Maybe<UpdateOneInvoiceLineItemPayload>;
  /** Mark an invoice as paid */
  invoiceMarkAsPaid?: Maybe<Invoice>;
  /** Refund an invoice (full or partial) */
  invoiceRefund?: Maybe<Invoice>;
  /** Update an existing invoice */
  invoiceUpdate?: Maybe<Invoice>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateById?: Maybe<UpdateByIdInvoicePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceUpdateMany?: Maybe<UpdateManyInvoicePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateOne?: Maybe<UpdateOneInvoicePayload>;
  /** Void an invoice */
  invoiceVoid?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  moduleCreateMany?: Maybe<CreateManyVendorModulePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  moduleCreateOne?: Maybe<CreateOneVendorModulePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateById?: Maybe<UpdateByIdVendorModulePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  moduleUpdateMany?: Maybe<UpdateManyVendorModulePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateOne?: Maybe<UpdateOneVendorModulePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  noteCreateMany?: Maybe<CreateManyNotePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreateOne?: Maybe<CreateOneNotePayload>;
  /** Delete a note by ID. */
  noteDelete?: Maybe<Note>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateById?: Maybe<UpdateByIdNotePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  noteUpdateMany?: Maybe<UpdateManyNotePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateOne?: Maybe<UpdateOneNotePayload>;
  /** Upsert a note for a processor scheduling. */
  noteUpsert?: Maybe<Note>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  notificationCreateMany?: Maybe<CreateManyNotificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationCreateOne?: Maybe<CreateOneNotificationPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateMany?: Maybe<CreateManyNotificationSettingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateOne?: Maybe<CreateOneNotificationSettingPayload>;
  /** Update notification settings by ID */
  notificationSettingsUpdate?: Maybe<NotificationSetting>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateById?: Maybe<UpdateByIdNotificationSettingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  notificationSettingsUpdateMany?: Maybe<UpdateManyNotificationSettingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateOne?: Maybe<UpdateOneNotificationSettingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationUpdateById?: Maybe<UpdateByIdNotificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  notificationUpdateMany?: Maybe<UpdateManyNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationUpdateOne?: Maybe<UpdateOneNotificationPayload>;
  /** Parse a cutsheet (PDF or image) using AI to extract catalog data and generate a questionnaire */
  parseCutsheet?: Maybe<ParseCutsheetPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCreateMany?: Maybe<CreateManyPrimalPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCreateOne?: Maybe<CreateOnePrimalPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateMany?: Maybe<CreateManyPrimalCutBlockerPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateOne?: Maybe<CreateOnePrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateById?: Maybe<UpdateByIdPrimalCutBlockerPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutBlockerUpdateMany?: Maybe<UpdateManyPrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateOne?: Maybe<UpdateOnePrimalCutBlockerPayload>;
  /** Upsert a primal cut blocker */
  primalCutBlockerUpsert?: Maybe<PrimalCutBlocker>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutCreateMany?: Maybe<CreateManyPrimalCutPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutCreateOne?: Maybe<CreateOnePrimalCutPayload>;
  /** Soft delete of primal cut */
  primalCutSoftDelete?: Maybe<PrimalCut>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateMany?: Maybe<CreateManyPrimalCutTypePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateOne?: Maybe<CreateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateById?: Maybe<UpdateByIdPrimalCutTypePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutTypeUpdateMany?: Maybe<UpdateManyPrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateOne?: Maybe<UpdateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateById?: Maybe<UpdateByIdPrimalCutPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutUpdateMany?: Maybe<UpdateManyPrimalCutPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateOne?: Maybe<UpdateOnePrimalCutPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalGroupCreateMany?: Maybe<CreateManyPrimalGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalGroupCreateOne?: Maybe<CreateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateById?: Maybe<UpdateByIdPrimalGroupPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalGroupUpdateMany?: Maybe<UpdateManyPrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateOne?: Maybe<UpdateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateById?: Maybe<UpdateByIdPrimalPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalUpdateMany?: Maybe<UpdateManyPrimalPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateOne?: Maybe<UpdateOnePrimalPayload>;
  /** Force update the status of a processor scheduling job. This bypasses all workflow logic, emails, and validations. Intended for administrative corrections when jobs were incorrectly moved forward in the workflow. Example: Moving a job from "Invoicing" back to "Killed" if it was prematurely advanced. */
  processingJobForceUpdateStatus?: Maybe<ProcessorSchedulingForceUpdateStatusResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersOneUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateMany?: Maybe<CreateManyProcessorCapabilityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateOne?: Maybe<CreateOneProcessorCapabilityPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateMany?: Maybe<CreateManyProcessorCapabilitySpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateOne?: Maybe<CreateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateById?: Maybe<UpdateByIdProcessorCapabilitySpecificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilitySpecificationUpdateMany?: Maybe<UpdateManyProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateOne?: Maybe<UpdateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateById?: Maybe<UpdateByIdProcessorCapabilityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilityUpdateMany?: Maybe<UpdateManyProcessorCapabilityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateOne?: Maybe<UpdateOneProcessorCapabilityPayload>;
  /** Upsert processor capabilities for an animal type. */
  processorCapabilityUpsert?: Maybe<ProcessorCapability>;
  /** Exports a CSV for a vendor. */
  processorExportCsv?: Maybe<ProcessorExportCsvResponse>;
  /** Generates CSV for a vendor. */
  processorExportCsvByVendorId?: Maybe<ProcessorExportCsvResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateMany?: Maybe<CreateManyProcessorNotificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateOne?: Maybe<CreateOneProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateById?: Maybe<UpdateByIdProcessorNotificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorNotificationUpdateMany?: Maybe<UpdateManyProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateOne?: Maybe<UpdateOneProcessorNotificationPayload>;
  /** Bulk update of animal heads on a particular processing job. */
  processorSchedulingAnimalHeadBulkUpdate?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Delete an animal head from a scheduled job. */
  processorSchedulingAnimalHeadDelete?: Maybe<ProcessorScheduling>;
  /** Partial update of a single animal head on a particular processing job. */
  processorSchedulingAnimalHeadPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  processorSchedulingBuyerCutsheetReminder?: Maybe<ProcessorScheduling>;
  /** Create a new processor scheduling. */
  processorSchedulingCreate?: Maybe<CreateProcessorScheduleResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateMany?: Maybe<CreateManyProcessorSchedulingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateOne?: Maybe<CreateOneProcessorSchedulingPayload>;
  processorSchedulingCutsheetReminder?: Maybe<ProcessorScheduling>;
  /** Update the dropoff date, cut date, and kill date, if exists, for a processor scheduling job. This is only used for the calendar drag and drop feature. */
  processorSchedulingDragAndDropUpdate?: Maybe<ProcessorScheduling>;
  /** Generates the billing statement for the proceessing job and returns it to be downloaded. */
  processorSchedulingGenerateBillingStatement?: Maybe<GenerateBillingStatementResponse>;
  /** Generates carcass tag pdfs for a scheduled job or specific animal heads in the job. */
  processorSchedulingGenerateCarcassTags?: Maybe<GenerateCarcassTagsResponse>;
  /** Generates CSV for a vendor. */
  processorSchedulingGenerateCsvByVendorId?: Maybe<GenerateCsvResponse>;
  /** Generates the cutsheet pdf(s) for a scheduled job and cutsheet request. */
  processorSchedulingGenerateCutsheetRequest?: Maybe<GenerateCutsheetResponse>;
  /** Generates CSV for a vendor for hanging weights. */
  processorSchedulingGenerateHangingWeightCsv?: Maybe<GenerateHangingWeightCsvResponse>;
  /** Generates kill sheet pdf for the selected date. */
  processorSchedulingGenerateKillSheet?: Maybe<GenerateKillSheetResponse>;
  /** Generates per-customer packing slips for the processing job, listing the recorded yield per split. When `cutsheetInformationId` is provided, the slip is scoped to just that split. */
  processorSchedulingGeneratePackingSlip?: Maybe<GeneratePackingSlipResponse>;
  /** Manually send out an email. You will have to give us the type and the right information. */
  processorSchedulingNotificationSend?: Maybe<ProcessorScheduling>;
  /** Partial update of a single processor scheduling job with support for adding new animal heads */
  processorSchedulingPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Update the split type and contact information for a specific animal head on a processor scheduling. */
  processorSchedulingSplitTypeUpdateById?: Maybe<ProcessorSchedulingSplitTypeUpdateResponse>;
  /** Update a processor scheduling job */
  processorSchedulingUpdate?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateById?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Partial update of cutsheets associated to a processor scheduling */
  processorSchedulingUpdateCutsheets?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSchedulingUpdateMany?: Maybe<UpdateManyProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateOne?: Maybe<UpdateOneProcessorSchedulingPayload>;
  /** Add new processor settings to the partners platform. Can include custom capacities for specific days. */
  processorSettingsCreate?: Maybe<CreateProcessorSettingsWithCustomCapacity>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateMany?: Maybe<CreateManyProcessorSettingsCustomCapacityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateOne?: Maybe<CreateOneProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateById?: Maybe<UpdateByIdProcessorSettingsCustomCapacityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsCustomCapacityUpdateMany?: Maybe<UpdateManyProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateOne?: Maybe<UpdateOneProcessorSettingsCustomCapacityPayload>;
  /** Update processor settings to the partners platform. Supports customized day scheduling updates. */
  processorSettingsUpdate?: Maybe<UpdateProcessorSettingsWithCustomCapacity>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Provision a new Twilio phone number for a processor */
  provisionPhoneNumber?: Maybe<ProvisionPhoneNumberResponse>;
  /** Refresh the status of a phone number (hosted landline order or provisioned number) */
  refreshHostedNumberStatus?: Maybe<RefreshHostedNumberStatusResponse>;
  /** Release a phone number from a processor */
  releasePhoneNumber?: Maybe<ReleasePhoneNumberResponse>;
  /** Sending message between customer and processor */
  sendMessage?: Maybe<ChatMessage>;
  /** Send a test notification to a given email address or phone number using sample data. Pass emailContent/smsContent to override the saved template (e.g. unsaved editor content). */
  sendTestNotification?: Maybe<SendTestNotificationResult>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  stateCreateMany?: Maybe<CreateManyStatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  stateCreateOne?: Maybe<CreateOneStatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateById?: Maybe<UpdateByIdStatePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  stateUpdateMany?: Maybe<UpdateManyStatePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateOne?: Maybe<UpdateOneStatePayload>;
  /** Create an stripe account for active_vendor. */
  stripeAccountCreate?: Maybe<Vendor>;
  /** Create an stripe session for active_vendor. */
  stripeSessionCreate?: Maybe<Vendor>;
  /** Submit a hosted landline number order to SMS-enable an existing business phone */
  submitHostedLandlineOrder?: Maybe<SubmitHostedLandlineOrderResponse>;
  /** Sync all Twilio conversation SMS participants to use the vendor's current phone number */
  syncConversationPhoneNumbers?: Maybe<SyncConversationPhoneNumbersResponse>;
  /** Add new tenant to Partners platform. */
  tenantCreate?: Maybe<Tenant>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tenantCreateMany?: Maybe<CreateManyTenantPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tenantCreateOne?: Maybe<CreateOneTenantPayload>;
  /** Enable or disable a tenant on the Partners platform. */
  tenantEnabledEdit?: Maybe<Tenant>;
  /** Modify tenant picture by uploading an image file. */
  tenantPictureUrlEdit?: Maybe<Tenant>;
  /** Modify tenant subscription on the Partners platform. */
  tenantSubscriptionEdit?: Maybe<Tenant>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateById?: Maybe<UpdateByIdTenantPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  tenantUpdateMany?: Maybe<UpdateManyTenantPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateOne?: Maybe<UpdateOneTenantPayload>;
  updateAuthMethod?: Maybe<UpdateAuthMethodPayload>;
  /** Update the SMS webhook URL for an existing phone number to receive inbound SMS */
  updatePhoneNumberSmsWebhook?: Maybe<UpdatePhoneNumberSmsWebhookResponse>;
  /** Update the authenticated user's profile information. */
  updateProfile?: Maybe<User>;
  /** Activate user on Partners platform. */
  userActivate?: Maybe<User>;
  /** Create or update a basic user. */
  userBasicUpsert?: Maybe<UserBasicUpsertPayload>;
  /** Add new user to Partners platform. */
  userCreate?: Maybe<User>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  userCreateMany?: Maybe<CreateManyUserPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreateOne?: Maybe<CreateOneUserPayload>;
  /** Deactivate user on Partners platform. */
  userDeactivate?: Maybe<User>;
  /** Update the current authenticated user's settings. */
  userSettingsUpdate?: Maybe<User>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateById?: Maybe<UpdateByIdUserPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  userUpdateMany?: Maybe<UpdateManyUserPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateOne?: Maybe<UpdateOneUserPayload>;
  /** Add new vendor to Partners platform. */
  vendorCreate?: Maybe<Vendor>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  vendorCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  vendorCreateOne?: Maybe<CreateOneVendorPayload>;
  /** Create or update a module for a vendor. */
  vendorModuleUpsert?: Maybe<VendorModule>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  vendorUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateOne?: Maybe<UpdateOneVendorPayload>;
  waitlistAdd?: Maybe<Waitlist>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  waitlistCreateMany?: Maybe<CreateManyWaitlistPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  waitlistCreateOne?: Maybe<CreateOneWaitlistPayload>;
  waitlistDelete?: Maybe<Waitlist>;
  waitlistUnsubscribe?: Maybe<Waitlist>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateById?: Maybe<UpdateByIdWaitlistPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  waitlistUpdateMany?: Maybe<UpdateManyWaitlistPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateOne?: Maybe<UpdateOneWaitlistPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  webhookCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  webhookCreateOne?: Maybe<CreateOneVendorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  webhookUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateOne?: Maybe<UpdateOneVendorPayload>;
};


export type MutationCutsheetCapabilityCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityCreateOneArgs = {
  record: CreateOneCutsheetCapabilityInput;
};


export type MutationCutsheetCapabilityDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityDuplicateArgs = {
  includeAssignmentRules: Scalars['Boolean']['input'];
  includeQuestionnaires: Scalars['Boolean']['input'];
  sourceCapabilityId: Scalars['MongoID']['input'];
  targetCapabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityMigrateLegacyArgs = {
  capabilityId: Scalars['MongoID']['input'];
  deactivateUnusedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCutsheetCapabilityPrintSettingsUpdateArgs = {
  alwaysShowPrimalNotes: Scalars['Boolean']['input'];
  baseFontSize: Scalars['Float']['input'];
  checkboxStyle: Scalars['String']['input'];
  hiddenGroupIds: Array<Scalars['String']['input']>;
  hiddenItemIds: Array<Scalars['String']['input']>;
  hiddenSpecificationIds: Array<Scalars['String']['input']>;
  hideUnselectedCuts: Scalars['Boolean']['input'];
  id: Scalars['MongoID']['input'];
  orientation: Scalars['String']['input'];
  primalColumns: Scalars['Float']['input'];
  showPrimalGroup: Scalars['Boolean']['input'];
  specsLayoutPosition: Scalars['String']['input'];
};


export type MutationCutsheetCapabilitySetLegacyMapArgs = {
  id: Scalars['MongoID']['input'];
  legacyInspectionLevelMap: Array<InputMaybe<CutsheetLegacyInspectionLevelEntryInput>>;
};


export type MutationCutsheetCapabilityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityInput;
};


export type MutationCutsheetCapabilityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityInput>;
  record: UpdateOneCutsheetCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityInput>;
};


export type MutationCutsheetCapabilityUpsertArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  species: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationAddPhoneToMessagingServiceArgs = {
  input?: InputMaybe<AddPhoneToMessagingServiceInput>;
};


export type MutationAddressCreateManyArgs = {
  records: Array<CreateManyAddressInput>;
};


export type MutationAddressCreateOneArgs = {
  record: CreateOneAddressInput;
};


export type MutationAddressUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAddressInput;
};


export type MutationAddressUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyAddressInput>;
};


export type MutationAddressUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneAddressInput>;
  record: UpdateOneAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneAddressInput>;
};


export type MutationAuthCheckUserArgs = {
  identifier: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthConfirmForgotPasswordArgs = {
  code: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationAuthForgotPasswordArgs = {
  identifier: Scalars['String']['input'];
};


export type MutationAuthLoginOAuthArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationAuthLoginPasswordArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthSendOtpArgs = {
  identifier: Scalars['String']['input'];
};


export type MutationAuthSetPasswordArgs = {
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthVerifyOtpArgs = {
  identifier: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancellationReasonCreateManyArgs = {
  records: Array<CreateManyCancellationReasonInput>;
};


export type MutationCancellationReasonCreateOneArgs = {
  record: CreateOneCancellationReasonInput;
};


export type MutationCancellationReasonUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCancellationReasonInput;
};


export type MutationCancellationReasonUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCancellationReasonInput>;
};


export type MutationCancellationReasonUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCancellationReasonInput>;
  record: UpdateOneCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCancellationReasonInput>;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationChatMessageCreateManyArgs = {
  records: Array<CreateManyChatMessageInput>;
};


export type MutationChatMessageCreateOneArgs = {
  record: CreateOneChatMessageInput;
};


export type MutationChatMessageUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChatMessageInput;
};


export type MutationChatMessageUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyChatMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyChatMessageInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyChatMessageInput>;
};


export type MutationChatMessageUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneChatMessageInput>;
  record: UpdateOneChatMessageInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneChatMessageInput>;
};


export type MutationChatRoomCreateManyArgs = {
  records: Array<CreateManyChatRoomInput>;
};


export type MutationChatRoomCreateOneArgs = {
  record: CreateOneChatRoomInput;
};


export type MutationChatRoomUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChatRoomInput;
};


export type MutationChatRoomUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyChatRoomInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyChatRoomInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyChatRoomInput>;
};


export type MutationChatRoomUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneChatRoomInput>;
  record: UpdateOneChatRoomInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneChatRoomInput>;
};


export type MutationCsvImportCancelJobArgs = {
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
};


export type MutationCsvImportDeleteRecordArgs = {
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
};


export type MutationCsvImportExecuteArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportForceCancelArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportJobCreateManyArgs = {
  records: Array<CreateManyCsvImportJobInput>;
};


export type MutationCsvImportJobCreateOneArgs = {
  record: CreateOneCsvImportJobInput;
};


export type MutationCsvImportJobUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCsvImportJobInput;
};


export type MutationCsvImportJobUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCsvImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCsvImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCsvImportJobInput>;
};


export type MutationCsvImportJobUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCsvImportJobInput>;
  record: UpdateOneCsvImportJobInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCsvImportJobInput>;
};


export type MutationCsvImportRevalidateArgs = {
  data: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportSaveColumnMappingArgs = {
  columnMapping: Scalars['JSON']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationCsvImportUpdateRowsArgs = {
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
};


export type MutationCsvImportUploadArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  tenantId: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetAssignmentRuleSetCreateManyArgs = {
  records: Array<CreateManyCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetCreateOneArgs = {
  record: CreateOneCutsheetAssignmentRuleSetInput;
};


export type MutationCutsheetAssignmentRuleSetDeleteArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetAssignmentRuleSetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetAssignmentRuleSetInput;
};


export type MutationCutsheetAssignmentRuleSetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetAssignmentRuleSetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetAssignmentRuleSetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetAssignmentRuleSetInput>;
  record: UpdateOneCutsheetAssignmentRuleSetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetAssignmentRuleSetInput>;
};


export type MutationCutsheetAssignmentRuleSetUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<CutsheetAssignmentRuleInput>>>;
};


export type MutationCutsheetCapabilityGenerateBlankCutsheetArgs = {
  cutsheetCapabilityId: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityOptionCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCapabilityOptionDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCapabilityOptionUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCapabilityOptionUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCapabilityOptionUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType: Scalars['String']['input'];
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCapabilityOptionSpecificationInput>>>;
  title: Scalars['String']['input'];
};


export type MutationCutsheetCreateManyArgs = {
  records: Array<CreateManyCutsheetInput>;
};


export type MutationCutsheetCreateOneArgs = {
  record: CreateOneCutsheetInput;
};


export type MutationCutsheetCutCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCutDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetCutUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetCutUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetCutUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricing?: InputMaybe<CutsheetCutPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetCutSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetExtraCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetExtraDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetExtraUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetExtraUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetExtraUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricing?: InputMaybe<CutsheetExtraPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetExtraSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetGroupCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupCreateOneArgs = {
  record: CreateOneCutsheetCapabilityGroupInput;
};


export type MutationCutsheetGroupDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetGroupReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetGroupUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityGroupInput;
};


export type MutationCutsheetGroupUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityGroupInput>;
  record: UpdateOneCutsheetCapabilityGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityGroupInput>;
};


export type MutationCutsheetGroupUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetMarkConvertedArgs = {
  cutsheetId: Scalars['MongoID']['input'];
  responseId: Scalars['MongoID']['input'];
};


export type MutationCutsheetOptionReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetQuestionnaireCreateManyArgs = {
  records: Array<CreateManyCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireCreateOneArgs = {
  record: CreateOneCutsheetQuestionnaireInput;
};


export type MutationCutsheetQuestionnaireDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseCreateManyArgs = {
  records: Array<CreateManyCutsheetQuestionnaireResponseInput>;
};


export type MutationCutsheetQuestionnaireResponseCreateOneArgs = {
  record: CreateOneCutsheetQuestionnaireResponseInput;
};


export type MutationCutsheetQuestionnaireResponseSoftDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetQuestionnaireResponseUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetQuestionnaireResponseInput;
};


export type MutationCutsheetQuestionnaireResponseUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireResponseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetQuestionnaireResponseInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetQuestionnaireResponseInput>;
};


export type MutationCutsheetQuestionnaireResponseUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireResponseInput>;
  record: UpdateOneCutsheetQuestionnaireResponseInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetQuestionnaireResponseInput>;
};


export type MutationCutsheetQuestionnaireResponseUpsertArgs = {
  extraSelections?: InputMaybe<CutsheetResponseExtraResponseInput>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaireId: Scalars['MongoID']['input'];
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetResponseCutOptionInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>>>;
  trimSelections?: InputMaybe<CutsheetResponseTrimResponseInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationCutsheetQuestionnaireUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetQuestionnaireInput;
};


export type MutationCutsheetQuestionnaireUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetQuestionnaireInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetQuestionnaireInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetQuestionnaireInput>;
  record: UpdateOneCutsheetQuestionnaireInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetQuestionnaireInput>;
};


export type MutationCutsheetQuestionnaireUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  pricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetPricingOverrideEntryInput>>>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<CutsheetQuestionInput>>>;
  specOptionPricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingEntryInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCutsheetSoftDeleteArgs = {
  cutsheetId: Scalars['MongoID']['input'];
};


export type MutationCutsheetSpecificationCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationCreateOneArgs = {
  record: CreateOneCutsheetCapabilitySpecificationInput;
};


export type MutationCutsheetSpecificationDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetSpecificationReorderArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationCutsheetSpecificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilitySpecificationInput;
};


export type MutationCutsheetSpecificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilitySpecificationInput>;
  record: UpdateOneCutsheetCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilitySpecificationInput>;
};


export type MutationCutsheetSpecificationUpsertArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  capabilityId: Scalars['MongoID']['input'];
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetTrimCreateManyArgs = {
  records: Array<CreateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimCreateOneArgs = {
  record: CreateOneCutsheetCapabilityOptionInput;
};


export type MutationCutsheetTrimDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationCutsheetTrimUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetCapabilityOptionInput;
};


export type MutationCutsheetTrimUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetCapabilityOptionInput>;
  record: UpdateOneCutsheetCapabilityOptionInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetCapabilityOptionInput>;
};


export type MutationCutsheetTrimUpsertArgs = {
  capabilityId: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  pricing?: InputMaybe<CutsheetTrimPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetTrimSpecificationInput>>>;
  title: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationCutsheetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetInput;
};


export type MutationCutsheetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetInput>;
};


export type MutationCutsheetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetInput>;
  record: UpdateOneCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetInput>;
};


export type MutationCutsheetUpsertArgs = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasTypeInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  name: Scalars['String']['input'];
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimTypeInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationFinancialReportingConfigCreateManyArgs = {
  records: Array<CreateManyFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigCreateOneArgs = {
  record: CreateOneFinancialReportingConfigInput;
};


export type MutationFinancialReportingConfigUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFinancialReportingConfigInput;
};


export type MutationFinancialReportingConfigUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyFinancialReportingConfigInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyFinancialReportingConfigInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneFinancialReportingConfigInput>;
  record: UpdateOneFinancialReportingConfigInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneFinancialReportingConfigInput>;
};


export type MutationFinancialReportingConfigUpsertArgs = {
  record: FinancialReportingConfigUpsertInput;
};


export type MutationFixVendorPhoneConfigArgs = {
  input?: InputMaybe<FixVendorPhoneConfigInput>;
};


export type MutationGenerateInvoicePdfArgs = {
  invoiceId: Scalars['MongoID']['input'];
};


export type MutationGenerateUploadUrlArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
};


export type MutationIntegrationCreateManyArgs = {
  records: Array<CreateManyIntegrationInput>;
};


export type MutationIntegrationCreateOneArgs = {
  record: CreateOneIntegrationInput;
};


export type MutationIntegrationInitArgs = {
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIntegrationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdIntegrationInput;
};


export type MutationIntegrationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyIntegrationInput>;
};


export type MutationIntegrationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneIntegrationInput>;
  record: UpdateOneIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneIntegrationInput>;
};


export type MutationInvoiceCreateForSchedulingJobArgs = {
  input?: InputMaybe<CreateInvoiceForSchedulingJobInput>;
};


export type MutationInvoiceCreateManyArgs = {
  records: Array<CreateManyInvoiceInput>;
};


export type MutationInvoiceCreateOneArgs = {
  record: CreateOneInvoiceInput;
};


export type MutationInvoiceFinalizeAndSendArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationInvoiceLineItemCreateManyArgs = {
  records: Array<CreateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemCreateOneArgs = {
  record: CreateOneInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceLineItemInput>;
  record: UpdateOneInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceLineItemInput>;
};


export type MutationInvoiceMarkAsPaidArgs = {
  input?: InputMaybe<MarkAsPaidInput>;
};


export type MutationInvoiceRefundArgs = {
  input?: InputMaybe<RefundInvoiceInput>;
};


export type MutationInvoiceUpdateArgs = {
  input?: InputMaybe<UpdateInvoiceInput>;
};


export type MutationInvoiceUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceInput;
};


export type MutationInvoiceUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceInput>;
};


export type MutationInvoiceUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceInput>;
  record: UpdateOneInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceInput>;
};


export type MutationInvoiceVoidArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationModuleCreateManyArgs = {
  records: Array<CreateManyVendorModuleInput>;
};


export type MutationModuleCreateOneArgs = {
  record: CreateOneVendorModuleInput;
};


export type MutationModuleUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorModuleInput;
};


export type MutationModuleUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorModuleInput>;
};


export type MutationModuleUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorModuleInput>;
  record: UpdateOneVendorModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorModuleInput>;
};


export type MutationNoteCreateManyArgs = {
  records: Array<CreateManyNoteInput>;
};


export type MutationNoteCreateOneArgs = {
  record: CreateOneNoteInput;
};


export type MutationNoteDeleteArgs = {
  noteId: Scalars['MongoID']['input'];
};


export type MutationNoteUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
};


export type MutationNoteUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNoteInput>;
};


export type MutationNoteUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNoteInput>;
  record: UpdateOneNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNoteInput>;
};


export type MutationNoteUpsertArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  note: Scalars['String']['input'];
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  removeAttachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<EnumNoteType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationNotificationCreateManyArgs = {
  records: Array<CreateManyNotificationInput>;
};


export type MutationNotificationCreateOneArgs = {
  record: CreateOneNotificationInput;
};


export type MutationNotificationSettingsCreateManyArgs = {
  records: Array<CreateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsCreateOneArgs = {
  record: CreateOneNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
};


export type MutationNotificationSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNotificationSettingInput>;
  record: UpdateOneNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationSettingInput>;
};


export type MutationNotificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNotificationInput;
};


export type MutationNotificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNotificationInput>;
};


export type MutationNotificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNotificationInput>;
  record: UpdateOneNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationInput>;
};


export type MutationParseCutsheetArgs = {
  capabilityId: Scalars['MongoID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationPrimalCreateManyArgs = {
  records: Array<CreateManyPrimalInput>;
};


export type MutationPrimalCreateOneArgs = {
  record: CreateOnePrimalInput;
};


export type MutationPrimalCutBlockerCreateManyArgs = {
  records: Array<CreateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerCreateOneArgs = {
  record: CreateOnePrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutBlockerInput>;
  record: UpdateOnePrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpsertArgs = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<BlockedByInput>>>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutCreateManyArgs = {
  records: Array<CreateManyPrimalCutInput>;
};


export type MutationPrimalCutCreateOneArgs = {
  record: CreateOnePrimalCutInput;
};


export type MutationPrimalCutSoftDeleteArgs = {
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutTypeCreateManyArgs = {
  records: Array<CreateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeCreateOneArgs = {
  record: CreateOnePrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutTypeInput>;
  record: UpdateOnePrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutTypeInput>;
};


export type MutationPrimalCutUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
};


export type MutationPrimalCutUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutInput>;
};


export type MutationPrimalCutUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutInput>;
  record: UpdateOnePrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutInput>;
};


export type MutationPrimalGroupCreateManyArgs = {
  records: Array<CreateManyPrimalGroupInput>;
};


export type MutationPrimalGroupCreateOneArgs = {
  record: CreateOnePrimalGroupInput;
};


export type MutationPrimalGroupUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalGroupInput;
};


export type MutationPrimalGroupUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalGroupInput>;
};


export type MutationPrimalGroupUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalGroupInput>;
  record: UpdateOnePrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalGroupInput>;
};


export type MutationPrimalUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
};


export type MutationPrimalUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalInput>;
};


export type MutationPrimalUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalInput>;
  record: UpdateOnePrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalInput>;
};


export type MutationProcessingJobForceUpdateStatusArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  processorSchedulingStatus: Scalars['String']['input'];
};


export type MutationProcessingPartnersCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessorCapabilityCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityCreateOneArgs = {
  record: CreateOneProcessorCapabilityInput;
};


export type MutationProcessorCapabilitySpecificationCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationCreateOneArgs = {
  record: CreateOneProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationInput>;
  record: UpdateOneProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilityInput;
};


export type MutationProcessorCapabilityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilityInput>;
  record: UpdateOneProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpsertArgs = {
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasModelInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImage?: InputMaybe<Scalars['Upload']['input']>;
  extrasImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  primalCuts: Array<Scalars['MongoID']['input']>;
  primalGroups?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalGroupInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimModelInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImage?: InputMaybe<Scalars['Upload']['input']>;
  trimImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessorExportCsvArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  type: ProcessorExportTypeEnum;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorExportCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorNotificationCreateManyArgs = {
  records: Array<CreateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationCreateOneArgs = {
  record: CreateOneProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorNotificationInput>;
  record: UpdateOneProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorNotificationInput>;
};


export type MutationProcessorSchedulingAnimalHeadBulkUpdateArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>>>;
};


export type MutationProcessorSchedulingAnimalHeadDeleteArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingAnimalHeadPartialUpdateByIdArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateAnimalHeadInput>;
};


export type MutationProcessorSchedulingBuyerCutsheetReminderArgs = {
  contactUserId: Scalars['MongoID']['input'];
  schedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingCreateArgs = {
  newSchedule?: InputMaybe<CreateProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateManyArgs = {
  records: Array<CreateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateOneArgs = {
  record: CreateOneProcessorSchedulingInput;
};


export type MutationProcessorSchedulingCutsheetReminderArgs = {
  schedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingDragAndDropUpdateArgs = {
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventDate: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateBillingStatementArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateCarcassTagsArgs = {
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateCutsheetRequestArgs = {
  cutsheetRequestId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateHangingWeightCsvArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateKillSheetArgs = {
  date: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGeneratePackingSlipArgs = {
  cutsheetInformationId?: InputMaybe<Scalars['MongoID']['input']>;
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingNotificationSendArgs = {
  request?: InputMaybe<NotificationRequestInput>;
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
};


export type MutationProcessorSchedulingPartialUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateInput>;
};


export type MutationProcessorSchedulingSplitTypeUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingSplitTypeUpdateInput>;
};


export type MutationProcessorSchedulingUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateCutsheetsArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<Array<InputMaybe<CutsheetPartialUpdateInput>>>;
};


export type MutationProcessorSchedulingUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSchedulingInput>;
  record: UpdateOneProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSchedulingInput>;
};


export type MutationProcessorSettingsCreateArgs = {
  newProcessor?: InputMaybe<CreateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessorSettingsCustomCapacityCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityCreateOneArgs = {
  record: CreateOneProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityInput>;
  record: UpdateOneProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateArgs = {
  updateProcessor?: InputMaybe<UpdateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessorSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProvisionPhoneNumberArgs = {
  input?: InputMaybe<ProvisionPhoneNumberInput>;
};


export type MutationRefreshHostedNumberStatusArgs = {
  input?: InputMaybe<RefreshHostedNumberStatusInput>;
};


export type MutationReleasePhoneNumberArgs = {
  input?: InputMaybe<ReleasePhoneNumberInput>;
};


export type MutationSendMessageArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  chatRoomId: Scalars['MongoID']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  message: Scalars['String']['input'];
};


export type MutationSendTestNotificationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  notificationSettingId: Scalars['MongoID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  smsContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStateCreateManyArgs = {
  records: Array<CreateManyStateInput>;
};


export type MutationStateCreateOneArgs = {
  record: CreateOneStateInput;
};


export type MutationStateUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdStateInput;
};


export type MutationStateUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyStateInput>;
};


export type MutationStateUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneStateInput>;
  record: UpdateOneStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneStateInput>;
};


export type MutationStripeAccountCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationStripeSessionCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationSubmitHostedLandlineOrderArgs = {
  input?: InputMaybe<SubmitHostedLandlineOrderInput>;
};


export type MutationSyncConversationPhoneNumbersArgs = {
  input?: InputMaybe<SyncConversationPhoneNumbersInput>;
};


export type MutationTenantCreateArgs = {
  newTenant: CreateOneTenantInput;
};


export type MutationTenantCreateManyArgs = {
  records: Array<CreateManyTenantInput>;
};


export type MutationTenantCreateOneArgs = {
  record: CreateOneTenantInput;
};


export type MutationTenantEnabledEditArgs = {
  enabled: Scalars['Boolean']['input'];
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantPictureUrlEditArgs = {
  pictureImage?: InputMaybe<Scalars['Upload']['input']>;
  pictureImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantSubscriptionEditArgs = {
  subscription: Scalars['String']['input'];
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTenantInput;
};


export type MutationTenantUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyTenantInput>;
};


export type MutationTenantUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneTenantInput>;
  record: UpdateOneTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneTenantInput>;
};


export type MutationUpdateAuthMethodArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  targetAuthMethod: Scalars['String']['input'];
};


export type MutationUpdatePhoneNumberSmsWebhookArgs = {
  input?: InputMaybe<UpdatePhoneNumberSmsWebhookInput>;
};


export type MutationUpdateProfileArgs = {
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressInputForProfile>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveSms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserActivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserBasicUpsertArgs = {
  address?: InputMaybe<AddressInputForUser>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<RelationshipsInputForUser>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationUserCreateArgs = {
  newUser: CreateOneUserInput;
};


export type MutationUserCreateManyArgs = {
  records: Array<CreateManyUserInput>;
};


export type MutationUserCreateOneArgs = {
  record: CreateOneUserInput;
};


export type MutationUserDeactivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserSettingsUpdateArgs = {
  settings: UserSettingsInput;
  userId: Scalars['MongoID']['input'];
};


export type MutationUserUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};


export type MutationUserUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyUserInput>;
};


export type MutationUserUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneUserInput>;
  record: UpdateOneUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneUserInput>;
};


export type MutationVendorCreateArgs = {
  newVendor: CreateOneVendorInput;
};


export type MutationVendorCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationVendorCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationVendorModuleUpsertArgs = {
  active: Scalars['Boolean']['input'];
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationVendorUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationVendorUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationVendorUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};


export type MutationWaitlistAddArgs = {
  animal: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationWaitlistCreateManyArgs = {
  records: Array<CreateManyWaitlistInput>;
};


export type MutationWaitlistCreateOneArgs = {
  record: CreateOneWaitlistInput;
};


export type MutationWaitlistDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWaitlistUnsubscribeArgs = {
  token: Scalars['String']['input'];
};


export type MutationWaitlistUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWaitlistInput;
};


export type MutationWaitlistUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyWaitlistInput>;
};


export type MutationWaitlistUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneWaitlistInput>;
  record: UpdateOneWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneWaitlistInput>;
};


export type MutationWebhookCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationWebhookCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationWebhookUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationWebhookUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationWebhookUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['MongoID']['output'];
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<NoteAttachments>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  processorScheduling?: Maybe<Scalars['MongoID']['output']>;
  type: EnumNoteType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
};

export type NoteAttachments = {
  __typename?: 'NoteAttachments';
  _id?: Maybe<Scalars['MongoID']['output']>;
  filename: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type NoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** List of items with pagination. */
export type NotePagination = {
  __typename?: 'NotePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Note>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['MongoID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Array<Maybe<EnumNotificationChannel>>>;
  chatRoomId?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailTo?: Maybe<Scalars['String']['output']>;
  error?: Maybe<NotificationError>;
  errorMessage?: Maybe<NotificationErrorMessage>;
  groupId?: Maybe<Scalars['String']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['MongoID']['output']>;
  notificationType?: Maybe<EnumNotificationNotificationType>;
  sentOn?: Maybe<Scalars['Date']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  smsTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NotificationStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['MongoID']['output']>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type NotificationError = {
  __typename?: 'NotificationError';
  email?: Maybe<NotificationErrorMessage>;
  sms?: Maybe<NotificationErrorMessage>;
};

export type NotificationErrorInput = {
  email?: InputMaybe<NotificationErrorMessageInput>;
  sms?: InputMaybe<NotificationErrorMessageInput>;
};

export type NotificationErrorMessage = {
  __typename?: 'NotificationErrorMessage';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type NotificationPagination = {
  __typename?: 'NotificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationRequestInput = {
  contactUserId: Scalars['MongoID']['input'];
  scheduledJobId: Scalars['MongoID']['input'];
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  emailMessage?: Maybe<NotificationTemplate>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSMS?: Maybe<Scalars['Boolean']['output']>;
  smsMessage?: Maybe<NotificationTemplate>;
  timings?: Maybe<Array<Maybe<NotificationSettingTimings>>>;
  trigger: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type NotificationSettingPagination = {
  __typename?: 'NotificationSettingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<NotificationSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationSettingTimings = {
  __typename?: 'NotificationSettingTimings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  days: Scalars['Float']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingsInput = {
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<NotificationMessageInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<NotificationMessageInput>;
  timings?: InputMaybe<Array<InputMaybe<NotificationTimingInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationStatus = {
  __typename?: 'NotificationStatus';
  email?: Maybe<EnumNotificationStatusEmail>;
  sms?: Maybe<EnumNotificationStatusSms>;
};

export type NotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  _id: Scalars['MongoID']['output'];
  channel: EnumNotificationTemplateChannel;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  type: EnumNotificationTemplateType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NotificationTimingInput = {
  days: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  relation: Scalars['String']['input'];
};

export type OverheadCostInput = {
  amount: Scalars['Float']['input'];
  frequency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type ParentProduct = {
  __typename?: 'ParentProduct';
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Scalars['MongoID']['output']>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumParentProductStock_Status>;
  type?: Maybe<EnumParentProductType>;
  vendor: Scalars['MongoID']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParseCutsheetPayload = {
  __typename?: 'ParseCutsheetPayload';
  catalog: ParsedCutsheetCatalog;
  questionnaire: ParsedCutsheetQuestionnaire;
};

export type ParsedCutsheetCatalog = {
  __typename?: 'ParsedCutsheetCatalog';
  animalType: Scalars['String']['output'];
  cuts: Array<ParsedCutsheetCut>;
  description?: Maybe<Scalars['String']['output']>;
  extras: Array<ParsedCutsheetExtra>;
  name: Scalars['String']['output'];
  primals: Array<ParsedCutsheetGroup>;
  specifications: Array<ParsedCutsheetSpecification>;
  trim: Array<ParsedCutsheetTrim>;
};

export type ParsedCutsheetCut = {
  __typename?: 'ParsedCutsheetCut';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  priceFeePerPound?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetExtra = {
  __typename?: 'ParsedCutsheetExtra';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetGroup = {
  __typename?: 'ParsedCutsheetGroup';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetQuestion = {
  __typename?: 'ParsedCutsheetQuestion';
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  availableCutIds?: Maybe<Array<Scalars['String']['output']>>;
  availableTrimIds?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  requireExactTotal?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Int']['output'];
  specificationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ParsedCutsheetQuestionnaire = {
  __typename?: 'ParsedCutsheetQuestionnaire';
  animalType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questions: Array<ParsedCutsheetQuestion>;
};

export type ParsedCutsheetSpecification = {
  __typename?: 'ParsedCutsheetSpecification';
  cutName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type ParsedCutsheetTrim = {
  __typename?: 'ParsedCutsheetTrim';
  description?: Maybe<Scalars['String']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  priceFee?: Maybe<Scalars['Float']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type Primal = {
  __typename?: 'Primal';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts: Array<PrimalCut>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<PrimalGroup>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};

export type PrimalCut = {
  __typename?: 'PrimalCut';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutType?: Maybe<PrimalCutType>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primal?: Maybe<Primal>;
  type?: Maybe<EnumPrimalCutType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrimalCutBlocker = {
  __typename?: 'PrimalCutBlocker';
  _id: Scalars['MongoID']['output'];
  animalSpecies: Scalars['String']['output'];
  blockedBy?: Maybe<Array<Maybe<PrimalCutBlockerBlockedBy>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  inspectionLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedBy = {
  __typename?: 'PrimalCutBlockerBlockedBy';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

/** List of items with pagination. */
export type PrimalCutBlockerPagination = {
  __typename?: 'PrimalCutBlockerPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutBlocker>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalCutPagination = {
  __typename?: 'PrimalCutPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCut>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalCutType = {
  __typename?: 'PrimalCutType';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lid?: Maybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['output'];
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type PrimalCutTypePagination = {
  __typename?: 'PrimalCutTypePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutType>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalGroup = {
  __typename?: 'PrimalGroup';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primals?: Maybe<Array<Maybe<Primal>>>;
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type PrimalGroupPagination = {
  __typename?: 'PrimalGroupPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalPagination = {
  __typename?: 'PrimalPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Primal>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessingPartnerTenant = {
  __typename?: 'ProcessingPartnerTenant';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type ProcessingPartnerVendor = {
  __typename?: 'ProcessingPartnerVendor';
  _id?: Maybe<Scalars['MongoID']['output']>;
  address?: Maybe<Address>;
  shop_name?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<ProcessingPartnerTenant>;
};

export type ProcessingPartners = {
  __typename?: 'ProcessingPartners';
  _id?: Maybe<Scalars['MongoID']['output']>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type ProcessorCapability = {
  __typename?: 'ProcessorCapability';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  canSelectMoreThanOneTrim?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts?: Maybe<Array<Maybe<PrimalCut>>>;
  extras?: Maybe<Array<Maybe<ProcessorCapabilityExtras>>>;
  extrasDescription?: Maybe<Scalars['String']['output']>;
  extrasImageUrl?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  primalCuts?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  primalGroups?: Maybe<Array<Maybe<PrimalGroup>>>;
  specificationSnapshots: Array<ProcessorCapabilitySpecification>;
  trim?: Maybe<Array<Maybe<ProcessorCapabilityTrim>>>;
  trimDescription?: Maybe<Scalars['String']['output']>;
  trimImageUrl?: Maybe<Scalars['String']['output']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
  wizardWelcomeContent?: Maybe<Scalars['String']['output']>;
  wizardWelcomeTitle?: Maybe<Scalars['String']['output']>;
};


export type ProcessorCapabilitySpecificationSnapshotsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};

export type ProcessorCapabilityExtras = {
  __typename?: 'ProcessorCapabilityExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

/** List of items with pagination. */
export type ProcessorCapabilityPagination = {
  __typename?: 'ProcessorCapabilityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapability>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilityPrimalCutInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutType?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorCapabilityPrimalGroupInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  primals?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ProcessorCapabilityPrimalInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cuts?: InputMaybe<Array<InputMaybe<ProcessorCapabilityPrimalCutInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorCapabilitySpecification = {
  __typename?: 'ProcessorCapabilitySpecification';
  _id: Scalars['MongoID']['output'];
  capability?: Maybe<ProcessorCapability>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  specifications?: Maybe<Array<Maybe<ProcessorCapabilitySpecificationSpecifications>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorCapabilitySpecificationPagination = {
  __typename?: 'ProcessorCapabilitySpecificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapabilitySpecification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilitySpecificationSpecifications = {
  __typename?: 'ProcessorCapabilitySpecificationSpecifications';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  measurementUnit?: Maybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name: Scalars['String']['output'];
  options: Array<Maybe<ProcessorCapabilitySpecificationSpecificationsOptions>>;
};

export type ProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  measurementUnit: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit;
  name: Scalars['String']['input'];
  options: Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsOptionsInput>>;
};

export type ProcessorCapabilitySpecificationSpecificationsOptions = {
  __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ProcessorCapabilityTrim = {
  __typename?: 'ProcessorCapabilityTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound: Scalars['Float']['output'];
};

export type ProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorCapabilityTrimModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorExportCsvResponse = {
  __typename?: 'ProcessorExportCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum ProcessorExportTypeEnum {
  /** Export invoice data */
  Invoice = 'invoice',
  /** Export job data */
  Job = 'job',
  /** Export splits data */
  Splits = 'splits',
  /** Export splits data with cutsheet */
  SplitsCutsheet = 'splits_cutsheet',
  /** Export user data */
  User = 'user'
}

export type ProcessorNotification = {
  __typename?: 'ProcessorNotification';
  _id: Scalars['MongoID']['output'];
  errorMessage?: Maybe<Scalars['JSON']['output']>;
  notificationType: Scalars['String']['output'];
  sentOn: Scalars['Date']['output'];
  sentTo: Scalars['String']['output'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type ProcessorNotificationPagination = {
  __typename?: 'ProcessorNotificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorScheduling = {
  __typename?: 'ProcessorScheduling';
  _id: Scalars['MongoID']['output'];
  additionalPickupDetails?: Maybe<Scalars['String']['output']>;
  animalHeads?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeads>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: Maybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: Maybe<Scalars['Float']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  cancellationCustomText?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['MongoID']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutsheetInformation?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsCutsheetInformation>>>;
  deposit?: Maybe<ProcessorSchedulingDeposit>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dropoffDateStr?: Maybe<Scalars['String']['output']>;
  /** Return Kill Date from the first animal head */
  firstKillDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the processor vendor has the Cutsheet Needed notification enabled */
  hasCutsheetNeededNotification?: Maybe<Scalars['Boolean']['output']>;
  headCount: Scalars['Float']['output'];
  invoice?: Maybe<ProcessorSchedulingInvoice>;
  invoices?: Maybe<ProcessorSchedulingInvoices>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isOnBehalfOf?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['String']['output'];
  killedDate?: Maybe<Scalars['Date']['output']>;
  linkedInvoices?: Maybe<Array<Maybe<Invoice>>>;
  notificationHistory: Array<Notification>;
  processorCapabilities: Array<ProcessorCapability>;
  processorSettings?: Maybe<ProcessorSettings>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  requestedBy?: Maybe<User>;
  scheduledDate?: Maybe<Scalars['Date']['output']>;
  source?: Maybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusChanges?: Maybe<Array<Maybe<ProcessorSchedulingStatusChanges>>>;
  statusLastUpdated?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
  vendorCutsheets: Array<Cutsheet>;
};


export type ProcessorSchedulingNotificationHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};


export type ProcessorSchedulingProcessorCapabilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type ProcessorSchedulingVendorCutsheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};

export type ProcessorSchedulingAnimalHeads = {
  __typename?: 'ProcessorSchedulingAnimalHeads';
  _id?: Maybe<Scalars['MongoID']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  cutDateStr?: Maybe<Scalars['String']['output']>;
  cutsheetInformation?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsCutsheetInformation>>>;
  dateFirstEnteredHangingWeight?: Maybe<Scalars['Date']['output']>;
  dateUpdatedHangingWeight?: Maybe<Scalars['Date']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: Maybe<ProcessorSchedulingAnimalHeadsInvoice>;
  invoice_line_item?: Maybe<Scalars['MongoID']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isKillAndChill?: Maybe<Scalars['Boolean']['output']>;
  isOverThirtyMonths?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  killDateStr?: Maybe<Scalars['String']['output']>;
  liveWeight?: Maybe<Scalars['Float']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  questionnaire?: Maybe<Scalars['MongoID']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  splitType?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  /** The ratio of carcass weight to live weight, expressed as a percentage. */
  yield?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformation = {
  __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation';
  _id?: Maybe<Scalars['MongoID']['output']>;
  contactUser?: Maybe<User>;
  cutsheet?: Maybe<Cutsheet>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  questionnaire?: Maybe<Scalars['MongoID']['output']>;
  questionnaireResponse?: Maybe<CutsheetQuestionnaireResponse>;
  splitPart?: Maybe<Scalars['String']['output']>;
  yield?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYield>>>;
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformationYield = {
  __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformationYield';
  _id?: Maybe<Scalars['MongoID']['output']>;
  capabilityOptionId?: Maybe<Scalars['String']['output']>;
  itemCount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  packageCount: Scalars['Float']['output'];
  packageIdentifier?: Maybe<Scalars['String']['output']>;
  weightLbs: Scalars['Float']['output'];
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
  packageCount: Scalars['Float']['input'];
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs: Scalars['Float']['input'];
};

export type ProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId: Scalars['String']['input'];
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoice = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoice';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges>>>;
  additionalCost?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceTrims>>>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceExtras = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceTrims = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingDeposit = {
  __typename?: 'ProcessorSchedulingDeposit';
  amount?: Maybe<Scalars['Float']['output']>;
  checkoutSession?: Maybe<ProcessorSchedulingDepositCheckoutSession>;
  price_external_id?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingDepositCheckoutSession = {
  __typename?: 'ProcessorSchedulingDepositCheckoutSession';
  customer_id?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<ProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingForceUpdateStatusResponse = {
  __typename?: 'ProcessorSchedulingForceUpdateStatusResponse';
  newStatus?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingInvoice = {
  __typename?: 'ProcessorSchedulingInvoice';
  additionalCost?: Maybe<ProcessorSchedulingInvoiceAdditionalCost>;
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  sendInvoicePDF?: Maybe<Scalars['Boolean']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<ProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSchedulingInvoices = {
  __typename?: 'ProcessorSchedulingInvoices';
  _id?: Maybe<Scalars['MongoID']['output']>;
  contacts?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContacts>>>;
  pricing?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesPricing>>>;
};

export type ProcessorSchedulingInvoicesContacts = {
  __typename?: 'ProcessorSchedulingInvoicesContacts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
  splits?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplits>>>;
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplits = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplits';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges>>>;
  animalHeadPublicId?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeights>;
  splitType?: Maybe<Scalars['String']['output']>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsTrims>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtras = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeights = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrims = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesPricingInput>>>;
};

export type ProcessorSchedulingInvoicesPricing = {
  __typename?: 'ProcessorSchedulingInvoicesPricing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type ProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

/** List of items with pagination. */
export type ProcessorSchedulingPagination = {
  __typename?: 'ProcessorSchedulingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorScheduling>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSchedulingPartialUpdateAnimalHeadInput = {
  cutDate?: InputMaybe<Scalars['String']['input']>;
  cutsheetInformation?: InputMaybe<CutsheetInformationPartialUpdateInput>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateInput = {
  addAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  dropoffDate?: InputMaybe<Scalars['String']['input']>;
  markInvoicePaid?: InputMaybe<Scalars['Boolean']['input']>;
  requestedBy?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSchedulingPartialUpdateRequestedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateResponse = {
  __typename?: 'ProcessorSchedulingPartialUpdateResponse';
  error?: Maybe<ErrorInterface>;
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
  warnings?: Maybe<Array<Maybe<ProcessorSchedulingPartialUpdateWarning>>>;
};

export type ProcessorSchedulingPartialUpdateWarning = {
  __typename?: 'ProcessorSchedulingPartialUpdateWarning';
  message?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingSplitTypeUpdateInput = {
  animalHeadId: Scalars['MongoID']['input'];
  cutsheetInformation?: InputMaybe<Array<InputMaybe<CutsheetInformationInput>>>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingSplitTypeUpdateResponse = {
  __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse';
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingStatusChanges = {
  __typename?: 'ProcessorSchedulingStatusChanges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  date: Scalars['Date']['output'];
  newStatus: EnumProcessorSchedulingStatusChangesNewStatus;
  previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus;
};

export type ProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date: Scalars['Date']['input'];
  newStatus: EnumProcessorSchedulingStatusChangesNewStatus;
  previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus;
};

export type ProcessorSettings = {
  __typename?: 'ProcessorSettings';
  _id: Scalars['MongoID']['output'];
  about?: Maybe<Scalars['String']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  animals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: Maybe<Array<Maybe<ProcessorSettingsAutoSchedulingSettings>>>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  capacityConfigurationType?: Maybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  carcassSettings?: Maybe<Array<Maybe<ProcessorSettingsCarcassSettings>>>;
  commercialStartDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customCapacities: Array<ProcessorSettingsCustomCapacity>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  documentSettings?: Maybe<ProcessorSettingsDocumentSettings>;
  enabledAnimalSplits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The enabled animals are ones that don't currently have validation errors associated to them. */
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  faq?: Maybe<Scalars['String']['output']>;
  invoicing?: Maybe<ProcessorSettingsInvoicing>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProcessorNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  outsideWindowNote?: Maybe<Scalars['String']['output']>;
  processorNotificationEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  schedulingDeposit: Scalars['Float']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  timeTrackingConfig?: Maybe<ProcessorSettingsTimeTrackingConfig>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validationErrors?: Maybe<Array<Maybe<ProcessorSettingsValidationErrors>>>;
  vendor?: Maybe<Vendor>;
};


export type ProcessorSettingsCustomCapacitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorSettingsAnimalSettings = {
  __typename?: 'ProcessorSettingsAnimalSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  inspectionLevels?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['output'];
  maxSchedulingDays?: Maybe<Scalars['Float']['output']>;
  minSchedulingDays?: Maybe<Scalars['Float']['output']>;
  showOutsideWindowDates?: Maybe<Scalars['Boolean']['output']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightedAnimalUnit?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricing = {
  __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing';
  animal?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  species?: Maybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSettingsAnimalSettingsPricingInput = {
  inspectionLevel: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type ProcessorSettingsAutoCarcassNumberSettingsInput = {
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: EnumProcessorSettingsAnimalSettingsInspectionLevels;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingInput = {
  cutDateDays: Scalars['Int']['input'];
  harvestDateDays: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettings = {
  __typename?: 'ProcessorSettingsAutoSchedulingSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  cutDateDays: Scalars['Float']['output'];
  harvestDateDays: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays: Scalars['Float']['input'];
  harvestDateDays: Scalars['Float']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export enum ProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export type ProcessorSettingsCapacitySettings = {
  __typename?: 'ProcessorSettingsCapacitySettings';
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  dayOfWeek: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type ProcessorSettingsCapacitySettingsDailyCapacityBlockInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value: Scalars['Float']['input'];
};

export type ProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  dayOfWeek: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type ProcessorSettingsCarcassSettings = {
  __typename?: 'ProcessorSettingsCarcassSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  currentNumber: Scalars['Float']['output'];
  inspectionLevel: Scalars['String']['output'];
  lastTakenNumber: Scalars['Float']['output'];
  species: Scalars['String']['output'];
  year: Scalars['Float']['output'];
};

export type ProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: Scalars['String']['input'];
  lastTakenNumber: Scalars['Float']['input'];
  species: Scalars['String']['input'];
  year: Scalars['Float']['input'];
};

export type ProcessorSettingsCustomCapacity = {
  __typename?: 'ProcessorSettingsCustomCapacity';
  _id: Scalars['MongoID']['output'];
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['output'];
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dateStr?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  processorSettings?: Maybe<ProcessorSettings>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorSettingsCustomCapacityPagination = {
  __typename?: 'ProcessorSettingsCustomCapacityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsDocumentSettings = {
  __typename?: 'ProcessorSettingsDocumentSettings';
  carcassTag?: Maybe<ProcessorSettingsDocumentSettingsCarcassTag>;
  cutsheet?: Maybe<ProcessorSettingsDocumentSettingsCutsheet>;
};

export type ProcessorSettingsDocumentSettingsCarcassTag = {
  __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag';
  title?: Maybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCutsheet = {
  __typename?: 'ProcessorSettingsDocumentSettingsCutsheet';
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsCutsheetInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<ProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type ProcessorSettingsInvoicing = {
  __typename?: 'ProcessorSettingsInvoicing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  defaultSplitRule?: Maybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  trackYields?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSettingsKillAndChillInput = {
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettings = {
  __typename?: 'ProcessorSettingsKillAndChillSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  pricePerHead: Scalars['Float']['output'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

/** List of items with pagination. */
export type ProcessorSettingsPagination = {
  __typename?: 'ProcessorSettingsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsTimeTrackingConfig = {
  __typename?: 'ProcessorSettingsTimeTrackingConfig';
  baseDigitalSavings: Scalars['Float']['output'];
  hourlyRate: Scalars['Float']['output'];
  timePerBooking: Scalars['Float']['output'];
  timePerCutsheet: Scalars['Float']['output'];
  timePerNotification: Scalars['Float']['output'];
};

export type ProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
};

export type ProcessorSettingsValidationErrors = {
  __typename?: 'ProcessorSettingsValidationErrors';
  group?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  property?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  children?: Maybe<Array<Maybe<ParentProduct>>>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Integration>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ParentProduct>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumProductStock_Status>;
  type?: Maybe<EnumProductType>;
  vendor?: Maybe<Vendor>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProvisionPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type ProvisionPhoneNumberResponse = {
  __typename?: 'ProvisionPhoneNumberResponse';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  CutsheetCapabilityById?: Maybe<CutsheetCapability>;
  CutsheetCapabilityByIds: Array<CutsheetCapability>;
  /** Retrieve cutsheet capabilities for a vendor and animal type */
  CutsheetCapabilityByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapability>>>;
  CutsheetCapabilityCount?: Maybe<Scalars['Int']['output']>;
  CutsheetCapabilityMany: Array<CutsheetCapability>;
  CutsheetCapabilityOne?: Maybe<CutsheetCapability>;
  CutsheetCapabilityPagination?: Maybe<CutsheetCapabilityPagination>;
  /** Load legacy ProcessorCapability data for a capability, organized by inspection level */
  CutsheetLegacyCapabilityData: Array<Maybe<LegacyCapabilityData>>;
  /** Retrieve a list of all active vendors. */
  activeVendorList?: Maybe<Array<Maybe<Vendor>>>;
  addressById?: Maybe<Address>;
  addressByIds: Array<Address>;
  addressCount?: Maybe<Scalars['Int']['output']>;
  addressMany: Array<Address>;
  addressOne?: Maybe<Address>;
  addressPagination?: Maybe<AddressPagination>;
  /** Admin-only user search with filters */
  adminUserSearch: Array<User>;
  /** Analyze historical processing data and suggest optimal animal configurations based on configurable time range. */
  analyzeAnimalConfigurations: Scalars['JSON']['output'];
  /** Analyze historical processing data for seasonality patterns and suggest monthly modifiers based on configurable time range. */
  analyzeSeasonality: Scalars['JSON']['output'];
  /** Calculate available processor capacity for a given date range */
  calculateProcessorCapacity?: Maybe<CapacityCalculationResult>;
  /** Calculate available processor capacity for all enabled animal species */
  calculateProcessorCapacityAllSpecies?: Maybe<CapacityCalculationAllSpeciesResult>;
  cancellationReasonById?: Maybe<CancellationReason>;
  cancellationReasonByIds: Array<CancellationReason>;
  cancellationReasonCount?: Maybe<Scalars['Int']['output']>;
  cancellationReasonMany: Array<CancellationReason>;
  cancellationReasonOne?: Maybe<CancellationReason>;
  cancellationReasonPagination?: Maybe<CancellationReasonPagination>;
  chatMessageById?: Maybe<ChatMessage>;
  chatMessageByIds: Array<ChatMessage>;
  chatMessageCount?: Maybe<Scalars['Int']['output']>;
  chatMessageMany: Array<ChatMessage>;
  chatMessageOne?: Maybe<ChatMessage>;
  chatMessagePagination?: Maybe<ChatMessagePagination>;
  chatRoomById?: Maybe<ChatRoom>;
  chatRoomByIds: Array<ChatRoom>;
  chatRoomCount?: Maybe<Scalars['Int']['output']>;
  chatRoomMany: Array<ChatRoom>;
  chatRoomOne?: Maybe<ChatRoom>;
  chatRoomPagination?: Maybe<ChatRoomPagination>;
  csvImportJobById?: Maybe<CsvImportJob>;
  csvImportJobByIds: Array<CsvImportJob>;
  csvImportJobCount?: Maybe<Scalars['Int']['output']>;
  csvImportJobMany: Array<CsvImportJob>;
  csvImportJobOne?: Maybe<CsvImportJob>;
  csvImportJobPagination?: Maybe<CsvImportJobPagination>;
  /** Get the status of a CSV import job (for polling) */
  csvImportJobStatus?: Maybe<CsvImportJobStatus>;
  /** List CSV import jobs for a tenant/vendor */
  csvImportJobs?: Maybe<CsvImportJobsPayload>;
  /** Retrieve the ordered assignment rule set for a cutsheet capability */
  cutsheetAssignmentRuleSetByCapabilityId?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetById?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetByIds: Array<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetCount?: Maybe<Scalars['Int']['output']>;
  cutsheetAssignmentRuleSetMany: Array<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetOne?: Maybe<CutsheetAssignmentRuleSet>;
  cutsheetAssignmentRuleSetPagination?: Maybe<CutsheetAssignmentRuleSetPagination>;
  cutsheetById?: Maybe<Cutsheet>;
  cutsheetByIds: Array<Cutsheet>;
  cutsheetCapabilityOptionById?: Maybe<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionByIds: Array<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCapabilityOptionMany: Array<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetCapabilityOptionPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve capability options (cuts) for a specific group */
  cutsheetCapabilityOptionsByGroupId?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  /** Retrieve capability options for a capability */
  cutsheetCapabilityOptionsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCutById?: Maybe<CutsheetCapabilityOption>;
  cutsheetCutByIds: Array<CutsheetCapabilityOption>;
  cutsheetCutCount?: Maybe<Scalars['Int']['output']>;
  cutsheetCutMany: Array<CutsheetCapabilityOption>;
  cutsheetCutOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetCutPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve cuts for a specific primal */
  cutsheetCutsByGroupId?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  /** Retrieve cuts for a capability */
  cutsheetCutsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetExtraById?: Maybe<CutsheetCapabilityOption>;
  cutsheetExtraByIds: Array<CutsheetCapabilityOption>;
  cutsheetExtraCount?: Maybe<Scalars['Int']['output']>;
  cutsheetExtraMany: Array<CutsheetCapabilityOption>;
  cutsheetExtraOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetExtraPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  /** Retrieve extras for a capability */
  cutsheetExtrasByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetGroupById?: Maybe<CutsheetCapabilityGroup>;
  cutsheetGroupByIds: Array<CutsheetCapabilityGroup>;
  cutsheetGroupCount?: Maybe<Scalars['Int']['output']>;
  cutsheetGroupMany: Array<CutsheetCapabilityGroup>;
  cutsheetGroupOne?: Maybe<CutsheetCapabilityGroup>;
  cutsheetGroupPagination?: Maybe<CutsheetCapabilityGroupPagination>;
  /** Retrieve cutsheetGroupsByVendorAndAnimal for a capability */
  cutsheetGroupsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityGroup>>>;
  cutsheetMany: Array<Cutsheet>;
  cutsheetOne?: Maybe<Cutsheet>;
  cutsheetPagination?: Maybe<CutsheetPagination>;
  cutsheetQuestionnaireById?: Maybe<CutsheetQuestionnaire>;
  cutsheetQuestionnaireByIds: Array<CutsheetQuestionnaire>;
  cutsheetQuestionnaireCount?: Maybe<Scalars['Int']['output']>;
  cutsheetQuestionnaireMany: Array<CutsheetQuestionnaire>;
  cutsheetQuestionnaireOne?: Maybe<CutsheetQuestionnaire>;
  cutsheetQuestionnairePagination?: Maybe<CutsheetQuestionnairePagination>;
  cutsheetQuestionnaireResponseById?: Maybe<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseByIds: Array<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseCount?: Maybe<Scalars['Int']['output']>;
  cutsheetQuestionnaireResponseMany: Array<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponseOne?: Maybe<CutsheetQuestionnaireResponse>;
  cutsheetQuestionnaireResponsePagination?: Maybe<CutsheetQuestionnaireResponsePagination>;
  /** Paginated search over questionnaire responses with vendor, user, questionnaire, type, and text filtering */
  cutsheetQuestionnaireResponseSearch?: Maybe<CutsheetQuestionnaireResponsePagination>;
  /** Retrieve all customer responses for a specific questionnaire (vendor view) */
  cutsheetQuestionnaireResponsesByQuestionnaire?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all of a customer's questionnaire responses, optionally filtered by questionnaire */
  cutsheetQuestionnaireResponsesByUser?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all customer questionnaire responses for a vendor (processor admin view) */
  cutsheetQuestionnaireResponsesByVendor?: Maybe<Array<Maybe<CutsheetQuestionnaireResponse>>>;
  /** Retrieve all questionnaires for a vendor */
  cutsheetQuestionnairesByVendor?: Maybe<Array<Maybe<CutsheetQuestionnaire>>>;
  /** Retrieve questionnaires for a capability */
  cutsheetQuestionnairesByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetQuestionnaire>>>;
  /** Enhanced cutsheet search with buyer, vendor, and type filtering */
  cutsheetSearch?: Maybe<CutsheetPagination>;
  cutsheetSpecificationById?: Maybe<CutsheetCapabilitySpecification>;
  cutsheetSpecificationByIds: Array<CutsheetCapabilitySpecification>;
  cutsheetSpecificationCount?: Maybe<Scalars['Int']['output']>;
  cutsheetSpecificationMany: Array<CutsheetCapabilitySpecification>;
  cutsheetSpecificationOne?: Maybe<CutsheetCapabilitySpecification>;
  cutsheetSpecificationPagination?: Maybe<CutsheetCapabilitySpecificationPagination>;
  /** Retrieve specifications for a capability */
  cutsheetSpecificationsByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilitySpecification>>>;
  cutsheetTrimById?: Maybe<CutsheetCapabilityOption>;
  cutsheetTrimByIds: Array<CutsheetCapabilityOption>;
  /** Retrieve trims for a capability */
  cutsheetTrimByVendorAndAnimal?: Maybe<Array<Maybe<CutsheetCapabilityOption>>>;
  cutsheetTrimCount?: Maybe<Scalars['Int']['output']>;
  cutsheetTrimMany: Array<CutsheetCapabilityOption>;
  cutsheetTrimOne?: Maybe<CutsheetCapabilityOption>;
  cutsheetTrimPagination?: Maybe<CutsheetCapabilityOptionPagination>;
  financialReportingConfigById?: Maybe<FinancialReportingConfig>;
  financialReportingConfigByIds: Array<FinancialReportingConfig>;
  financialReportingConfigCount?: Maybe<Scalars['Int']['output']>;
  financialReportingConfigMany: Array<FinancialReportingConfig>;
  financialReportingConfigOne?: Maybe<FinancialReportingConfig>;
  financialReportingConfigPagination?: Maybe<FinancialReportingConfigPagination>;
  /** Calculate comprehensive financial reporting metrics for the current vendor with optional comparison type (defaults to previous period). */
  financialReportingMetrics: Scalars['JSON']['output'];
  /** Get all notification settings for a given vendorId */
  findNotificationSettingsByVendorId?: Maybe<NotificationSettingPagination>;
  /** Get notifications for a ProcessorScheduling job by jobId (paginated). */
  findNotificationsByJobId?: Maybe<NotificationPagination>;
  /** Retrieve a single processor scheduling job. */
  findProcessorSchedulingById?: Maybe<ProcessorScheduling>;
  /** Get all records with missing cutsheets in valid statuses for notifications */
  findProcessorSchedulingsWithMissingCutsheets?: Maybe<ProcessorSchedulingPagination>;
  /** Get all records with missing hanging weights that killDate is in past and there is no hanging weights */
  findProcessorSchedulingsWithMissingHangingWeights?: Maybe<ProcessorSchedulingPagination>;
  /** Retrieve the field-level audit history for a document, sorted newest first. */
  getAuditLogs?: Maybe<AuditLogsResponse>;
  /** Get comprehensive summary details for a customer including job counts and relationship data */
  getCustomerSummaryDetails?: Maybe<CustomerSummaryDetails>;
  /** Get all jobs with custom filters */
  getFilteredProcessorScheduling?: Maybe<ProcessorSchedulingPagination>;
  /** Get filtered tenants with search and pagination */
  getFilteredTenants?: Maybe<TenantPagination>;
  /** Get all customers with custom filters */
  getProcessorCustomers?: Maybe<UserPagination>;
  /** Get processor scheduled jobs between the two dates. */
  getProcessorSchedulingCalendar?: Maybe<Array<Maybe<ProcessorScheduling>>>;
  /** Get public holidays for a specific country and date range. */
  getPublicHolidays?: Maybe<HolidaysResponse>;
  integrationById?: Maybe<Integration>;
  integrationByIds: Array<Integration>;
  integrationCount?: Maybe<Scalars['Int']['output']>;
  integrationMany: Array<Integration>;
  integrationOne?: Maybe<Integration>;
  integrationPagination?: Maybe<IntegrationPagination>;
  invoiceById?: Maybe<Invoice>;
  invoiceByIds: Array<Invoice>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemById?: Maybe<InvoiceLineItem>;
  invoiceLineItemByIds: Array<InvoiceLineItem>;
  invoiceLineItemCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemMany: Array<InvoiceLineItem>;
  invoiceLineItemOne?: Maybe<InvoiceLineItem>;
  invoiceLineItemPagination?: Maybe<InvoiceLineItemPagination>;
  invoiceMany: Array<Invoice>;
  invoiceOne?: Maybe<Invoice>;
  invoicePagination?: Maybe<InvoicePagination>;
  /** Get all chat rooms for the logged in user */
  messagesByChatRoom?: Maybe<ChatMessagePagination>;
  moduleById?: Maybe<VendorModule>;
  moduleByIds: Array<VendorModule>;
  moduleCount?: Maybe<Scalars['Int']['output']>;
  moduleMany: Array<VendorModule>;
  moduleOne?: Maybe<VendorModule>;
  modulePagination?: Maybe<VendorModulePagination>;
  /** Get all chat-rooms for given processor for logged in user and Basic user */
  myChatRooms?: Maybe<ChatRoomPagination>;
  noteById?: Maybe<Note>;
  noteByIds: Array<Note>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  noteMany: Array<Note>;
  noteOne?: Maybe<Note>;
  notePagination?: Maybe<NotePagination>;
  notificationById?: Maybe<Notification>;
  notificationByIds: Array<Notification>;
  notificationCount?: Maybe<Scalars['Int']['output']>;
  notificationMany: Array<Notification>;
  notificationOne?: Maybe<Notification>;
  notificationPagination?: Maybe<NotificationPagination>;
  notificationSettingsById?: Maybe<NotificationSetting>;
  notificationSettingsByIds: Array<NotificationSetting>;
  notificationSettingsCount?: Maybe<Scalars['Int']['output']>;
  notificationSettingsMany: Array<NotificationSetting>;
  notificationSettingsOne?: Maybe<NotificationSetting>;
  notificationSettingsPagination?: Maybe<NotificationSettingPagination>;
  /** Get all notifications for a given chat room with pagination. */
  notificationsByChatRoom?: Maybe<NotificationPagination>;
  primalById?: Maybe<Primal>;
  primalByIds: Array<Primal>;
  primalCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerById?: Maybe<PrimalCutBlocker>;
  primalCutBlockerByIds: Array<PrimalCutBlocker>;
  primalCutBlockerCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerMany: Array<PrimalCutBlocker>;
  primalCutBlockerOne?: Maybe<PrimalCutBlocker>;
  primalCutBlockerPagination?: Maybe<PrimalCutBlockerPagination>;
  primalCutById?: Maybe<PrimalCut>;
  primalCutByIds: Array<PrimalCut>;
  primalCutCount?: Maybe<Scalars['Int']['output']>;
  primalCutMany: Array<PrimalCut>;
  primalCutOne?: Maybe<PrimalCut>;
  primalCutPagination?: Maybe<PrimalCutPagination>;
  primalCutTypeById?: Maybe<PrimalCutType>;
  primalCutTypeByIds: Array<PrimalCutType>;
  primalCutTypeCount?: Maybe<Scalars['Int']['output']>;
  primalCutTypeMany: Array<PrimalCutType>;
  primalCutTypeOne?: Maybe<PrimalCutType>;
  primalCutTypePagination?: Maybe<PrimalCutTypePagination>;
  primalGroupById?: Maybe<PrimalGroup>;
  primalGroupByIds: Array<PrimalGroup>;
  primalGroupCount?: Maybe<Scalars['Int']['output']>;
  primalGroupMany: Array<PrimalGroup>;
  primalGroupOne?: Maybe<PrimalGroup>;
  primalGroupPagination?: Maybe<PrimalGroupPagination>;
  primalMany: Array<Primal>;
  primalOne?: Maybe<Primal>;
  primalPagination?: Maybe<PrimalPagination>;
  /** Retrieve a complete list of our processing partners */
  processingPartners?: Maybe<Array<Maybe<ProcessingPartners>>>;
  processingPartnersById?: Maybe<ProcessorSettings>;
  processingPartnersByIds: Array<ProcessorSettings>;
  processingPartnersCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersMany: Array<ProcessorSettings>;
  /** Retrieve a single processing partner */
  processingPartnersOne?: Maybe<ProcessingPartnersOne>;
  processingPartnersOneById?: Maybe<ProcessorSettings>;
  processingPartnersOneByIds: Array<ProcessorSettings>;
  processingPartnersOneCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersOneMany: Array<ProcessorSettings>;
  processingPartnersOneOne?: Maybe<ProcessorSettings>;
  processingPartnersOnePagination?: Maybe<ProcessorSettingsPagination>;
  processingPartnersPagination?: Maybe<ProcessorSettingsPagination>;
  processorCapabilityById?: Maybe<ProcessorCapability>;
  processorCapabilityByIds: Array<ProcessorCapability>;
  processorCapabilityCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilityMany: Array<ProcessorCapability>;
  processorCapabilityOne?: Maybe<ProcessorCapability>;
  processorCapabilityPagination?: Maybe<ProcessorCapabilityPagination>;
  processorCapabilitySpecificationById?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationByIds: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilitySpecificationMany: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationOne?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationPagination?: Maybe<ProcessorCapabilitySpecificationPagination>;
  processorNotificationById?: Maybe<ProcessorNotification>;
  processorNotificationByIds: Array<ProcessorNotification>;
  processorNotificationCount?: Maybe<Scalars['Int']['output']>;
  processorNotificationMany: Array<ProcessorNotification>;
  processorNotificationOne?: Maybe<ProcessorNotification>;
  processorNotificationPagination?: Maybe<ProcessorNotificationPagination>;
  processorSchedulingById?: Maybe<ProcessorScheduling>;
  processorSchedulingByIds: Array<ProcessorScheduling>;
  processorSchedulingCount?: Maybe<Scalars['Int']['output']>;
  processorSchedulingMany: Array<ProcessorScheduling>;
  processorSchedulingOne?: Maybe<ProcessorScheduling>;
  processorSchedulingPagination?: Maybe<ProcessorSchedulingPagination>;
  processorSettingsById?: Maybe<ProcessorSettings>;
  processorSettingsByIds: Array<ProcessorSettings>;
  processorSettingsCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityById?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityByIds: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityMany: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityOne?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityPagination?: Maybe<ProcessorSettingsCustomCapacityPagination>;
  processorSettingsMany: Array<ProcessorSettings>;
  processorSettingsOne?: Maybe<ProcessorSettings>;
  processorSettingsPagination?: Maybe<ProcessorSettingsPagination>;
  /** Render a notification email template with sample data and return the HTML */
  renderNotificationEmailPreview?: Maybe<EmailPreviewResult>;
  /** Search for available Twilio phone numbers to provision */
  searchAvailablePhoneNumbers?: Maybe<Array<Maybe<AvailablePhoneNumber>>>;
  /** Search customer users with optional filters */
  searchCustomers: Array<User>;
  /** Get all invoices with custom filters */
  searchInvoices?: Maybe<InvoicePagination>;
  stateById?: Maybe<State>;
  stateByIds: Array<State>;
  stateCount?: Maybe<Scalars['Int']['output']>;
  stateMany: Array<State>;
  stateOne?: Maybe<State>;
  statePagination?: Maybe<StatePagination>;
  tenantById?: Maybe<Tenant>;
  tenantByIds: Array<Tenant>;
  tenantCount?: Maybe<Scalars['Int']['output']>;
  tenantMany: Array<Tenant>;
  tenantOne?: Maybe<Tenant>;
  tenantPagination?: Maybe<TenantPagination>;
  userById?: Maybe<User>;
  userByIds: Array<User>;
  userCount?: Maybe<Scalars['Int']['output']>;
  userMany: Array<User>;
  userOne?: Maybe<User>;
  userPagination?: Maybe<UserPagination>;
  /** Get a user's settings by their user ID. */
  userSettingsByUserId?: Maybe<UserSettingsByUserId>;
  /** Get the user/tenant/vendor associated with a user. */
  userTenantVendor?: Maybe<User>;
  vendorById?: Maybe<Vendor>;
  vendorByIds: Array<Vendor>;
  vendorCount?: Maybe<Scalars['Int']['output']>;
  /** Retrieve a list of all vendors. */
  vendorList?: Maybe<Array<Maybe<Vendor>>>;
  vendorMany: Array<Vendor>;
  vendorOne?: Maybe<Vendor>;
  vendorPagination?: Maybe<VendorPagination>;
  waitlistById?: Maybe<Waitlist>;
  waitlistByIds: Array<Waitlist>;
  /** Retrieve the waitlist for a vendor. */
  waitlistByVendorId?: Maybe<Array<Maybe<Waitlist>>>;
  waitlistCount?: Maybe<Scalars['Int']['output']>;
  waitlistMany: Array<Waitlist>;
  waitlistOne?: Maybe<Waitlist>;
  waitlistPagination?: Maybe<WaitlistPagination>;
  webhookById?: Maybe<Vendor>;
  webhookByIds: Array<Vendor>;
  webhookCount?: Maybe<Scalars['Int']['output']>;
  webhookMany: Array<Vendor>;
  webhookOne?: Maybe<Vendor>;
  webhookPagination?: Maybe<VendorPagination>;
};


export type QueryCutsheetCapabilityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityByVendorAndAnimalArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityInput>;
};


export type QueryCutsheetCapabilityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityInput>;
};


export type QueryCutsheetLegacyCapabilityDataArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type QueryAddressByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAddressByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAddressInput>;
};


export type QueryAddressCountArgs = {
  filter?: InputMaybe<FilterCountAddressInput>;
};


export type QueryAddressManyArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryAddressOneArgs = {
  filter?: InputMaybe<FilterFindOneAddressInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneAddressInput>;
};


export type QueryAddressPaginationArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryAdminUserSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<EnumUserRole>;
  search: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyzeAnimalConfigurationsArgs = {
  backwardMonths?: InputMaybe<Scalars['Int']['input']>;
  forwardMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyzeSeasonalityArgs = {
  backwardMonths?: InputMaybe<Scalars['Int']['input']>;
  forwardMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculateProcessorCapacityArgs = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  groupFormat?: InputMaybe<Scalars['String']['input']>;
  selectedAnimalSpecies: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};


export type QueryCalculateProcessorCapacityAllSpeciesArgs = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  groupFormat?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};


export type QueryCancellationReasonByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCancellationReasonByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCancellationReasonInput>;
};


export type QueryCancellationReasonCountArgs = {
  filter?: InputMaybe<FilterCountCancellationReasonInput>;
};


export type QueryCancellationReasonManyArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryCancellationReasonOneArgs = {
  filter?: InputMaybe<FilterFindOneCancellationReasonInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCancellationReasonInput>;
};


export type QueryCancellationReasonPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryChatMessageByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChatMessageByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsChatMessageInput>;
};


export type QueryChatMessageCountArgs = {
  filter?: InputMaybe<FilterCountChatMessageInput>;
};


export type QueryChatMessageManyArgs = {
  filter?: InputMaybe<FilterFindManyChatMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatMessageInput>;
};


export type QueryChatMessageOneArgs = {
  filter?: InputMaybe<FilterFindOneChatMessageInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneChatMessageInput>;
};


export type QueryChatMessagePaginationArgs = {
  filter?: InputMaybe<FilterFindManyChatMessageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatMessageInput>;
};


export type QueryChatRoomByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChatRoomByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsChatRoomInput>;
};


export type QueryChatRoomCountArgs = {
  filter?: InputMaybe<FilterCountChatRoomInput>;
};


export type QueryChatRoomManyArgs = {
  filter?: InputMaybe<FilterFindManyChatRoomInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryChatRoomOneArgs = {
  filter?: InputMaybe<FilterFindOneChatRoomInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneChatRoomInput>;
};


export type QueryChatRoomPaginationArgs = {
  filter?: InputMaybe<FilterFindManyChatRoomInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryCsvImportJobByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCsvImportJobByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCsvImportJobInput>;
};


export type QueryCsvImportJobCountArgs = {
  filter?: InputMaybe<FilterCountCsvImportJobInput>;
};


export type QueryCsvImportJobManyArgs = {
  filter?: InputMaybe<FilterFindManyCsvImportJobInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCsvImportJobInput>;
};


export type QueryCsvImportJobOneArgs = {
  filter?: InputMaybe<FilterFindOneCsvImportJobInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCsvImportJobInput>;
};


export type QueryCsvImportJobPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCsvImportJobInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCsvImportJobInput>;
};


export type QueryCsvImportJobStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryCsvImportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCutsheetAssignmentRuleSetByCapabilityIdArgs = {
  capabilityId: Scalars['MongoID']['input'];
};


export type QueryCutsheetAssignmentRuleSetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetAssignmentRuleSetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetAssignmentRuleSetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetAssignmentRuleSetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetAssignmentRuleSetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetAssignmentRuleSetInput>;
};


export type QueryCutsheetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetInput>;
};


export type QueryCutsheetCapabilityOptionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCapabilityOptionByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCapabilityOptionsByGroupIdArgs = {
  groupId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetCapabilityOptionsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCutsheetCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetInput>;
};


export type QueryCutsheetCutByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetCutByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetCutsByGroupIdArgs = {
  groupId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetCutsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetExtraByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetExtraByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtraPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetExtrasByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityGroupInput>;
};


export type QueryCutsheetGroupsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryCutsheetOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetInput>;
};


export type QueryCutsheetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryCutsheetQuestionnaireByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetQuestionnaireInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnairePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireInput>;
};


export type QueryCutsheetQuestionnaireResponseByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponseByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetQuestionnaireResponseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponsePaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetQuestionnaireResponseInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetQuestionnaireResponseInput>;
};


export type QueryCutsheetQuestionnaireResponseSearchArgs = {
  capabilitySetId?: InputMaybe<Scalars['MongoID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sort: SortFindManyCutsheetQuestionnaireResponseInput;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireResponseType>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryCutsheetQuestionnaireResponsesByQuestionnaireArgs = {
  questionnaireId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponsesByUserArgs = {
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  userId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnaireResponsesByVendorArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnairesByVendorArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryCutsheetQuestionnairesByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCutsheetSearchArgs = {
  buyerId?: InputMaybe<Scalars['MongoID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<EnumCutsheetInspectionLevels>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetInput;
  species?: InputMaybe<EnumCutsheetAnimalSpecies>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetType>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryCutsheetSpecificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetSpecificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilitySpecificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilitySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilitySpecificationInput>;
};


export type QueryCutsheetSpecificationsByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetTrimByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetTrimByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimByVendorAndAnimalArgs = {
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCutsheetTrimCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetCapabilityOptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetCapabilityOptionInput>;
};


export type QueryCutsheetTrimPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetCapabilityOptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetCapabilityOptionInput>;
};


export type QueryFinancialReportingConfigByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryFinancialReportingConfigByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigCountArgs = {
  filter?: InputMaybe<FilterCountFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigManyArgs = {
  filter?: InputMaybe<FilterFindManyFinancialReportingConfigInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigOneArgs = {
  filter?: InputMaybe<FilterFindOneFinancialReportingConfigInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneFinancialReportingConfigInput>;
};


export type QueryFinancialReportingConfigPaginationArgs = {
  filter?: InputMaybe<FilterFindManyFinancialReportingConfigInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFinancialReportingConfigInput>;
};


export type QueryFinancialReportingMetricsArgs = {
  comparisonType?: InputMaybe<ComparisonType>;
  dateAnchor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindNotificationSettingsByVendorIdArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryFindNotificationsByJobIdArgs = {
  jobId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryFindProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
};


export type QueryFindProcessorSchedulingsWithMissingCutsheetsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryFindProcessorSchedulingsWithMissingHangingWeightsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetAuditLogsArgs = {
  documentId: Scalars['MongoID']['input'];
  documentType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCustomerSummaryDetailsArgs = {
  customerId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetFilteredProcessorSchedulingArgs = {
  animalSpecies?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  missingCutsheets?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetFilteredTenantsArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyTenantInput;
};


export type QueryGetProcessorCustomersArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetProcessorSchedulingCalendarArgs = {
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  startDate: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetPublicHolidaysArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegrationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryIntegrationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsIntegrationInput>;
};


export type QueryIntegrationCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationInput>;
};


export type QueryIntegrationManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryIntegrationOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationInput>;
};


export type QueryIntegrationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryInvoiceByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceInput>;
};


export type QueryInvoiceCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceInput>;
};


export type QueryInvoiceLineItemByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceLineItemByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceLineItemInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryInvoiceOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceInput>;
};


export type QueryInvoicePaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryMessagesByChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryModuleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryModuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorModuleInput>;
};


export type QueryModuleCountArgs = {
  filter?: InputMaybe<FilterCountVendorModuleInput>;
};


export type QueryModuleManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type QueryModuleOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorModuleInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorModuleInput>;
};


export type QueryModulePaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorModuleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type QueryMyChatRoomsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryNoteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNoteByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNoteInput>;
};


export type QueryNoteCountArgs = {
  filter?: InputMaybe<FilterCountNoteInput>;
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNoteOneArgs = {
  filter?: InputMaybe<FilterFindOneNoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNoteInput>;
};


export type QueryNotePaginationArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNotificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNotificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNotificationInput>;
};


export type QueryNotificationCountArgs = {
  filter?: InputMaybe<FilterCountNotificationInput>;
};


export type QueryNotificationManyArgs = {
  filter?: InputMaybe<FilterFindManyNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};


export type QueryNotificationOneArgs = {
  filter?: InputMaybe<FilterFindOneNotificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNotificationInput>;
};


export type QueryNotificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyNotificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationInput>;
};


export type QueryNotificationSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNotificationSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNotificationSettingInput>;
};


export type QueryNotificationSettingsCountArgs = {
  filter?: InputMaybe<FilterCountNotificationSettingInput>;
};


export type QueryNotificationSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryNotificationSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNotificationSettingInput>;
};


export type QueryNotificationSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryNotificationsByChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryPrimalByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalInput>;
};


export type QueryPrimalCountArgs = {
  filter?: InputMaybe<FilterCountPrimalInput>;
};


export type QueryPrimalCutBlockerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutBlockerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutBlockerInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};


export type QueryPrimalCutCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutInput>;
};


export type QueryPrimalCutManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutInput>;
};


export type QueryPrimalCutPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutTypeByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutTypeByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutTypeInput>;
};


export type QueryPrimalCutTypePaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalGroupInput>;
};


export type QueryPrimalGroupCountArgs = {
  filter?: InputMaybe<FilterCountPrimalGroupInput>;
};


export type QueryPrimalGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalGroupOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalGroupInput>;
};


export type QueryPrimalGroupPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryPrimalOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalInput>;
};


export type QueryPrimalPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryProcessingPartnersArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProcessingPartnersByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProcessingPartnersOneByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersOneByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessingPartnersOnePaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorCapabilityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilitySpecificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilitySpecificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorNotificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorNotificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorNotificationInput>;
};


export type QueryProcessorNotificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorNotificationInput>;
};


export type QueryProcessorNotificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorNotificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorNotificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorNotificationInput>;
};


export type QueryProcessorNotificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSchedulingByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessorSettingsCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessorSettingsCustomCapacityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsCustomCapacityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessorSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryRenderNotificationEmailPreviewArgs = {
  content: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
  vendorName: Scalars['String']['input'];
};


export type QuerySearchAvailablePhoneNumbersArgs = {
  input?: InputMaybe<SearchAvailablePhoneNumbersInput>;
};


export type QuerySearchCustomersArgs = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
};


export type QuerySearchInvoicesArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyInvoiceInput;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};


export type QueryStateByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryStateByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsStateInput>;
};


export type QueryStateCountArgs = {
  filter?: InputMaybe<FilterCountStateInput>;
};


export type QueryStateManyArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryStateOneArgs = {
  filter?: InputMaybe<FilterFindOneStateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneStateInput>;
};


export type QueryStatePaginationArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryTenantByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTenantByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTenantInput>;
};


export type QueryTenantCountArgs = {
  filter?: InputMaybe<FilterCountTenantInput>;
};


export type QueryTenantManyArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryTenantOneArgs = {
  filter?: InputMaybe<FilterFindOneTenantInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTenantInput>;
};


export type QueryTenantPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};


export type QueryUserCountArgs = {
  filter?: InputMaybe<FilterCountUserInput>;
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};


export type QueryUserPaginationArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserSettingsByUserIdArgs = {
  userId: Scalars['MongoID']['input'];
};


export type QueryVendorByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryVendorByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryVendorCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryVendorListArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryVendorManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryVendorOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryVendorPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWaitlistByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWaitlistByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsWaitlistInput>;
};


export type QueryWaitlistByVendorIdArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryWaitlistCountArgs = {
  filter?: InputMaybe<FilterCountWaitlistInput>;
};


export type QueryWaitlistManyArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWaitlistOneArgs = {
  filter?: InputMaybe<FilterFindOneWaitlistInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneWaitlistInput>;
};


export type QueryWaitlistPaginationArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWebhookByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWebhookByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryWebhookCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryWebhookManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWebhookOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryWebhookPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};

export type RefreshHostedNumberStatusInput = {
  vendorId: Scalars['String']['input'];
};

export type RefreshHostedNumberStatusResponse = {
  __typename?: 'RefreshHostedNumberStatusResponse';
  error?: Maybe<Scalars['String']['output']>;
  isProvisioned?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RefundInvoiceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RelationshipsInputForUser = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ReleasePhoneNumberInput = {
  vendorId: Scalars['String']['input'];
};

export type ReleasePhoneNumberResponse = {
  __typename?: 'ReleasePhoneNumberResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RequesterContactInformationInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['MongoID']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SearchAvailablePhoneNumbersInput = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['String']['input'];
};

export type SendTestNotificationResult = {
  __typename?: 'SendTestNotificationResult';
  emailSent: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
};

export enum SortFindByIdsAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChatMessageInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChatRoomInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStateInput {
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTenantInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVendorInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  VendorNameAsc = 'VENDOR_NAME_ASC',
  VendorNameDesc = 'VENDOR_NAME_DESC',
  VendorNumberAsc = 'VENDOR_NUMBER_ASC',
  VendorNumberDesc = 'VENDOR_NUMBER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCsvImportJobInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusCreatedatAsc = 'STATUS__CREATEDAT_ASC',
  StatusCreatedatDesc = 'STATUS__CREATEDAT_DESC',
  TenantidAsc = 'TENANTID_ASC',
  TenantidDesc = 'TENANTID_DESC',
  TenantidCreatedatAsc = 'TENANTID__CREATEDAT_ASC',
  TenantidCreatedatDesc = 'TENANTID__CREATEDAT_DESC',
  UploadedbyAsc = 'UPLOADEDBY_ASC',
  UploadedbyDesc = 'UPLOADEDBY_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  VendoridCreatedatAsc = 'VENDORID__CREATEDAT_ASC',
  VendoridCreatedatDesc = 'VENDORID__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetAssignmentRuleSetInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityGroupInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorSpeciesAsc = 'VENDOR__SPECIES_ASC',
  VendorSpeciesDesc = 'VENDOR__SPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilityOptionInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CapabilityidOptiontypeAsc = 'CAPABILITYID__OPTIONTYPE_ASC',
  CapabilityidOptiontypeDesc = 'CAPABILITYID__OPTIONTYPE_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  OptiontypeAsc = 'OPTIONTYPE_ASC',
  OptiontypeDesc = 'OPTIONTYPE_DESC',
  OptiontypeIsactiveAsc = 'OPTIONTYPE__ISACTIVE_ASC',
  OptiontypeIsactiveDesc = 'OPTIONTYPE__ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorOptiontypeAsc = 'VENDOR__OPTIONTYPE_ASC',
  VendorOptiontypeDesc = 'VENDOR__OPTIONTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetCapabilitySpecificationInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  IsactiveAsc = 'ISACTIVE_ASC',
  IsactiveDesc = 'ISACTIVE_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetQuestionnaireInput {
  CapabilityidAsc = 'CAPABILITYID_ASC',
  CapabilityidDesc = 'CAPABILITYID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetQuestionnaireResponseInput {
  CapabilitysetAsc = 'CAPABILITYSET_ASC',
  CapabilitysetDesc = 'CAPABILITYSET_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IsdeletedAsc = 'ISDELETED_ASC',
  IsdeletedDesc = 'ISDELETED_DESC',
  QuestionnaireAsc = 'QUESTIONNAIRE_ASC',
  QuestionnaireDesc = 'QUESTIONNAIRE_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneFinancialReportingConfigInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNotificationInput {
  ChatroomidAsc = 'CHATROOMID_ASC',
  ChatroomidDesc = 'CHATROOMID_DESC',
  ChatroomidCreatedatAsc = 'CHATROOMID__CREATEDAT_ASC',
  ChatroomidCreatedatDesc = 'CHATROOMID__CREATEDAT_DESC',
  GroupidAsc = 'GROUPID_ASC',
  GroupidDesc = 'GROUPID_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridVendoridAsc = 'USERID__VENDORID_ASC',
  UseridVendoridDesc = 'USERID__VENDORID_DESC',
  UseridVendoridTriggerAsc = 'USERID__VENDORID__TRIGGER_ASC',
  UseridVendoridTriggerDesc = 'USERID__VENDORID__TRIGGER_DESC',
  VendoridAsc = 'VENDORID_ASC',
  VendoridDesc = 'VENDORID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsAnimalspeciesAsc = 'PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  ProcessorsettingsAnimalspeciesDesc = 'PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL_DESC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedAsc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_ASC',
  ProcessorsettingsAnimalspeciesInspectionlevelIsdeletedDesc = 'PROCESSORSETTINGS__ANIMALSPECIES__INSPECTIONLEVEL__ISDELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilityInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsCustomCapacityInput {
  ProcessorsettingsAsc = 'PROCESSORSETTINGS_ASC',
  ProcessorsettingsDesc = 'PROCESSORSETTINGS_DESC',
  ProcessorsettingsIsdeletedAsc = 'PROCESSORSETTINGS__ISDELETED_ASC',
  ProcessorsettingsIsdeletedDesc = 'PROCESSORSETTINGS__ISDELETED_DESC',
  ProcessorsettingsIsdeletedDateAsc = 'PROCESSORSETTINGS__ISDELETED__DATE_ASC',
  ProcessorsettingsIsdeletedDateDesc = 'PROCESSORSETTINGS__ISDELETED__DATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneUserInput {
  AuthMethodAsc = 'AUTH_METHOD_ASC',
  AuthMethodDesc = 'AUTH_METHOD_DESC',
  CognitoUsernameAsc = 'COGNITO_USERNAME_ASC',
  CognitoUsernameDesc = 'COGNITO_USERNAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  RelationshipsVendoridAsc = 'RELATIONSHIPS__VENDORID_ASC',
  RelationshipsVendoridDesc = 'RELATIONSHIPS__VENDORID_DESC',
  RelationshipsVendoridRelationshipsProduceridAsc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_ASC',
  RelationshipsVendoridRelationshipsProduceridDesc = 'RELATIONSHIPS__VENDORID__RELATIONSHIPS__PRODUCERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  TenantAsc = 'TENANT_ASC',
  TenantDesc = 'TENANT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneVendorModuleInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type SpeciesComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type SpeciesInspectionComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema';
  inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel;
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type SplitYieldItemInput = {
  capabilityOptionId?: InputMaybe<Scalars['String']['input']>;
  itemCount: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  packageCount: Scalars['Int']['input'];
  packageIdentifier?: InputMaybe<Scalars['String']['input']>;
  weightLbs: Scalars['Float']['input'];
};

export type State = {
  __typename?: 'State';
  _id: Scalars['MongoID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** List of items with pagination. */
export type StatePagination = {
  __typename?: 'StatePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<State>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SubmitHostedLandlineOrderInput = {
  phoneNumber: Scalars['String']['input'];
  smsWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type SubmitHostedLandlineOrderResponse = {
  __typename?: 'SubmitHostedLandlineOrderResponse';
  error?: Maybe<Scalars['String']['output']>;
  hostedNumberOrderSid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SyncConversationPhoneNumbersInput = {
  vendorId: Scalars['String']['input'];
};

export type SyncConversationPhoneNumbersResponse = {
  __typename?: 'SyncConversationPhoneNumbersResponse';
  error?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  _id: Scalars['MongoID']['output'];
  date_created: Scalars['Date']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  picture_url?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  vendors: Array<Vendor>;
};


export type TenantUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type TenantVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};

/** List of items with pagination. */
export type TenantPagination = {
  __typename?: 'TenantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tenant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TimeConfigurationInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerInvoicing: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
  timePerProducerBooking: Scalars['Float']['input'];
};

export type TimeTrackingConfigInput = {
  baseDigitalSavings: Scalars['Float']['input'];
  hourlyRate: Scalars['Float']['input'];
  timePerBooking: Scalars['Float']['input'];
  timePerCutsheet: Scalars['Float']['input'];
  timePerNotification: Scalars['Float']['input'];
};

export type UpdateAuthMethodPayload = {
  __typename?: 'UpdateAuthMethodPayload';
  authMethod: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateByIdAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateByIdAddressPayload = {
  __typename?: 'UpdateByIdAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateByIdCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCsvImportJobPayload = {
  __typename?: 'UpdateByIdCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCancellationReasonPayload = {
  __typename?: 'UpdateByIdCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdChatMessagePayload = {
  __typename?: 'UpdateByIdChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdChatRoomPayload = {
  __typename?: 'UpdateByIdChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateByIdCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateByIdCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateByIdCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<UpdateByIdCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetCapabilityPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateByIdCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateByIdCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateByIdCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetPayload = {
  __typename?: 'UpdateByIdCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateByIdCutsheetQuestionnaireInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateByIdCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetQuestionnairePayload = {
  __typename?: 'UpdateByIdCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateByIdCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCutsheetQuestionnaireResponseInput = {
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<UpdateByIdCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetQuestionnaireResponsePayload = {
  __typename?: 'UpdateByIdCutsheetQuestionnaireResponsePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaireResponse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateByIdDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateByIdDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateByIdFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateByIdFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateByIdFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateByIdFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateByIdFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFinancialReportingConfigPayload = {
  __typename?: 'UpdateByIdFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdIntegrationPayload = {
  __typename?: 'UpdateByIdIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemPayload = {
  __typename?: 'UpdateByIdInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoicePayload = {
  __typename?: 'UpdateByIdInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateByIdNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateByIdNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotePayload = {
  __typename?: 'UpdateByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationErrorInput = {
  email?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
};

export type UpdateByIdNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateByIdNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateByIdNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateByIdNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotificationPayload = {
  __typename?: 'UpdateByIdNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateByIdNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotificationSettingPayload = {
  __typename?: 'UpdateByIdNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateByIdNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateByIdPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateByIdPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerPayload = {
  __typename?: 'UpdateByIdPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutPayload = {
  __typename?: 'UpdateByIdPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutTypePayload = {
  __typename?: 'UpdateByIdPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalGroupPayload = {
  __typename?: 'UpdateByIdPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalPayload = {
  __typename?: 'UpdateByIdPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateByIdProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityPayload = {
  __typename?: 'UpdateByIdProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateByIdProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorNotificationPayload = {
  __typename?: 'UpdateByIdProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateByIdProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateByIdProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateByIdProcessorSchedulingPayload = {
  __typename?: 'UpdateByIdProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateByIdProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateByIdProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateByIdProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateByIdProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsPayload = {
  __typename?: 'UpdateByIdProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdStatePayload = {
  __typename?: 'UpdateByIdStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTenantPayload = {
  __typename?: 'UpdateByIdTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateByIdUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateByIdUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdUserPayload = {
  __typename?: 'UpdateByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserSettingsInput = {
  calendar?: InputMaybe<UpdateByIdUserSettingsCalendarInput>;
};

export type UpdateByIdVendorInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateByIdVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdVendorModulePayload = {
  __typename?: 'UpdateByIdVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdVendorPayload = {
  __typename?: 'UpdateByIdVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateByIdWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdWaitlistPayload = {
  __typename?: 'UpdateByIdWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateInvoiceInput = {
  description: Scalars['String']['input'];
  id: Scalars['MongoID']['input'];
  invoiceNumber: Scalars['String']['input'];
  line_items?: InputMaybe<Array<InputMaybe<InvoiceUpdateLineItemInput>>>;
};

export type UpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateManyAddressPayload = {
  __typename?: 'UpdateManyAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateManyCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCsvImportJobPayload = {
  __typename?: 'UpdateManyCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCancellationReasonPayload = {
  __typename?: 'UpdateManyCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyChatMessagePayload = {
  __typename?: 'UpdateManyChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyChatRoomPayload = {
  __typename?: 'UpdateManyChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateManyCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateManyCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateManyCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<UpdateManyCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetCapabilityPayload = {
  __typename?: 'UpdateManyCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateManyCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateManyCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetPayload = {
  __typename?: 'UpdateManyCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateManyCutsheetQuestionnaireInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateManyCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetQuestionnairePayload = {
  __typename?: 'UpdateManyCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateManyCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCutsheetQuestionnaireResponseInput = {
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<UpdateManyCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetQuestionnaireResponsePayload = {
  __typename?: 'UpdateManyCutsheetQuestionnaireResponsePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateManyFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateManyFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateManyFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateManyFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateManyFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyFinancialReportingConfigPayload = {
  __typename?: 'UpdateManyFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyIntegrationPayload = {
  __typename?: 'UpdateManyIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemPayload = {
  __typename?: 'UpdateManyInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoicePayload = {
  __typename?: 'UpdateManyInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateManyNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateManyNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotePayload = {
  __typename?: 'UpdateManyNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationErrorInput = {
  email?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
};

export type UpdateManyNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateManyNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateManyNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateManyNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotificationPayload = {
  __typename?: 'UpdateManyNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotificationSettingPayload = {
  __typename?: 'UpdateManyNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateManyNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerPayload = {
  __typename?: 'UpdateManyPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutPayload = {
  __typename?: 'UpdateManyPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutTypePayload = {
  __typename?: 'UpdateManyPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalGroupPayload = {
  __typename?: 'UpdateManyPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalPayload = {
  __typename?: 'UpdateManyPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityPayload = {
  __typename?: 'UpdateManyProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateManyProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorNotificationPayload = {
  __typename?: 'UpdateManyProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateManyProcessorSchedulingPayload = {
  __typename?: 'UpdateManyProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateManyProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateManyProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateManyProcessorSettingsPayload = {
  __typename?: 'UpdateManyProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyStatePayload = {
  __typename?: 'UpdateManyStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyTenantPayload = {
  __typename?: 'UpdateManyTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateManyUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateManyUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyUserPayload = {
  __typename?: 'UpdateManyUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyUserSettingsInput = {
  calendar?: InputMaybe<UpdateManyUserSettingsCalendarInput>;
};

export type UpdateManyVendorInput = {
  address?: InputMaybe<UpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateManyVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyVendorModulePayload = {
  __typename?: 'UpdateManyVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyVendorPayload = {
  __typename?: 'UpdateManyVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateManyWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyWaitlistPayload = {
  __typename?: 'UpdateManyWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateOneAddressPayload = {
  __typename?: 'UpdateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCsvImportJobFailuresInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneCsvImportJobInput = {
  cancelledAt?: InputMaybe<Scalars['Date']['input']>;
  cancelledAtStage?: InputMaybe<EnumCsvImportJobCancelledAtStage>;
  columnMapping?: InputMaybe<Scalars['JSON']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedRows?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  failures?: InputMaybe<Array<InputMaybe<UpdateOneCsvImportJobFailuresInput>>>;
  failuresFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidFilePath?: InputMaybe<Scalars['String']['input']>;
  invalidRows?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  parsedData?: InputMaybe<Scalars['JSON']['input']>;
  processedCount?: InputMaybe<Scalars['Float']['input']>;
  rawFilePath?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCsvImportJobStatus>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['MongoID']['input']>;
  totalRows?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCsvImportJobType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  validFilePath?: InputMaybe<Scalars['String']['input']>;
  validRows?: InputMaybe<Scalars['Float']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneCsvImportJobValidationErrorsInput>>>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCsvImportJobPayload = {
  __typename?: 'UpdateOneCSVImportJobPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CsvImportJob>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCsvImportJobValidationErrorsInput = {
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  row?: InputMaybe<Scalars['Float']['input']>;
  warningMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCancellationReasonPayload = {
  __typename?: 'UpdateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneChatMessagePayload = {
  __typename?: 'UpdateOneChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  twilioConversationSid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneChatRoomPayload = {
  __typename?: 'UpdateOneChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetAssignmentRuleSetInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetAssignmentRuleSetRulesInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetAssignmentRuleSetPayload = {
  __typename?: 'UpdateOneCutsheetAssignmentRuleSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetAssignmentRuleSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetAssignmentRuleSetRulesInput = {
  buyer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  inspectionLevel?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesInspectionLevel>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  splitIndex?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  splitType?: InputMaybe<Array<InputMaybe<EnumCutsheetAssignmentRuleSetRulesSplitType>>>;
};

export type UpdateOneCutsheetCapabilityGroupInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityGroupPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  legacyInspectionLevelMap?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<UpdateOneCutsheetCapabilityPrintSettingsInput>;
  species?: InputMaybe<EnumCutsheetCapabilitySpecies>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput = {
  newOptionValue?: InputMaybe<Scalars['String']['input']>;
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldExtraName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapInput = {
  cutMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapCutMappingsInput>>>;
  extraMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapExtraMappingsInput>>>;
  inspectionLevel?: InputMaybe<EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  specMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput>>>;
  trimMappings?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput>>>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapSpecMappingsInput = {
  newSpecificationId?: InputMaybe<Scalars['MongoID']['input']>;
  oldSpecName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityLegacyInspectionLevelMapTrimMappingsInput = {
  newOptionId?: InputMaybe<Scalars['MongoID']['input']>;
  oldTrimName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  optionType?: InputMaybe<EnumCutsheetCapabilityOptionOptionType>;
  pricing?: InputMaybe<UpdateOneCutsheetCapabilityOptionPricingInput>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetCapabilityOptionSpecificationsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityOptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilityOption>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityOptionPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<EnumCutsheetCapabilityOptionPricingModel>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneCutsheetCapabilityOptionSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetCapabilityOptionSpecificationsType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetCapabilityPayload = {
  __typename?: 'UpdateOneCutsheetCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetCapabilityPrintSettingsInput = {
  alwaysShowPrimalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  baseFontSize?: InputMaybe<Scalars['Float']['input']>;
  checkboxStyle?: InputMaybe<EnumCutsheetCapabilityPrintSettingsCheckboxStyle>;
  hiddenGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hiddenSpecificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideUnselectedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  orientation?: InputMaybe<EnumCutsheetCapabilityPrintSettingsOrientation>;
  primalColumns?: InputMaybe<Scalars['Float']['input']>;
  showPrimalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  specsLayoutPosition?: InputMaybe<EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition>;
};

export type UpdateOneCutsheetCapabilitySpecificationInput = {
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<EnumCutsheetCapabilitySpecificationInputType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetCapabilitySpecificationPayload = {
  __typename?: 'UpdateOneCutsheetCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  convertedToQuestionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetPayload = {
  __typename?: 'UpdateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput = {
  extras?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtrasInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsInput = {
  extraSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  primalNotes?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimNotes?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput>>>;
  trimSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsPrimalNotesInput = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput = {
  specification: Scalars['String']['input'];
  type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType;
  value: Scalars['JSON']['input'];
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput = {
  trim?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput>>>;
  type?: InputMaybe<EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType>;
};

export type UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrimInput = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
};

export type UpdateOneCutsheetQuestionnaireInput = {
  capabilityId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  defaultSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  printSettings?: InputMaybe<UpdateOneCutsheetCapabilityPrintSettingsInput>;
  questions?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireQuestionsInput>>>;
  specOptionPricingOverrides?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumCutsheetQuestionnaireStatus>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetQuestionnairePayload = {
  __typename?: 'UpdateOneCutsheetQuestionnairePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaire>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetQuestionnaireQuestionsInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowSubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  availableCutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableExtraIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableTrimIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  maxSelections?: InputMaybe<Scalars['Float']['input']>;
  minSelections?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireQuestionsOptionsInput>>>;
  requireExactTotal?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  specificationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumCutsheetQuestionnaireQuestionsType>;
};

export type UpdateOneCutsheetQuestionnaireQuestionsOptionsInput = {
  cutIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCutsheetQuestionnaireResponseInput = {
  capabilitySet?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  extraSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsExtraSelectionsInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsInput>>>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsInput>>>;
  trimSelections?: InputMaybe<UpdateOneCutsheetQuestionnaireDefaultSelectionsTrimSelectionsInput>;
  type?: InputMaybe<EnumCutsheetQuestionnaireResponseType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetQuestionnaireResponsePayload = {
  __typename?: 'UpdateOneCutsheetQuestionnaireResponsePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CutsheetQuestionnaireResponse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigAnimalConfigurationsInput = {
  averageHangingWeight?: InputMaybe<Scalars['Float']['input']>;
  expectedThroughput?: InputMaybe<Scalars['Float']['input']>;
  maxCapacity?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  revenue?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumFinancialReportingConfigAnimalConfigurationsSpecies>;
};

export type UpdateOneFinancialReportingConfigInput = {
  animalConfigurations?: InputMaybe<Array<InputMaybe<UpdateOneFinancialReportingConfigAnimalConfigurationsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dateAnchor?: InputMaybe<EnumFinancialReportingConfigDateAnchor>;
  monthlyModifiers?: InputMaybe<UpdateOneFinancialReportingConfigMonthlyModifiersInput>;
  overheadCosts?: InputMaybe<Array<InputMaybe<UpdateOneFinancialReportingConfigOverheadCostsInput>>>;
  timeConfiguration?: InputMaybe<UpdateOneFinancialReportingConfigTimeConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigMonthlyModifiersInput = {
  april?: InputMaybe<Scalars['Float']['input']>;
  august?: InputMaybe<Scalars['Float']['input']>;
  december?: InputMaybe<Scalars['Float']['input']>;
  february?: InputMaybe<Scalars['Float']['input']>;
  january?: InputMaybe<Scalars['Float']['input']>;
  july?: InputMaybe<Scalars['Float']['input']>;
  june?: InputMaybe<Scalars['Float']['input']>;
  march?: InputMaybe<Scalars['Float']['input']>;
  may?: InputMaybe<Scalars['Float']['input']>;
  november?: InputMaybe<Scalars['Float']['input']>;
  october?: InputMaybe<Scalars['Float']['input']>;
  september?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneFinancialReportingConfigOverheadCostsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<EnumFinancialReportingConfigOverheadCostsFrequency>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneFinancialReportingConfigPayload = {
  __typename?: 'UpdateOneFinancialReportingConfigPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FinancialReportingConfig>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneFinancialReportingConfigTimeConfigurationInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerInvoicing?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
  timePerProducerBooking?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneIntegrationPayload = {
  __typename?: 'UpdateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemPayload = {
  __typename?: 'UpdateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoicePayload = {
  __typename?: 'UpdateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateOneNoteAttachmentsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateOneNoteAttachmentsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotePayload = {
  __typename?: 'UpdateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationErrorInput = {
  email?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
  sms?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
};

export type UpdateOneNotificationErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Array<InputMaybe<EnumNotificationChannel>>>;
  chatRoomId?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<UpdateOneNotificationErrorInput>;
  errorMessage?: InputMaybe<UpdateOneNotificationErrorMessageInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['MongoID']['input']>;
  notificationType?: InputMaybe<EnumNotificationNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  smsTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateOneNotificationStatusInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotificationPayload = {
  __typename?: 'UpdateOneNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Notification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotificationSettingPayload = {
  __typename?: 'UpdateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateOneNotificationStatusInput = {
  email?: InputMaybe<EnumNotificationStatusEmail>;
  sms?: InputMaybe<EnumNotificationStatusSms>;
};

export type UpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerPayload = {
  __typename?: 'UpdateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutPayload = {
  __typename?: 'UpdateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutTypePayload = {
  __typename?: 'UpdateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalGroupPayload = {
  __typename?: 'UpdateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalPayload = {
  __typename?: 'UpdateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImageUrl?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimImageUrl?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityPayload = {
  __typename?: 'UpdateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorNotificationPayload = {
  __typename?: 'UpdateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireResponse?: InputMaybe<Scalars['MongoID']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
  yield?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationYieldInput>>>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['MongoID']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusChanges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingStatusChangesInput>>>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateOneProcessorSchedulingPayload = {
  __typename?: 'UpdateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSchedulingStatusChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  newStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesNewStatus>;
  previousStatus?: InputMaybe<EnumProcessorSchedulingStatusChangesPreviousStatus>;
};

export type UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Float']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timeTrackingConfig?: InputMaybe<UpdateOneProcessorSettingsTimeTrackingConfigInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateOneProcessorSettingsPayload = {
  __typename?: 'UpdateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsTimeTrackingConfigInput = {
  baseDigitalSavings?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  timePerBooking?: InputMaybe<Scalars['Float']['input']>;
  timePerCutsheet?: InputMaybe<Scalars['Float']['input']>;
  timePerNotification?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneStatePayload = {
  __typename?: 'UpdateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneTenantPayload = {
  __typename?: 'UpdateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  account_locked_until?: InputMaybe<Scalars['Date']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['MongoID']['input']>;
  auth_method?: InputMaybe<EnumUserAuth_Method>;
  can_receive_email_updates?: InputMaybe<Scalars['Boolean']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  cognito_groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  failed_auth_attempts?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_auth_at?: InputMaybe<Scalars['Date']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password_reset_required?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  privacy_policy_accepted_at?: InputMaybe<Scalars['Date']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<UpdateOneUserRelationshipsInput>>>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateOneUserSettingsInput>;
  status?: InputMaybe<EnumUserStatus>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneUserPayload = {
  __typename?: 'UpdateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneUserSettingsInput = {
  calendar?: InputMaybe<UpdateOneUserSettingsCalendarInput>;
};

export type UpdateOneVendorInput = {
  address?: InputMaybe<UpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  show_in_directory?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  twilioPhoneConfig?: InputMaybe<UpdateOneVendorTwilioPhoneConfigInput>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneVendorModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<EnumVendorModuleModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneVendorModulePayload = {
  __typename?: 'UpdateOneVendorModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<VendorModule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneVendorPayload = {
  __typename?: 'UpdateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneVendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type UpdateOneWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneWaitlistPayload = {
  __typename?: 'UpdateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdatePhoneNumberSmsWebhookInput = {
  vendorId: Scalars['String']['input'];
};

export type UpdatePhoneNumberSmsWebhookResponse = {
  __typename?: 'UpdatePhoneNumberSmsWebhookResponse';
  error?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProcessorSettingsWithCustomCapacity = {
  __typename?: 'UpdateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type UpdateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  outsideWindowNote?: InputMaybe<Scalars['String']['input']>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processorSettingsId: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit: Scalars['Float']['input'];
  timeTrackingConfig?: InputMaybe<TimeTrackingConfigInput>;
  vendor: Scalars['MongoID']['input'];
};

export type UpsertProcessorSettingsAnimalSettings = {
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  maxSchedulingDays?: InputMaybe<Scalars['Int']['input']>;
  minSchedulingDays?: InputMaybe<Scalars['Int']['input']>;
  showOutsideWindowDates?: InputMaybe<Scalars['Boolean']['input']>;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertProcessorSettingsCustomCapacityInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  access_token?: Maybe<Scalars['String']['output']>;
  account_locked_until?: Maybe<Scalars['Date']['output']>;
  active_vendor?: Maybe<Vendor>;
  address?: Maybe<Address>;
  auth_method?: Maybe<EnumUserAuth_Method>;
  can_receive_email_updates?: Maybe<Scalars['Boolean']['output']>;
  can_receive_sms?: Maybe<Scalars['Boolean']['output']>;
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cognito_username?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  failed_auth_attempts?: Maybe<Scalars['Float']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  intercomWebToken?: Maybe<Scalars['String']['output']>;
  last_auth_at?: Maybe<Scalars['Date']['output']>;
  last_login?: Maybe<Scalars['Float']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  password_reset_required?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
  privacy_policy_accepted_at?: Maybe<Scalars['Date']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Maybe<UserRelationships>>>;
  role?: Maybe<EnumUserRole>;
  settings?: Maybe<UserSettings>;
  status?: Maybe<EnumUserStatus>;
  tenant?: Maybe<Tenant>;
  tos_accepted_at?: Maybe<Scalars['Date']['output']>;
};

export type UserBasicUpsertPayload = {
  __typename?: 'UserBasicUpsertPayload';
  message?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** List of items with pagination. */
export type UserPagination = {
  __typename?: 'UserPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserRelationships = {
  __typename?: 'UserRelationships';
  producer?: Maybe<User>;
  producerId?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumUserRelationshipsType>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['MongoID']['output']>;
};

export type UserRelationshipsInput = {
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumUserRelationshipsType>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  calendar?: Maybe<UserSettingsCalendar>;
};

export type UserSettingsByUserId = {
  __typename?: 'UserSettingsByUserId';
  settings?: Maybe<UserSettings>;
};

export type UserSettingsCalendar = {
  __typename?: 'UserSettingsCalendar';
  calendarView?: Maybe<Scalars['String']['output']>;
  dateConfiguration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAllEvents?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettingsInput = {
  calendar?: InputMaybe<UserSettingsCalendarInput>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  _id: Scalars['MongoID']['output'];
  address: Address;
  annualHangingWeightThroughput?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  free_shipping_amount?: Maybe<Scalars['Float']['output']>;
  integrations: Array<Integration>;
  modules: Array<VendorModule>;
  pickup_days?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prefers_dropoff?: Maybe<Scalars['Boolean']['output']>;
  processorSettings?: Maybe<ProcessorSettings>;
  products?: Maybe<Array<Maybe<Product>>>;
  shop_name: Scalars['String']['output'];
  shop_slug?: Maybe<Scalars['String']['output']>;
  shop_url?: Maybe<Scalars['String']['output']>;
  show_in_directory: Scalars['Boolean']['output'];
  stripe_config?: Maybe<Scalars['JSON']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  twilioPhoneConfig?: Maybe<VendorTwilioPhoneConfig>;
  zone?: Maybe<Scalars['Float']['output']>;
};


export type VendorIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type VendorModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorModuleInput>;
};


export type VendorProcessorSettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};

export type VendorModule = {
  __typename?: 'VendorModule';
  _id: Scalars['MongoID']['output'];
  active: Scalars['Boolean']['output'];
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
  moduleType: EnumVendorModuleModuleType;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type VendorModulePagination = {
  __typename?: 'VendorModulePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<VendorModule>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type VendorPagination = {
  __typename?: 'VendorPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Vendor>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type VendorTwilioPhoneConfig = {
  __typename?: 'VendorTwilioPhoneConfig';
  _id?: Maybe<Scalars['MongoID']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  hostedNumberOrderSid?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
  phoneNumberStatus?: Maybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: Maybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type VendorTwilioPhoneConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  hostedNumberOrderSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumberStatus?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberStatus>;
  phoneNumberType?: InputMaybe<EnumVendorTwilioPhoneConfigPhoneNumberType>;
};

export type VoidInvoiceInput = {
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Waitlist = {
  __typename?: 'Waitlist';
  _id: Scalars['MongoID']['output'];
  animal: EnumWaitlistAnimal;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  sendWaitlistEmail?: Maybe<Scalars['Boolean']['output']>;
  sendWaitlistSMS?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: Maybe<Scalars['Date']['output']>;
  unsubscribeToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type WaitlistPagination = {
  __typename?: 'WaitlistPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Waitlist>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WeightedAnimalComplexAnimalCapacitySchema = {
  __typename?: 'WeightedAnimalComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ProcessingPartnersOne = {
  __typename?: 'processingPartnersOne';
  _id?: Maybe<Scalars['MongoID']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  capacityConfigurationType?: Maybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  faq?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  refundDeadlineDays: Scalars['Int']['output'];
  schedulingDeposit?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type AddressFragmentFragment = { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any };

export type CapabilitySpecificationFragment = { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null };

export type ChatMessageFragmentFragment = { __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null };

export type ChatRoomFragmentFragment = { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null };

export type CutsheetAssignmentRuleSetFragmentFragment = { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null };

export type CutsheetCapabilityFragmentFragment = { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null };

export type CutsheetCapabilityOptionFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null };

export type CutsheetCapabilityCutFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null };

export type CutsheetCapabilityExtraFragmentFragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null };

export type CutsheetFragmentFragment = { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null };

export type CutsheetCapabilityGroupFragmentFragment = { __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetQuestionnaireFragmentFragment = { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null };

export type CutsheetCapabilitySpecificationFragmentFragment = { __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null };

export type CutsheetCapabilityTrimFragmentV2Fragment = { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null };

export type ExtrasFragmentFragment = { __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null };

export type InvoiceFragmentLineItemFragment = { __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number };

export type InvoiceFragmentFragment = { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null };

export type NoteFragmentFragment = { __typename?: 'Note', _id: any, note?: string | null, type: EnumNoteType, createdAt?: any | null, updatedAt?: any | null, attachments?: Array<{ __typename?: 'NoteAttachments', url: string, filename: string, mimeType?: string | null } | null> | null, createdBy?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null };

export type NotificationSettingFragmentFragment = { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, sendEmail?: boolean | null, sendSMS?: boolean | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null };

export type PrimalCutBlockerFragmentFragment = { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null };

export type PrimalCutFragmentFragment = { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null };

export type ProcessorCapabilityFragmentFragment = { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null };

export type ContactUserFragment = { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null };

export type CutsheetInformationFragment = { __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null };

export type AnimalHeadFragment = { __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null };

export type ProcessorSchedulingFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus } | null> | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null };

export type ProcessorSchedulingCalendarFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null } | null> | null };

export type ProcessorSchedulingSlimFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null } | null> | null };

export type DailyCapacityFragmentFragment = { __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null };

export type DailyCapacityBlockFragmentFragment = { __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null };

export type ProcessorSettingsFragmentFragment = { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null };

export type ProcessorSettingsCustomCapacityFragmentFragment = { __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null };

export type ParentProductFragment = { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null };

export type ProductFragmentFragment = { __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null };

export type TenantFragmentFragment = { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> };

export type TrimFragmentFragment = { __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection };

export type UserFragmentFragment = { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, _id: any, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null };

export type VendorFragmentFragment = { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null };

export type WaitlistFragmentFragment = { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null };

export type IntegrationCreateOneMutationVariables = Exact<{
  record: CreateOneIntegrationInput;
}>;


export type IntegrationCreateOneMutation = { __typename?: 'Mutation', integrationCreateOne?: { __typename?: 'CreateOneIntegrationPayload', recordId?: any | null, record?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type IntegrationUpdateConfigMutationVariables = Exact<{
  integrationId: Scalars['MongoID']['input'];
  config: Scalars['JSON']['input'];
}>;


export type IntegrationUpdateConfigMutation = { __typename?: 'Mutation', integrationUpdateById?: { __typename?: 'UpdateByIdIntegrationPayload', recordId?: any | null } | null };

export type ProcessorSettingsUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
}>;


export type ProcessorSettingsUpdateByIdMutation = { __typename?: 'Mutation', processorSettingsUpdateById?: { __typename?: 'UpdateByIdProcessorSettingsPayload', recordId?: any | null } | null };

export type TenantCreateMutationVariables = Exact<{
  newTenant: CreateOneTenantInput;
}>;


export type TenantCreateMutation = { __typename?: 'Mutation', tenantCreate?: { __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any } | null };

export type TenantEnabledEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type TenantEnabledEditMutation = { __typename?: 'Mutation', tenantEnabledEdit?: { __typename?: 'Tenant', _id: any, enabled: boolean } | null };

export type TenantPictureUrlEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  pictureImage?: InputMaybe<Scalars['Upload']['input']>;
  pictureImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TenantPictureUrlEditMutation = { __typename?: 'Mutation', tenantPictureUrlEdit?: { __typename?: 'Tenant', external_id?: string | null, name: string, enabled: boolean, _id: any, picture_url?: string | null } | null };

export type TenantSubscriptionEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  subscription: Scalars['String']['input'];
}>;


export type TenantSubscriptionEditMutation = { __typename?: 'Mutation', tenantSubscriptionEdit?: { __typename?: 'Tenant', external_id?: string | null, external_ids?: any | null, name: string, email: string, date_created: any, picture_url?: string | null, primary_color?: string | null, domain?: string | null, enabled: boolean, _id: any } | null };

export type UserActivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserActivateMutation = { __typename?: 'Mutation', userActivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type UserCreateMutationVariables = Exact<{
  newUser: CreateOneUserInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, access_token?: string | null, refresh_token?: string | null, last_login?: number | null, _id: any } | null };

export type UserDeactivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserDeactivateMutation = { __typename?: 'Mutation', userDeactivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type VendorCreateMutationVariables = Exact<{
  newVendor: CreateOneVendorInput;
}>;


export type VendorCreateMutation = { __typename?: 'Mutation', vendorCreate?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, tagline?: string | null, enabled: boolean, annualHangingWeightThroughput?: number | null, _id: any } | null };

export type VendorModuleUpsertMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  moduleType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  label: Scalars['String']['input'];
  href: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  active: Scalars['Boolean']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type VendorModuleUpsertMutation = { __typename?: 'Mutation', vendorModuleUpsert?: { __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null } | null };

export type VendorUpdateByIdMutationVariables = Exact<{
  record: UpdateByIdVendorInput;
  _id: Scalars['MongoID']['input'];
}>;


export type VendorUpdateByIdMutation = { __typename?: 'Mutation', vendorUpdateById?: { __typename?: 'UpdateByIdVendorPayload', record?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null } | null };

export type AuthCheckUserMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthCheckUserMutation = { __typename?: 'Mutation', authCheckUser?: { __typename?: 'AuthCheckUserPayload', exists: boolean, authMethod?: string | null, requiresPasswordReset?: boolean | null, redirectUrl?: string | null, otpSent?: boolean | null, session?: string | null, message?: string | null, resetCodeSent?: boolean | null, resetDestination?: string | null } | null };

export type AuthLoginOAuthMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type AuthLoginOAuthMutation = { __typename?: 'Mutation', authLoginOAuth?: { __typename?: 'AuthLoginOAuthPayload', accessToken: string, idToken: string, refreshToken: string, expiresIn: number } | null };

export type AuthLoginPasswordMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AuthLoginPasswordMutation = { __typename?: 'Mutation', authLoginPassword?: { __typename?: 'AuthLoginPasswordPayload', accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, expiresIn?: number | null, requiresNewPassword?: boolean | null, session?: string | null } | null };

export type AuthRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AuthRefreshTokenMutation = { __typename?: 'Mutation', authRefreshToken?: { __typename?: 'AuthRefreshTokenPayload', accessToken: string, idToken: string, expiresIn: number } | null };

export type AuthSendOtpMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type AuthSendOtpMutation = { __typename?: 'Mutation', authSendOTP?: { __typename?: 'AuthSendOTPPayload', success: boolean, message: string, session?: string | null } | null };

export type AuthSetPasswordMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthSetPasswordMutation = { __typename?: 'Mutation', authSetPassword?: { __typename?: 'AuthSetPasswordPayload', accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, expiresIn?: number | null } | null };

export type AuthVerifyOtpMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthVerifyOtpMutation = { __typename?: 'Mutation', authVerifyOTP?: { __typename?: 'AuthVerifyOTPPayload', accessToken?: string | null, idToken?: string | null, refreshToken?: string | null, expiresIn?: number | null, requiresProfileCompletion?: boolean | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', success: boolean, message: string } | null };

export type ChatRoomCreateOneMutationVariables = Exact<{
  record: CreateOneChatRoomInput;
}>;


export type ChatRoomCreateOneMutation = { __typename?: 'Mutation', chatRoomCreateOne?: { __typename?: 'CreateOneChatRoomPayload', recordId?: any | null, record?: { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null } | null } | null };

export type CreateProcessorSchedulingMutationVariables = Exact<{
  newSchedule: CreateProcessorSchedulingInput;
}>;


export type CreateProcessorSchedulingMutation = { __typename?: 'Mutation', processorSchedulingCreate?: { __typename?: 'CreateProcessorScheduleResponse', messages?: Array<string | null> | null, scheduling: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus } | null> | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null }, checkoutSession?: { __typename?: 'CheckoutSessionResponse', clientSecret: string } | null } | null };

export type CsvImportCancelJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
}>;


export type CsvImportCancelJobMutation = { __typename?: 'Mutation', csvImportCancelJob?: { __typename?: 'CSVImportCancelJobPayload', jobId: string, status: string, cancelledAt: any, cancelledAtStage: string, message: string } | null };

export type CsvImportDeleteRecordMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
}>;


export type CsvImportDeleteRecordMutation = { __typename?: 'Mutation', csvImportDeleteRecord?: { __typename?: 'CSVImportDeleteRecordPayload', jobId: string, deletedRows: Array<number>, validRows: number } | null };

export type CsvImportExecuteMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportExecuteMutation = { __typename?: 'Mutation', csvImportExecute?: { __typename?: 'CSVImportExecutePayload', jobId: string, status: string, message?: string | null } | null };

export type CsvImportRevalidateMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;


export type CsvImportRevalidateMutation = { __typename?: 'Mutation', csvImportRevalidate?: { __typename?: 'CSVImportRevalidatePayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string> }> } | null };

export type CsvImportSaveColumnMappingMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  columnMapping: Scalars['JSON']['input'];
}>;


export type CsvImportSaveColumnMappingMutation = { __typename?: 'Mutation', csvImportSaveColumnMapping?: { __typename?: 'CSVImportSaveColumnMappingPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, s3Keys?: any | null, parsedData?: any | null, columns: Array<string>, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportUpdateRowsMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  updatedRows: Scalars['JSON']['input'];
}>;


export type CsvImportUpdateRowsMutation = { __typename?: 'Mutation', csvImportUpdateRows?: { __typename?: 'CSVImportUpdateRowsPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportForceCancelMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportForceCancelMutation = { __typename?: 'Mutation', csvImportForceCancel?: { __typename?: 'CSVImportForceCancelPayload', jobId: string, status: string, cancelledAt: any, message: string, warning?: string | null } | null };

export type CsvImportUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  type: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
  tenantId: Scalars['MongoID']['input'];
}>;


export type CsvImportUploadMutation = { __typename?: 'Mutation', csvImportUpload?: { __typename?: 'CSVImportUploadPayload', jobId: string, totalRows: number, validRows: number, invalidRows: number, validFilePath?: string | null, invalidFilePath?: string | null, detectedColumns: Array<string>, suggestedMapping?: any | null, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string> }>, availableColumns: Array<{ __typename?: 'AvailableColumn', fieldName: string, aliases: Array<string>, required: boolean, description: string, validationRules?: string | null }> } | null };

export type CutsheetAssignmentRuleSetDeleteMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetAssignmentRuleSetDeleteMutation = { __typename?: 'Mutation', cutsheetAssignmentRuleSetDelete?: boolean | null };

export type CutsheetAssignmentRuleSetUpsertMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  rules?: InputMaybe<Array<CutsheetAssignmentRuleInput> | CutsheetAssignmentRuleInput>;
  defaultQuestionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetAssignmentRuleSetUpsertMutation = { __typename?: 'Mutation', cutsheetAssignmentRuleSetUpsert?: { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null } | null };

export type CutsheetCapabilityDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityDeleteMutation = { __typename?: 'Mutation', CutsheetCapabilityDelete: boolean };

export type CutsheetCapabilityUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  species: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityUpsertMutation = { __typename?: 'Mutation', CutsheetCapabilityUpsert?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilityDuplicateMutationVariables = Exact<{
  sourceCapabilityId: Scalars['MongoID']['input'];
  targetCapabilityId: Scalars['MongoID']['input'];
  includeQuestionnaires: Scalars['Boolean']['input'];
  includeAssignmentRules: Scalars['Boolean']['input'];
}>;


export type CutsheetCapabilityDuplicateMutation = { __typename?: 'Mutation', CutsheetCapabilityDuplicate?: { __typename?: 'CutsheetCapabilityDuplicateResponse', capability?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null, summary?: { __typename?: 'CutsheetCapabilityDuplicateSummary', groupsCopied: number, optionsCopied: number, specificationsCopied: number, questionnairesCopied: number, assignmentRulesCopied: number } | null } | null };

export type CutsheetCapabilityGenerateBlankCutsheetMutationVariables = Exact<{
  cutsheetCapabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGenerateBlankCutsheetMutation = { __typename?: 'Mutation', cutsheetCapabilityGenerateBlankCutsheet?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type CutsheetCapabilityMigrateLegacyMutationVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deactivateUnusedCuts?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityMigrateLegacyMutation = { __typename?: 'Mutation', CutsheetCapabilityMigrateLegacy?: { __typename?: 'CutsheetCapabilityMigrateLegacyResponse', capability?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null, summary?: { __typename?: 'CutsheetCapabilityMigrateLegacySummary', inspectionLevelsMigrated: Array<string>, groupsCreated: number, groupsReused: number, cutsCreated: number, cutsReused: number, trimsCreated: number, trimsReused: number, specificationsCreated: number, specificationsReused: number, questionnairesCreated: number, questionnairesReused: number, assignmentRulesAdded: number } | null } | null };

export type CutsheetCapabilityOptionDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionDeleteMutation = { __typename?: 'Mutation', cutsheetCapabilityOptionDelete: boolean };

export type CutsheetCapabilityOptionUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  optionType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CutsheetCapabilityOptionSpecificationInput> | CutsheetCapabilityOptionSpecificationInput>;
  pricing?: InputMaybe<CutsheetCapabilityOptionPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityOptionUpsertMutation = { __typename?: 'Mutation', cutsheetCapabilityOptionUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null };

export type CutsheetCapabilityPrintSettingsUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  baseFontSize: Scalars['Float']['input'];
  primalColumns: Scalars['Float']['input'];
  specsLayoutPosition: Scalars['String']['input'];
  checkboxStyle: Scalars['String']['input'];
  showPrimalGroup: Scalars['Boolean']['input'];
  alwaysShowPrimalNotes: Scalars['Boolean']['input'];
  hideUnselectedCuts: Scalars['Boolean']['input'];
  orientation: Scalars['String']['input'];
  hiddenGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hiddenItemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hiddenSpecificationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CutsheetCapabilityPrintSettingsUpdateMutation = { __typename?: 'Mutation', CutsheetCapabilityPrintSettingsUpdate?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilitySetLegacyMapMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  legacyInspectionLevelMap: Array<CutsheetLegacyInspectionLevelEntryInput> | CutsheetLegacyInspectionLevelEntryInput;
}>;


export type CutsheetCapabilitySetLegacyMapMutation = { __typename?: 'Mutation', CutsheetCapabilitySetLegacyMap?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCreateOneMutationVariables = Exact<{
  record: CreateOneCutsheetInput;
}>;


export type CutsheetCreateOneMutation = { __typename?: 'Mutation', cutsheetCreateOne?: { __typename?: 'CreateOneCutsheetPayload', recordId?: any | null, record?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null } | null };

export type CutsheetCapabilityCutDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityCutDeleteMutation = { __typename?: 'Mutation', cutsheetCutDelete: boolean };

export type CutsheetCapabilityCutUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  groupId?: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CutsheetCutSpecificationInput> | CutsheetCutSpecificationInput>;
  pricing?: InputMaybe<CutsheetCutPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityCutUpsertMutation = { __typename?: 'Mutation', cutsheetCutUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null };

export type CutsheetCapabilityExtraDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityExtraDeleteMutation = { __typename?: 'Mutation', cutsheetExtraDelete: boolean };

export type CutsheetCapabilityExtraUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  hasCharge?: InputMaybe<Scalars['Boolean']['input']>;
  specifications?: InputMaybe<Array<CutsheetExtraSpecificationInput> | CutsheetExtraSpecificationInput>;
  pricing?: InputMaybe<CutsheetExtraPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityExtraUpsertMutation = { __typename?: 'Mutation', cutsheetExtraUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null };

export type CutsheetCapabilityGroupDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGroupDeleteMutation = { __typename?: 'Mutation', cutsheetGroupDelete: boolean };

export type CutsheetCapabilityGroupReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityGroupReorderMutation = { __typename?: 'Mutation', cutsheetGroupReorder: boolean };

export type CutsheetCapabilityGroupUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityGroupUpsertMutation = { __typename?: 'Mutation', cutsheetGroupUpsert?: { __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type CutsheetMarkConvertedMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
  responseId: Scalars['MongoID']['input'];
}>;


export type CutsheetMarkConvertedMutation = { __typename?: 'Mutation', cutsheetMarkConverted?: { __typename?: 'Cutsheet', _id: any, convertedToQuestionnaireResponse?: any | null } | null };

export type CutsheetCapabilityOptionReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionReorderMutation = { __typename?: 'Mutation', cutsheetOptionReorder: boolean };

export type CutsheetQuestionnaireDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireDeleteMutation = { __typename?: 'Mutation', cutsheetQuestionnaireDelete: boolean };

export type CutsheetQuestionnaireResponseSoftDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseSoftDeleteMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseSoftDelete: boolean };

export type CutsheetQuestionnaireResponseUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireId: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  selectedCuts?: InputMaybe<Array<InputMaybe<CutsheetResponseCutOptionInput>> | InputMaybe<CutsheetResponseCutOptionInput>>;
  trimSelections?: InputMaybe<CutsheetResponseTrimResponseInput>;
  specifications?: InputMaybe<Array<InputMaybe<CutsheetResponseSpecificationSelectionInput>> | InputMaybe<CutsheetResponseSpecificationSelectionInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetQuestionnaireResponseUpsertMutation = { __typename?: 'Mutation', cutsheetQuestionnaireResponseUpsert?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, questionnaire: any, capabilitySet: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null };

export type CutsheetQuestionnaireUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  capabilityId: Scalars['MongoID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CutsheetQuestionInput> | CutsheetQuestionInput>;
  pricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetPricingOverrideEntryInput>> | InputMaybe<CutsheetPricingOverrideEntryInput>>;
  specOptionPricingOverrides?: InputMaybe<Array<InputMaybe<CutsheetSpecOptionPricingEntryInput>> | InputMaybe<CutsheetSpecOptionPricingEntryInput>>;
  defaultSelections?: InputMaybe<CutsheetQuestionnaireDefaultSelectionsInput>;
  useCustomPrintSettings?: InputMaybe<Scalars['Boolean']['input']>;
  printSettings?: InputMaybe<CutsheetQuestionnairePrintSettingsInput>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetQuestionnaireUpsertMutation = { __typename?: 'Mutation', cutsheetQuestionnaireUpsert?: { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null } | null };

export type CutsheetSoftDeleteMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
}>;


export type CutsheetSoftDeleteMutation = { __typename?: 'Mutation', cutsheetSoftDelete?: { __typename?: 'Cutsheet', _id: any } | null };

export type CutsheetCapabilitySpecificationDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilitySpecificationDeleteMutation = { __typename?: 'Mutation', cutsheetSpecificationDelete: boolean };

export type CutsheetCapabilitySpecificationReorderMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilitySpecificationReorderMutation = { __typename?: 'Mutation', cutsheetSpecificationReorder: boolean };

export type CutsheetCapabilitySpecificationUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  inputType: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  pricingAdjustments?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilitySpecificationUpsertMutation = { __typename?: 'Mutation', cutsheetSpecificationUpsert?: { __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type CutsheetCapabilityTrimDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityTrimDeleteMutation = { __typename?: 'Mutation', cutsheetTrimDelete: boolean };

export type CutsheetCapabilityTrimUpsertMutationVariables = Exact<{
  id?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  capabilityId: Scalars['MongoID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  minQty?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<CutsheetTrimSpecificationInput> | CutsheetTrimSpecificationInput>;
  pricing?: InputMaybe<CutsheetTrimPricingInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  printedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityTrimUpsertMutation = { __typename?: 'Mutation', cutsheetTrimUpsert?: { __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null };

export type CutsheetUpsertMutationVariables = Exact<{
  parentCutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumCutsheetType>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>> | InputMaybe<EnumCutsheetInspectionLevels>>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  extras?: InputMaybe<Array<CutsheetExtrasTypeInput> | CutsheetExtrasTypeInput>;
  trim?: InputMaybe<Array<CutsheetTrimTypeInput> | CutsheetTrimTypeInput>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetUpsertMutation = { __typename?: 'Mutation', cutsheetUpsert?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null };

export type GenerateUploadUrlMutationVariables = Exact<{
  key: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateUploadUrlMutation = { __typename?: 'Mutation', generateUploadUrl?: { __typename?: 'GenerateUploadUrlPayload', uploadUrl: string, cdnUrl: string } | null };

export type IntegrationInitMutationVariables = Exact<{
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
}>;


export type IntegrationInitMutation = { __typename?: 'Mutation', integrationInit?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any } | null };

export type InvoiceCreateForSchedulingJobMutationVariables = Exact<{
  input: CreateInvoiceForSchedulingJobInput;
}>;


export type InvoiceCreateForSchedulingJobMutation = { __typename?: 'Mutation', invoiceCreateForSchedulingJob?: { __typename?: 'Invoice', _id: any, number?: string | null, status: EnumInvoiceStatus, amount_due: number, amount_discounted?: number | null, due_date: any, type: EnumInvoiceType, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null } | null } | null };

export type InvoiceFinalizeAndSendMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceFinalizeAndSendMutation = { __typename?: 'Mutation', invoiceFinalizeAndSend?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type GenerateInvoicePdfMutationVariables = Exact<{
  invoiceId: Scalars['MongoID']['input'];
}>;


export type GenerateInvoicePdfMutation = { __typename?: 'Mutation', generateInvoicePdf?: { __typename?: 'GenerateInvoicePdfResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type InvoiceMarkAsPaidMutationVariables = Exact<{
  input?: InputMaybe<MarkAsPaidInput>;
}>;


export type InvoiceMarkAsPaidMutation = { __typename?: 'Mutation', invoiceMarkAsPaid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceRefundMutationVariables = Exact<{
  input?: InputMaybe<RefundInvoiceInput>;
}>;


export type InvoiceRefundMutation = { __typename?: 'Mutation', invoiceRefund?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceUpdateMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvoiceInput>;
}>;


export type InvoiceUpdateMutation = { __typename?: 'Mutation', invoiceUpdate?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceVoidMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceVoidMutation = { __typename?: 'Mutation', invoiceVoid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type NoteDeleteMutationVariables = Exact<{
  noteId: Scalars['MongoID']['input'];
}>;


export type NoteDeleteMutation = { __typename?: 'Mutation', noteDelete?: { __typename?: 'Note', _id: any } | null };

export type NoteUpsertMutationVariables = Exact<{
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  note: Scalars['String']['input'];
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  removeAttachmentUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type NoteUpsertMutation = { __typename?: 'Mutation', noteUpsert?: { __typename?: 'Note', _id: any } | null };

export type NotificationSettingsUpdateMutationVariables = Exact<{
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
}>;


export type NotificationSettingsUpdateMutation = { __typename?: 'Mutation', notificationSettingsUpdate?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, sendEmail?: boolean | null, sendSMS?: boolean | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null } | null };

export type ParseCutsheetMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  capabilityId: Scalars['MongoID']['input'];
}>;


export type ParseCutsheetMutation = { __typename?: 'Mutation', parseCutsheet?: { __typename?: 'ParseCutsheetPayload', catalog: { __typename?: 'ParsedCutsheetCatalog', name: string, description?: string | null, animalType: string, primals: Array<{ __typename?: 'ParsedCutsheetGroup', title: string, description?: string | null }>, cuts: Array<{ __typename?: 'ParsedCutsheetCut', title: string, description?: string | null, primalName?: string | null, pricePerPound?: number | null, priceFee?: number | null, priceFeePerPound?: number | null, minLbs?: number | null }>, specifications: Array<{ __typename?: 'ParsedCutsheetSpecification', title: string, description?: string | null, cutName?: string | null, options?: Array<string> | null }>, trim: Array<{ __typename?: 'ParsedCutsheetTrim', title: string, description?: string | null, pricePerPound?: number | null, priceFee?: number | null, minLbs?: number | null }>, extras: Array<{ __typename?: 'ParsedCutsheetExtra', title: string, description?: string | null, pricePerPound?: number | null, priceFee?: number | null, minLbs?: number | null }> }, questionnaire: { __typename?: 'ParsedCutsheetQuestionnaire', name: string, description?: string | null, animalType: string, questions: Array<{ __typename?: 'ParsedCutsheetQuestion', id: string, type: string, title: string, description?: string | null, required?: boolean | null, sortOrder: number, details?: string | null, imageUrl?: string | null, availableCutIds?: Array<string> | null, allowMultiple?: boolean | null, specificationId?: string | null, availableTrimIds?: Array<string> | null, requireExactTotal?: boolean | null }> } } | null };

export type SearchAvailablePhoneNumbersQueryVariables = Exact<{
  input: SearchAvailablePhoneNumbersInput;
}>;


export type SearchAvailablePhoneNumbersQuery = { __typename?: 'Query', searchAvailablePhoneNumbers?: Array<{ __typename?: 'AvailablePhoneNumber', phoneNumber: string, friendlyName: string, locality?: string | null, region?: string | null, capabilities?: { __typename?: 'AvailablePhoneNumberCapabilities', voice: boolean, sms: boolean, mms: boolean } | null } | null> | null };

export type ProvisionPhoneNumberMutationVariables = Exact<{
  input: ProvisionPhoneNumberInput;
}>;


export type ProvisionPhoneNumberMutation = { __typename?: 'Mutation', provisionPhoneNumber?: { __typename?: 'ProvisionPhoneNumberResponse', success: boolean, error?: string | null, phoneNumber?: string | null, phoneNumberSid?: string | null } | null };

export type ReleasePhoneNumberMutationVariables = Exact<{
  input: ReleasePhoneNumberInput;
}>;


export type ReleasePhoneNumberMutation = { __typename?: 'Mutation', releasePhoneNumber?: { __typename?: 'ReleasePhoneNumberResponse', success: boolean, error?: string | null } | null };

export type SubmitHostedLandlineOrderMutationVariables = Exact<{
  input: SubmitHostedLandlineOrderInput;
}>;


export type SubmitHostedLandlineOrderMutation = { __typename?: 'Mutation', submitHostedLandlineOrder?: { __typename?: 'SubmitHostedLandlineOrderResponse', success: boolean, error?: string | null, hostedNumberOrderSid?: string | null, status?: string | null } | null };

export type RefreshHostedNumberStatusMutationVariables = Exact<{
  input: RefreshHostedNumberStatusInput;
}>;


export type RefreshHostedNumberStatusMutation = { __typename?: 'Mutation', refreshHostedNumberStatus?: { __typename?: 'RefreshHostedNumberStatusResponse', success: boolean, error?: string | null, status?: string | null, phoneNumberSid?: string | null, isProvisioned?: boolean | null } | null };

export type UpdatePhoneNumberSmsWebhookMutationVariables = Exact<{
  input: UpdatePhoneNumberSmsWebhookInput;
}>;


export type UpdatePhoneNumberSmsWebhookMutation = { __typename?: 'Mutation', updatePhoneNumberSmsWebhook?: { __typename?: 'UpdatePhoneNumberSmsWebhookResponse', success: boolean, error?: string | null, phoneNumber?: string | null } | null };

export type AddPhoneToMessagingServiceMutationVariables = Exact<{
  input: AddPhoneToMessagingServiceInput;
}>;


export type AddPhoneToMessagingServiceMutation = { __typename?: 'Mutation', addPhoneToMessagingService?: { __typename?: 'AddPhoneToMessagingServiceResponse', success: boolean, error?: string | null } | null };

export type PrimalCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalInput;
}>;


export type PrimalCreateOneMutation = { __typename?: 'Mutation', primalCreateOne?: { __typename?: 'CreateOnePrimalPayload', recordId?: any | null } | null };

export type PrimalCutBlockerUpsertMutationVariables = Exact<{
  animalSpecies: Scalars['String']['input'];
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  blockedBy: Array<BlockedByInput> | BlockedByInput;
}>;


export type PrimalCutBlockerUpsertMutation = { __typename?: 'Mutation', primalCutBlockerUpsert?: { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null } | null };

export type PrimalCutCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutInput;
}>;


export type PrimalCutCreateOneMutation = { __typename?: 'Mutation', primalCutCreateOne?: { __typename?: 'CreateOnePrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalCutSoftDeleteMutationVariables = Exact<{
  primalCutId: Scalars['MongoID']['input'];
}>;


export type PrimalCutSoftDeleteMutation = { __typename?: 'Mutation', primalCutSoftDelete?: { __typename?: 'PrimalCut', _id: any, primal?: { __typename?: 'Primal', _id: any, group?: { __typename?: 'PrimalGroup', _id: any } | null } | null } | null };

export type PrimalCutTypeCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutTypeInput;
}>;


export type PrimalCutTypeCreateOneMutation = { __typename?: 'Mutation', primalCutTypeCreateOne?: { __typename?: 'CreateOnePrimalCutTypePayload', recordId?: any | null } | null };

export type PrimalCutUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
}>;


export type PrimalCutUpdateByIdMutation = { __typename?: 'Mutation', primalCutUpdateById?: { __typename?: 'UpdateByIdPrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalGroupSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalGroupSoftDeleteByIdMutation = { __typename?: 'Mutation', primalGroupUpdateById?: { __typename?: 'UpdateByIdPrimalGroupPayload', record?: { __typename?: 'PrimalGroup', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalSoftDeleteByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', record?: { __typename?: 'Primal', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
}>;


export type PrimalUpdateByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', recordId?: any | null } | null };

export type ProcessingJobForceUpdateStatusMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  processorSchedulingStatus: Scalars['String']['input'];
}>;


export type ProcessingJobForceUpdateStatusMutation = { __typename?: 'Mutation', processingJobForceUpdateStatus?: { __typename?: 'ProcessorSchedulingForceUpdateStatusResponse', recordId?: any | null, previousStatus?: string | null, newStatus?: string | null, record?: { __typename?: 'ProcessorScheduling', _id: any, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null } | null } | null };

export type ProcessorCapabilityUpsertMutationVariables = Exact<{
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  trimSelection: EnumProcessorCapabilityTrimSelection;
  extras?: InputMaybe<Array<ProcessorCapabilityExtrasModelInput> | ProcessorCapabilityExtrasModelInput>;
  trim?: InputMaybe<Array<ProcessorCapabilityTrimModelInput> | ProcessorCapabilityTrimModelInput>;
  specifications?: InputMaybe<Array<ProcessorCapabilitySpecificationSpecificationsInput> | ProcessorCapabilitySpecificationSpecificationsInput>;
  primalGroups?: InputMaybe<Array<ProcessorCapabilityPrimalGroupInput> | ProcessorCapabilityPrimalGroupInput>;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  extrasImage?: InputMaybe<Scalars['Upload']['input']>;
  extrasImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
  trimImage?: InputMaybe<Scalars['Upload']['input']>;
  trimImageToRemove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorCapabilityUpsertMutation = { __typename?: 'Mutation', processorCapabilityUpsert?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null } | null };

export type ProcessorExportCsvMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  type: ProcessorExportTypeEnum;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  anchorDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorExportCsvMutation = { __typename?: 'Mutation', processorExportCsv?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorExportCsvByVendorIdMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorExportCsvByVendorIdMutation = { __typename?: 'Mutation', processorExportCsvByVendorId?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>> | InputMaybe<AnimalHeadUpdatesInput>>;
}>;


export type ProcessorSchedulingAnimalHeadBulkUpdateMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadBulkUpdate?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingAnimalHeadDeleteMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingAnimalHeadDeleteMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadDelete?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateAnimalHeadInput;
}>;


export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, tracking?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, liveWeight?: number | null, killDate?: any | null } | null> | null } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingBuyerCutsheetReminderMutationVariables = Exact<{
  schedulingId: Scalars['MongoID']['input'];
  contactUserId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingBuyerCutsheetReminderMutation = { __typename?: 'Mutation', processorSchedulingBuyerCutsheetReminder?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingCutsheetReminderMutationVariables = Exact<{
  schedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingCutsheetReminderMutation = { __typename?: 'Mutation', processorSchedulingCutsheetReminder?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus } | null> | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetsPartialUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: Array<InputMaybe<CutsheetPartialUpdateInput>> | InputMaybe<CutsheetPartialUpdateInput>;
}>;


export type ProcessorSchedulingCutsheetsPartialUpdateMutation = { __typename?: 'Mutation', processorSchedulingUpdateCutsheets?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null } | null };

export type ProcessorSchedulingDragAndDropUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  eventType: Scalars['String']['input'];
  eventDate: Scalars['String']['input'];
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingDragAndDropUpdateMutation = { __typename?: 'Mutation', processorSchedulingDragAndDropUpdate?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingGenerateBillingStatementMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateBillingStatementMutation = { __typename?: 'Mutation', processorSchedulingGenerateBillingStatement?: { __typename?: 'GenerateBillingStatementResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCarcassTagsMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingGenerateCarcassTagsMutation = { __typename?: 'Mutation', processorSchedulingGenerateCarcassTags?: { __typename?: 'GenerateCarcassTagsResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCsvByVendorIdMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateCsvByVendorIdMutation = { __typename?: 'Mutation', processorSchedulingGenerateCsvByVendorId?: { __typename?: 'GenerateCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateCutsheetRequestMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  cutsheetRequestId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateCutsheetRequestMutation = { __typename?: 'Mutation', processorSchedulingGenerateCutsheetRequest?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateHangingWeightCsvMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateHangingWeightCsvMutation = { __typename?: 'Mutation', processorSchedulingGenerateHangingWeightCsv?: { __typename?: 'GenerateHangingWeightCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateKillSheetMutationVariables = Exact<{
  date: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateKillSheetMutation = { __typename?: 'Mutation', processorSchedulingGenerateKillSheet?: { __typename?: 'GenerateKillSheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGeneratePackingSlipMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  cutsheetInformationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProcessorSchedulingGeneratePackingSlipMutation = { __typename?: 'Mutation', processorSchedulingGeneratePackingSlip?: { __typename?: 'GeneratePackingSlipResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingNotificationSendMutationVariables = Exact<{
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
  notificationRequest?: InputMaybe<NotificationRequestInput>;
}>;


export type ProcessorSchedulingNotificationSendMutation = { __typename?: 'Mutation', processorSchedulingNotificationSend?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateInput;
}>;


export type ProcessorSchedulingPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: Array<InputMaybe<CutsheetPartialUpdateInput>> | InputMaybe<CutsheetPartialUpdateInput>;
}>;


export type ProcessorSchedulingCutsheetInformationPartialUpdateMutation = { __typename?: 'Mutation', processorSchedulingUpdateCutsheets?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null } | null };

export type ProcessorSchedulingSplitTypeUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingSplitTypeUpdateInput;
}>;


export type ProcessorSchedulingSplitTypeUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingSplitTypeUpdateById?: { __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse', recordId?: any | null } | null };

export type ProcessorSchedulingUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
}>;


export type ProcessorSchedulingUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingUpdate?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', status: EnumProcessorSchedulingStatus } | null } | null };

export type ProcessorSettingsCreateMutationVariables = Exact<{
  newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsCreateMutation = { __typename?: 'Mutation', processorSettingsCreate?: { __typename?: 'CreateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type ProcessorSettingsUpdateMutationVariables = Exact<{
  updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsUpdateMutation = { __typename?: 'Mutation', processorSettingsUpdate?: { __typename?: 'UpdateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type CreateFinancialReportingConfigMutationVariables = Exact<{
  record: CreateOneFinancialReportingConfigInput;
}>;


export type CreateFinancialReportingConfigMutation = { __typename?: 'Mutation', financialReportingConfigCreateOne?: { __typename?: 'CreateOneFinancialReportingConfigPayload', record?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, createdAt?: any | null, updatedAt?: any | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type UpdateFinancialReportingConfigMutationVariables = Exact<{
  filter: FilterUpdateOneFinancialReportingConfigInput;
  record: UpdateOneFinancialReportingConfigInput;
}>;


export type UpdateFinancialReportingConfigMutation = { __typename?: 'Mutation', financialReportingConfigUpdateOne?: { __typename?: 'UpdateOneFinancialReportingConfigPayload', record?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, updatedAt?: any | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type SendMessageMutationVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  message: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null } | null };

export type SendTestNotificationMutationVariables = Exact<{
  notificationSettingId: Scalars['MongoID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  smsContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification?: { __typename?: 'SendTestNotificationResult', emailSent: boolean, smsSent: boolean, errors: Array<string> } | null };

export type StripeAccountCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeAccountCreateMutation = { __typename?: 'Mutation', stripeAccountCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type StripeSessionCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeSessionCreateMutation = { __typename?: 'Mutation', stripeSessionCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type UpdateAuthMethodMutationVariables = Exact<{
  targetAuthMethod: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAuthMethodMutation = { __typename?: 'Mutation', updateAuthMethod?: { __typename?: 'UpdateAuthMethodPayload', success: boolean, message: string, authMethod: string } | null };

export type UpdateProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInputForProfile>;
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveEmailUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveSms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, tos_accepted_at?: any | null, privacy_policy_accepted_at?: any | null, can_receive_email_updates?: boolean | null, can_receive_sms?: boolean | null, address?: { __typename?: 'Address', _id: any, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string } | null } | null };

export type UserBasicUpsertMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInputForUser>;
  relationships?: InputMaybe<Array<InputMaybe<RelationshipsInputForUser>> | InputMaybe<RelationshipsInputForUser>>;
}>;


export type UserBasicUpsertMutation = { __typename?: 'Mutation', userBasicUpsert?: { __typename?: 'UserBasicUpsertPayload', message?: string | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, role?: EnumUserRole | null, enabled: boolean, address?: { __typename?: 'Address', _id: any, address_1: string, address_2?: string | null, city: string, state: string, postcode: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null } | null };

export type UserSettingsUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  settings: UserSettingsInput;
}>;


export type UserSettingsUpdateMutation = { __typename?: 'Mutation', userSettingsUpdate?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, _id: any, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserUpdateActiveVendorMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  active_vendor: Scalars['MongoID']['input'];
}>;


export type UserUpdateActiveVendorMutation = { __typename?: 'Mutation', userUpdateById?: { __typename?: 'UpdateByIdUserPayload', recordId?: any | null } | null };

export type UserUpdateRoleMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  role: EnumUserRole;
}>;


export type UserUpdateRoleMutation = { __typename?: 'Mutation', userUpdateById?: { __typename?: 'UpdateByIdUserPayload', record?: { __typename?: 'User', _id: any, role?: EnumUserRole | null, first_name?: string | null, last_name?: string | null, email?: string | null } | null } | null };

export type WaitlistAddMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  animal: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type WaitlistAddMutation = { __typename?: 'Mutation', waitlistAdd?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type WaitlistDeleteMutationVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
}>;


export type WaitlistDeleteMutation = { __typename?: 'Mutation', waitlistDelete?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type WaitlistUnsubscribeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type WaitlistUnsubscribeMutation = { __typename?: 'Mutation', waitlistUnsubscribe?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type ViewProcessingPartnerQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewProcessingPartnerQuery = { __typename?: 'Query', processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, about?: string | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, isWaitlistFunctionalityDisabled?: boolean | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null };

export type ViewProcessorAdminQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
}>;


export type ViewProcessorAdminQuery = { __typename?: 'Query', processorSettingsOne?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null }>, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, processorCapabilityMany: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null }> };

export type ViewProcessorAdminLightQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
}>;


export type ViewProcessorAdminLightQuery = { __typename?: 'Query', processorSettingsOne?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, note?: string | null, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null }>, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, processorCapabilityMany: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null }> };

export type ViewSchedulingCreateQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  animalSpeciesCutsheet: EnumCutsheetAnimalSpecies;
  animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies;
  statuses?: InputMaybe<Array<EnumProcessorSchedulingStatus> | EnumProcessorSchedulingStatus>;
}>;


export type ViewSchedulingCreateQuery = { __typename?: 'Query', cutsheetMany: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorCapabilityOne?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null } | null, processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, faq?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, vendor?: { __typename?: 'ProcessingPartnerVendor', shop_name?: string | null, _id?: any | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null, processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null } | null> | null }> };

export type ViewSchedulingEditQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type ViewSchedulingEditQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, isDeleted?: boolean | null, status: EnumProcessorSchedulingStatus, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean } | null } | null> | null } | null> | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendorCutsheets: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', isEnabled: boolean, pricePerHead: number, species: EnumProcessorSettingsKillAndChillSettingsSpecies } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, species: EnumProcessorSettingsAnimalSettingsSpecies, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null } | null> | null, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null, _id: any } | null } | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', date: any, capacity?: any | null, isDeleted: boolean, _id: any }>, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', animal?: string | null, price: number } | null> | null } | null, processorCapabilities: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, extrasImageUrl?: string | null, trimImageUrl?: string | null, cuts?: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, isDeleted?: boolean | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, isDeleted?: boolean | null, processorSettings?: any | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups?: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals?: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, imageUrl?: string | null, order: number } | null> | null } | null> | null }> } | null, cutsheetMany: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> };

export type ActiveVendorListQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveVendorListQuery = { __typename?: 'Query', activeVendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, enabled: boolean } | null> | null };

export type AdminUserSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUserSearchQuery = { __typename?: 'Query', adminUserSearch: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, role?: EnumUserRole | null, enabled: boolean, company?: string | null, active_vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', type?: EnumUserRelationshipsType | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null } | null> | null }> };

export type TenantByIdQueryVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
}>;


export type TenantByIdQuery = { __typename?: 'Query', tenantById?: { __typename?: 'Tenant', _id: any, date_created: any, domain?: string | null, email: string, enabled: boolean, external_id?: string | null, external_ids?: any | null, name: string, picture_url?: string | null, primary_color?: string | null, users: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, enabled: boolean, _id: any }>, vendors: Array<{ __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, shop_url?: string | null, tagline?: string | null, prefers_dropoff?: boolean | null, pickup_days?: Array<number | null> | null, free_shipping_amount?: number | null, enabled: boolean, show_in_directory: boolean, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', config?: any | null, name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any }>, processorSettings?: { __typename?: 'ProcessorSettings', isEnabled?: boolean | null, commercialStartDate?: any | null, _id: any } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }> }> } | null };

export type TenantFilteredQueryVariables = Exact<{
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyTenantInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TenantFilteredQuery = { __typename?: 'Query', getFilteredTenants?: { __typename?: 'TenantPagination', count?: number | null, items?: Array<{ __typename?: 'Tenant', _id: any, external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, users: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, role?: EnumUserRole | null }>, vendors: Array<{ __typename?: 'Vendor', _id: any, date_created: any, shop_name: string, shop_slug?: string | null, enabled: boolean }> }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type TenantPaginationQueryVariables = Exact<{
  sort: SortFindManyTenantInput;
  filter: FilterFindManyTenantInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TenantPaginationQuery = { __typename?: 'Query', tenantPagination?: { __typename?: 'TenantPagination', count?: number | null, items?: Array<{ __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any, users: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, role?: EnumUserRole | null, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, shop_name: string, shop_slug?: string | null, enabled: boolean, _id: any }> }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type BuyerJobCutsheetByIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
}>;


export type BuyerJobCutsheetByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any } | null } | null> | null } | null> | null } | null };

export type CalculateProcessorCapacityAllSpeciesQueryVariables = Exact<{
  vendorId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  groupFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateProcessorCapacityAllSpeciesQuery = { __typename?: 'Query', calculateProcessorCapacityAllSpecies?: { __typename?: 'CapacityCalculationAllSpeciesResult', spotGroups: any, totalSpots: number, hasAvailableSpots: boolean, bySpecies: any } | null };

export type CalculateProcessorCapacityQueryVariables = Exact<{
  vendorId: Scalars['String']['input'];
  selectedAnimalSpecies: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  groupFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateProcessorCapacityQuery = { __typename?: 'Query', calculateProcessorCapacity?: { __typename?: 'CapacityCalculationResult', spotGroups: any, totalSpots: number, hasAvailableSpots: boolean } | null };

export type CancellationReasonManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
}>;


export type CancellationReasonManyQuery = { __typename?: 'Query', cancellationReasonMany: Array<{ __typename?: 'CancellationReason', reason: string, index?: number | null, isEnabled: boolean, _id: any }> };

export type CsvImportJobStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CsvImportJobStatusQuery = { __typename?: 'Query', csvImportJobStatus?: { __typename?: 'CSVImportJobStatus', jobId: string, type: string, status: string, totalRows: number, validRows: number, invalidRows: number, processedCount: number, successCount: number, failureCount: number, s3Keys?: any | null, deletedRows: Array<number>, createdAt: any, completedAt?: any | null, failures: Array<{ __typename?: 'CSVImportFailure', row: number, error: string }>, validationErrors: Array<{ __typename?: 'CSVValidationError', row: number, errorMessages: Array<string>, warningMessages?: Array<string> | null }> } | null };

export type CsvImportJobsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CsvImportJobsQuery = { __typename?: 'Query', csvImportJobs?: { __typename?: 'CSVImportJobsPayload', total: number, hasMore: boolean, jobs: Array<{ __typename?: 'CSVImportJobItem', jobId: string, type: string, status: string, totalRows?: number | null, validRows?: number | null, invalidRows?: number | null, processedCount?: number | null, successCount?: number | null, failureCount?: number | null, s3Keys?: any | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null }> } | null };

export type CutsheetQuestionnaireResponseSearchQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
  capabilitySetId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetQuestionnaireResponseType>> | InputMaybe<EnumCutsheetQuestionnaireResponseType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetQuestionnaireResponseInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetQuestionnaireResponseSearchQuery = { __typename?: 'Query', cutsheetQuestionnaireResponseSearch?: { __typename?: 'CutsheetQuestionnaireResponsePagination', count?: number | null, items?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, type: EnumCutsheetQuestionnaireResponseType, createdAt?: any | null, questionnaire: any, questionnaireName?: string | null, user?: any | null, userFullName?: string | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, itemCount?: number | null, pageCount?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } } | null };

export type CutsheetAssignmentRuleSetByCapabilityIdQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetAssignmentRuleSetByCapabilityIdQuery = { __typename?: 'Query', cutsheetAssignmentRuleSetByCapabilityId?: { __typename?: 'CutsheetAssignmentRuleSet', _id: any, vendor: any, capabilityId: any, defaultQuestionnaireId?: any | null, createdAt?: any | null, updatedAt?: any | null, rules?: Array<{ __typename?: 'CutsheetAssignmentRuleSetRules', sortOrder: number, label?: string | null, inspectionLevel?: Array<EnumCutsheetAssignmentRuleSetRulesInspectionLevel | null> | null, splitType?: Array<EnumCutsheetAssignmentRuleSetRulesSplitType | null> | null, splitIndex?: Array<number | null> | null, producer?: Array<any | null> | null, buyer?: Array<any | null> | null, questionnaireId: any } | null> | null } | null };

export type CutsheetCapabilityByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityByIdQuery = { __typename?: 'Query', CutsheetCapabilityById?: { __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null };

export type CutsheetCapabilityManyQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  species?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityManyQuery = { __typename?: 'Query', CutsheetCapabilityByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapability', _id: any, vendor: any, species: EnumCutsheetCapabilitySpecies, name: string, description?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null, legacyInspectionLevelMap?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMap', inspectionLevel: EnumCutsheetCapabilityLegacyInspectionLevelMapInspectionLevel, questionnaireId: any, cutMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapCutMappings', oldCutId: any, newOptionId: any } | null> | null, trimMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapTrimMappings', oldTrimName: string, newOptionId: any } | null> | null, extraMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapExtraMappings', oldExtraName: string, newSpecificationId: any, newOptionValue: string } | null> | null, specMappings?: Array<{ __typename?: 'CutsheetCapabilityLegacyInspectionLevelMapSpecMappings', oldSpecName: string, newSpecificationId: any } | null> | null } | null> | null } | null> | null };

export type CutsheetCapabilityOptionsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetCapabilityOptionsByIdsQuery = { __typename?: 'Query', cutsheetCapabilityOptionByIds: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null }> };

export type CutsheetCapabilityOptionsManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CutsheetCapabilityOptionsManyQuery = { __typename?: 'Query', cutsheetCapabilityOptionsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, optionType: EnumCutsheetCapabilityOptionOptionType, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, groupId?: any | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null> | null };

export type CutsheetCapabilityCutManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityCutManyQuery = { __typename?: 'Query', cutsheetCutsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, groupId?: any | null, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null> | null };

export type CutsheetCapabilityExtraManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityExtraManyQuery = { __typename?: 'Query', cutsheetExtrasByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null> | null };

export type CutsheetCapabilityGroupManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityGroupManyQuery = { __typename?: 'Query', cutsheetGroupsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityGroup', _id: any, vendor: any, capabilityId: any, title: string, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null };

export type CutsheetLegacyCapabilityDataQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
}>;


export type CutsheetLegacyCapabilityDataQuery = { __typename?: 'Query', CutsheetLegacyCapabilityData: Array<{ __typename?: 'LegacyCapabilityData', inspectionLevel: string, cuts: Array<{ __typename?: 'LegacyCut', _id: any, name: string, primalName?: string | null } | null>, trims: Array<{ __typename?: 'LegacyTrim', name: string } | null>, extras: Array<{ __typename?: 'LegacyExtra', name: string } | null>, specifications: Array<{ __typename?: 'LegacySpecification', name: string } | null> } | null> };

export type CutsheetQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireByIdQuery = { __typename?: 'Query', cutsheetQuestionnaireById?: { __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null } | null };

export type CutsheetQuestionnaireManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetQuestionnaireManyQuery = { __typename?: 'Query', cutsheetQuestionnairesByVendorAndAnimal?: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null } | null> | null };

export type CutsheetQuestionnaireResponseByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponseByIdQuery = { __typename?: 'Query', cutsheetQuestionnaireResponseById?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, type: EnumCutsheetQuestionnaireResponseType, questionnaire: any, capabilitySet: any, createdAt?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null };

export type CutsheetQuestionnaireResponsesByUserQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  questionnaireId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type CutsheetQuestionnaireResponsesByUserQuery = { __typename?: 'Query', cutsheetQuestionnaireResponsesByUser?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, questionnaire: any, capabilitySet: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null };

export type CutsheetQuestionnaireResponsesByVendorQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnaireResponsesByVendorQuery = { __typename?: 'Query', cutsheetQuestionnaireResponsesByVendor?: Array<{ __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, questionnaire: any, user?: any | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string } | null> | null } | null } | null> | null };

export type CutsheetQuestionnairesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnairesByIdsQuery = { __typename?: 'Query', cutsheetQuestionnaireByIds: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, vendor: any, capabilityId: any, name: string, description?: string | null, pricingOverrides?: any | null, specOptionPricingOverrides?: any | null, useCustomPrintSettings?: boolean | null, status?: EnumCutsheetQuestionnaireStatus | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'CutsheetQuestionnaireQuestions', id?: string | null, type: EnumCutsheetQuestionnaireQuestionsType, title: string, description?: string | null, required?: boolean | null, sortOrder: number, specificationId?: string | null, availableCutIds?: Array<string | null> | null, allowMultiple?: boolean | null, minSelections?: number | null, maxSelections?: number | null, allowSubSelection?: boolean | null, availableTrimIds?: Array<string | null> | null, requireExactTotal?: boolean | null, imageUrl?: string | null, details?: string | null, options?: Array<{ __typename?: 'CutsheetQuestionnaireQuestionsOptions', id?: string | null, label: string, description?: string | null, imageUrl?: string | null, cutIds?: Array<string | null> | null } | null> | null } | null> | null, defaultSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelections', selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, rank?: number | null, quantity?: number | null, percentage?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null, primalNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null, trimNotes?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsPrimalNotes', id: string, note: string } | null> | null } | null, printSettings?: { __typename?: 'CutsheetCapabilityPrintSettings', baseFontSize?: number | null, primalColumns?: number | null, specsLayoutPosition?: EnumCutsheetCapabilityPrintSettingsSpecsLayoutPosition | null, checkboxStyle?: EnumCutsheetCapabilityPrintSettingsCheckboxStyle | null, showPrimalGroup?: boolean | null, alwaysShowPrimalNotes?: boolean | null, hideUnselectedCuts?: boolean | null, orientation?: EnumCutsheetCapabilityPrintSettingsOrientation | null, hiddenGroupIds?: Array<string | null> | null, hiddenItemIds?: Array<string | null> | null, hiddenSpecificationIds?: Array<string | null> | null } | null }> };

export type CutsheetQuestionnairesByVendorQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type CutsheetQuestionnairesByVendorQuery = { __typename?: 'Query', cutsheetQuestionnairesByVendor?: Array<{ __typename?: 'CutsheetQuestionnaire', _id: any, name: string, status?: EnumCutsheetQuestionnaireStatus | null, capabilityId: any } | null> | null };

export type CutsheetCapabilitySpecificationManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilitySpecificationManyQuery = { __typename?: 'Query', cutsheetSpecificationsByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> | null };

export type CutsheetCapabilityTrimManyQueryVariables = Exact<{
  capabilityId: Scalars['MongoID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CutsheetCapabilityTrimManyQuery = { __typename?: 'Query', cutsheetTrimByVendorAndAnimal?: Array<{ __typename?: 'CutsheetCapabilityOption', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, imageUrl?: string | null, printedText?: string | null, isDefault?: boolean | null, minQty?: number | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, specifications?: Array<{ __typename?: 'CutsheetCapabilityOptionSpecifications', title: string, description?: string | null, imageUrl?: string | null, type: EnumCutsheetCapabilityOptionSpecificationsType, options?: Array<string | null> | null, unit?: string | null, required?: boolean | null } | null> | null, pricing?: { __typename?: 'CutsheetCapabilityOptionPricing', model: EnumCutsheetCapabilityOptionPricingModel, price: number, minimumCharge?: number | null, description?: string | null } | null } | null> | null };

export type CutsheetSearchQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  buyerId?: InputMaybe<Scalars['MongoID']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Array<InputMaybe<EnumCutsheetType>> | InputMaybe<EnumCutsheetType>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumCutsheetAnimalSpecies>;
  inspectionLevel?: InputMaybe<EnumCutsheetInspectionLevels>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyCutsheetInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetSearchQuery = { __typename?: 'Query', cutsheetSearch?: { __typename?: 'CutsheetPagination', count?: number | null, items?: Array<{ __typename?: 'Cutsheet', lastUsedDate?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, itemCount?: number | null, pageCount?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } } | null };

export type CutsheetPaginationQueryVariables = Exact<{
  sort: SortFindManyCutsheetInput;
  filter: FilterFindManyCutsheetInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetPaginationQuery = { __typename?: 'Query', cutsheetPagination?: { __typename?: 'CutsheetPagination', count?: number | null, items?: Array<{ __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type CutsheetSpecificationByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type CutsheetSpecificationByIdsQuery = { __typename?: 'Query', cutsheetSpecificationByIds: Array<{ __typename?: 'CutsheetCapabilitySpecification', _id: any, vendor: any, capabilityId: any, title: string, description?: string | null, inputType: EnumCutsheetCapabilitySpecificationInputType, options?: any | null, unit?: string | null, defaultValue?: string | null, required?: boolean | null, printedText?: string | null, assignedToIds?: Array<any | null> | null, pricingAdjustments?: any | null, sortOrder: number, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null }> };

export type GetPublicHolidaysQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPublicHolidaysQuery = { __typename?: 'Query', getPublicHolidays?: { __typename?: 'HolidaysResponse', holidays?: Array<{ __typename?: 'Holiday', name: string, date: string, type?: string | null, country: string, lang: string } | null> | null, meta?: { __typename?: 'HolidaysMeta', country: string, lang: string, start: string, end: string, count: number } | null } | null };

export type GetAuditLogsQueryVariables = Exact<{
  documentType: Scalars['String']['input'];
  documentId: Scalars['MongoID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', getAuditLogs?: { __typename?: 'AuditLogsResponse', total: number, logs?: Array<{ __typename?: 'AuditLogResult', _id: any, documentId: any, documentType: string, actorId?: any | null, createdAt: any, updatedAt: any, actor?: { __typename?: 'AuditLogActorResult', first_name?: string | null, last_name?: string | null, picture_url?: string | null } | null, changes?: Array<{ __typename?: 'AuditLogChangeResult', path: string, from?: any | null, to?: any | null } | null> | null } | null> | null } | null };

export type GetCustomerSummaryDetailsQueryVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type GetCustomerSummaryDetailsQuery = { __typename?: 'Query', getCustomerSummaryDetails?: { __typename?: 'CustomerSummaryDetails', customerCount?: number | null, jobSummary: { __typename?: 'CustomerJobSummary', inProgressCount: number, needsApprovalCount: number, completedCount: number, cancelledCount: number, firstJobDate?: any | null, lastJobDate?: any | null }, linkedProducer?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null } | null } | null };

export type IntegrationOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
}>;


export type IntegrationOneQuery = { __typename?: 'Query', integrationOne?: { __typename?: 'Integration', _id: any, name: EnumIntegrationName, config?: any | null } | null };

export type InvoiceByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type InvoiceByIdQuery = { __typename?: 'Query', invoiceById?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type SearchInvoicesQueryVariables = Exact<{
  type: Scalars['String']['input'];
  sort: SortFindManyInvoiceInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchInvoicesQuery = { __typename?: 'Query', searchInvoices?: { __typename?: 'InvoicePagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null }> | null } | null };

export type MessagesByChatRoomQueryVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type MessagesByChatRoomQuery = { __typename?: 'Query', messagesByChatRoom?: { __typename?: 'ChatMessagePagination', count?: number | null, items?: Array<{ __typename?: 'ChatMessage', _id: any, content?: string | null, imageUrl?: string | null, isNotification?: boolean | null, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MyChatRoomsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type MyChatRoomsQuery = { __typename?: 'Query', myChatRooms?: { __typename?: 'ChatRoomPagination', count?: number | null, items?: Array<{ __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, twilioConversationSid?: string | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content?: string | null, sender?: { __typename?: 'User', _id: any } | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotePaginationQueryVariables = Exact<{
  sort: SortFindManyNoteInput;
  filter: FilterFindManyNoteInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotePaginationQuery = { __typename?: 'Query', notePagination?: { __typename?: 'NotePagination', count?: number | null, items?: Array<{ __typename?: 'Note', _id: any, note?: string | null, type: EnumNoteType, createdAt?: any | null, updatedAt?: any | null, attachments?: Array<{ __typename?: 'NoteAttachments', url: string, filename: string, mimeType?: string | null } | null> | null, createdBy?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationSettingsByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationSettingsByVendorIdQuery = { __typename?: 'Query', findNotificationSettingsByVendorId?: { __typename?: 'NotificationSettingPagination', count?: number | null, items?: Array<{ __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, sendEmail?: boolean | null, sendSMS?: boolean | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationSettingsOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
}>;


export type NotificationSettingsOneQuery = { __typename?: 'Query', notificationSettingsOne?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: string, sendEmail?: boolean | null, sendSMS?: boolean | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation, enabled?: boolean | null } | null> | null, emailMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null, smsMessage?: { __typename?: 'NotificationTemplate', _id: any, content: string, type: EnumNotificationTemplateType } | null } | null };

export type NotificationsByJobIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationsByJobIdQuery = { __typename?: 'Query', findNotificationsByJobId?: { __typename?: 'NotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Notification', _id: any, jobId?: any | null, notificationType?: EnumNotificationNotificationType | null, type?: string | null, sentTo?: string | null, sentOn?: any | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null } | null, errorMessage?: { __typename?: 'NotificationErrorMessage', message?: string | null, code?: string | null } | null }> | null } | null };

export type NotificationsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationsByUserIdQuery = { __typename?: 'Query', notificationPagination?: { __typename?: 'NotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Notification', _id: any, jobId?: any | null, notificationType?: EnumNotificationNotificationType | null, type?: string | null, sentTo?: string | null, sentOn?: any | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null, email?: string | null, phone?: string | null } | null, errorMessage?: { __typename?: 'NotificationErrorMessage', message?: string | null, code?: string | null } | null }> | null } | null };

export type PrimalCutBlockerManyQueryVariables = Exact<{
  filter: FilterFindManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutBlockerManyQuery = { __typename?: 'Query', primalCutBlockerMany: Array<{ __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null }> };

export type PrimalCutManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
}>;


export type PrimalCutManyQuery = { __typename?: 'Query', primalCutMany: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, isDeleted?: boolean | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null, primal?: { __typename?: 'Primal', name: string, order: number, _id: any, group?: { __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, _id: any } | null } | null }> };

export type PrimalCutTypeManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutTypeManyQuery = { __typename?: 'Query', primalCutTypeMany: Array<{ __typename?: 'PrimalCutType', _id: any, name: string, isDeleted?: boolean | null, animalSpecies?: EnumPrimalCutTypeAnimalSpecies | null, processorSettings?: any | null }> };

export type PrimalGroupManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
}>;


export type PrimalGroupManyQuery = { __typename?: 'Query', primalGroupMany: Array<{ __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDeleted?: boolean | null, _id: any, primals?: Array<{ __typename?: 'Primal', isDeleted?: boolean | null, order: number, name: string, description?: string | null, _id: any, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }> } | null> | null }> };

export type ProcessingPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessingPartnersQuery = { __typename?: 'Query', processingPartners?: Array<{ __typename?: 'ProcessingPartners', _id?: any | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, slug?: string | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', city: string, state: string } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null } | null } | null } | null> | null };

export type ProcessorCustomerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProcessorCustomerByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, enabled: boolean, company?: string | null, _id: any, relationships?: Array<{ __typename?: 'UserRelationships', type?: EnumUserRelationshipsType | null, vendorId?: any | null, producerId?: any | null } | null> | null, address?: { __typename?: 'Address', address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string } | null } | null };

export type ProcessorCustomersPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  vendorId: Scalars['MongoID']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorCustomersPaginationQuery = { __typename?: 'Query', getProcessorCustomers?: { __typename?: 'UserPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, _id: any, status?: EnumUserStatus | null, address?: { __typename?: 'Address', address_1: string, address_2?: string | null, city: string, state: string, postcode: string } | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null }> | null } | null };

export type ProcessorNotificationPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorNotificationInput;
  filter: FilterFindManyProcessorNotificationInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorNotificationPaginationQuery = { __typename?: 'Query', processorNotificationPagination?: { __typename?: 'ProcessorNotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorNotification', _id: any, vendor: any, notificationType: string, type: EnumProcessorNotificationType, sentTo: string, sentOn: any, errorMessage?: any | null }> | null } | null };

export type ProcessorSchedulingByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  includeCutsheetInformation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', dropoffDate?: any | null, dropoffDateStr?: string | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, _id: any, vendor?: { __typename?: 'Vendor', shop_name: string, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, email?: string | null, phone?: string | null, _id: any } } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, splitType?: string | null, producerIdentifier?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, tracking?: string | null, publicId: string, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, _id?: any | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null, capabilitySet: any, questionnaire: any, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, quantity?: number | null, percentage?: number | null, rank?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, extraSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections', extras?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras', optionId: string, quantity?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null } | null, yield?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformationYield', _id?: any | null, capabilityOptionId?: string | null, label: string, weightLbs: number, itemCount: number, packageCount: number, packageIdentifier?: string | null } | null> | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, company?: string | null } | null } | null> | null } | null> | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingCalendarQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
}>;


export type ProcessorSchedulingCalendarQuery = { __typename?: 'Query', getProcessorSchedulingCalendar?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null } | null> | null } | null> | null };

export type ProcessorSchedulingFilteredQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
  animalSpecies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  missingCutsheets?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingFilteredQuery = { __typename?: 'Query', getFilteredProcessorScheduling?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProcessorSchedulingManyQuery = { __typename?: 'Query', processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', jobId: string, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, _id: any, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, tracking?: string | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, killDate?: any | null, cutDate?: any | null, producerIdentifier?: string | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null } | null> | null } | null> | null }> };

export type ProcessorSchedulingPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorSchedulingInput;
  filter: FilterFindManyProcessorSchedulingInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorSchedulingPaginationQuery = { __typename?: 'Query', processorSchedulingPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, questionnaire?: any | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingCutsheetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProcessorSchedulingWithMissingCutsheetsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingCutsheets?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingHangingWeightsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingWithMissingHangingWeightsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingHangingWeights?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorSchedulingsByUserIdQuery = { __typename?: 'Query', processorSchedulingPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, source?: EnumProcessorSchedulingSource | null, createdAt?: any | null, dropoffDate?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null }> | null } | null };

export type ProducerJobByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProducerJobByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockTitle?: string | null, hasCutsheetNeededNotification?: boolean | null, requestedBy?: { __typename?: 'User', _id: any } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, splitType?: string | null, questionnaire?: any | null, publicId: string, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, killDate?: any | null, cutDate?: any | null, tracking?: string | null, hangingWeight?: number | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, isHangingWeightPerSide?: boolean | null, producerIdentifier?: string | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, locked?: boolean | null, questionnaire?: any | null, yield?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformationYield', _id?: any | null, capabilityOptionId?: string | null, label: string, weightLbs: number, itemCount: number, packageCount: number, packageIdentifier?: string | null } | null> | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, notes?: string | null, questionnaire: any, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, selectedCuts?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCuts', optionId: string, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null, trimSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelections', type: EnumCutsheetQuestionnaireDefaultSelectionsTrimSelectionsType, trim?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsTrimSelectionsTrim', optionId: string, quantity?: number | null, percentage?: number | null, rank?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null, extraSelections?: { __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelections', extras?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsExtraSelectionsExtras', optionId: string, quantity?: number | null, specifications?: Array<{ __typename?: 'CutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecifications', specification: string, type: EnumCutsheetQuestionnaireDefaultSelectionsSelectedCutsSpecificationsType, value: any } | null> | null } | null> | null } | null } | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null } | null> | null } | null> | null, notificationHistory: Array<{ __typename?: 'Notification', _id: any, type?: string | null, sentTo?: string | null, user?: { __typename?: 'User', _id: any } | null }>, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', species: EnumProcessorSettingsAnimalSettingsSpecies, splitTypes?: Array<string | null> | null } | null> | null } | null } | null };

export type ProducersByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProducersByVendorIdQuery = { __typename?: 'Query', searchCustomers: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null }> };

export type RenderNotificationEmailPreviewQueryVariables = Exact<{
  content: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenderNotificationEmailPreviewQuery = { __typename?: 'Query', renderNotificationEmailPreview?: { __typename?: 'EmailPreviewResult', html: string } | null };

export type GetFinancialReportingConfigQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneFinancialReportingConfigInput>;
}>;


export type GetFinancialReportingConfigQuery = { __typename?: 'Query', financialReportingConfigOne?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, dateAnchor?: EnumFinancialReportingConfigDateAnchor | null, createdAt?: any | null, updatedAt?: any | null, animalConfigurations?: Array<{ __typename?: 'FinancialReportingConfigAnimalConfigurations', species: EnumFinancialReportingConfigAnimalConfigurationsSpecies, expectedThroughput: number, maxCapacity: number, processingCost: number, revenue: number, averageHangingWeight: number } | null> | null, overheadCosts?: Array<{ __typename?: 'FinancialReportingConfigOverheadCosts', name: string, amount: number, frequency: EnumFinancialReportingConfigOverheadCostsFrequency } | null> | null, timeConfiguration?: { __typename?: 'FinancialReportingConfigTimeConfiguration', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null, monthlyModifiers?: { __typename?: 'FinancialReportingConfigMonthlyModifiers', january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number } | null } | null };

export type FinancialReportingConfigUpsertMutationVariables = Exact<{
  record: FinancialReportingConfigUpsertInput;
}>;


export type FinancialReportingConfigUpsertMutation = { __typename?: 'Mutation', financialReportingConfigUpsert?: { __typename?: 'FinancialReportingConfig', _id: any, vendor: any, dateAnchor?: EnumFinancialReportingConfigDateAnchor | null, createdAt?: any | null, updatedAt?: any | null, animalConfigurations?: Array<{ __typename?: 'FinancialReportingConfigAnimalConfigurations', species: EnumFinancialReportingConfigAnimalConfigurationsSpecies, expectedThroughput: number, maxCapacity: number, processingCost: number, revenue: number, averageHangingWeight: number } | null> | null, overheadCosts?: Array<{ __typename?: 'FinancialReportingConfigOverheadCosts', name: string, amount: number, frequency: EnumFinancialReportingConfigOverheadCostsFrequency } | null> | null, timeConfiguration?: { __typename?: 'FinancialReportingConfigTimeConfiguration', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null, monthlyModifiers?: { __typename?: 'FinancialReportingConfigMonthlyModifiers', january: number, february: number, march: number, april: number, may: number, june: number, july: number, august: number, september: number, october: number, november: number, december: number } | null } | null };

export type GetFinancialReportingMetricsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  dateAnchor?: InputMaybe<Scalars['String']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
}>;


export type GetFinancialReportingMetricsQuery = { __typename?: 'Query', financialReportingMetrics: any };

export type SearchCustomersQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  producerId?: InputMaybe<Scalars['MongoID']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchCustomersQuery = { __typename?: 'Query', searchCustomers: Array<{ __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, phone?: string | null }> };

export type StateManyQueryVariables = Exact<{ [key: string]: never; }>;


export type StateManyQuery = { __typename?: 'Query', stateMany: Array<{ __typename?: 'State', name: string, code: string, _id: any }> };

export type UserSettingsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserSettingsByUserIdQuery = { __typename?: 'Query', userSettingsByUserId?: { __typename?: 'UserSettingsByUserId', settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserTenantVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTenantVendorQuery = { __typename?: 'Query', userTenantVendor?: { __typename?: 'User', intercomWebToken?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, auth_method?: EnumUserAuth_Method | null, _id: any, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, outsideWindowNote?: string | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, minSchedulingDays?: number | null, maxSchedulingDays?: number | null, showOutsideWindowDates?: boolean | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, show_in_directory: boolean, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products?: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null } | null> | null, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }>, modules: Array<{ __typename?: 'VendorModule', _id: any, moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null }>, twilioPhoneConfig?: { __typename?: 'VendorTwilioPhoneConfig', phoneNumberSid?: string | null, phoneNumber?: string | null, phoneNumberType?: EnumVendorTwilioPhoneConfigPhoneNumberType | null, phoneNumberStatus?: EnumVendorTwilioPhoneConfigPhoneNumberStatus | null, hostedNumberOrderSid?: string | null, friendlyName?: string | null } | null } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null, timeTrackingConfig?: { __typename?: 'ProcessorSettingsTimeTrackingConfig', timePerNotification: number, timePerCutsheet: number, timePerBooking: number, baseDigitalSavings: number, hourlyRate: number } | null } | null, modules: Array<{ __typename?: 'VendorModule', moduleType: EnumVendorModuleModuleType, name: string, label: string, href: string, order: number, active: boolean, settings?: any | null, _id: any }>, tenant?: { __typename?: 'Tenant', _id: any, picture_url?: string | null } | null } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, show_in_directory: boolean, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type VendorListQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type VendorListQuery = { __typename?: 'Query', vendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string } | null } | null> | null };

export type ProcessingJobByIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  includeProcessorSettings: Scalars['Boolean']['input'];
}>;


export type ProcessingJobByIdQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, createdAt?: any | null, source?: EnumProcessorSchedulingSource | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, enabledAnimalSplits?: Array<string | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null, statusChanges?: Array<{ __typename?: 'ProcessorSchedulingStatusChanges', _id?: any | null, date: any, newStatus: EnumProcessorSchedulingStatusChangesNewStatus, previousStatus: EnumProcessorSchedulingStatusChangesPreviousStatus } | null> | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null, relationships?: Array<{ __typename?: 'UserRelationships', vendorId?: any | null, producerId?: any | null, type?: EnumUserRelationshipsType | null } | null> | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, questionnaire?: any | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, questionnaire?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, convertedToQuestionnaireResponse?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string } | null, user?: { __typename?: 'User', _id: any, first_name?: string | null, last_name?: string | null, company?: string | null } | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, imageUrl?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, questionnaireResponse?: { __typename?: 'CutsheetQuestionnaireResponse', _id: any, name: string, type: EnumCutsheetQuestionnaireResponseType, pricePerPound?: number | null, createdAt?: any | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type WaitlistByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type WaitlistByVendorIdQuery = { __typename?: 'Query', waitlistByVendorId?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null> | null };

export const ChatMessageFragmentFragmentDoc = gql`
    fragment ChatMessageFragment on ChatMessage {
  _id
  chatRoom {
    _id
    vendor {
      _id
      shop_name
      tenant {
        name
        picture_url
      }
    }
  }
  content
  imageUrl
  isNotification
  sender {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  createdAt
  updatedAt
}
    `;
export const ChatRoomFragmentFragmentDoc = gql`
    fragment ChatRoomFragment on ChatRoom {
  _id
  vendor {
    _id
    shop_name
    tenant {
      name
      picture_url
    }
  }
  participants {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  createdAt
  createdBy {
    _id
  }
  updatedAt
  twilioConversationSid
  lastMessage {
    content
    sender {
      _id
    }
  }
}
    `;
export const CutsheetAssignmentRuleSetFragmentFragmentDoc = gql`
    fragment CutsheetAssignmentRuleSetFragment on CutsheetAssignmentRuleSet {
  _id
  vendor
  capabilityId
  defaultQuestionnaireId
  rules {
    sortOrder
    label
    inspectionLevel
    splitType
    splitIndex
    producer
    buyer
    questionnaireId
  }
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityFragment on CutsheetCapability {
  _id
  vendor
  species
  name
  description
  printSettings {
    baseFontSize
    primalColumns
    specsLayoutPosition
    checkboxStyle
    showPrimalGroup
    alwaysShowPrimalNotes
    hideUnselectedCuts
    orientation
    hiddenGroupIds
    hiddenItemIds
    hiddenSpecificationIds
  }
  legacyInspectionLevelMap {
    inspectionLevel
    questionnaireId
    cutMappings {
      oldCutId
      newOptionId
    }
    trimMappings {
      oldTrimName
      newOptionId
    }
    extraMappings {
      oldExtraName
      newSpecificationId
      newOptionValue
    }
    specMappings {
      oldSpecName
      newSpecificationId
    }
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityOptionFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityOptionFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  optionType
  title
  description
  imageUrl
  printedText
  groupId
  isDefault
  minQty
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityCutFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityCutFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  groupId
  title
  description
  imageUrl
  printedText
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityExtraFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityExtraFragment on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  title
  description
  imageUrl
  printedText
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityGroupFragmentFragmentDoc = gql`
    fragment CutsheetCapabilityGroupFragment on CutsheetCapabilityGroup {
  _id
  vendor
  capabilityId
  title
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetQuestionnaireFragmentFragmentDoc = gql`
    fragment CutsheetQuestionnaireFragment on CutsheetQuestionnaire {
  _id
  vendor
  capabilityId
  name
  description
  questions {
    id
    type
    title
    description
    required
    sortOrder
    specificationId
    availableCutIds
    allowMultiple
    minSelections
    maxSelections
    allowSubSelection
    options {
      id
      label
      description
      imageUrl
      cutIds
    }
    availableTrimIds
    requireExactTotal
    imageUrl
    details
  }
  pricingOverrides
  specOptionPricingOverrides
  defaultSelections {
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
    primalNotes {
      id
      note
    }
    trimNotes {
      id
      note
    }
  }
  useCustomPrintSettings
  printSettings {
    baseFontSize
    primalColumns
    specsLayoutPosition
    checkboxStyle
    showPrimalGroup
    alwaysShowPrimalNotes
    hideUnselectedCuts
    orientation
    hiddenGroupIds
    hiddenItemIds
    hiddenSpecificationIds
  }
  status
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilitySpecificationFragmentFragmentDoc = gql`
    fragment CutsheetCapabilitySpecificationFragment on CutsheetCapabilitySpecification {
  _id
  vendor
  capabilityId
  title
  description
  inputType
  options
  unit
  defaultValue
  required
  printedText
  assignedToIds
  pricingAdjustments
  sortOrder
  isActive
  createdAt
  updatedAt
}
    `;
export const CutsheetCapabilityTrimFragmentV2FragmentDoc = gql`
    fragment CutsheetCapabilityTrimFragmentV2 on CutsheetCapabilityOption {
  _id
  vendor
  capabilityId
  title
  description
  imageUrl
  printedText
  isDefault
  minQty
  sortOrder
  specifications {
    title
    description
    imageUrl
    type
    options
    unit
    required
  }
  pricing {
    model
    price
    minimumCharge
    description
  }
  isActive
  createdAt
  updatedAt
}
    `;
export const NoteFragmentFragmentDoc = gql`
    fragment NoteFragment on Note {
  _id
  note
  type
  attachments {
    url
    filename
    mimeType
  }
  createdBy {
    first_name
    last_name
  }
  createdAt
  updatedAt
}
    `;
export const NotificationSettingFragmentFragmentDoc = gql`
    fragment NotificationSettingFragment on NotificationSetting {
  _id
  name
  enabled
  trigger
  timings {
    days
    relation
    enabled
  }
  sendEmail
  sendSMS
  ctaButtonText
  ctaButtonUrl
  emailMessage {
    _id
    content
    type
  }
  smsMessage {
    _id
    content
    type
  }
}
    `;
export const PrimalCutBlockerFragmentFragmentDoc = gql`
    fragment PrimalCutBlockerFragment on PrimalCutBlocker {
  _id
  vendor
  animalSpecies
  inspectionLevel
  name
  primalCutId
  type
  blockedBy {
    name
    primalCutId
    _id
  }
}
    `;
export const CapabilitySpecificationFragmentDoc = gql`
    fragment CapabilitySpecification on ProcessorCapabilitySpecification {
  _id
  capability {
    _id
    animalSpecies
    inspectionLevel
  }
  specifications {
    _id
    name
    description
    imageUrl
    options {
      _id
      name
      isVisible
      isDefault
      description
    }
    measurementUnit
    isVisible
    isRequired
  }
}
    `;
export const ProcessorCapabilityFragmentFragmentDoc = gql`
    fragment ProcessorCapabilityFragment on ProcessorCapability {
  _id
  vendor
  animalSpecies
  inspectionLevel
  canSelectMoreThanOneTrim
  trimSelection
  primalCuts
  cuts {
    primal {
      name
      description
      group {
        animalSpecies
        inspectionLevel
        name
        order
        isDefault
        isDeleted
        processorSettings
        _id
      }
      isDeleted
      order
      _id
    }
    isDeleted
    name
    description
    cutType {
      name
      _id
    }
    order
    _id
  }
  extras {
    name
    pricePerPound
    minLbs
    isActive
    _id
    type
    fee
    description
  }
  trim {
    name
    pricePerPound
    minLbs
    isActive
    _id
    description
  }
  activeSpecification {
    ...CapabilitySpecification
  }
  primalGroups {
    _id
    name
    order
    primals {
      _id
      name
      description
      imageUrl
      order
    }
  }
  wizardWelcomeTitle
  wizardWelcomeContent
  extrasDescription
  trimDescription
  extrasImageUrl
  trimImageUrl
}
    ${CapabilitySpecificationFragmentDoc}`;
export const PrimalCutFragmentFragmentDoc = gql`
    fragment PrimalCutFragment on PrimalCut {
  primal {
    group {
      animalType
      name
      order
      isDeleted
      _id
    }
    name
    order
    isDeleted
    _id
  }
  name
  cutType {
    name
    _id
  }
  order
  _id
}
    `;
export const ExtrasFragmentFragmentDoc = gql`
    fragment ExtrasFragment on CutsheetExtras {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  type
  fee
}
    `;
export const TrimFragmentFragmentDoc = gql`
    fragment TrimFragment on CutsheetTrim {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  rank
  trimSelection
}
    `;
export const CutsheetFragmentFragmentDoc = gql`
    fragment CutsheetFragment on Cutsheet {
  vendor {
    _id
    shop_name
  }
  user {
    _id
    first_name
    last_name
    company
  }
  type
  animalSpecies
  inspectionLevels
  primalCuts {
    ...PrimalCutFragment
  }
  name
  pricePerPound
  steakThickness
  steaksPerPack
  groundMeatSize
  roastSize
  isDeleted
  _id
  splitTypes
  activeSpecification {
    _id
    ...CapabilitySpecification
  }
  selectedSpecifications
  extras {
    ...ExtrasFragment
  }
  trim {
    ...TrimFragment
  }
  notes
  convertedToQuestionnaireResponse
}
    ${PrimalCutFragmentFragmentDoc}
${CapabilitySpecificationFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;
export const ContactUserFragmentDoc = gql`
    fragment ContactUser on User {
  _id
  email
  first_name
  last_name
  phone
  enabled
  role
  company
}
    `;
export const CutsheetInformationFragmentDoc = gql`
    fragment CutsheetInformation on ProcessorSchedulingAnimalHeadsCutsheetInformation {
  _id
  cutsheet {
    ...CutsheetFragment
  }
  questionnaire
  questionnaireResponse {
    _id
    name
    type
    pricePerPound
    createdAt
  }
  splitPart
  quantity
  notes
  locked
  contactUser {
    ...ContactUser
  }
}
    ${CutsheetFragmentFragmentDoc}
${ContactUserFragmentDoc}`;
export const AnimalHeadFragmentDoc = gql`
    fragment AnimalHead on ProcessorSchedulingAnimalHeads {
  _id
  publicId
  producerIdentifier
  tracking
  splitType
  questionnaire
  isHangingWeightPerSide
  hangingWeightSideA
  hangingWeightSideB
  hangingWeight
  liveWeight
  grade
  yield
  killDate
  killDateStr
  cutDate
  cutDateStr
  cutsheetInformation {
    ...CutsheetInformation
  }
  isOverThirtyMonths
  isKillAndChill
  sex
  inspectionLevel
  butcherSlotPrice
  invoice {
    additionalCost {
      cost
      reason
    }
    additionalCharges {
      description
      amount
    }
    extras {
      description
      quantity
      unitPrice
    }
    trims {
      description
      quantity
      unitPrice
    }
    finishedWeights {
      type
      totalWeight
      categories {
        name
        weight
      }
    }
  }
}
    ${CutsheetInformationFragmentDoc}`;
export const InvoiceFragmentLineItemFragmentDoc = gql`
    fragment InvoiceFragmentLineItem on InvoiceLineItem {
  _id
  external_id
  description
  quantity
  amount
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  vendor {
    shop_name
    _id
  }
  user {
    first_name
    last_name
    email
    phone
    _id
  }
  external_id
  description
  billing_month
  billing_year
  date_created
  amount_due
  amount_paid
  amount_refunded
  amount_discounted
  line_items {
    ...InvoiceFragmentLineItem
  }
  status_changes {
    date
    previous_status
    new_status
  }
  external_links {
    stripe
    quickbooks
  }
  links {
    entityType
    parentEntityId
    subEntityId
    entity
    description
  }
  due_date
  number
  status
  status_changes {
    date
    previous_status
    new_status
  }
  _id
  type
}
    ${InvoiceFragmentLineItemFragmentDoc}`;
export const ProcessorSchedulingFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingFragment on ProcessorScheduling {
  _id
  jobId
  status
  statusLastUpdated
  createdAt
  statusChanges {
    _id
    date
    newStatus
    previousStatus
  }
  source
  isDeleted
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  blockIndex
  blockTitle
  deposit {
    amount
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
    relationships {
      vendorId
      producerId
      type
    }
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    ...AnimalHead
  }
  processorSettings {
    _id
  }
  invoice {
    invoice_status
    additionalCost {
      cost
      reason
    }
  }
  linkedInvoices {
    ...InvoiceFragment
  }
}
    ${AnimalHeadFragmentDoc}
${InvoiceFragmentFragmentDoc}`;
export const ProcessorSchedulingCalendarFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingCalendarFragment on ProcessorScheduling {
  _id
  jobId
  status
  statusLastUpdated
  isDeleted
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  blockIndex
  blockTitle
  deposit {
    amount
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    _id
    publicId
    producerIdentifier
    tracking
    splitType
    isHangingWeightPerSide
    hangingWeightSideA
    hangingWeightSideB
    hangingWeight
    liveWeight
    grade
    yield
    killDate
    killDateStr
    cutDate
    cutDateStr
    isOverThirtyMonths
    isKillAndChill
    sex
    inspectionLevel
    butcherSlotPrice
  }
}
    `;
export const ProcessorSchedulingSlimFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingSlimFragment on ProcessorScheduling {
  _id
  vendor {
    _id
  }
  dropoffDate
  status
  animalSpecies
  headCount
  blockIndex
  blockTitle
  animalHeads {
    _id
    inspectionLevel
  }
}
    `;
export const DailyCapacityFragmentFragmentDoc = gql`
    fragment DailyCapacityFragment on DailyCapacityCapacitiesByType {
  type
  capacities {
    ... on SpeciesComplexAnimalCapacitySchema {
      species
      value
    }
    ... on SpeciesInspectionComplexAnimalCapacitySchema {
      species
      inspectionLevel
      value
    }
    ... on WeightedAnimalComplexAnimalCapacitySchema {
      value
    }
  }
}
    `;
export const DailyCapacityBlockFragmentFragmentDoc = gql`
    fragment DailyCapacityBlockFragment on DailyCapacity {
  title
  capacitiesByType {
    ...DailyCapacityFragment
  }
}
    ${DailyCapacityFragmentFragmentDoc}`;
export const ProcessorSettingsCustomCapacityFragmentFragmentDoc = gql`
    fragment ProcessorSettingsCustomCapacityFragment on ProcessorSettingsCustomCapacity {
  _id
  isDeleted
  date
  dailyCapacities {
    ...DailyCapacityBlockFragment
  }
  note
  dateStr
}
    ${DailyCapacityBlockFragmentFragmentDoc}`;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  first_name
  last_name
  company
  address_1
  address_2
  city
  state
  postcode
  country
  email
  phone
  type
  _id
}
    `;
export const TenantFragmentFragmentDoc = gql`
    fragment TenantFragment on Tenant {
  name
  date_created
  enabled
  domain
  vendors {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    show_in_directory
    tagline
    address {
      ...AddressFragment
    }
    _id
  }
  _id
}
    ${AddressFragmentFragmentDoc}`;
export const ParentProductFragmentDoc = gql`
    fragment ParentProduct on ParentProduct {
  _id
  vendor
  external_id
  slug
  name
  permalink
  price
  weight
  description
  short_description
  stock_status
  stock_quantity
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  external_id
  slug
  name
  permalink
  price
  weight
  enabled
  description
  short_description
  stock_status
  stock_quantity
  _id
  integration {
    name
  }
  parent {
    ...ParentProduct
  }
  children {
    ...ParentProduct
  }
}
    ${ParentProductFragmentDoc}`;
export const VendorFragmentFragmentDoc = gql`
    fragment VendorFragment on Vendor {
  external_id
  date_created
  shop_name
  shop_slug
  pickup_days
  enabled
  free_shipping_amount
  prefers_dropoff
  show_in_directory
  tagline
  _id
  tenant {
    ...TenantFragment
  }
  address {
    ...AddressFragment
  }
  products {
    ...ProductFragment
  }
  integrations {
    _id
    name
    type
  }
  modules {
    _id
    moduleType
    name
    label
    href
    order
    active
    settings
  }
  zone
  stripe_config
  twilioPhoneConfig {
    phoneNumberSid
    phoneNumber
    phoneNumberType
    phoneNumberStatus
    hostedNumberOrderSid
    friendlyName
  }
}
    ${TenantFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;
export const ProcessorSettingsFragmentFragmentDoc = gql`
    fragment ProcessorSettingsFragment on ProcessorSettings {
  _id
  animalSettings {
    _id
    isEnabled
    species
    inspectionLevels
    splitTypes
    weightedAnimalUnit
    minSchedulingDays
    maxSchedulingDays
    showOutsideWindowDates
    customCutsheetPricing {
      price
      inspectionLevel
    }
    butcherSlotPricing {
      price
      inspectionLevel
    }
  }
  capacityConfigurationType
  capacitySettings {
    isEnabled
    dayOfWeek
    dailyCapacities {
      ...DailyCapacityBlockFragment
    }
  }
  carcassSettings {
    species
    inspectionLevel
    year
    currentNumber
    lastTakenNumber
  }
  schedulingDeposit
  refundDeadlineDays
  vendor {
    ...VendorFragment
  }
  faq
  validationErrors {
    type
    value
    property
    messages
    group
  }
  about
  autoSchedulingSettings {
    species
    isEnabled
    cutDateDays
    harvestDateDays
  }
  killAndChillSettings {
    species
    isEnabled
    pricePerHead
  }
  isWaitlistFunctionalityDisabled
  outsideWindowNote
  isProcessorNotificationsEnabled
  processorNotificationEmailAddresses
  animals
  invoicing {
    trackYields
    showYieldOnInvoice
    defaultSplitRule
  }
  documentSettings {
    cutsheet {
      format
    }
    carcassTag {
      title
    }
  }
  timeTrackingConfig {
    timePerNotification
    timePerCutsheet
    timePerBooking
    baseDigitalSavings
    hourlyRate
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${VendorFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  first_name
  last_name
  email
  phone
  company
  picture_url
  role
  enabled
  auth_method
  relationships {
    vendorId
    producerId
    type
  }
  active_vendor {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    tagline
    address {
      ...AddressFragment
    }
    integrations {
      name
      type
      isSyncing
      lastSynced
      _id
    }
    zone
    stripe_config
    twilioPhoneConfig {
      phoneNumberSid
      phoneNumber
      phoneNumberType
      phoneNumberStatus
      hostedNumberOrderSid
      friendlyName
    }
    processorSettings {
      ...ProcessorSettingsFragment
    }
    modules {
      moduleType
      name
      label
      href
      order
      active
      settings
      _id
    }
    tenant {
      _id
      picture_url
    }
    _id
  }
  tenant {
    ...TenantFragment
  }
  settings {
    calendar {
      dateConfiguration
      calendarView
      showAllEvents
    }
  }
  _id
}
    ${AddressFragmentFragmentDoc}
${ProcessorSettingsFragmentFragmentDoc}
${TenantFragmentFragmentDoc}`;
export const WaitlistFragmentFragmentDoc = gql`
    fragment WaitlistFragment on Waitlist {
  _id
  vendor
  firstName
  lastName
  email
  phone
  company
  createdAt
  updatedAt
  sendWaitlistEmail
  sendWaitlistSMS
  animal
  startDate
  endDate
}
    `;
export const IntegrationCreateOneDocument = gql`
    mutation IntegrationCreateOne($record: CreateOneIntegrationInput!) {
  integrationCreateOne(record: $record) {
    recordId
    record {
      name
      type
      endpoint
      key
      _id
    }
    error {
      message
    }
  }
}
    `;
export type IntegrationCreateOneMutationFn = Apollo.MutationFunction<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;

/**
 * __useIntegrationCreateOneMutation__
 *
 * To run a mutation, you first call `useIntegrationCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationCreateOneMutation, { data, loading, error }] = useIntegrationCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useIntegrationCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>(IntegrationCreateOneDocument, options);
      }
export type IntegrationCreateOneMutationHookResult = ReturnType<typeof useIntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationResult = Apollo.MutationResult<IntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationOptions = Apollo.BaseMutationOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;
export const IntegrationUpdateConfigDocument = gql`
    mutation IntegrationUpdateConfig($integrationId: MongoID!, $config: JSON!) {
  integrationUpdateById(_id: $integrationId, record: {config: $config}) {
    recordId
  }
}
    `;
export type IntegrationUpdateConfigMutationFn = Apollo.MutationFunction<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;

/**
 * __useIntegrationUpdateConfigMutation__
 *
 * To run a mutation, you first call `useIntegrationUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationUpdateConfigMutation, { data, loading, error }] = useIntegrationUpdateConfigMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useIntegrationUpdateConfigMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>(IntegrationUpdateConfigDocument, options);
      }
export type IntegrationUpdateConfigMutationHookResult = ReturnType<typeof useIntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationResult = Apollo.MutationResult<IntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationOptions = Apollo.BaseMutationOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;
export const ProcessorSettingsUpdateByIdDocument = gql`
    mutation ProcessorSettingsUpdateById($id: MongoID!, $record: UpdateByIdProcessorSettingsInput!) {
  processorSettingsUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ProcessorSettingsUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;

/**
 * __useProcessorSettingsUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateByIdMutation, { data, loading, error }] = useProcessorSettingsUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSettingsUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>(ProcessorSettingsUpdateByIdDocument, options);
      }
export type ProcessorSettingsUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;
export const TenantCreateDocument = gql`
    mutation TenantCreate($newTenant: CreateOneTenantInput!) {
  tenantCreate(newTenant: $newTenant) {
    external_id
    name
    date_created
    domain
    enabled
    _id
  }
}
    `;
export type TenantCreateMutationFn = Apollo.MutationFunction<TenantCreateMutation, TenantCreateMutationVariables>;

/**
 * __useTenantCreateMutation__
 *
 * To run a mutation, you first call `useTenantCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantCreateMutation, { data, loading, error }] = useTenantCreateMutation({
 *   variables: {
 *      newTenant: // value for 'newTenant'
 *   },
 * });
 */
export function useTenantCreateMutation(baseOptions?: Apollo.MutationHookOptions<TenantCreateMutation, TenantCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantCreateMutation, TenantCreateMutationVariables>(TenantCreateDocument, options);
      }
export type TenantCreateMutationHookResult = ReturnType<typeof useTenantCreateMutation>;
export type TenantCreateMutationResult = Apollo.MutationResult<TenantCreateMutation>;
export type TenantCreateMutationOptions = Apollo.BaseMutationOptions<TenantCreateMutation, TenantCreateMutationVariables>;
export const TenantEnabledEditDocument = gql`
    mutation TenantEnabledEdit($tenantId: MongoID!, $enabled: Boolean!) {
  tenantEnabledEdit(tenantId: $tenantId, enabled: $enabled) {
    _id
    enabled
  }
}
    `;
export type TenantEnabledEditMutationFn = Apollo.MutationFunction<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>;

/**
 * __useTenantEnabledEditMutation__
 *
 * To run a mutation, you first call `useTenantEnabledEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantEnabledEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantEnabledEditMutation, { data, loading, error }] = useTenantEnabledEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useTenantEnabledEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>(TenantEnabledEditDocument, options);
      }
export type TenantEnabledEditMutationHookResult = ReturnType<typeof useTenantEnabledEditMutation>;
export type TenantEnabledEditMutationResult = Apollo.MutationResult<TenantEnabledEditMutation>;
export type TenantEnabledEditMutationOptions = Apollo.BaseMutationOptions<TenantEnabledEditMutation, TenantEnabledEditMutationVariables>;
export const TenantPictureUrlEditDocument = gql`
    mutation TenantPictureUrlEdit($tenantId: MongoID!, $pictureImage: Upload, $pictureImageToRemove: Boolean) {
  tenantPictureUrlEdit(
    tenantId: $tenantId
    pictureImage: $pictureImage
    pictureImageToRemove: $pictureImageToRemove
  ) {
    external_id
    name
    enabled
    _id
    picture_url
  }
}
    `;
export type TenantPictureUrlEditMutationFn = Apollo.MutationFunction<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;

/**
 * __useTenantPictureUrlEditMutation__
 *
 * To run a mutation, you first call `useTenantPictureUrlEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantPictureUrlEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantPictureUrlEditMutation, { data, loading, error }] = useTenantPictureUrlEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      pictureImage: // value for 'pictureImage'
 *      pictureImageToRemove: // value for 'pictureImageToRemove'
 *   },
 * });
 */
export function useTenantPictureUrlEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>(TenantPictureUrlEditDocument, options);
      }
export type TenantPictureUrlEditMutationHookResult = ReturnType<typeof useTenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationResult = Apollo.MutationResult<TenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationOptions = Apollo.BaseMutationOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;
export const TenantSubscriptionEditDocument = gql`
    mutation TenantSubscriptionEdit($tenantId: MongoID!, $subscription: String!) {
  tenantSubscriptionEdit(tenantId: $tenantId, subscription: $subscription) {
    external_id
    external_ids
    name
    email
    date_created
    picture_url
    primary_color
    domain
    enabled
    _id
  }
}
    `;
export type TenantSubscriptionEditMutationFn = Apollo.MutationFunction<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;

/**
 * __useTenantSubscriptionEditMutation__
 *
 * To run a mutation, you first call `useTenantSubscriptionEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantSubscriptionEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantSubscriptionEditMutation, { data, loading, error }] = useTenantSubscriptionEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useTenantSubscriptionEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>(TenantSubscriptionEditDocument, options);
      }
export type TenantSubscriptionEditMutationHookResult = ReturnType<typeof useTenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationResult = Apollo.MutationResult<TenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationOptions = Apollo.BaseMutationOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;
export const UserActivateDocument = gql`
    mutation UserActivate($userId: MongoID!) {
  userActivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserActivateMutationFn = Apollo.MutationFunction<UserActivateMutation, UserActivateMutationVariables>;

/**
 * __useUserActivateMutation__
 *
 * To run a mutation, you first call `useUserActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userActivateMutation, { data, loading, error }] = useUserActivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserActivateMutation(baseOptions?: Apollo.MutationHookOptions<UserActivateMutation, UserActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserActivateMutation, UserActivateMutationVariables>(UserActivateDocument, options);
      }
export type UserActivateMutationHookResult = ReturnType<typeof useUserActivateMutation>;
export type UserActivateMutationResult = Apollo.MutationResult<UserActivateMutation>;
export type UserActivateMutationOptions = Apollo.BaseMutationOptions<UserActivateMutation, UserActivateMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($newUser: CreateOneUserInput!) {
  userCreate(newUser: $newUser) {
    first_name
    last_name
    email
    picture_url
    role
    access_token
    refresh_token
    access_token
    refresh_token
    last_login
    _id
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserDeactivateDocument = gql`
    mutation UserDeactivate($userId: MongoID!) {
  userDeactivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserDeactivateMutationFn = Apollo.MutationFunction<UserDeactivateMutation, UserDeactivateMutationVariables>;

/**
 * __useUserDeactivateMutation__
 *
 * To run a mutation, you first call `useUserDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeactivateMutation, { data, loading, error }] = useUserDeactivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<UserDeactivateMutation, UserDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeactivateMutation, UserDeactivateMutationVariables>(UserDeactivateDocument, options);
      }
export type UserDeactivateMutationHookResult = ReturnType<typeof useUserDeactivateMutation>;
export type UserDeactivateMutationResult = Apollo.MutationResult<UserDeactivateMutation>;
export type UserDeactivateMutationOptions = Apollo.BaseMutationOptions<UserDeactivateMutation, UserDeactivateMutationVariables>;
export const VendorCreateDocument = gql`
    mutation VendorCreate($newVendor: CreateOneVendorInput!) {
  vendorCreate(newVendor: $newVendor) {
    external_id
    date_created
    shop_name
    shop_slug
    tagline
    enabled
    annualHangingWeightThroughput
    _id
  }
}
    `;
export type VendorCreateMutationFn = Apollo.MutationFunction<VendorCreateMutation, VendorCreateMutationVariables>;

/**
 * __useVendorCreateMutation__
 *
 * To run a mutation, you first call `useVendorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCreateMutation, { data, loading, error }] = useVendorCreateMutation({
 *   variables: {
 *      newVendor: // value for 'newVendor'
 *   },
 * });
 */
export function useVendorCreateMutation(baseOptions?: Apollo.MutationHookOptions<VendorCreateMutation, VendorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCreateMutation, VendorCreateMutationVariables>(VendorCreateDocument, options);
      }
export type VendorCreateMutationHookResult = ReturnType<typeof useVendorCreateMutation>;
export type VendorCreateMutationResult = Apollo.MutationResult<VendorCreateMutation>;
export type VendorCreateMutationOptions = Apollo.BaseMutationOptions<VendorCreateMutation, VendorCreateMutationVariables>;
export const VendorModuleUpsertDocument = gql`
    mutation VendorModuleUpsert($vendorId: MongoID!, $moduleType: String!, $name: String!, $label: String!, $href: String!, $order: Int, $active: Boolean!, $settings: JSON) {
  vendorModuleUpsert(
    vendorId: $vendorId
    moduleType: $moduleType
    name: $name
    label: $label
    href: $href
    order: $order
    active: $active
    settings: $settings
  ) {
    _id
    moduleType
    name
    label
    href
    order
    active
    settings
  }
}
    `;
export type VendorModuleUpsertMutationFn = Apollo.MutationFunction<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>;

/**
 * __useVendorModuleUpsertMutation__
 *
 * To run a mutation, you first call `useVendorModuleUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorModuleUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorModuleUpsertMutation, { data, loading, error }] = useVendorModuleUpsertMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      moduleType: // value for 'moduleType'
 *      name: // value for 'name'
 *      label: // value for 'label'
 *      href: // value for 'href'
 *      order: // value for 'order'
 *      active: // value for 'active'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useVendorModuleUpsertMutation(baseOptions?: Apollo.MutationHookOptions<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>(VendorModuleUpsertDocument, options);
      }
export type VendorModuleUpsertMutationHookResult = ReturnType<typeof useVendorModuleUpsertMutation>;
export type VendorModuleUpsertMutationResult = Apollo.MutationResult<VendorModuleUpsertMutation>;
export type VendorModuleUpsertMutationOptions = Apollo.BaseMutationOptions<VendorModuleUpsertMutation, VendorModuleUpsertMutationVariables>;
export const VendorUpdateByIdDocument = gql`
    mutation VendorUpdateById($record: UpdateByIdVendorInput!, $_id: MongoID!) {
  vendorUpdateById(record: $record, _id: $_id) {
    record {
      ...VendorFragment
    }
  }
}
    ${VendorFragmentFragmentDoc}`;
export type VendorUpdateByIdMutationFn = Apollo.MutationFunction<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;

/**
 * __useVendorUpdateByIdMutation__
 *
 * To run a mutation, you first call `useVendorUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorUpdateByIdMutation, { data, loading, error }] = useVendorUpdateByIdMutation({
 *   variables: {
 *      record: // value for 'record'
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useVendorUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>(VendorUpdateByIdDocument, options);
      }
export type VendorUpdateByIdMutationHookResult = ReturnType<typeof useVendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationResult = Apollo.MutationResult<VendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationOptions = Apollo.BaseMutationOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;
export const AuthCheckUserDocument = gql`
    mutation AuthCheckUser($identifier: String!, $redirectPath: String) {
  authCheckUser(identifier: $identifier, redirectPath: $redirectPath) {
    exists
    authMethod
    requiresPasswordReset
    redirectUrl
    otpSent
    session
    message
    resetCodeSent
    resetDestination
  }
}
    `;
export type AuthCheckUserMutationFn = Apollo.MutationFunction<AuthCheckUserMutation, AuthCheckUserMutationVariables>;

/**
 * __useAuthCheckUserMutation__
 *
 * To run a mutation, you first call `useAuthCheckUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthCheckUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authCheckUserMutation, { data, loading, error }] = useAuthCheckUserMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      redirectPath: // value for 'redirectPath'
 *   },
 * });
 */
export function useAuthCheckUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthCheckUserMutation, AuthCheckUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthCheckUserMutation, AuthCheckUserMutationVariables>(AuthCheckUserDocument, options);
      }
export type AuthCheckUserMutationHookResult = ReturnType<typeof useAuthCheckUserMutation>;
export type AuthCheckUserMutationResult = Apollo.MutationResult<AuthCheckUserMutation>;
export type AuthCheckUserMutationOptions = Apollo.BaseMutationOptions<AuthCheckUserMutation, AuthCheckUserMutationVariables>;
export const AuthLoginOAuthDocument = gql`
    mutation AuthLoginOAuth($code: String!, $redirectUri: String!) {
  authLoginOAuth(code: $code, redirectUri: $redirectUri) {
    accessToken
    idToken
    refreshToken
    expiresIn
  }
}
    `;
export type AuthLoginOAuthMutationFn = Apollo.MutationFunction<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>;

/**
 * __useAuthLoginOAuthMutation__
 *
 * To run a mutation, you first call `useAuthLoginOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginOAuthMutation, { data, loading, error }] = useAuthLoginOAuthMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useAuthLoginOAuthMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>(AuthLoginOAuthDocument, options);
      }
export type AuthLoginOAuthMutationHookResult = ReturnType<typeof useAuthLoginOAuthMutation>;
export type AuthLoginOAuthMutationResult = Apollo.MutationResult<AuthLoginOAuthMutation>;
export type AuthLoginOAuthMutationOptions = Apollo.BaseMutationOptions<AuthLoginOAuthMutation, AuthLoginOAuthMutationVariables>;
export const AuthLoginPasswordDocument = gql`
    mutation AuthLoginPassword($identifier: String!, $password: String!) {
  authLoginPassword(identifier: $identifier, password: $password) {
    accessToken
    idToken
    refreshToken
    expiresIn
    requiresNewPassword
    session
  }
}
    `;
export type AuthLoginPasswordMutationFn = Apollo.MutationFunction<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>;

/**
 * __useAuthLoginPasswordMutation__
 *
 * To run a mutation, you first call `useAuthLoginPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginPasswordMutation, { data, loading, error }] = useAuthLoginPasswordMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthLoginPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>(AuthLoginPasswordDocument, options);
      }
export type AuthLoginPasswordMutationHookResult = ReturnType<typeof useAuthLoginPasswordMutation>;
export type AuthLoginPasswordMutationResult = Apollo.MutationResult<AuthLoginPasswordMutation>;
export type AuthLoginPasswordMutationOptions = Apollo.BaseMutationOptions<AuthLoginPasswordMutation, AuthLoginPasswordMutationVariables>;
export const AuthRefreshTokenDocument = gql`
    mutation AuthRefreshToken($refreshToken: String!) {
  authRefreshToken(refreshToken: $refreshToken) {
    accessToken
    idToken
    expiresIn
  }
}
    `;
export type AuthRefreshTokenMutationFn = Apollo.MutationFunction<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;

/**
 * __useAuthRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAuthRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshTokenMutation, { data, loading, error }] = useAuthRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAuthRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>(AuthRefreshTokenDocument, options);
      }
export type AuthRefreshTokenMutationHookResult = ReturnType<typeof useAuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationResult = Apollo.MutationResult<AuthRefreshTokenMutation>;
export type AuthRefreshTokenMutationOptions = Apollo.BaseMutationOptions<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>;
export const AuthSendOtpDocument = gql`
    mutation AuthSendOTP($identifier: String!) {
  authSendOTP(identifier: $identifier) {
    success
    message
    session
  }
}
    `;
export type AuthSendOtpMutationFn = Apollo.MutationFunction<AuthSendOtpMutation, AuthSendOtpMutationVariables>;

/**
 * __useAuthSendOtpMutation__
 *
 * To run a mutation, you first call `useAuthSendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSendOtpMutation, { data, loading, error }] = useAuthSendOtpMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useAuthSendOtpMutation(baseOptions?: Apollo.MutationHookOptions<AuthSendOtpMutation, AuthSendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSendOtpMutation, AuthSendOtpMutationVariables>(AuthSendOtpDocument, options);
      }
export type AuthSendOtpMutationHookResult = ReturnType<typeof useAuthSendOtpMutation>;
export type AuthSendOtpMutationResult = Apollo.MutationResult<AuthSendOtpMutation>;
export type AuthSendOtpMutationOptions = Apollo.BaseMutationOptions<AuthSendOtpMutation, AuthSendOtpMutationVariables>;
export const AuthSetPasswordDocument = gql`
    mutation AuthSetPassword($identifier: String!, $newPassword: String!, $temporaryPassword: String, $session: String) {
  authSetPassword(
    identifier: $identifier
    newPassword: $newPassword
    temporaryPassword: $temporaryPassword
    session: $session
  ) {
    accessToken
    idToken
    refreshToken
    expiresIn
  }
}
    `;
export type AuthSetPasswordMutationFn = Apollo.MutationFunction<AuthSetPasswordMutation, AuthSetPasswordMutationVariables>;

/**
 * __useAuthSetPasswordMutation__
 *
 * To run a mutation, you first call `useAuthSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSetPasswordMutation, { data, loading, error }] = useAuthSetPasswordMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      newPassword: // value for 'newPassword'
 *      temporaryPassword: // value for 'temporaryPassword'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useAuthSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AuthSetPasswordMutation, AuthSetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSetPasswordMutation, AuthSetPasswordMutationVariables>(AuthSetPasswordDocument, options);
      }
export type AuthSetPasswordMutationHookResult = ReturnType<typeof useAuthSetPasswordMutation>;
export type AuthSetPasswordMutationResult = Apollo.MutationResult<AuthSetPasswordMutation>;
export type AuthSetPasswordMutationOptions = Apollo.BaseMutationOptions<AuthSetPasswordMutation, AuthSetPasswordMutationVariables>;
export const AuthVerifyOtpDocument = gql`
    mutation AuthVerifyOTP($identifier: String!, $otp: String!, $session: String) {
  authVerifyOTP(identifier: $identifier, otp: $otp, session: $session) {
    accessToken
    idToken
    refreshToken
    expiresIn
    requiresProfileCompletion
  }
}
    `;
export type AuthVerifyOtpMutationFn = Apollo.MutationFunction<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>;

/**
 * __useAuthVerifyOtpMutation__
 *
 * To run a mutation, you first call `useAuthVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authVerifyOtpMutation, { data, loading, error }] = useAuthVerifyOtpMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      otp: // value for 'otp'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useAuthVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>(AuthVerifyOtpDocument, options);
      }
export type AuthVerifyOtpMutationHookResult = ReturnType<typeof useAuthVerifyOtpMutation>;
export type AuthVerifyOtpMutationResult = Apollo.MutationResult<AuthVerifyOtpMutation>;
export type AuthVerifyOtpMutationOptions = Apollo.BaseMutationOptions<AuthVerifyOtpMutation, AuthVerifyOtpMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
  changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    success
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChatRoomCreateOneDocument = gql`
    mutation ChatRoomCreateOne($record: CreateOneChatRoomInput!) {
  chatRoomCreateOne(record: $record) {
    recordId
    record {
      ...ChatRoomFragment
    }
  }
}
    ${ChatRoomFragmentFragmentDoc}`;
export type ChatRoomCreateOneMutationFn = Apollo.MutationFunction<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;

/**
 * __useChatRoomCreateOneMutation__
 *
 * To run a mutation, you first call `useChatRoomCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatRoomCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatRoomCreateOneMutation, { data, loading, error }] = useChatRoomCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useChatRoomCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>(ChatRoomCreateOneDocument, options);
      }
export type ChatRoomCreateOneMutationHookResult = ReturnType<typeof useChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationResult = Apollo.MutationResult<ChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationOptions = Apollo.BaseMutationOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;
export const CreateProcessorSchedulingDocument = gql`
    mutation CreateProcessorScheduling($newSchedule: CreateProcessorSchedulingInput!) {
  processorSchedulingCreate(newSchedule: $newSchedule) {
    scheduling {
      ...ProcessorSchedulingFragment
    }
    checkoutSession {
      clientSecret
    }
    messages
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type CreateProcessorSchedulingMutationFn = Apollo.MutationFunction<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;

/**
 * __useCreateProcessorSchedulingMutation__
 *
 * To run a mutation, you first call `useCreateProcessorSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessorSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessorSchedulingMutation, { data, loading, error }] = useCreateProcessorSchedulingMutation({
 *   variables: {
 *      newSchedule: // value for 'newSchedule'
 *   },
 * });
 */
export function useCreateProcessorSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>(CreateProcessorSchedulingDocument, options);
      }
export type CreateProcessorSchedulingMutationHookResult = ReturnType<typeof useCreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationResult = Apollo.MutationResult<CreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationOptions = Apollo.BaseMutationOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;
export const CsvImportCancelJobDocument = gql`
    mutation CsvImportCancelJob($jobId: String!, $stage: String!) {
  csvImportCancelJob(jobId: $jobId, stage: $stage) {
    jobId
    status
    cancelledAt
    cancelledAtStage
    message
  }
}
    `;
export type CsvImportCancelJobMutationFn = Apollo.MutationFunction<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>;

/**
 * __useCsvImportCancelJobMutation__
 *
 * To run a mutation, you first call `useCsvImportCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportCancelJobMutation, { data, loading, error }] = useCsvImportCancelJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useCsvImportCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>(CsvImportCancelJobDocument, options);
      }
export type CsvImportCancelJobMutationHookResult = ReturnType<typeof useCsvImportCancelJobMutation>;
export type CsvImportCancelJobMutationResult = Apollo.MutationResult<CsvImportCancelJobMutation>;
export type CsvImportCancelJobMutationOptions = Apollo.BaseMutationOptions<CsvImportCancelJobMutation, CsvImportCancelJobMutationVariables>;
export const CsvImportDeleteRecordDocument = gql`
    mutation csvImportDeleteRecord($jobId: String!, $rowNumber: Int!) {
  csvImportDeleteRecord(jobId: $jobId, rowNumber: $rowNumber) {
    jobId
    deletedRows
    validRows
  }
}
    `;
export type CsvImportDeleteRecordMutationFn = Apollo.MutationFunction<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>;

/**
 * __useCsvImportDeleteRecordMutation__
 *
 * To run a mutation, you first call `useCsvImportDeleteRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportDeleteRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportDeleteRecordMutation, { data, loading, error }] = useCsvImportDeleteRecordMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      rowNumber: // value for 'rowNumber'
 *   },
 * });
 */
export function useCsvImportDeleteRecordMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>(CsvImportDeleteRecordDocument, options);
      }
export type CsvImportDeleteRecordMutationHookResult = ReturnType<typeof useCsvImportDeleteRecordMutation>;
export type CsvImportDeleteRecordMutationResult = Apollo.MutationResult<CsvImportDeleteRecordMutation>;
export type CsvImportDeleteRecordMutationOptions = Apollo.BaseMutationOptions<CsvImportDeleteRecordMutation, CsvImportDeleteRecordMutationVariables>;
export const CsvImportExecuteDocument = gql`
    mutation CsvImportExecute($jobId: String!) {
  csvImportExecute(jobId: $jobId) {
    jobId
    status
    message
  }
}
    `;
export type CsvImportExecuteMutationFn = Apollo.MutationFunction<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>;

/**
 * __useCsvImportExecuteMutation__
 *
 * To run a mutation, you first call `useCsvImportExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportExecuteMutation, { data, loading, error }] = useCsvImportExecuteMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportExecuteMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>(CsvImportExecuteDocument, options);
      }
export type CsvImportExecuteMutationHookResult = ReturnType<typeof useCsvImportExecuteMutation>;
export type CsvImportExecuteMutationResult = Apollo.MutationResult<CsvImportExecuteMutation>;
export type CsvImportExecuteMutationOptions = Apollo.BaseMutationOptions<CsvImportExecuteMutation, CsvImportExecuteMutationVariables>;
export const CsvImportRevalidateDocument = gql`
    mutation CsvImportRevalidate($jobId: String!, $data: JSON!) {
  csvImportRevalidate(jobId: $jobId, data: $data) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
    }
  }
}
    `;
export type CsvImportRevalidateMutationFn = Apollo.MutationFunction<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>;

/**
 * __useCsvImportRevalidateMutation__
 *
 * To run a mutation, you first call `useCsvImportRevalidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportRevalidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportRevalidateMutation, { data, loading, error }] = useCsvImportRevalidateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCsvImportRevalidateMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>(CsvImportRevalidateDocument, options);
      }
export type CsvImportRevalidateMutationHookResult = ReturnType<typeof useCsvImportRevalidateMutation>;
export type CsvImportRevalidateMutationResult = Apollo.MutationResult<CsvImportRevalidateMutation>;
export type CsvImportRevalidateMutationOptions = Apollo.BaseMutationOptions<CsvImportRevalidateMutation, CsvImportRevalidateMutationVariables>;
export const CsvImportSaveColumnMappingDocument = gql`
    mutation CsvImportSaveColumnMapping($jobId: String!, $columnMapping: JSON!) {
  csvImportSaveColumnMapping(jobId: $jobId, columnMapping: $columnMapping) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
    s3Keys
    parsedData
    columns
  }
}
    `;
export type CsvImportSaveColumnMappingMutationFn = Apollo.MutationFunction<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>;

/**
 * __useCsvImportSaveColumnMappingMutation__
 *
 * To run a mutation, you first call `useCsvImportSaveColumnMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportSaveColumnMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportSaveColumnMappingMutation, { data, loading, error }] = useCsvImportSaveColumnMappingMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      columnMapping: // value for 'columnMapping'
 *   },
 * });
 */
export function useCsvImportSaveColumnMappingMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>(CsvImportSaveColumnMappingDocument, options);
      }
export type CsvImportSaveColumnMappingMutationHookResult = ReturnType<typeof useCsvImportSaveColumnMappingMutation>;
export type CsvImportSaveColumnMappingMutationResult = Apollo.MutationResult<CsvImportSaveColumnMappingMutation>;
export type CsvImportSaveColumnMappingMutationOptions = Apollo.BaseMutationOptions<CsvImportSaveColumnMappingMutation, CsvImportSaveColumnMappingMutationVariables>;
export const CsvImportUpdateRowsDocument = gql`
    mutation csvImportUpdateRows($jobId: String!, $updatedRows: JSON!) {
  csvImportUpdateRows(jobId: $jobId, updatedRows: $updatedRows) {
    jobId
    totalRows
    validRows
    invalidRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
  }
}
    `;
export type CsvImportUpdateRowsMutationFn = Apollo.MutationFunction<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>;

/**
 * __useCsvImportUpdateRowsMutation__
 *
 * To run a mutation, you first call `useCsvImportUpdateRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportUpdateRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportUpdateRowsMutation, { data, loading, error }] = useCsvImportUpdateRowsMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      updatedRows: // value for 'updatedRows'
 *   },
 * });
 */
export function useCsvImportUpdateRowsMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>(CsvImportUpdateRowsDocument, options);
      }
export type CsvImportUpdateRowsMutationHookResult = ReturnType<typeof useCsvImportUpdateRowsMutation>;
export type CsvImportUpdateRowsMutationResult = Apollo.MutationResult<CsvImportUpdateRowsMutation>;
export type CsvImportUpdateRowsMutationOptions = Apollo.BaseMutationOptions<CsvImportUpdateRowsMutation, CsvImportUpdateRowsMutationVariables>;
export const CsvImportForceCancelDocument = gql`
    mutation CsvImportForceCancel($jobId: String!) {
  csvImportForceCancel(jobId: $jobId) {
    jobId
    status
    cancelledAt
    message
    warning
  }
}
    `;
export type CsvImportForceCancelMutationFn = Apollo.MutationFunction<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>;

/**
 * __useCsvImportForceCancelMutation__
 *
 * To run a mutation, you first call `useCsvImportForceCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportForceCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportForceCancelMutation, { data, loading, error }] = useCsvImportForceCancelMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportForceCancelMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>(CsvImportForceCancelDocument, options);
      }
export type CsvImportForceCancelMutationHookResult = ReturnType<typeof useCsvImportForceCancelMutation>;
export type CsvImportForceCancelMutationResult = Apollo.MutationResult<CsvImportForceCancelMutation>;
export type CsvImportForceCancelMutationOptions = Apollo.BaseMutationOptions<CsvImportForceCancelMutation, CsvImportForceCancelMutationVariables>;
export const CsvImportUploadDocument = gql`
    mutation CsvImportUpload($file: Upload!, $type: String!, $vendorId: MongoID!, $tenantId: MongoID!) {
  csvImportUpload(
    file: $file
    type: $type
    vendorId: $vendorId
    tenantId: $tenantId
  ) {
    jobId
    totalRows
    validRows
    invalidRows
    validFilePath
    invalidFilePath
    validationErrors {
      row
      errorMessages
    }
    availableColumns {
      fieldName
      aliases
      required
      description
      validationRules
    }
    detectedColumns
    suggestedMapping
  }
}
    `;
export type CsvImportUploadMutationFn = Apollo.MutationFunction<CsvImportUploadMutation, CsvImportUploadMutationVariables>;

/**
 * __useCsvImportUploadMutation__
 *
 * To run a mutation, you first call `useCsvImportUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCsvImportUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [csvImportUploadMutation, { data, loading, error }] = useCsvImportUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      vendorId: // value for 'vendorId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCsvImportUploadMutation(baseOptions?: Apollo.MutationHookOptions<CsvImportUploadMutation, CsvImportUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CsvImportUploadMutation, CsvImportUploadMutationVariables>(CsvImportUploadDocument, options);
      }
export type CsvImportUploadMutationHookResult = ReturnType<typeof useCsvImportUploadMutation>;
export type CsvImportUploadMutationResult = Apollo.MutationResult<CsvImportUploadMutation>;
export type CsvImportUploadMutationOptions = Apollo.BaseMutationOptions<CsvImportUploadMutation, CsvImportUploadMutationVariables>;
export const CutsheetAssignmentRuleSetDeleteDocument = gql`
    mutation CutsheetAssignmentRuleSetDelete($capabilityId: MongoID!) {
  cutsheetAssignmentRuleSetDelete(capabilityId: $capabilityId)
}
    `;
export type CutsheetAssignmentRuleSetDeleteMutationFn = Apollo.MutationFunction<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>;

/**
 * __useCutsheetAssignmentRuleSetDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetAssignmentRuleSetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetAssignmentRuleSetDeleteMutation, { data, loading, error }] = useCutsheetAssignmentRuleSetDeleteMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>(CutsheetAssignmentRuleSetDeleteDocument, options);
      }
export type CutsheetAssignmentRuleSetDeleteMutationHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetDeleteMutation>;
export type CutsheetAssignmentRuleSetDeleteMutationResult = Apollo.MutationResult<CutsheetAssignmentRuleSetDeleteMutation>;
export type CutsheetAssignmentRuleSetDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetAssignmentRuleSetDeleteMutation, CutsheetAssignmentRuleSetDeleteMutationVariables>;
export const CutsheetAssignmentRuleSetUpsertDocument = gql`
    mutation CutsheetAssignmentRuleSetUpsert($capabilityId: MongoID!, $rules: [CutsheetAssignmentRuleInput!], $defaultQuestionnaireId: MongoID) {
  cutsheetAssignmentRuleSetUpsert(
    capabilityId: $capabilityId
    rules: $rules
    defaultQuestionnaireId: $defaultQuestionnaireId
  ) {
    ...CutsheetAssignmentRuleSetFragment
  }
}
    ${CutsheetAssignmentRuleSetFragmentFragmentDoc}`;
export type CutsheetAssignmentRuleSetUpsertMutationFn = Apollo.MutationFunction<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>;

/**
 * __useCutsheetAssignmentRuleSetUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetAssignmentRuleSetUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetAssignmentRuleSetUpsertMutation, { data, loading, error }] = useCutsheetAssignmentRuleSetUpsertMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      rules: // value for 'rules'
 *      defaultQuestionnaireId: // value for 'defaultQuestionnaireId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>(CutsheetAssignmentRuleSetUpsertDocument, options);
      }
export type CutsheetAssignmentRuleSetUpsertMutationHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetUpsertMutation>;
export type CutsheetAssignmentRuleSetUpsertMutationResult = Apollo.MutationResult<CutsheetAssignmentRuleSetUpsertMutation>;
export type CutsheetAssignmentRuleSetUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetAssignmentRuleSetUpsertMutation, CutsheetAssignmentRuleSetUpsertMutationVariables>;
export const CutsheetCapabilityDeleteDocument = gql`
    mutation CutsheetCapabilityDelete($id: MongoID!) {
  CutsheetCapabilityDelete(id: $id)
}
    `;
export type CutsheetCapabilityDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityDeleteMutation, { data, loading, error }] = useCutsheetCapabilityDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>(CutsheetCapabilityDeleteDocument, options);
      }
export type CutsheetCapabilityDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityDeleteMutation>;
export type CutsheetCapabilityDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityDeleteMutation>;
export type CutsheetCapabilityDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityDeleteMutation, CutsheetCapabilityDeleteMutationVariables>;
export const CutsheetCapabilityUpsertDocument = gql`
    mutation CutsheetCapabilityUpsert($id: MongoID, $vendorId: MongoID!, $species: String!, $name: String!, $description: String, $isActive: Boolean) {
  CutsheetCapabilityUpsert(
    id: $id
    vendorId: $vendorId
    species: $species
    name: $name
    description: $description
    isActive: $isActive
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityUpsertMutation, { data, loading, error }] = useCutsheetCapabilityUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>(CutsheetCapabilityUpsertDocument, options);
      }
export type CutsheetCapabilityUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityUpsertMutation>;
export type CutsheetCapabilityUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityUpsertMutation>;
export type CutsheetCapabilityUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityUpsertMutation, CutsheetCapabilityUpsertMutationVariables>;
export const CutsheetCapabilityDuplicateDocument = gql`
    mutation CutsheetCapabilityDuplicate($sourceCapabilityId: MongoID!, $targetCapabilityId: MongoID!, $includeQuestionnaires: Boolean!, $includeAssignmentRules: Boolean!) {
  CutsheetCapabilityDuplicate(
    sourceCapabilityId: $sourceCapabilityId
    targetCapabilityId: $targetCapabilityId
    includeQuestionnaires: $includeQuestionnaires
    includeAssignmentRules: $includeAssignmentRules
  ) {
    capability {
      ...CutsheetCapabilityFragment
    }
    summary {
      groupsCopied
      optionsCopied
      specificationsCopied
      questionnairesCopied
      assignmentRulesCopied
    }
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityDuplicateMutationFn = Apollo.MutationFunction<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>;

/**
 * __useCutsheetCapabilityDuplicateMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityDuplicateMutation, { data, loading, error }] = useCutsheetCapabilityDuplicateMutation({
 *   variables: {
 *      sourceCapabilityId: // value for 'sourceCapabilityId'
 *      targetCapabilityId: // value for 'targetCapabilityId'
 *      includeQuestionnaires: // value for 'includeQuestionnaires'
 *      includeAssignmentRules: // value for 'includeAssignmentRules'
 *   },
 * });
 */
export function useCutsheetCapabilityDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>(CutsheetCapabilityDuplicateDocument, options);
      }
export type CutsheetCapabilityDuplicateMutationHookResult = ReturnType<typeof useCutsheetCapabilityDuplicateMutation>;
export type CutsheetCapabilityDuplicateMutationResult = Apollo.MutationResult<CutsheetCapabilityDuplicateMutation>;
export type CutsheetCapabilityDuplicateMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityDuplicateMutation, CutsheetCapabilityDuplicateMutationVariables>;
export const CutsheetCapabilityGenerateBlankCutsheetDocument = gql`
    mutation CutsheetCapabilityGenerateBlankCutsheet($cutsheetCapabilityId: MongoID!) {
  cutsheetCapabilityGenerateBlankCutsheet(
    cutsheetCapabilityId: $cutsheetCapabilityId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type CutsheetCapabilityGenerateBlankCutsheetMutationFn = Apollo.MutationFunction<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>;

/**
 * __useCutsheetCapabilityGenerateBlankCutsheetMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGenerateBlankCutsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGenerateBlankCutsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGenerateBlankCutsheetMutation, { data, loading, error }] = useCutsheetCapabilityGenerateBlankCutsheetMutation({
 *   variables: {
 *      cutsheetCapabilityId: // value for 'cutsheetCapabilityId'
 *   },
 * });
 */
export function useCutsheetCapabilityGenerateBlankCutsheetMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>(CutsheetCapabilityGenerateBlankCutsheetDocument, options);
      }
export type CutsheetCapabilityGenerateBlankCutsheetMutationHookResult = ReturnType<typeof useCutsheetCapabilityGenerateBlankCutsheetMutation>;
export type CutsheetCapabilityGenerateBlankCutsheetMutationResult = Apollo.MutationResult<CutsheetCapabilityGenerateBlankCutsheetMutation>;
export type CutsheetCapabilityGenerateBlankCutsheetMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGenerateBlankCutsheetMutation, CutsheetCapabilityGenerateBlankCutsheetMutationVariables>;
export const CutsheetCapabilityMigrateLegacyDocument = gql`
    mutation CutsheetCapabilityMigrateLegacy($capabilityId: MongoID!, $enabledOnly: Boolean, $deactivateUnusedCuts: Boolean, $inspectionLevel: String) {
  CutsheetCapabilityMigrateLegacy(
    capabilityId: $capabilityId
    enabledOnly: $enabledOnly
    deactivateUnusedCuts: $deactivateUnusedCuts
    inspectionLevel: $inspectionLevel
  ) {
    capability {
      ...CutsheetCapabilityFragment
    }
    summary {
      inspectionLevelsMigrated
      groupsCreated
      groupsReused
      cutsCreated
      cutsReused
      trimsCreated
      trimsReused
      specificationsCreated
      specificationsReused
      questionnairesCreated
      questionnairesReused
      assignmentRulesAdded
    }
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityMigrateLegacyMutationFn = Apollo.MutationFunction<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>;

/**
 * __useCutsheetCapabilityMigrateLegacyMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityMigrateLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityMigrateLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityMigrateLegacyMutation, { data, loading, error }] = useCutsheetCapabilityMigrateLegacyMutation({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      enabledOnly: // value for 'enabledOnly'
 *      deactivateUnusedCuts: // value for 'deactivateUnusedCuts'
 *      inspectionLevel: // value for 'inspectionLevel'
 *   },
 * });
 */
export function useCutsheetCapabilityMigrateLegacyMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>(CutsheetCapabilityMigrateLegacyDocument, options);
      }
export type CutsheetCapabilityMigrateLegacyMutationHookResult = ReturnType<typeof useCutsheetCapabilityMigrateLegacyMutation>;
export type CutsheetCapabilityMigrateLegacyMutationResult = Apollo.MutationResult<CutsheetCapabilityMigrateLegacyMutation>;
export type CutsheetCapabilityMigrateLegacyMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityMigrateLegacyMutation, CutsheetCapabilityMigrateLegacyMutationVariables>;
export const CutsheetCapabilityOptionDeleteDocument = gql`
    mutation CutsheetCapabilityOptionDelete($id: MongoID!) {
  cutsheetCapabilityOptionDelete(id: $id)
}
    `;
export type CutsheetCapabilityOptionDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityOptionDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionDeleteMutation, { data, loading, error }] = useCutsheetCapabilityOptionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>(CutsheetCapabilityOptionDeleteDocument, options);
      }
export type CutsheetCapabilityOptionDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionDeleteMutation>;
export type CutsheetCapabilityOptionDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionDeleteMutation>;
export type CutsheetCapabilityOptionDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionDeleteMutation, CutsheetCapabilityOptionDeleteMutationVariables>;
export const CutsheetCapabilityOptionUpsertDocument = gql`
    mutation CutsheetCapabilityOptionUpsert($id: MongoID, $capabilityId: MongoID!, $optionType: String!, $title: String!, $description: String, $imageUrl: String, $specifications: [CutsheetCapabilityOptionSpecificationInput!], $pricing: CutsheetCapabilityOptionPricingInput, $isActive: Boolean, $groupId: MongoID, $isDefault: Boolean, $minQty: Float, $hasCharge: Boolean, $printedText: String) {
  cutsheetCapabilityOptionUpsert(
    id: $id
    capabilityId: $capabilityId
    optionType: $optionType
    title: $title
    description: $description
    imageUrl: $imageUrl
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    groupId: $groupId
    isDefault: $isDefault
    minQty: $minQty
    hasCharge: $hasCharge
    printedText: $printedText
  ) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;
export type CutsheetCapabilityOptionUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityOptionUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionUpsertMutation, { data, loading, error }] = useCutsheetCapabilityOptionUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      capabilityId: // value for 'capabilityId'
 *      optionType: // value for 'optionType'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      groupId: // value for 'groupId'
 *      isDefault: // value for 'isDefault'
 *      minQty: // value for 'minQty'
 *      hasCharge: // value for 'hasCharge'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>(CutsheetCapabilityOptionUpsertDocument, options);
      }
export type CutsheetCapabilityOptionUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionUpsertMutation>;
export type CutsheetCapabilityOptionUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionUpsertMutation>;
export type CutsheetCapabilityOptionUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionUpsertMutation, CutsheetCapabilityOptionUpsertMutationVariables>;
export const CutsheetCapabilityPrintSettingsUpdateDocument = gql`
    mutation CutsheetCapabilityPrintSettingsUpdate($id: MongoID!, $baseFontSize: Float!, $primalColumns: Float!, $specsLayoutPosition: String!, $checkboxStyle: String!, $showPrimalGroup: Boolean!, $alwaysShowPrimalNotes: Boolean!, $hideUnselectedCuts: Boolean!, $orientation: String!, $hiddenGroupIds: [String!]!, $hiddenItemIds: [String!]!, $hiddenSpecificationIds: [String!]!) {
  CutsheetCapabilityPrintSettingsUpdate(
    id: $id
    baseFontSize: $baseFontSize
    primalColumns: $primalColumns
    specsLayoutPosition: $specsLayoutPosition
    checkboxStyle: $checkboxStyle
    showPrimalGroup: $showPrimalGroup
    alwaysShowPrimalNotes: $alwaysShowPrimalNotes
    hideUnselectedCuts: $hideUnselectedCuts
    orientation: $orientation
    hiddenGroupIds: $hiddenGroupIds
    hiddenItemIds: $hiddenItemIds
    hiddenSpecificationIds: $hiddenSpecificationIds
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilityPrintSettingsUpdateMutationFn = Apollo.MutationFunction<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>;

/**
 * __useCutsheetCapabilityPrintSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityPrintSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityPrintSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityPrintSettingsUpdateMutation, { data, loading, error }] = useCutsheetCapabilityPrintSettingsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      baseFontSize: // value for 'baseFontSize'
 *      primalColumns: // value for 'primalColumns'
 *      specsLayoutPosition: // value for 'specsLayoutPosition'
 *      checkboxStyle: // value for 'checkboxStyle'
 *      showPrimalGroup: // value for 'showPrimalGroup'
 *      alwaysShowPrimalNotes: // value for 'alwaysShowPrimalNotes'
 *      hideUnselectedCuts: // value for 'hideUnselectedCuts'
 *      orientation: // value for 'orientation'
 *      hiddenGroupIds: // value for 'hiddenGroupIds'
 *      hiddenItemIds: // value for 'hiddenItemIds'
 *      hiddenSpecificationIds: // value for 'hiddenSpecificationIds'
 *   },
 * });
 */
export function useCutsheetCapabilityPrintSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>(CutsheetCapabilityPrintSettingsUpdateDocument, options);
      }
export type CutsheetCapabilityPrintSettingsUpdateMutationHookResult = ReturnType<typeof useCutsheetCapabilityPrintSettingsUpdateMutation>;
export type CutsheetCapabilityPrintSettingsUpdateMutationResult = Apollo.MutationResult<CutsheetCapabilityPrintSettingsUpdateMutation>;
export type CutsheetCapabilityPrintSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityPrintSettingsUpdateMutation, CutsheetCapabilityPrintSettingsUpdateMutationVariables>;
export const CutsheetCapabilitySetLegacyMapDocument = gql`
    mutation CutsheetCapabilitySetLegacyMap($id: MongoID!, $legacyInspectionLevelMap: [CutsheetLegacyInspectionLevelEntryInput!]!) {
  CutsheetCapabilitySetLegacyMap(
    id: $id
    legacyInspectionLevelMap: $legacyInspectionLevelMap
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;
export type CutsheetCapabilitySetLegacyMapMutationFn = Apollo.MutationFunction<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>;

/**
 * __useCutsheetCapabilitySetLegacyMapMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySetLegacyMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySetLegacyMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySetLegacyMapMutation, { data, loading, error }] = useCutsheetCapabilitySetLegacyMapMutation({
 *   variables: {
 *      id: // value for 'id'
 *      legacyInspectionLevelMap: // value for 'legacyInspectionLevelMap'
 *   },
 * });
 */
export function useCutsheetCapabilitySetLegacyMapMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>(CutsheetCapabilitySetLegacyMapDocument, options);
      }
export type CutsheetCapabilitySetLegacyMapMutationHookResult = ReturnType<typeof useCutsheetCapabilitySetLegacyMapMutation>;
export type CutsheetCapabilitySetLegacyMapMutationResult = Apollo.MutationResult<CutsheetCapabilitySetLegacyMapMutation>;
export type CutsheetCapabilitySetLegacyMapMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySetLegacyMapMutation, CutsheetCapabilitySetLegacyMapMutationVariables>;
export const CutsheetCreateOneDocument = gql`
    mutation CutsheetCreateOne($record: CreateOneCutsheetInput!) {
  cutsheetCreateOne(record: $record) {
    recordId
    record {
      ...CutsheetFragment
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetCreateOneMutationFn = Apollo.MutationFunction<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;

/**
 * __useCutsheetCreateOneMutation__
 *
 * To run a mutation, you first call `useCutsheetCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCreateOneMutation, { data, loading, error }] = useCutsheetCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>(CutsheetCreateOneDocument, options);
      }
export type CutsheetCreateOneMutationHookResult = ReturnType<typeof useCutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationResult = Apollo.MutationResult<CutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationOptions = Apollo.BaseMutationOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;
export const CutsheetCapabilityCutDeleteDocument = gql`
    mutation CutsheetCapabilityCutDelete($id: MongoID!) {
  cutsheetCutDelete(id: $id)
}
    `;
export type CutsheetCapabilityCutDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityCutDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityCutDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityCutDeleteMutation, { data, loading, error }] = useCutsheetCapabilityCutDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityCutDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>(CutsheetCapabilityCutDeleteDocument, options);
      }
export type CutsheetCapabilityCutDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityCutDeleteMutation>;
export type CutsheetCapabilityCutDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityCutDeleteMutation>;
export type CutsheetCapabilityCutDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityCutDeleteMutation, CutsheetCapabilityCutDeleteMutationVariables>;
export const CutsheetCapabilityCutUpsertDocument = gql`
    mutation CutsheetCapabilityCutUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $groupId: MongoID, $title: String!, $description: String, $imageUrl: String, $specifications: [CutsheetCutSpecificationInput!], $pricing: CutsheetCutPricingInput, $isActive: Boolean, $printedText: String) {
  cutsheetCutUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    groupId: $groupId
    title: $title
    description: $description
    imageUrl: $imageUrl
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
  ) {
    ...CutsheetCapabilityCutFragment
  }
}
    ${CutsheetCapabilityCutFragmentFragmentDoc}`;
export type CutsheetCapabilityCutUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityCutUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityCutUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityCutUpsertMutation, { data, loading, error }] = useCutsheetCapabilityCutUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      groupId: // value for 'groupId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilityCutUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>(CutsheetCapabilityCutUpsertDocument, options);
      }
export type CutsheetCapabilityCutUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityCutUpsertMutation>;
export type CutsheetCapabilityCutUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityCutUpsertMutation>;
export type CutsheetCapabilityCutUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityCutUpsertMutation, CutsheetCapabilityCutUpsertMutationVariables>;
export const CutsheetCapabilityExtraDeleteDocument = gql`
    mutation CutsheetCapabilityExtraDelete($id: MongoID!) {
  cutsheetExtraDelete(id: $id)
}
    `;
export type CutsheetCapabilityExtraDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityExtraDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityExtraDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityExtraDeleteMutation, { data, loading, error }] = useCutsheetCapabilityExtraDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>(CutsheetCapabilityExtraDeleteDocument, options);
      }
export type CutsheetCapabilityExtraDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityExtraDeleteMutation>;
export type CutsheetCapabilityExtraDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityExtraDeleteMutation>;
export type CutsheetCapabilityExtraDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityExtraDeleteMutation, CutsheetCapabilityExtraDeleteMutationVariables>;
export const CutsheetCapabilityExtraUpsertDocument = gql`
    mutation CutsheetCapabilityExtraUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $hasCharge: Boolean, $specifications: [CutsheetExtraSpecificationInput!], $pricing: CutsheetExtraPricingInput, $isActive: Boolean, $printedText: String) {
  cutsheetExtraUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    hasCharge: $hasCharge
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
  ) {
    ...CutsheetCapabilityExtraFragment
  }
}
    ${CutsheetCapabilityExtraFragmentFragmentDoc}`;
export type CutsheetCapabilityExtraUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityExtraUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityExtraUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityExtraUpsertMutation, { data, loading, error }] = useCutsheetCapabilityExtraUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      hasCharge: // value for 'hasCharge'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>(CutsheetCapabilityExtraUpsertDocument, options);
      }
export type CutsheetCapabilityExtraUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityExtraUpsertMutation>;
export type CutsheetCapabilityExtraUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityExtraUpsertMutation>;
export type CutsheetCapabilityExtraUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityExtraUpsertMutation, CutsheetCapabilityExtraUpsertMutationVariables>;
export const CutsheetCapabilityGroupDeleteDocument = gql`
    mutation CutsheetCapabilityGroupDelete($id: MongoID!) {
  cutsheetGroupDelete(id: $id)
}
    `;
export type CutsheetCapabilityGroupDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityGroupDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupDeleteMutation, { data, loading, error }] = useCutsheetCapabilityGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>(CutsheetCapabilityGroupDeleteDocument, options);
      }
export type CutsheetCapabilityGroupDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupDeleteMutation>;
export type CutsheetCapabilityGroupDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupDeleteMutation>;
export type CutsheetCapabilityGroupDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupDeleteMutation, CutsheetCapabilityGroupDeleteMutationVariables>;
export const CutsheetCapabilityGroupReorderDocument = gql`
    mutation CutsheetCapabilityGroupReorder($ids: [MongoID!]!) {
  cutsheetGroupReorder(ids: $ids)
}
    `;
export type CutsheetCapabilityGroupReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>;

/**
 * __useCutsheetCapabilityGroupReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupReorderMutation, { data, loading, error }] = useCutsheetCapabilityGroupReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>(CutsheetCapabilityGroupReorderDocument, options);
      }
export type CutsheetCapabilityGroupReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupReorderMutation>;
export type CutsheetCapabilityGroupReorderMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupReorderMutation>;
export type CutsheetCapabilityGroupReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupReorderMutation, CutsheetCapabilityGroupReorderMutationVariables>;
export const CutsheetCapabilityGroupUpsertDocument = gql`
    mutation CutsheetCapabilityGroupUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $sortOrder: Float, $isActive: Boolean) {
  cutsheetGroupUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    sortOrder: $sortOrder
    isActive: $isActive
  ) {
    ...CutsheetCapabilityGroupFragment
  }
}
    ${CutsheetCapabilityGroupFragmentFragmentDoc}`;
export type CutsheetCapabilityGroupUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityGroupUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityGroupUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityGroupUpsertMutation, { data, loading, error }] = useCutsheetCapabilityGroupUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      sortOrder: // value for 'sortOrder'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>(CutsheetCapabilityGroupUpsertDocument, options);
      }
export type CutsheetCapabilityGroupUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityGroupUpsertMutation>;
export type CutsheetCapabilityGroupUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityGroupUpsertMutation>;
export type CutsheetCapabilityGroupUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityGroupUpsertMutation, CutsheetCapabilityGroupUpsertMutationVariables>;
export const CutsheetMarkConvertedDocument = gql`
    mutation CutsheetMarkConverted($cutsheetId: MongoID!, $responseId: MongoID!) {
  cutsheetMarkConverted(cutsheetId: $cutsheetId, responseId: $responseId) {
    _id
    convertedToQuestionnaireResponse
  }
}
    `;
export type CutsheetMarkConvertedMutationFn = Apollo.MutationFunction<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>;

/**
 * __useCutsheetMarkConvertedMutation__
 *
 * To run a mutation, you first call `useCutsheetMarkConvertedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetMarkConvertedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetMarkConvertedMutation, { data, loading, error }] = useCutsheetMarkConvertedMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useCutsheetMarkConvertedMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>(CutsheetMarkConvertedDocument, options);
      }
export type CutsheetMarkConvertedMutationHookResult = ReturnType<typeof useCutsheetMarkConvertedMutation>;
export type CutsheetMarkConvertedMutationResult = Apollo.MutationResult<CutsheetMarkConvertedMutation>;
export type CutsheetMarkConvertedMutationOptions = Apollo.BaseMutationOptions<CutsheetMarkConvertedMutation, CutsheetMarkConvertedMutationVariables>;
export const CutsheetCapabilityOptionReorderDocument = gql`
    mutation CutsheetCapabilityOptionReorder($ids: [MongoID!]!) {
  cutsheetOptionReorder(ids: $ids)
}
    `;
export type CutsheetCapabilityOptionReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>;

/**
 * __useCutsheetCapabilityOptionReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityOptionReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityOptionReorderMutation, { data, loading, error }] = useCutsheetCapabilityOptionReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>(CutsheetCapabilityOptionReorderDocument, options);
      }
export type CutsheetCapabilityOptionReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilityOptionReorderMutation>;
export type CutsheetCapabilityOptionReorderMutationResult = Apollo.MutationResult<CutsheetCapabilityOptionReorderMutation>;
export type CutsheetCapabilityOptionReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityOptionReorderMutation, CutsheetCapabilityOptionReorderMutationVariables>;
export const CutsheetQuestionnaireDeleteDocument = gql`
    mutation CutsheetQuestionnaireDelete($id: MongoID!) {
  cutsheetQuestionnaireDelete(id: $id)
}
    `;
export type CutsheetQuestionnaireDeleteMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>;

/**
 * __useCutsheetQuestionnaireDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireDeleteMutation, { data, loading, error }] = useCutsheetQuestionnaireDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>(CutsheetQuestionnaireDeleteDocument, options);
      }
export type CutsheetQuestionnaireDeleteMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireDeleteMutation>;
export type CutsheetQuestionnaireDeleteMutationResult = Apollo.MutationResult<CutsheetQuestionnaireDeleteMutation>;
export type CutsheetQuestionnaireDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireDeleteMutation, CutsheetQuestionnaireDeleteMutationVariables>;
export const CutsheetQuestionnaireResponseSoftDeleteDocument = gql`
    mutation CutsheetQuestionnaireResponseSoftDelete($id: MongoID!) {
  cutsheetQuestionnaireResponseSoftDelete(id: $id)
}
    `;
export type CutsheetQuestionnaireResponseSoftDeleteMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseSoftDeleteMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseSoftDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>(CutsheetQuestionnaireResponseSoftDeleteDocument, options);
      }
export type CutsheetQuestionnaireResponseSoftDeleteMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSoftDeleteMutation>;
export type CutsheetQuestionnaireResponseSoftDeleteMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseSoftDeleteMutation>;
export type CutsheetQuestionnaireResponseSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseSoftDeleteMutation, CutsheetQuestionnaireResponseSoftDeleteMutationVariables>;
export const CutsheetQuestionnaireResponseUpsertDocument = gql`
    mutation CutsheetQuestionnaireResponseUpsert($id: MongoID, $questionnaireId: MongoID!, $name: String!, $pricePerPound: Float, $type: String, $userId: MongoID, $selectedCuts: [CutsheetResponseCutOptionInput], $trimSelections: CutsheetResponseTrimResponseInput, $specifications: [CutsheetResponseSpecificationSelectionInput], $notes: String) {
  cutsheetQuestionnaireResponseUpsert(
    id: $id
    questionnaireId: $questionnaireId
    name: $name
    pricePerPound: $pricePerPound
    type: $type
    userId: $userId
    selectedCuts: $selectedCuts
    trimSelections: $trimSelections
    specifications: $specifications
    notes: $notes
  ) {
    _id
    name
    questionnaire
    capabilitySet
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
  }
}
    `;
export type CutsheetQuestionnaireResponseUpsertMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>;

/**
 * __useCutsheetQuestionnaireResponseUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireResponseUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireResponseUpsertMutation, { data, loading, error }] = useCutsheetQuestionnaireResponseUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionnaireId: // value for 'questionnaireId'
 *      name: // value for 'name'
 *      pricePerPound: // value for 'pricePerPound'
 *      type: // value for 'type'
 *      userId: // value for 'userId'
 *      selectedCuts: // value for 'selectedCuts'
 *      trimSelections: // value for 'trimSelections'
 *      specifications: // value for 'specifications'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>(CutsheetQuestionnaireResponseUpsertDocument, options);
      }
export type CutsheetQuestionnaireResponseUpsertMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseUpsertMutation>;
export type CutsheetQuestionnaireResponseUpsertMutationResult = Apollo.MutationResult<CutsheetQuestionnaireResponseUpsertMutation>;
export type CutsheetQuestionnaireResponseUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireResponseUpsertMutation, CutsheetQuestionnaireResponseUpsertMutationVariables>;
export const CutsheetQuestionnaireUpsertDocument = gql`
    mutation CutsheetQuestionnaireUpsert($id: MongoID, $capabilityId: MongoID!, $name: String!, $description: String, $questions: [CutsheetQuestionInput!], $pricingOverrides: [CutsheetPricingOverrideEntryInput], $specOptionPricingOverrides: [CutsheetSpecOptionPricingEntryInput], $defaultSelections: CutsheetQuestionnaireDefaultSelectionsInput, $useCustomPrintSettings: Boolean, $printSettings: CutsheetQuestionnairePrintSettingsInput, $status: String) {
  cutsheetQuestionnaireUpsert(
    id: $id
    capabilityId: $capabilityId
    name: $name
    description: $description
    questions: $questions
    pricingOverrides: $pricingOverrides
    specOptionPricingOverrides: $specOptionPricingOverrides
    defaultSelections: $defaultSelections
    useCustomPrintSettings: $useCustomPrintSettings
    printSettings: $printSettings
    status: $status
  ) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;
export type CutsheetQuestionnaireUpsertMutationFn = Apollo.MutationFunction<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>;

/**
 * __useCutsheetQuestionnaireUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetQuestionnaireUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetQuestionnaireUpsertMutation, { data, loading, error }] = useCutsheetQuestionnaireUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      capabilityId: // value for 'capabilityId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      questions: // value for 'questions'
 *      pricingOverrides: // value for 'pricingOverrides'
 *      specOptionPricingOverrides: // value for 'specOptionPricingOverrides'
 *      defaultSelections: // value for 'defaultSelections'
 *      useCustomPrintSettings: // value for 'useCustomPrintSettings'
 *      printSettings: // value for 'printSettings'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCutsheetQuestionnaireUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>(CutsheetQuestionnaireUpsertDocument, options);
      }
export type CutsheetQuestionnaireUpsertMutationHookResult = ReturnType<typeof useCutsheetQuestionnaireUpsertMutation>;
export type CutsheetQuestionnaireUpsertMutationResult = Apollo.MutationResult<CutsheetQuestionnaireUpsertMutation>;
export type CutsheetQuestionnaireUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetQuestionnaireUpsertMutation, CutsheetQuestionnaireUpsertMutationVariables>;
export const CutsheetSoftDeleteDocument = gql`
    mutation cutsheetSoftDelete($cutsheetId: MongoID!) {
  cutsheetSoftDelete(cutsheetId: $cutsheetId) {
    _id
  }
}
    `;
export type CutsheetSoftDeleteMutationFn = Apollo.MutationFunction<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;

/**
 * __useCutsheetSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetSoftDeleteMutation, { data, loading, error }] = useCutsheetSoftDeleteMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *   },
 * });
 */
export function useCutsheetSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>(CutsheetSoftDeleteDocument, options);
      }
export type CutsheetSoftDeleteMutationHookResult = ReturnType<typeof useCutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationResult = Apollo.MutationResult<CutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;
export const CutsheetCapabilitySpecificationDeleteDocument = gql`
    mutation CutsheetCapabilitySpecificationDelete($id: MongoID!) {
  cutsheetSpecificationDelete(id: $id)
}
    `;
export type CutsheetCapabilitySpecificationDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationDeleteMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>(CutsheetCapabilitySpecificationDeleteDocument, options);
      }
export type CutsheetCapabilitySpecificationDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationDeleteMutation>;
export type CutsheetCapabilitySpecificationDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationDeleteMutation>;
export type CutsheetCapabilitySpecificationDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationDeleteMutation, CutsheetCapabilitySpecificationDeleteMutationVariables>;
export const CutsheetCapabilitySpecificationReorderDocument = gql`
    mutation CutsheetCapabilitySpecificationReorder($ids: [MongoID!]!) {
  cutsheetSpecificationReorder(ids: $ids)
}
    `;
export type CutsheetCapabilitySpecificationReorderMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationReorderMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationReorderMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationReorderMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationReorderMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>(CutsheetCapabilitySpecificationReorderDocument, options);
      }
export type CutsheetCapabilitySpecificationReorderMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationReorderMutation>;
export type CutsheetCapabilitySpecificationReorderMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationReorderMutation>;
export type CutsheetCapabilitySpecificationReorderMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationReorderMutation, CutsheetCapabilitySpecificationReorderMutationVariables>;
export const CutsheetCapabilitySpecificationUpsertDocument = gql`
    mutation CutsheetCapabilitySpecificationUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $inputType: String!, $options: JSON, $unit: String, $defaultValue: String, $required: Boolean, $assignedToIds: [MongoID!], $pricingAdjustments: JSON, $isActive: Boolean, $printedText: String) {
  cutsheetSpecificationUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    inputType: $inputType
    options: $options
    unit: $unit
    defaultValue: $defaultValue
    required: $required
    assignedToIds: $assignedToIds
    pricingAdjustments: $pricingAdjustments
    isActive: $isActive
    printedText: $printedText
  ) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;
export type CutsheetCapabilitySpecificationUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>;

/**
 * __useCutsheetCapabilitySpecificationUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilitySpecificationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilitySpecificationUpsertMutation, { data, loading, error }] = useCutsheetCapabilitySpecificationUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      inputType: // value for 'inputType'
 *      options: // value for 'options'
 *      unit: // value for 'unit'
 *      defaultValue: // value for 'defaultValue'
 *      required: // value for 'required'
 *      assignedToIds: // value for 'assignedToIds'
 *      pricingAdjustments: // value for 'pricingAdjustments'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>(CutsheetCapabilitySpecificationUpsertDocument, options);
      }
export type CutsheetCapabilitySpecificationUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationUpsertMutation>;
export type CutsheetCapabilitySpecificationUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilitySpecificationUpsertMutation>;
export type CutsheetCapabilitySpecificationUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilitySpecificationUpsertMutation, CutsheetCapabilitySpecificationUpsertMutationVariables>;
export const CutsheetCapabilityTrimDeleteDocument = gql`
    mutation CutsheetCapabilityTrimDelete($id: MongoID!) {
  cutsheetTrimDelete(id: $id)
}
    `;
export type CutsheetCapabilityTrimDeleteMutationFn = Apollo.MutationFunction<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>;

/**
 * __useCutsheetCapabilityTrimDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityTrimDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityTrimDeleteMutation, { data, loading, error }] = useCutsheetCapabilityTrimDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>(CutsheetCapabilityTrimDeleteDocument, options);
      }
export type CutsheetCapabilityTrimDeleteMutationHookResult = ReturnType<typeof useCutsheetCapabilityTrimDeleteMutation>;
export type CutsheetCapabilityTrimDeleteMutationResult = Apollo.MutationResult<CutsheetCapabilityTrimDeleteMutation>;
export type CutsheetCapabilityTrimDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityTrimDeleteMutation, CutsheetCapabilityTrimDeleteMutationVariables>;
export const CutsheetCapabilityTrimUpsertDocument = gql`
    mutation CutsheetCapabilityTrimUpsert($id: MongoID, $vendorId: MongoID!, $capabilityId: MongoID!, $title: String!, $description: String, $imageUrl: String, $isDefault: Boolean, $minQty: Float, $specifications: [CutsheetTrimSpecificationInput!], $pricing: CutsheetTrimPricingInput, $isActive: Boolean, $printedText: String) {
  cutsheetTrimUpsert(
    id: $id
    vendorId: $vendorId
    capabilityId: $capabilityId
    title: $title
    description: $description
    imageUrl: $imageUrl
    isDefault: $isDefault
    minQty: $minQty
    specifications: $specifications
    pricing: $pricing
    isActive: $isActive
    printedText: $printedText
  ) {
    ...CutsheetCapabilityTrimFragmentV2
  }
}
    ${CutsheetCapabilityTrimFragmentV2FragmentDoc}`;
export type CutsheetCapabilityTrimUpsertMutationFn = Apollo.MutationFunction<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>;

/**
 * __useCutsheetCapabilityTrimUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetCapabilityTrimUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCapabilityTrimUpsertMutation, { data, loading, error }] = useCutsheetCapabilityTrimUpsertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vendorId: // value for 'vendorId'
 *      capabilityId: // value for 'capabilityId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      isDefault: // value for 'isDefault'
 *      minQty: // value for 'minQty'
 *      specifications: // value for 'specifications'
 *      pricing: // value for 'pricing'
 *      isActive: // value for 'isActive'
 *      printedText: // value for 'printedText'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>(CutsheetCapabilityTrimUpsertDocument, options);
      }
export type CutsheetCapabilityTrimUpsertMutationHookResult = ReturnType<typeof useCutsheetCapabilityTrimUpsertMutation>;
export type CutsheetCapabilityTrimUpsertMutationResult = Apollo.MutationResult<CutsheetCapabilityTrimUpsertMutation>;
export type CutsheetCapabilityTrimUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetCapabilityTrimUpsertMutation, CutsheetCapabilityTrimUpsertMutationVariables>;
export const CutsheetUpsertDocument = gql`
    mutation CutsheetUpsert($parentCutsheet: MongoID, $cutsheetId: MongoID, $type: EnumCutsheetType, $animalSpecies: EnumCutsheetAnimalSpecies, $inspectionLevels: [EnumCutsheetInspectionLevels], $primalCuts: [MongoID!], $splitTypes: [String!], $name: String!, $pricePerPound: Float, $activeSpecification: MongoID, $selectedSpecifications: JSON, $extras: [CutsheetExtrasTypeInput!], $trim: [CutsheetTrimTypeInput!], $userId: MongoID) {
  cutsheetUpsert(
    parentCutsheet: $parentCutsheet
    cutsheetId: $cutsheetId
    type: $type
    animalSpecies: $animalSpecies
    inspectionLevels: $inspectionLevels
    primalCuts: $primalCuts
    splitTypes: $splitTypes
    name: $name
    pricePerPound: $pricePerPound
    activeSpecification: $activeSpecification
    selectedSpecifications: $selectedSpecifications
    extras: $extras
    trim: $trim
    userId: $userId
  ) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetUpsertMutationFn = Apollo.MutationFunction<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;

/**
 * __useCutsheetUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetUpsertMutation, { data, loading, error }] = useCutsheetUpsertMutation({
 *   variables: {
 *      parentCutsheet: // value for 'parentCutsheet'
 *      cutsheetId: // value for 'cutsheetId'
 *      type: // value for 'type'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevels: // value for 'inspectionLevels'
 *      primalCuts: // value for 'primalCuts'
 *      splitTypes: // value for 'splitTypes'
 *      name: // value for 'name'
 *      pricePerPound: // value for 'pricePerPound'
 *      activeSpecification: // value for 'activeSpecification'
 *      selectedSpecifications: // value for 'selectedSpecifications'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCutsheetUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>(CutsheetUpsertDocument, options);
      }
export type CutsheetUpsertMutationHookResult = ReturnType<typeof useCutsheetUpsertMutation>;
export type CutsheetUpsertMutationResult = Apollo.MutationResult<CutsheetUpsertMutation>;
export type CutsheetUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;
export const GenerateUploadUrlDocument = gql`
    mutation GenerateUploadUrl($key: String!, $contentType: String, $expiresIn: Int) {
  generateUploadUrl(key: $key, contentType: $contentType, expiresIn: $expiresIn) {
    uploadUrl
    cdnUrl
  }
}
    `;
export type GenerateUploadUrlMutationFn = Apollo.MutationFunction<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;

/**
 * __useGenerateUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlMutation, { data, loading, error }] = useGenerateUploadUrlMutation({
 *   variables: {
 *      key: // value for 'key'
 *      contentType: // value for 'contentType'
 *      expiresIn: // value for 'expiresIn'
 *   },
 * });
 */
export function useGenerateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>(GenerateUploadUrlDocument, options);
      }
export type GenerateUploadUrlMutationHookResult = ReturnType<typeof useGenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationResult = Apollo.MutationResult<GenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;
export const IntegrationInitDocument = gql`
    mutation IntegrationInit($integrationName: EnumIntegrationName!, $shop: String) {
  integrationInit(integrationName: $integrationName, shop: $shop) {
    name
    type
    endpoint
    key
    _id
  }
}
    `;
export type IntegrationInitMutationFn = Apollo.MutationFunction<IntegrationInitMutation, IntegrationInitMutationVariables>;

/**
 * __useIntegrationInitMutation__
 *
 * To run a mutation, you first call `useIntegrationInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationInitMutation, { data, loading, error }] = useIntegrationInitMutation({
 *   variables: {
 *      integrationName: // value for 'integrationName'
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useIntegrationInitMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationInitMutation, IntegrationInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationInitMutation, IntegrationInitMutationVariables>(IntegrationInitDocument, options);
      }
export type IntegrationInitMutationHookResult = ReturnType<typeof useIntegrationInitMutation>;
export type IntegrationInitMutationResult = Apollo.MutationResult<IntegrationInitMutation>;
export type IntegrationInitMutationOptions = Apollo.BaseMutationOptions<IntegrationInitMutation, IntegrationInitMutationVariables>;
export const InvoiceCreateForSchedulingJobDocument = gql`
    mutation InvoiceCreateForSchedulingJob($input: CreateInvoiceForSchedulingJobInput!) {
  invoiceCreateForSchedulingJob(input: $input) {
    _id
    number
    status
    amount_due
    amount_discounted
    due_date
    type
    user {
      _id
      first_name
      last_name
      email
    }
  }
}
    `;
export type InvoiceCreateForSchedulingJobMutationFn = Apollo.MutationFunction<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>;

/**
 * __useInvoiceCreateForSchedulingJobMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateForSchedulingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateForSchedulingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateForSchedulingJobMutation, { data, loading, error }] = useInvoiceCreateForSchedulingJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceCreateForSchedulingJobMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>(InvoiceCreateForSchedulingJobDocument, options);
      }
export type InvoiceCreateForSchedulingJobMutationHookResult = ReturnType<typeof useInvoiceCreateForSchedulingJobMutation>;
export type InvoiceCreateForSchedulingJobMutationResult = Apollo.MutationResult<InvoiceCreateForSchedulingJobMutation>;
export type InvoiceCreateForSchedulingJobMutationOptions = Apollo.BaseMutationOptions<InvoiceCreateForSchedulingJobMutation, InvoiceCreateForSchedulingJobMutationVariables>;
export const InvoiceFinalizeAndSendDocument = gql`
    mutation InvoiceFinalizeAndSend($input: VoidInvoiceInput) {
  invoiceFinalizeAndSend(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceFinalizeAndSendMutationFn = Apollo.MutationFunction<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;

/**
 * __useInvoiceFinalizeAndSendMutation__
 *
 * To run a mutation, you first call `useInvoiceFinalizeAndSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFinalizeAndSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceFinalizeAndSendMutation, { data, loading, error }] = useInvoiceFinalizeAndSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceFinalizeAndSendMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>(InvoiceFinalizeAndSendDocument, options);
      }
export type InvoiceFinalizeAndSendMutationHookResult = ReturnType<typeof useInvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationResult = Apollo.MutationResult<InvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationOptions = Apollo.BaseMutationOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;
export const GenerateInvoicePdfDocument = gql`
    mutation generateInvoicePdf($invoiceId: MongoID!) {
  generateInvoicePdf(invoiceId: $invoiceId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type GenerateInvoicePdfMutationFn = Apollo.MutationFunction<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;

/**
 * __useGenerateInvoicePdfMutation__
 *
 * To run a mutation, you first call `useGenerateInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoicePdfMutation, { data, loading, error }] = useGenerateInvoicePdfMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>(GenerateInvoicePdfDocument, options);
      }
export type GenerateInvoicePdfMutationHookResult = ReturnType<typeof useGenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationResult = Apollo.MutationResult<GenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationOptions = Apollo.BaseMutationOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;
export const InvoiceMarkAsPaidDocument = gql`
    mutation InvoiceMarkAsPaid($input: MarkAsPaidInput) {
  invoiceMarkAsPaid(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceMarkAsPaidMutationFn = Apollo.MutationFunction<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;

/**
 * __useInvoiceMarkAsPaidMutation__
 *
 * To run a mutation, you first call `useInvoiceMarkAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceMarkAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceMarkAsPaidMutation, { data, loading, error }] = useInvoiceMarkAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceMarkAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>(InvoiceMarkAsPaidDocument, options);
      }
export type InvoiceMarkAsPaidMutationHookResult = ReturnType<typeof useInvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationResult = Apollo.MutationResult<InvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationOptions = Apollo.BaseMutationOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;
export const InvoiceRefundDocument = gql`
    mutation InvoiceRefund($input: RefundInvoiceInput) {
  invoiceRefund(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceRefundMutationFn = Apollo.MutationFunction<InvoiceRefundMutation, InvoiceRefundMutationVariables>;

/**
 * __useInvoiceRefundMutation__
 *
 * To run a mutation, you first call `useInvoiceRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRefundMutation, { data, loading, error }] = useInvoiceRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceRefundMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceRefundMutation, InvoiceRefundMutationVariables>(InvoiceRefundDocument, options);
      }
export type InvoiceRefundMutationHookResult = ReturnType<typeof useInvoiceRefundMutation>;
export type InvoiceRefundMutationResult = Apollo.MutationResult<InvoiceRefundMutation>;
export type InvoiceRefundMutationOptions = Apollo.BaseMutationOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>;
export const InvoiceUpdateDocument = gql`
    mutation InvoiceUpdate($input: UpdateInvoiceInput) {
  invoiceUpdate(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceUpdateMutationFn = Apollo.MutationFunction<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;

/**
 * __useInvoiceUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceUpdateMutation, { data, loading, error }] = useInvoiceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>(InvoiceUpdateDocument, options);
      }
export type InvoiceUpdateMutationHookResult = ReturnType<typeof useInvoiceUpdateMutation>;
export type InvoiceUpdateMutationResult = Apollo.MutationResult<InvoiceUpdateMutation>;
export type InvoiceUpdateMutationOptions = Apollo.BaseMutationOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;
export const InvoiceVoidDocument = gql`
    mutation InvoiceVoid($input: VoidInvoiceInput) {
  invoiceVoid(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceVoidMutationFn = Apollo.MutationFunction<InvoiceVoidMutation, InvoiceVoidMutationVariables>;

/**
 * __useInvoiceVoidMutation__
 *
 * To run a mutation, you first call `useInvoiceVoidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceVoidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceVoidMutation, { data, loading, error }] = useInvoiceVoidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceVoidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceVoidMutation, InvoiceVoidMutationVariables>(InvoiceVoidDocument, options);
      }
export type InvoiceVoidMutationHookResult = ReturnType<typeof useInvoiceVoidMutation>;
export type InvoiceVoidMutationResult = Apollo.MutationResult<InvoiceVoidMutation>;
export type InvoiceVoidMutationOptions = Apollo.BaseMutationOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>;
export const NoteDeleteDocument = gql`
    mutation NoteDelete($noteId: MongoID!) {
  noteDelete(noteId: $noteId) {
    _id
  }
}
    `;
export type NoteDeleteMutationFn = Apollo.MutationFunction<NoteDeleteMutation, NoteDeleteMutationVariables>;

/**
 * __useNoteDeleteMutation__
 *
 * To run a mutation, you first call `useNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteDeleteMutation, { data, loading, error }] = useNoteDeleteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useNoteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<NoteDeleteMutation, NoteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteDeleteMutation, NoteDeleteMutationVariables>(NoteDeleteDocument, options);
      }
export type NoteDeleteMutationHookResult = ReturnType<typeof useNoteDeleteMutation>;
export type NoteDeleteMutationResult = Apollo.MutationResult<NoteDeleteMutation>;
export type NoteDeleteMutationOptions = Apollo.BaseMutationOptions<NoteDeleteMutation, NoteDeleteMutationVariables>;
export const NoteUpsertDocument = gql`
    mutation NoteUpsert($noteId: MongoID, $note: String!, $processorScheduling: MongoID, $type: EnumNoteType, $attachments: [Upload], $removeAttachmentUrls: [String], $user: MongoID) {
  noteUpsert(
    noteId: $noteId
    note: $note
    processorScheduling: $processorScheduling
    type: $type
    attachments: $attachments
    removeAttachmentUrls: $removeAttachmentUrls
    user: $user
  ) {
    _id
  }
}
    `;
export type NoteUpsertMutationFn = Apollo.MutationFunction<NoteUpsertMutation, NoteUpsertMutationVariables>;

/**
 * __useNoteUpsertMutation__
 *
 * To run a mutation, you first call `useNoteUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpsertMutation, { data, loading, error }] = useNoteUpsertMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      note: // value for 'note'
 *      processorScheduling: // value for 'processorScheduling'
 *      type: // value for 'type'
 *      attachments: // value for 'attachments'
 *      removeAttachmentUrls: // value for 'removeAttachmentUrls'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useNoteUpsertMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpsertMutation, NoteUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpsertMutation, NoteUpsertMutationVariables>(NoteUpsertDocument, options);
      }
export type NoteUpsertMutationHookResult = ReturnType<typeof useNoteUpsertMutation>;
export type NoteUpsertMutationResult = Apollo.MutationResult<NoteUpsertMutation>;
export type NoteUpsertMutationOptions = Apollo.BaseMutationOptions<NoteUpsertMutation, NoteUpsertMutationVariables>;
export const NotificationSettingsUpdateDocument = gql`
    mutation NotificationSettingsUpdate($notificationSettingId: MongoID!, $settings: NotificationSettingsInput!) {
  notificationSettingsUpdate(
    notificationSettingId: $notificationSettingId
    settings: $settings
  ) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;
export type NotificationSettingsUpdateMutationFn = Apollo.MutationFunction<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;

/**
 * __useNotificationSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSettingsUpdateMutation, { data, loading, error }] = useNotificationSettingsUpdateMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useNotificationSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>(NotificationSettingsUpdateDocument, options);
      }
export type NotificationSettingsUpdateMutationHookResult = ReturnType<typeof useNotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationResult = Apollo.MutationResult<NotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;
export const ParseCutsheetDocument = gql`
    mutation ParseCutsheet($file: Upload!, $capabilityId: MongoID!) {
  parseCutsheet(file: $file, capabilityId: $capabilityId) {
    catalog {
      name
      description
      animalType
      primals {
        title
        description
      }
      cuts {
        title
        description
        primalName
        pricePerPound
        priceFee
        priceFeePerPound
        minLbs
      }
      specifications {
        title
        description
        cutName
        options
      }
      trim {
        title
        description
        pricePerPound
        priceFee
        minLbs
      }
      extras {
        title
        description
        pricePerPound
        priceFee
        minLbs
      }
    }
    questionnaire {
      name
      description
      animalType
      questions {
        id
        type
        title
        description
        required
        sortOrder
        details
        imageUrl
        availableCutIds
        allowMultiple
        specificationId
        availableTrimIds
        requireExactTotal
      }
    }
  }
}
    `;
export type ParseCutsheetMutationFn = Apollo.MutationFunction<ParseCutsheetMutation, ParseCutsheetMutationVariables>;

/**
 * __useParseCutsheetMutation__
 *
 * To run a mutation, you first call `useParseCutsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseCutsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseCutsheetMutation, { data, loading, error }] = useParseCutsheetMutation({
 *   variables: {
 *      file: // value for 'file'
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useParseCutsheetMutation(baseOptions?: Apollo.MutationHookOptions<ParseCutsheetMutation, ParseCutsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseCutsheetMutation, ParseCutsheetMutationVariables>(ParseCutsheetDocument, options);
      }
export type ParseCutsheetMutationHookResult = ReturnType<typeof useParseCutsheetMutation>;
export type ParseCutsheetMutationResult = Apollo.MutationResult<ParseCutsheetMutation>;
export type ParseCutsheetMutationOptions = Apollo.BaseMutationOptions<ParseCutsheetMutation, ParseCutsheetMutationVariables>;
export const SearchAvailablePhoneNumbersDocument = gql`
    query SearchAvailablePhoneNumbers($input: SearchAvailablePhoneNumbersInput!) {
  searchAvailablePhoneNumbers(input: $input) {
    phoneNumber
    friendlyName
    locality
    region
    capabilities {
      voice
      sms
      mms
    }
  }
}
    `;

/**
 * __useSearchAvailablePhoneNumbersQuery__
 *
 * To run a query within a React component, call `useSearchAvailablePhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailablePhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailablePhoneNumbersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAvailablePhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>(SearchAvailablePhoneNumbersDocument, options);
      }
export function useSearchAvailablePhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>(SearchAvailablePhoneNumbersDocument, options);
        }
export type SearchAvailablePhoneNumbersQueryHookResult = ReturnType<typeof useSearchAvailablePhoneNumbersQuery>;
export type SearchAvailablePhoneNumbersLazyQueryHookResult = ReturnType<typeof useSearchAvailablePhoneNumbersLazyQuery>;
export type SearchAvailablePhoneNumbersQueryResult = Apollo.QueryResult<SearchAvailablePhoneNumbersQuery, SearchAvailablePhoneNumbersQueryVariables>;
export const ProvisionPhoneNumberDocument = gql`
    mutation ProvisionPhoneNumber($input: ProvisionPhoneNumberInput!) {
  provisionPhoneNumber(input: $input) {
    success
    error
    phoneNumber
    phoneNumberSid
  }
}
    `;
export type ProvisionPhoneNumberMutationFn = Apollo.MutationFunction<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>;

/**
 * __useProvisionPhoneNumberMutation__
 *
 * To run a mutation, you first call `useProvisionPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionPhoneNumberMutation, { data, loading, error }] = useProvisionPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>(ProvisionPhoneNumberDocument, options);
      }
export type ProvisionPhoneNumberMutationHookResult = ReturnType<typeof useProvisionPhoneNumberMutation>;
export type ProvisionPhoneNumberMutationResult = Apollo.MutationResult<ProvisionPhoneNumberMutation>;
export type ProvisionPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ProvisionPhoneNumberMutation, ProvisionPhoneNumberMutationVariables>;
export const ReleasePhoneNumberDocument = gql`
    mutation ReleasePhoneNumber($input: ReleasePhoneNumberInput!) {
  releasePhoneNumber(input: $input) {
    success
    error
  }
}
    `;
export type ReleasePhoneNumberMutationFn = Apollo.MutationFunction<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;

/**
 * __useReleasePhoneNumberMutation__
 *
 * To run a mutation, you first call `useReleasePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePhoneNumberMutation, { data, loading, error }] = useReleasePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleasePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>(ReleasePhoneNumberDocument, options);
      }
export type ReleasePhoneNumberMutationHookResult = ReturnType<typeof useReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationResult = Apollo.MutationResult<ReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;
export const SubmitHostedLandlineOrderDocument = gql`
    mutation SubmitHostedLandlineOrder($input: SubmitHostedLandlineOrderInput!) {
  submitHostedLandlineOrder(input: $input) {
    success
    error
    hostedNumberOrderSid
    status
  }
}
    `;
export type SubmitHostedLandlineOrderMutationFn = Apollo.MutationFunction<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>;

/**
 * __useSubmitHostedLandlineOrderMutation__
 *
 * To run a mutation, you first call `useSubmitHostedLandlineOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitHostedLandlineOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitHostedLandlineOrderMutation, { data, loading, error }] = useSubmitHostedLandlineOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitHostedLandlineOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>(SubmitHostedLandlineOrderDocument, options);
      }
export type SubmitHostedLandlineOrderMutationHookResult = ReturnType<typeof useSubmitHostedLandlineOrderMutation>;
export type SubmitHostedLandlineOrderMutationResult = Apollo.MutationResult<SubmitHostedLandlineOrderMutation>;
export type SubmitHostedLandlineOrderMutationOptions = Apollo.BaseMutationOptions<SubmitHostedLandlineOrderMutation, SubmitHostedLandlineOrderMutationVariables>;
export const RefreshHostedNumberStatusDocument = gql`
    mutation RefreshHostedNumberStatus($input: RefreshHostedNumberStatusInput!) {
  refreshHostedNumberStatus(input: $input) {
    success
    error
    status
    phoneNumberSid
    isProvisioned
  }
}
    `;
export type RefreshHostedNumberStatusMutationFn = Apollo.MutationFunction<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>;

/**
 * __useRefreshHostedNumberStatusMutation__
 *
 * To run a mutation, you first call `useRefreshHostedNumberStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshHostedNumberStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshHostedNumberStatusMutation, { data, loading, error }] = useRefreshHostedNumberStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshHostedNumberStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>(RefreshHostedNumberStatusDocument, options);
      }
export type RefreshHostedNumberStatusMutationHookResult = ReturnType<typeof useRefreshHostedNumberStatusMutation>;
export type RefreshHostedNumberStatusMutationResult = Apollo.MutationResult<RefreshHostedNumberStatusMutation>;
export type RefreshHostedNumberStatusMutationOptions = Apollo.BaseMutationOptions<RefreshHostedNumberStatusMutation, RefreshHostedNumberStatusMutationVariables>;
export const UpdatePhoneNumberSmsWebhookDocument = gql`
    mutation UpdatePhoneNumberSmsWebhook($input: UpdatePhoneNumberSmsWebhookInput!) {
  updatePhoneNumberSmsWebhook(input: $input) {
    success
    error
    phoneNumber
  }
}
    `;
export type UpdatePhoneNumberSmsWebhookMutationFn = Apollo.MutationFunction<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>;

/**
 * __useUpdatePhoneNumberSmsWebhookMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberSmsWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberSmsWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberSmsWebhookMutation, { data, loading, error }] = useUpdatePhoneNumberSmsWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhoneNumberSmsWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>(UpdatePhoneNumberSmsWebhookDocument, options);
      }
export type UpdatePhoneNumberSmsWebhookMutationHookResult = ReturnType<typeof useUpdatePhoneNumberSmsWebhookMutation>;
export type UpdatePhoneNumberSmsWebhookMutationResult = Apollo.MutationResult<UpdatePhoneNumberSmsWebhookMutation>;
export type UpdatePhoneNumberSmsWebhookMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberSmsWebhookMutation, UpdatePhoneNumberSmsWebhookMutationVariables>;
export const AddPhoneToMessagingServiceDocument = gql`
    mutation AddPhoneToMessagingService($input: AddPhoneToMessagingServiceInput!) {
  addPhoneToMessagingService(input: $input) {
    success
    error
  }
}
    `;
export type AddPhoneToMessagingServiceMutationFn = Apollo.MutationFunction<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>;

/**
 * __useAddPhoneToMessagingServiceMutation__
 *
 * To run a mutation, you first call `useAddPhoneToMessagingServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhoneToMessagingServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhoneToMessagingServiceMutation, { data, loading, error }] = useAddPhoneToMessagingServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPhoneToMessagingServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>(AddPhoneToMessagingServiceDocument, options);
      }
export type AddPhoneToMessagingServiceMutationHookResult = ReturnType<typeof useAddPhoneToMessagingServiceMutation>;
export type AddPhoneToMessagingServiceMutationResult = Apollo.MutationResult<AddPhoneToMessagingServiceMutation>;
export type AddPhoneToMessagingServiceMutationOptions = Apollo.BaseMutationOptions<AddPhoneToMessagingServiceMutation, AddPhoneToMessagingServiceMutationVariables>;
export const PrimalCreateOneDocument = gql`
    mutation PrimalCreateOne($record: CreateOnePrimalInput!) {
  primalCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCreateOneMutationFn = Apollo.MutationFunction<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;

/**
 * __usePrimalCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCreateOneMutation, { data, loading, error }] = usePrimalCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>(PrimalCreateOneDocument, options);
      }
export type PrimalCreateOneMutationHookResult = ReturnType<typeof usePrimalCreateOneMutation>;
export type PrimalCreateOneMutationResult = Apollo.MutationResult<PrimalCreateOneMutation>;
export type PrimalCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;
export const PrimalCutBlockerUpsertDocument = gql`
    mutation PrimalCutBlockerUpsert($animalSpecies: String!, $inspectionLevel: String!, $name: String!, $primalCutId: MongoID!, $blockedBy: [BlockedByInput!]!) {
  primalCutBlockerUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    name: $name
    primalCutId: $primalCutId
    blockedBy: $blockedBy
  ) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;
export type PrimalCutBlockerUpsertMutationFn = Apollo.MutationFunction<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;

/**
 * __usePrimalCutBlockerUpsertMutation__
 *
 * To run a mutation, you first call `usePrimalCutBlockerUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutBlockerUpsertMutation, { data, loading, error }] = usePrimalCutBlockerUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      name: // value for 'name'
 *      primalCutId: // value for 'primalCutId'
 *      blockedBy: // value for 'blockedBy'
 *   },
 * });
 */
export function usePrimalCutBlockerUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>(PrimalCutBlockerUpsertDocument, options);
      }
export type PrimalCutBlockerUpsertMutationHookResult = ReturnType<typeof usePrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationResult = Apollo.MutationResult<PrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationOptions = Apollo.BaseMutationOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;
export const PrimalCutCreateOneDocument = gql`
    mutation PrimalCutCreateOne($record: CreateOnePrimalCutInput!) {
  primalCutCreateOne(record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutCreateOneMutationFn = Apollo.MutationFunction<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;

/**
 * __usePrimalCutCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutCreateOneMutation, { data, loading, error }] = usePrimalCutCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>(PrimalCutCreateOneDocument, options);
      }
export type PrimalCutCreateOneMutationHookResult = ReturnType<typeof usePrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationResult = Apollo.MutationResult<PrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;
export const PrimalCutSoftDeleteDocument = gql`
    mutation PrimalCutSoftDelete($primalCutId: MongoID!) {
  primalCutSoftDelete(primalCutId: $primalCutId) {
    _id
    primal {
      _id
      group {
        _id
      }
    }
  }
}
    `;
export type PrimalCutSoftDeleteMutationFn = Apollo.MutationFunction<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;

/**
 * __usePrimalCutSoftDeleteMutation__
 *
 * To run a mutation, you first call `usePrimalCutSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutSoftDeleteMutation, { data, loading, error }] = usePrimalCutSoftDeleteMutation({
 *   variables: {
 *      primalCutId: // value for 'primalCutId'
 *   },
 * });
 */
export function usePrimalCutSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>(PrimalCutSoftDeleteDocument, options);
      }
export type PrimalCutSoftDeleteMutationHookResult = ReturnType<typeof usePrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationResult = Apollo.MutationResult<PrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationOptions = Apollo.BaseMutationOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;
export const PrimalCutTypeCreateOneDocument = gql`
    mutation PrimalCutTypeCreateOne($record: CreateOnePrimalCutTypeInput!) {
  primalCutTypeCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCutTypeCreateOneMutationFn = Apollo.MutationFunction<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;

/**
 * __usePrimalCutTypeCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutTypeCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutTypeCreateOneMutation, { data, loading, error }] = usePrimalCutTypeCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutTypeCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>(PrimalCutTypeCreateOneDocument, options);
      }
export type PrimalCutTypeCreateOneMutationHookResult = ReturnType<typeof usePrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationResult = Apollo.MutationResult<PrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;
export const PrimalCutUpdateByIdDocument = gql`
    mutation PrimalCutUpdateById($_id: MongoID!, $record: UpdateByIdPrimalCutInput!) {
  primalCutUpdateById(_id: $_id, record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutUpdateByIdMutationFn = Apollo.MutationFunction<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;

/**
 * __usePrimalCutUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalCutUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutUpdateByIdMutation, { data, loading, error }] = usePrimalCutUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>(PrimalCutUpdateByIdDocument, options);
      }
export type PrimalCutUpdateByIdMutationHookResult = ReturnType<typeof usePrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationResult = Apollo.MutationResult<PrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;
export const PrimalGroupSoftDeleteByIdDocument = gql`
    mutation PrimalGroupSoftDeleteById($id: MongoID!) {
  primalGroupUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalGroupSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalGroupSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalGroupSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalGroupSoftDeleteByIdMutation, { data, loading, error }] = usePrimalGroupSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalGroupSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>(PrimalGroupSoftDeleteByIdDocument, options);
      }
export type PrimalGroupSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;
export const PrimalSoftDeleteByIdDocument = gql`
    mutation PrimalSoftDeleteById($id: MongoID!) {
  primalUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalSoftDeleteByIdMutation, { data, loading, error }] = usePrimalSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>(PrimalSoftDeleteByIdDocument, options);
      }
export type PrimalSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;
export const PrimalUpdateByIdDocument = gql`
    mutation PrimalUpdateById($_id: MongoID!, $record: UpdateByIdPrimalInput!) {
  primalUpdateById(_id: $_id, record: $record) {
    recordId
  }
}
    `;
export type PrimalUpdateByIdMutationFn = Apollo.MutationFunction<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;

/**
 * __usePrimalUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalUpdateByIdMutation, { data, loading, error }] = usePrimalUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>(PrimalUpdateByIdDocument, options);
      }
export type PrimalUpdateByIdMutationHookResult = ReturnType<typeof usePrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationResult = Apollo.MutationResult<PrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;
export const ProcessingJobForceUpdateStatusDocument = gql`
    mutation ProcessingJobForceUpdateStatus($processorSchedulingId: MongoID!, $processorSchedulingStatus: String!) {
  processingJobForceUpdateStatus(
    processorSchedulingId: $processorSchedulingId
    processorSchedulingStatus: $processorSchedulingStatus
  ) {
    recordId
    record {
      _id
      status
      statusLastUpdated
    }
    previousStatus
    newStatus
  }
}
    `;
export type ProcessingJobForceUpdateStatusMutationFn = Apollo.MutationFunction<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>;

/**
 * __useProcessingJobForceUpdateStatusMutation__
 *
 * To run a mutation, you first call `useProcessingJobForceUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobForceUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processingJobForceUpdateStatusMutation, { data, loading, error }] = useProcessingJobForceUpdateStatusMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      processorSchedulingStatus: // value for 'processorSchedulingStatus'
 *   },
 * });
 */
export function useProcessingJobForceUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>(ProcessingJobForceUpdateStatusDocument, options);
      }
export type ProcessingJobForceUpdateStatusMutationHookResult = ReturnType<typeof useProcessingJobForceUpdateStatusMutation>;
export type ProcessingJobForceUpdateStatusMutationResult = Apollo.MutationResult<ProcessingJobForceUpdateStatusMutation>;
export type ProcessingJobForceUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ProcessingJobForceUpdateStatusMutation, ProcessingJobForceUpdateStatusMutationVariables>;
export const ProcessorCapabilityUpsertDocument = gql`
    mutation ProcessorCapabilityUpsert($animalSpecies: EnumProcessorCapabilityAnimalSpecies!, $inspectionLevel: EnumProcessorCapabilityInspectionLevel!, $primalCuts: [MongoID!]!, $canSelectMoreThanOneTrim: Boolean!, $trimSelection: EnumProcessorCapabilityTrimSelection!, $extras: [ProcessorCapabilityExtrasModelInput!], $trim: [ProcessorCapabilityTrimModelInput!], $specifications: [ProcessorCapabilitySpecificationSpecificationsInput!], $primalGroups: [ProcessorCapabilityPrimalGroupInput!], $newCutBlockers: JSON, $wizardWelcomeTitle: String, $wizardWelcomeContent: String, $extrasDescription: String, $trimDescription: String, $extrasImage: Upload, $extrasImageToRemove: Boolean, $trimImage: Upload, $trimImageToRemove: Boolean) {
  processorCapabilityUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    primalCuts: $primalCuts
    extras: $extras
    trim: $trim
    canSelectMoreThanOneTrim: $canSelectMoreThanOneTrim
    trimSelection: $trimSelection
    specifications: $specifications
    primalGroups: $primalGroups
    newCutBlockers: $newCutBlockers
    wizardWelcomeTitle: $wizardWelcomeTitle
    wizardWelcomeContent: $wizardWelcomeContent
    extrasDescription: $extrasDescription
    trimDescription: $trimDescription
    extrasImage: $extrasImage
    extrasImageToRemove: $extrasImageToRemove
    trimImage: $trimImage
    trimImageToRemove: $trimImageToRemove
  ) {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorCapabilityFragmentFragmentDoc}`;
export type ProcessorCapabilityUpsertMutationFn = Apollo.MutationFunction<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;

/**
 * __useProcessorCapabilityUpsertMutation__
 *
 * To run a mutation, you first call `useProcessorCapabilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorCapabilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorCapabilityUpsertMutation, { data, loading, error }] = useProcessorCapabilityUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      primalCuts: // value for 'primalCuts'
 *      canSelectMoreThanOneTrim: // value for 'canSelectMoreThanOneTrim'
 *      trimSelection: // value for 'trimSelection'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *      specifications: // value for 'specifications'
 *      primalGroups: // value for 'primalGroups'
 *      newCutBlockers: // value for 'newCutBlockers'
 *      wizardWelcomeTitle: // value for 'wizardWelcomeTitle'
 *      wizardWelcomeContent: // value for 'wizardWelcomeContent'
 *      extrasDescription: // value for 'extrasDescription'
 *      trimDescription: // value for 'trimDescription'
 *      extrasImage: // value for 'extrasImage'
 *      extrasImageToRemove: // value for 'extrasImageToRemove'
 *      trimImage: // value for 'trimImage'
 *      trimImageToRemove: // value for 'trimImageToRemove'
 *   },
 * });
 */
export function useProcessorCapabilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>(ProcessorCapabilityUpsertDocument, options);
      }
export type ProcessorCapabilityUpsertMutationHookResult = ReturnType<typeof useProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationResult = Apollo.MutationResult<ProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationOptions = Apollo.BaseMutationOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;
export const ProcessorExportCsvDocument = gql`
    mutation ProcessorExportCsv($vendorId: MongoID!, $type: ProcessorExportTypeEnum!, $startDate: String!, $endDate: String!, $animalSpecies: String, $inspectionLevel: String, $anchorDate: String) {
  processorExportCsv(
    vendorId: $vendorId
    type: $type
    startDate: $startDate
    endDate: $endDate
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    anchorDate: $anchorDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvMutationFn = Apollo.MutationFunction<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;

/**
 * __useProcessorExportCsvMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvMutation, { data, loading, error }] = useProcessorExportCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      type: // value for 'type'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      anchorDate: // value for 'anchorDate'
 *   },
 * });
 */
export function useProcessorExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>(ProcessorExportCsvDocument, options);
      }
export type ProcessorExportCsvMutationHookResult = ReturnType<typeof useProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationResult = Apollo.MutationResult<ProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;
export const ProcessorExportCsvByVendorIdDocument = gql`
    mutation ProcessorExportCsvByVendorId($vendorId: MongoID!, $startDate: String!, $endDate: String!) {
  processorExportCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;

/**
 * __useProcessorExportCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvByVendorIdMutation, { data, loading, error }] = useProcessorExportCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorExportCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>(ProcessorExportCsvByVendorIdDocument, options);
      }
export type ProcessorExportCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingAnimalHeadBulkUpdateDocument = gql`
    mutation ProcessorSchedulingAnimalHeadBulkUpdate($processorSchedulingId: MongoID!, $updatedAnimalHeads: [AnimalHeadUpdatesInput]) {
  processorSchedulingAnimalHeadBulkUpdate(
    processorSchedulingId: $processorSchedulingId
    updatedAnimalHeads: $updatedAnimalHeads
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadBulkUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadBulkUpdateMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadBulkUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      updatedAnimalHeads: // value for 'updatedAnimalHeads'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadBulkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>(ProcessorSchedulingAnimalHeadBulkUpdateDocument, options);
      }
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;
export const ProcessorSchedulingAnimalHeadDeleteDocument = gql`
    mutation ProcessorSchedulingAnimalHeadDelete($processorSchedulingId: MongoID!, $animalHeadId: MongoID!) {
  processorSchedulingAnimalHeadDelete(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingAnimalHeadDeleteMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadDeleteMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadDeleteMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadDeleteMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>(ProcessorSchedulingAnimalHeadDeleteDocument, options);
      }
export type ProcessorSchedulingAnimalHeadDeleteMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;
export const ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingAnimalHeadPartialUpdateById($processorSchedulingId: MongoID!, $animalHeadId: MongoID!, $record: ProcessorSchedulingPartialUpdateAnimalHeadInput!) {
  processorSchedulingAnimalHeadPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
    record: $record
  ) {
    recordId
    record {
      _id
      animalHeads {
        _id
        tracking
        isHangingWeightPerSide
        hangingWeight
        hangingWeightSideA
        hangingWeightSideB
        liveWeight
        killDate
      }
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>(ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingBuyerCutsheetReminderDocument = gql`
    mutation ProcessorSchedulingBuyerCutsheetReminder($schedulingId: MongoID!, $contactUserId: MongoID!) {
  processorSchedulingBuyerCutsheetReminder(
    schedulingId: $schedulingId
    contactUserId: $contactUserId
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingBuyerCutsheetReminderMutationFn = Apollo.MutationFunction<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>;

/**
 * __useProcessorSchedulingBuyerCutsheetReminderMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingBuyerCutsheetReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingBuyerCutsheetReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingBuyerCutsheetReminderMutation, { data, loading, error }] = useProcessorSchedulingBuyerCutsheetReminderMutation({
 *   variables: {
 *      schedulingId: // value for 'schedulingId'
 *      contactUserId: // value for 'contactUserId'
 *   },
 * });
 */
export function useProcessorSchedulingBuyerCutsheetReminderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>(ProcessorSchedulingBuyerCutsheetReminderDocument, options);
      }
export type ProcessorSchedulingBuyerCutsheetReminderMutationHookResult = ReturnType<typeof useProcessorSchedulingBuyerCutsheetReminderMutation>;
export type ProcessorSchedulingBuyerCutsheetReminderMutationResult = Apollo.MutationResult<ProcessorSchedulingBuyerCutsheetReminderMutation>;
export type ProcessorSchedulingBuyerCutsheetReminderMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingBuyerCutsheetReminderMutation, ProcessorSchedulingBuyerCutsheetReminderMutationVariables>;
export const ProcessorSchedulingCutsheetReminderDocument = gql`
    mutation processorSchedulingCutsheetReminder($schedulingId: MongoID!) {
  processorSchedulingCutsheetReminder(schedulingId: $schedulingId) {
    ...ProcessorSchedulingFragment
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type ProcessorSchedulingCutsheetReminderMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetReminderMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetReminderMutation, { data, loading, error }] = useProcessorSchedulingCutsheetReminderMutation({
 *   variables: {
 *      schedulingId: // value for 'schedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetReminderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>(ProcessorSchedulingCutsheetReminderDocument, options);
      }
export type ProcessorSchedulingCutsheetReminderMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;
export const ProcessorSchedulingCutsheetsPartialUpdateDocument = gql`
    mutation ProcessorSchedulingCutsheetsPartialUpdate($processorSchedulingId: MongoID!, $record: [CutsheetPartialUpdateInput]!) {
  processorSchedulingUpdateCutsheets(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
  }
}
    `;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetsPartialUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetsPartialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetsPartialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetsPartialUpdateMutation, { data, loading, error }] = useProcessorSchedulingCutsheetsPartialUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetsPartialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>(ProcessorSchedulingCutsheetsPartialUpdateDocument, options);
      }
export type ProcessorSchedulingCutsheetsPartialUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetsPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetsPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetsPartialUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetsPartialUpdateMutation, ProcessorSchedulingCutsheetsPartialUpdateMutationVariables>;
export const ProcessorSchedulingDragAndDropUpdateDocument = gql`
    mutation processorSchedulingDragAndDropUpdate($processorSchedulingId: MongoID!, $eventType: String!, $eventDate: String!, $animalHeadIds: [MongoID]) {
  processorSchedulingDragAndDropUpdate(
    processorSchedulingId: $processorSchedulingId
    eventType: $eventType
    eventDate: $eventDate
    animalHeadIds: $animalHeadIds
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingDragAndDropUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;

/**
 * __useProcessorSchedulingDragAndDropUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDragAndDropUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDragAndDropUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDragAndDropUpdateMutation, { data, loading, error }] = useProcessorSchedulingDragAndDropUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      eventType: // value for 'eventType'
 *      eventDate: // value for 'eventDate'
 *      animalHeadIds: // value for 'animalHeadIds'
 *   },
 * });
 */
export function useProcessorSchedulingDragAndDropUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>(ProcessorSchedulingDragAndDropUpdateDocument, options);
      }
export type ProcessorSchedulingDragAndDropUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;
export const ProcessorSchedulingGenerateBillingStatementDocument = gql`
    mutation ProcessorSchedulingGenerateBillingStatement($processorSchedulingId: MongoID!) {
  processorSchedulingGenerateBillingStatement(
    processorSchedulingId: $processorSchedulingId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateBillingStatementMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;

/**
 * __useProcessorSchedulingGenerateBillingStatementMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateBillingStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateBillingStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateBillingStatementMutation, { data, loading, error }] = useProcessorSchedulingGenerateBillingStatementMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateBillingStatementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>(ProcessorSchedulingGenerateBillingStatementDocument, options);
      }
export type ProcessorSchedulingGenerateBillingStatementMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;
export const ProcessorSchedulingGenerateCarcassTagsDocument = gql`
    mutation ProcessorSchedulingGenerateCarcassTags($processorSchedulingId: MongoID!, $animalHeadIds: [MongoID]) {
  processorSchedulingGenerateCarcassTags(
    processorSchedulingId: $processorSchedulingId
    animalHeadIds: $animalHeadIds
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCarcassTagsMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCarcassTagsMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCarcassTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCarcassTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCarcassTagsMutation, { data, loading, error }] = useProcessorSchedulingGenerateCarcassTagsMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadIds: // value for 'animalHeadIds'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCarcassTagsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>(ProcessorSchedulingGenerateCarcassTagsDocument, options);
      }
export type ProcessorSchedulingGenerateCarcassTagsMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;
export const ProcessorSchedulingGenerateCsvByVendorIdDocument = gql`
    mutation ProcessorSchedulingGenerateCsvByVendorId($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCsvByVendorIdMutation, { data, loading, error }] = useProcessorSchedulingGenerateCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>(ProcessorSchedulingGenerateCsvByVendorIdDocument, options);
      }
export type ProcessorSchedulingGenerateCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingGenerateCutsheetRequestDocument = gql`
    mutation ProcessorSchedulingGenerateCutsheetRequest($processorSchedulingId: MongoID!, $cutsheetRequestId: MongoID!) {
  processorSchedulingGenerateCutsheetRequest(
    processorSchedulingId: $processorSchedulingId
    cutsheetRequestId: $cutsheetRequestId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCutsheetRequestMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCutsheetRequestMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCutsheetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCutsheetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCutsheetRequestMutation, { data, loading, error }] = useProcessorSchedulingGenerateCutsheetRequestMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      cutsheetRequestId: // value for 'cutsheetRequestId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCutsheetRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>(ProcessorSchedulingGenerateCutsheetRequestDocument, options);
      }
export type ProcessorSchedulingGenerateCutsheetRequestMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;
export const ProcessorSchedulingGenerateHangingWeightCsvDocument = gql`
    mutation ProcessorSchedulingGenerateHangingWeightCsv($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateHangingWeightCsv(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;

/**
 * __useProcessorSchedulingGenerateHangingWeightCsvMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateHangingWeightCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateHangingWeightCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateHangingWeightCsvMutation, { data, loading, error }] = useProcessorSchedulingGenerateHangingWeightCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateHangingWeightCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>(ProcessorSchedulingGenerateHangingWeightCsvDocument, options);
      }
export type ProcessorSchedulingGenerateHangingWeightCsvMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;
export const ProcessorSchedulingGenerateKillSheetDocument = gql`
    mutation ProcessorSchedulingGenerateKillSheet($date: Date!, $vendorId: MongoID!) {
  processorSchedulingGenerateKillSheet(date: $date, vendorId: $vendorId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateKillSheetMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;

/**
 * __useProcessorSchedulingGenerateKillSheetMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateKillSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateKillSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateKillSheetMutation, { data, loading, error }] = useProcessorSchedulingGenerateKillSheetMutation({
 *   variables: {
 *      date: // value for 'date'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateKillSheetMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>(ProcessorSchedulingGenerateKillSheetDocument, options);
      }
export type ProcessorSchedulingGenerateKillSheetMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;
export const ProcessorSchedulingGeneratePackingSlipDocument = gql`
    mutation ProcessorSchedulingGeneratePackingSlip($processorSchedulingId: MongoID!, $cutsheetInformationId: MongoID) {
  processorSchedulingGeneratePackingSlip(
    processorSchedulingId: $processorSchedulingId
    cutsheetInformationId: $cutsheetInformationId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGeneratePackingSlipMutationFn = Apollo.MutationFunction<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>;

/**
 * __useProcessorSchedulingGeneratePackingSlipMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGeneratePackingSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGeneratePackingSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGeneratePackingSlipMutation, { data, loading, error }] = useProcessorSchedulingGeneratePackingSlipMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      cutsheetInformationId: // value for 'cutsheetInformationId'
 *   },
 * });
 */
export function useProcessorSchedulingGeneratePackingSlipMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>(ProcessorSchedulingGeneratePackingSlipDocument, options);
      }
export type ProcessorSchedulingGeneratePackingSlipMutationHookResult = ReturnType<typeof useProcessorSchedulingGeneratePackingSlipMutation>;
export type ProcessorSchedulingGeneratePackingSlipMutationResult = Apollo.MutationResult<ProcessorSchedulingGeneratePackingSlipMutation>;
export type ProcessorSchedulingGeneratePackingSlipMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGeneratePackingSlipMutation, ProcessorSchedulingGeneratePackingSlipMutationVariables>;
export const ProcessorSchedulingNotificationSendDocument = gql`
    mutation ProcessorSchedulingNotificationSend($type: NotificationTypeInput, $notificationRequest: NotificationRequestInput) {
  processorSchedulingNotificationSend(type: $type, request: $notificationRequest) {
    _id
  }
}
    `;
export type ProcessorSchedulingNotificationSendMutationFn = Apollo.MutationFunction<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;

/**
 * __useProcessorSchedulingNotificationSendMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingNotificationSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingNotificationSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingNotificationSendMutation, { data, loading, error }] = useProcessorSchedulingNotificationSendMutation({
 *   variables: {
 *      type: // value for 'type'
 *      notificationRequest: // value for 'notificationRequest'
 *   },
 * });
 */
export function useProcessorSchedulingNotificationSendMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>(ProcessorSchedulingNotificationSendDocument, options);
      }
export type ProcessorSchedulingNotificationSendMutationHookResult = ReturnType<typeof useProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationResult = Apollo.MutationResult<ProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;
export const ProcessorSchedulingPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingPartialUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingPartialUpdateInput!) {
  processorSchedulingPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>(ProcessorSchedulingPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingCutsheetInformationPartialUpdateDocument = gql`
    mutation ProcessorSchedulingCutsheetInformationPartialUpdate($processorSchedulingId: MongoID!, $record: [CutsheetPartialUpdateInput]!) {
  processorSchedulingUpdateCutsheets(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
    record {
      _id
    }
  }
}
    `;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetInformationPartialUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetInformationPartialUpdateMutation, { data, loading, error }] = useProcessorSchedulingCutsheetInformationPartialUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetInformationPartialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>(ProcessorSchedulingCutsheetInformationPartialUpdateDocument, options);
      }
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;
export const ProcessorSchedulingSplitTypeUpdateByIdDocument = gql`
    mutation ProcessorSchedulingSplitTypeUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingSplitTypeUpdateInput!) {
  processorSchedulingSplitTypeUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
  }
}
    `;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingSplitTypeUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingSplitTypeUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingSplitTypeUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingSplitTypeUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingSplitTypeUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingSplitTypeUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>(ProcessorSchedulingSplitTypeUpdateByIdDocument, options);
      }
export type ProcessorSchedulingSplitTypeUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;
export const ProcessorSchedulingUpdateByIdDocument = gql`
    mutation ProcessorSchedulingUpdateById($id: MongoID!, $record: UpdateByIdProcessorSchedulingInput!) {
  processorSchedulingUpdate(_id: $id, record: $record) {
    recordId
    record {
      status
    }
  }
}
    `;
export type ProcessorSchedulingUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>(ProcessorSchedulingUpdateByIdDocument, options);
      }
export type ProcessorSchedulingUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;
export const ProcessorSettingsCreateDocument = gql`
    mutation ProcessorSettingsCreate($newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsCreate(newProcessor: $newProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsCreateMutationFn = Apollo.MutationFunction<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;

/**
 * __useProcessorSettingsCreateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsCreateMutation, { data, loading, error }] = useProcessorSettingsCreateMutation({
 *   variables: {
 *      newProcessorSettings: // value for 'newProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>(ProcessorSettingsCreateDocument, options);
      }
export type ProcessorSettingsCreateMutationHookResult = ReturnType<typeof useProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationResult = Apollo.MutationResult<ProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;
export const ProcessorSettingsUpdateDocument = gql`
    mutation ProcessorSettingsUpdate($updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsUpdate(updateProcessor: $updateProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsUpdateMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;

/**
 * __useProcessorSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateMutation, { data, loading, error }] = useProcessorSettingsUpdateMutation({
 *   variables: {
 *      updateProcessorSettings: // value for 'updateProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>(ProcessorSettingsUpdateDocument, options);
      }
export type ProcessorSettingsUpdateMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;
export const CreateFinancialReportingConfigDocument = gql`
    mutation CreateFinancialReportingConfig($record: CreateOneFinancialReportingConfigInput!) {
  financialReportingConfigCreateOne(record: $record) {
    record {
      _id
      vendor
      createdAt
      updatedAt
    }
    error {
      message
    }
  }
}
    `;
export type CreateFinancialReportingConfigMutationFn = Apollo.MutationFunction<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>;

/**
 * __useCreateFinancialReportingConfigMutation__
 *
 * To run a mutation, you first call `useCreateFinancialReportingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinancialReportingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinancialReportingConfigMutation, { data, loading, error }] = useCreateFinancialReportingConfigMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreateFinancialReportingConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>(CreateFinancialReportingConfigDocument, options);
      }
export type CreateFinancialReportingConfigMutationHookResult = ReturnType<typeof useCreateFinancialReportingConfigMutation>;
export type CreateFinancialReportingConfigMutationResult = Apollo.MutationResult<CreateFinancialReportingConfigMutation>;
export type CreateFinancialReportingConfigMutationOptions = Apollo.BaseMutationOptions<CreateFinancialReportingConfigMutation, CreateFinancialReportingConfigMutationVariables>;
export const UpdateFinancialReportingConfigDocument = gql`
    mutation UpdateFinancialReportingConfig($filter: FilterUpdateOneFinancialReportingConfigInput!, $record: UpdateOneFinancialReportingConfigInput!) {
  financialReportingConfigUpdateOne(filter: $filter, record: $record) {
    record {
      _id
      vendor
      updatedAt
    }
    error {
      message
    }
  }
}
    `;
export type UpdateFinancialReportingConfigMutationFn = Apollo.MutationFunction<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>;

/**
 * __useUpdateFinancialReportingConfigMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialReportingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialReportingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialReportingConfigMutation, { data, loading, error }] = useUpdateFinancialReportingConfigMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUpdateFinancialReportingConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>(UpdateFinancialReportingConfigDocument, options);
      }
export type UpdateFinancialReportingConfigMutationHookResult = ReturnType<typeof useUpdateFinancialReportingConfigMutation>;
export type UpdateFinancialReportingConfigMutationResult = Apollo.MutationResult<UpdateFinancialReportingConfigMutation>;
export type UpdateFinancialReportingConfigMutationOptions = Apollo.BaseMutationOptions<UpdateFinancialReportingConfigMutation, UpdateFinancialReportingConfigMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($chatRoomId: MongoID!, $message: String!, $customerId: MongoID, $attachment: Upload) {
  sendMessage(
    chatRoomId: $chatRoomId
    message: $message
    customerId: $customerId
    attachment: $attachment
  ) {
    ...ChatMessageFragment
  }
}
    ${ChatMessageFragmentFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      message: // value for 'message'
 *      customerId: // value for 'customerId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($notificationSettingId: MongoID!, $email: String, $phone: String, $emailContent: String, $smsContent: String) {
  sendTestNotification(
    notificationSettingId: $notificationSettingId
    email: $email
    phone: $phone
    emailContent: $emailContent
    smsContent: $smsContent
  ) {
    emailSent
    smsSent
    errors
  }
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      emailContent: // value for 'emailContent'
 *      smsContent: // value for 'smsContent'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const StripeAccountCreateDocument = gql`
    mutation StripeAccountCreate($vendorId: MongoID) {
  stripeAccountCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeAccountCreateMutationFn = Apollo.MutationFunction<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;

/**
 * __useStripeAccountCreateMutation__
 *
 * To run a mutation, you first call `useStripeAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeAccountCreateMutation, { data, loading, error }] = useStripeAccountCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>(StripeAccountCreateDocument, options);
      }
export type StripeAccountCreateMutationHookResult = ReturnType<typeof useStripeAccountCreateMutation>;
export type StripeAccountCreateMutationResult = Apollo.MutationResult<StripeAccountCreateMutation>;
export type StripeAccountCreateMutationOptions = Apollo.BaseMutationOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;
export const StripeSessionCreateDocument = gql`
    mutation StripeSessionCreate($vendorId: MongoID) {
  stripeSessionCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeSessionCreateMutationFn = Apollo.MutationFunction<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;

/**
 * __useStripeSessionCreateMutation__
 *
 * To run a mutation, you first call `useStripeSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSessionCreateMutation, { data, loading, error }] = useStripeSessionCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>(StripeSessionCreateDocument, options);
      }
export type StripeSessionCreateMutationHookResult = ReturnType<typeof useStripeSessionCreateMutation>;
export type StripeSessionCreateMutationResult = Apollo.MutationResult<StripeSessionCreateMutation>;
export type StripeSessionCreateMutationOptions = Apollo.BaseMutationOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;
export const UpdateAuthMethodDocument = gql`
    mutation UpdateAuthMethod($targetAuthMethod: String!, $newPassword: String) {
  updateAuthMethod(targetAuthMethod: $targetAuthMethod, newPassword: $newPassword) {
    success
    message
    authMethod
  }
}
    `;
export type UpdateAuthMethodMutationFn = Apollo.MutationFunction<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>;

/**
 * __useUpdateAuthMethodMutation__
 *
 * To run a mutation, you first call `useUpdateAuthMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthMethodMutation, { data, loading, error }] = useUpdateAuthMethodMutation({
 *   variables: {
 *      targetAuthMethod: // value for 'targetAuthMethod'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdateAuthMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>(UpdateAuthMethodDocument, options);
      }
export type UpdateAuthMethodMutationHookResult = ReturnType<typeof useUpdateAuthMethodMutation>;
export type UpdateAuthMethodMutationResult = Apollo.MutationResult<UpdateAuthMethodMutation>;
export type UpdateAuthMethodMutationOptions = Apollo.BaseMutationOptions<UpdateAuthMethodMutation, UpdateAuthMethodMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($firstName: String, $lastName: String, $email: String, $phone: String, $company: String, $address: AddressInputForProfile, $acceptTos: Boolean, $acceptPrivacyPolicy: Boolean, $canReceiveEmailUpdates: Boolean, $canReceiveSms: Boolean) {
  updateProfile(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    address: $address
    acceptTos: $acceptTos
    acceptPrivacyPolicy: $acceptPrivacyPolicy
    canReceiveEmailUpdates: $canReceiveEmailUpdates
    canReceiveSms: $canReceiveSms
  ) {
    _id
    first_name
    last_name
    email
    phone
    company
    tos_accepted_at
    privacy_policy_accepted_at
    can_receive_email_updates
    can_receive_sms
    address {
      _id
      address_1
      address_2
      city
      state
      postcode
      country
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      address: // value for 'address'
 *      acceptTos: // value for 'acceptTos'
 *      acceptPrivacyPolicy: // value for 'acceptPrivacyPolicy'
 *      canReceiveEmailUpdates: // value for 'canReceiveEmailUpdates'
 *      canReceiveSms: // value for 'canReceiveSms'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UserBasicUpsertDocument = gql`
    mutation UserBasicUpsert($userId: MongoID, $firstName: String!, $lastName: String, $email: String, $phone: String, $company: String, $address: AddressInputForUser, $relationships: [RelationshipsInputForUser]) {
  userBasicUpsert(
    userId: $userId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    address: $address
    relationships: $relationships
  ) {
    user {
      _id
      first_name
      last_name
      email
      phone
      company
      role
      enabled
      address {
        _id
        address_1
        address_2
        city
        state
        postcode
      }
      relationships {
        vendorId
        producerId
        type
      }
    }
    message
  }
}
    `;
export type UserBasicUpsertMutationFn = Apollo.MutationFunction<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>;

/**
 * __useUserBasicUpsertMutation__
 *
 * To run a mutation, you first call `useUserBasicUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBasicUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBasicUpsertMutation, { data, loading, error }] = useUserBasicUpsertMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      address: // value for 'address'
 *      relationships: // value for 'relationships'
 *   },
 * });
 */
export function useUserBasicUpsertMutation(baseOptions?: Apollo.MutationHookOptions<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>(UserBasicUpsertDocument, options);
      }
export type UserBasicUpsertMutationHookResult = ReturnType<typeof useUserBasicUpsertMutation>;
export type UserBasicUpsertMutationResult = Apollo.MutationResult<UserBasicUpsertMutation>;
export type UserBasicUpsertMutationOptions = Apollo.BaseMutationOptions<UserBasicUpsertMutation, UserBasicUpsertMutationVariables>;
export const UserSettingsUpdateDocument = gql`
    mutation UserSettingsUpdate($userId: MongoID!, $settings: UserSettingsInput!) {
  userSettingsUpdate(userId: $userId, settings: $settings) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UserSettingsUpdateMutationFn = Apollo.MutationFunction<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;

/**
 * __useUserSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useUserSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSettingsUpdateMutation, { data, loading, error }] = useUserSettingsUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUserSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>(UserSettingsUpdateDocument, options);
      }
export type UserSettingsUpdateMutationHookResult = ReturnType<typeof useUserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationResult = Apollo.MutationResult<UserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;
export const UserUpdateActiveVendorDocument = gql`
    mutation UserUpdateActiveVendor($userId: MongoID!, $active_vendor: MongoID!) {
  userUpdateById(_id: $userId, record: {active_vendor: $active_vendor}) {
    recordId
  }
}
    `;
export type UserUpdateActiveVendorMutationFn = Apollo.MutationFunction<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;

/**
 * __useUserUpdateActiveVendorMutation__
 *
 * To run a mutation, you first call `useUserUpdateActiveVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateActiveVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateActiveVendorMutation, { data, loading, error }] = useUserUpdateActiveVendorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      active_vendor: // value for 'active_vendor'
 *   },
 * });
 */
export function useUserUpdateActiveVendorMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>(UserUpdateActiveVendorDocument, options);
      }
export type UserUpdateActiveVendorMutationHookResult = ReturnType<typeof useUserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationResult = Apollo.MutationResult<UserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationOptions = Apollo.BaseMutationOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;
export const UserUpdateRoleDocument = gql`
    mutation UserUpdateRole($userId: MongoID!, $role: EnumUserRole!) {
  userUpdateById(_id: $userId, record: {role: $role}) {
    record {
      _id
      role
      first_name
      last_name
      email
    }
  }
}
    `;
export type UserUpdateRoleMutationFn = Apollo.MutationFunction<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;

/**
 * __useUserUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUserUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateRoleMutation, { data, loading, error }] = useUserUpdateRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>(UserUpdateRoleDocument, options);
      }
export type UserUpdateRoleMutationHookResult = ReturnType<typeof useUserUpdateRoleMutation>;
export type UserUpdateRoleMutationResult = Apollo.MutationResult<UserUpdateRoleMutation>;
export type UserUpdateRoleMutationOptions = Apollo.BaseMutationOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;
export const WaitlistAddDocument = gql`
    mutation WaitlistAdd($slug: String, $vendorId: MongoID, $firstName: String!, $lastName: String!, $email: String, $phone: String, $company: String, $sendWaitlistEmail: Boolean, $sendWaitlistSMS: Boolean, $animal: String!, $startDate: String!, $endDate: String!) {
  waitlistAdd(
    slug: $slug
    vendorId: $vendorId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    sendWaitlistEmail: $sendWaitlistEmail
    sendWaitlistSMS: $sendWaitlistSMS
    animal: $animal
    startDate: $startDate
    endDate: $endDate
  ) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistAddMutationFn = Apollo.MutationFunction<WaitlistAddMutation, WaitlistAddMutationVariables>;

/**
 * __useWaitlistAddMutation__
 *
 * To run a mutation, you first call `useWaitlistAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistAddMutation, { data, loading, error }] = useWaitlistAddMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      vendorId: // value for 'vendorId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      sendWaitlistEmail: // value for 'sendWaitlistEmail'
 *      sendWaitlistSMS: // value for 'sendWaitlistSMS'
 *      animal: // value for 'animal'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWaitlistAddMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistAddMutation, WaitlistAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistAddMutation, WaitlistAddMutationVariables>(WaitlistAddDocument, options);
      }
export type WaitlistAddMutationHookResult = ReturnType<typeof useWaitlistAddMutation>;
export type WaitlistAddMutationResult = Apollo.MutationResult<WaitlistAddMutation>;
export type WaitlistAddMutationOptions = Apollo.BaseMutationOptions<WaitlistAddMutation, WaitlistAddMutationVariables>;
export const WaitlistDeleteDocument = gql`
    mutation WaitlistDelete($customerId: MongoID!) {
  waitlistDelete(_id: $customerId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistDeleteMutationFn = Apollo.MutationFunction<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;

/**
 * __useWaitlistDeleteMutation__
 *
 * To run a mutation, you first call `useWaitlistDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistDeleteMutation, { data, loading, error }] = useWaitlistDeleteMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useWaitlistDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>(WaitlistDeleteDocument, options);
      }
export type WaitlistDeleteMutationHookResult = ReturnType<typeof useWaitlistDeleteMutation>;
export type WaitlistDeleteMutationResult = Apollo.MutationResult<WaitlistDeleteMutation>;
export type WaitlistDeleteMutationOptions = Apollo.BaseMutationOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;
export const WaitlistUnsubscribeDocument = gql`
    mutation WaitlistUnsubscribe($token: String!) {
  waitlistUnsubscribe(token: $token) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistUnsubscribeMutationFn = Apollo.MutationFunction<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;

/**
 * __useWaitlistUnsubscribeMutation__
 *
 * To run a mutation, you first call `useWaitlistUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistUnsubscribeMutation, { data, loading, error }] = useWaitlistUnsubscribeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWaitlistUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>(WaitlistUnsubscribeDocument, options);
      }
export type WaitlistUnsubscribeMutationHookResult = ReturnType<typeof useWaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationResult = Apollo.MutationResult<WaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationOptions = Apollo.BaseMutationOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;
export const ViewProcessingPartnerDocument = gql`
    query ViewProcessingPartner($vendorId: MongoID, $slug: String) {
  processingPartnersOne(vendorId: $vendorId, slug: $slug) {
    _id
    about
    isEnabled
    enabledAnimals
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      butcherSlotPricing {
        inspectionLevel
        price
      }
      customCutsheetPricing {
        inspectionLevel
        price
      }
    }
    capacityConfigurationType
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    vendor {
      _id
      shop_name
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
    }
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useViewProcessingPartnerQuery__
 *
 * To run a query within a React component, call `useViewProcessingPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessingPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessingPartnerQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useViewProcessingPartnerQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
      }
export function useViewProcessingPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
        }
export type ViewProcessingPartnerQueryHookResult = ReturnType<typeof useViewProcessingPartnerQuery>;
export type ViewProcessingPartnerLazyQueryHookResult = ReturnType<typeof useViewProcessingPartnerLazyQuery>;
export type ViewProcessingPartnerQueryResult = Apollo.QueryResult<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>;
export const ViewProcessorAdminDocument = gql`
    query ViewProcessorAdmin($filter: FilterFindOneProcessorSettingsInput) {
  processorSettingsOne(filter: $filter) {
    ...ProcessorSettingsFragment
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
  processorCapabilityMany {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewProcessorAdminQuery__
 *
 * To run a query within a React component, call `useViewProcessorAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessorAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessorAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useViewProcessorAdminQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
      }
export function useViewProcessorAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
        }
export type ViewProcessorAdminQueryHookResult = ReturnType<typeof useViewProcessorAdminQuery>;
export type ViewProcessorAdminLazyQueryHookResult = ReturnType<typeof useViewProcessorAdminLazyQuery>;
export type ViewProcessorAdminQueryResult = Apollo.QueryResult<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>;
export const ViewProcessorAdminLightDocument = gql`
    query ViewProcessorAdminLight($filter: FilterFindOneProcessorSettingsInput) {
  processorSettingsOne(filter: $filter) {
    ...ProcessorSettingsFragment
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
  processorCapabilityMany {
    _id
    vendor
    animalSpecies
    inspectionLevel
    canSelectMoreThanOneTrim
    trimSelection
    primalCuts
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;

/**
 * __useViewProcessorAdminLightQuery__
 *
 * To run a query within a React component, call `useViewProcessorAdminLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessorAdminLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessorAdminLightQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useViewProcessorAdminLightQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>(ViewProcessorAdminLightDocument, options);
      }
export function useViewProcessorAdminLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>(ViewProcessorAdminLightDocument, options);
        }
export type ViewProcessorAdminLightQueryHookResult = ReturnType<typeof useViewProcessorAdminLightQuery>;
export type ViewProcessorAdminLightLazyQueryHookResult = ReturnType<typeof useViewProcessorAdminLightLazyQuery>;
export type ViewProcessorAdminLightQueryResult = Apollo.QueryResult<ViewProcessorAdminLightQuery, ViewProcessorAdminLightQueryVariables>;
export const ViewSchedulingCreateDocument = gql`
    query ViewSchedulingCreate($userId: MongoID, $vendorId: MongoID!, $animalSpeciesCutsheet: EnumCutsheetAnimalSpecies!, $animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies!, $statuses: [EnumProcessorSchedulingStatus!]) {
  cutsheetMany(
    filter: {OR: [{user: $userId}, {vendor: $vendorId}], animalSpecies: $animalSpeciesCutsheet}
  ) {
    ...CutsheetFragment
  }
  processorCapabilityOne(
    filter: {vendor: $vendorId, animalSpecies: $animalSpeciesProcessorCapability}
  ) {
    ...ProcessorCapabilityFragment
  }
  processingPartnersOne(vendorId: $vendorId) {
    _id
    vendor {
      shop_name
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
      _id
    }
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    capacityConfigurationType
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    faq
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      butcherSlotPricing {
        inspectionLevel
        price
      }
    }
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
  }
  processorSchedulingMany(
    filter: {vendor: $vendorId, _operators: {status: {in: $statuses}}}
    skip: 0
    limit: 10000
  ) {
    ...ProcessorSchedulingSlimFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${DailyCapacityBlockFragmentFragmentDoc}
${ProcessorSchedulingSlimFragmentFragmentDoc}`;

/**
 * __useViewSchedulingCreateQuery__
 *
 * To run a query within a React component, call `useViewSchedulingCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingCreateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      animalSpeciesCutsheet: // value for 'animalSpeciesCutsheet'
 *      animalSpeciesProcessorCapability: // value for 'animalSpeciesProcessorCapability'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useViewSchedulingCreateQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
      }
export function useViewSchedulingCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
        }
export type ViewSchedulingCreateQueryHookResult = ReturnType<typeof useViewSchedulingCreateQuery>;
export type ViewSchedulingCreateLazyQueryHookResult = ReturnType<typeof useViewSchedulingCreateLazyQuery>;
export type ViewSchedulingCreateQueryResult = Apollo.QueryResult<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>;
export const ViewSchedulingEditDocument = gql`
    query ViewSchedulingEdit($jobId: MongoID!, $userId: MongoID!, $isDeleted: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    _id
    vendor {
      _id
      shop_name
      address {
        email
        phone
      }
    }
    animalHeads {
      _id
      producerIdentifier
      splitType
      inspectionLevel
      butcherSlotPrice
      cutsheetInformation {
        _id
        cutsheet {
          _id
          name
          type
          pricePerPound
        }
        questionnaire
        questionnaireResponse {
          _id
          name
          type
          pricePerPound
          createdAt
        }
        splitPart
        quantity
        notes
        locked
        contactUser {
          _id
          email
          first_name
          last_name
          phone
          enabled
        }
      }
      isKillAndChill
    }
    requestedBy {
      _id
      first_name
      last_name
      email
      phone
    }
    isDeleted
    status
    dropoffDate
    dropoffDateStr
    animalSpecies
    headCount
    refundDeadlineDays
    deposit {
      amount
    }
    vendorCutsheets {
      ...CutsheetFragment
    }
    processorSettings {
      _id
      killAndChillSettings {
        isEnabled
        pricePerHead
        species
      }
      animalSettings {
        isEnabled
        inspectionLevels
        species
        butcherSlotPricing {
          inspectionLevel
          species
          price
        }
        customCutsheetPricing {
          inspectionLevel
          species
          price
        }
      }
      vendor {
        shop_name
        address {
          ...AddressFragment
        }
        tenant {
          name
          picture_url
          _id
        }
        _id
      }
      customCapacities {
        date
        capacity
        isDeleted
        _id
      }
      customCutsheetPricing {
        animal
        price
      }
      schedulingDeposit
      refundDeadlineDays
      faq
    }
    processorCapabilities {
      ...ProcessorCapabilityFragment
    }
  }
  cutsheetMany(filter: {user: $userId, isDeleted: $isDeleted}) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewSchedulingEditQuery__
 *
 * To run a query within a React component, call `useViewSchedulingEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingEditQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      userId: // value for 'userId'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useViewSchedulingEditQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
      }
export function useViewSchedulingEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
        }
export type ViewSchedulingEditQueryHookResult = ReturnType<typeof useViewSchedulingEditQuery>;
export type ViewSchedulingEditLazyQueryHookResult = ReturnType<typeof useViewSchedulingEditLazyQuery>;
export type ViewSchedulingEditQueryResult = Apollo.QueryResult<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>;
export const ActiveVendorListDocument = gql`
    query ActiveVendorList {
  activeVendorList {
    _id
    shop_name
    enabled
  }
}
    `;

/**
 * __useActiveVendorListQuery__
 *
 * To run a query within a React component, call `useActiveVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveVendorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveVendorListQuery(baseOptions?: Apollo.QueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
      }
export function useActiveVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
        }
export type ActiveVendorListQueryHookResult = ReturnType<typeof useActiveVendorListQuery>;
export type ActiveVendorListLazyQueryHookResult = ReturnType<typeof useActiveVendorListLazyQuery>;
export type ActiveVendorListQueryResult = Apollo.QueryResult<ActiveVendorListQuery, ActiveVendorListQueryVariables>;
export const AdminUserSearchDocument = gql`
    query AdminUserSearch($search: String!, $limit: Int = 10) {
  adminUserSearch(search: $search, limit: $limit) {
    _id
    first_name
    last_name
    email
    phone
    role
    enabled
    company
    active_vendor {
      _id
      shop_name
    }
    relationships {
      type
      vendor {
        _id
        shop_name
      }
    }
  }
}
    `;

/**
 * __useAdminUserSearchQuery__
 *
 * To run a query within a React component, call `useAdminUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminUserSearchQuery(baseOptions: Apollo.QueryHookOptions<AdminUserSearchQuery, AdminUserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserSearchQuery, AdminUserSearchQueryVariables>(AdminUserSearchDocument, options);
      }
export function useAdminUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserSearchQuery, AdminUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserSearchQuery, AdminUserSearchQueryVariables>(AdminUserSearchDocument, options);
        }
export type AdminUserSearchQueryHookResult = ReturnType<typeof useAdminUserSearchQuery>;
export type AdminUserSearchLazyQueryHookResult = ReturnType<typeof useAdminUserSearchLazyQuery>;
export type AdminUserSearchQueryResult = Apollo.QueryResult<AdminUserSearchQuery, AdminUserSearchQueryVariables>;
export const TenantByIdDocument = gql`
    query TenantById($tenantId: MongoID!) {
  tenantById(_id: $tenantId) {
    _id
    date_created
    domain
    email
    enabled
    external_id
    external_ids
    name
    picture_url
    primary_color
    users {
      first_name
      last_name
      email
      picture_url
      role
      last_login
      enabled
      _id
    }
    vendors {
      external_id
      date_created
      shop_name
      shop_slug
      shop_url
      tagline
      prefers_dropoff
      pickup_days
      free_shipping_amount
      enabled
      show_in_directory
      address {
        ...AddressFragment
      }
      integrations {
        config
        name
        type
        endpoint
        key
        _id
      }
      processorSettings {
        isEnabled
        commercialStartDate
        _id
      }
      modules {
        moduleType
        name
        label
        href
        order
        active
        settings
        _id
      }
      _id
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useTenantByIdQuery__
 *
 * To run a query within a React component, call `useTenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantByIdQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTenantByIdQuery(baseOptions: Apollo.QueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
      }
export function useTenantByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
        }
export type TenantByIdQueryHookResult = ReturnType<typeof useTenantByIdQuery>;
export type TenantByIdLazyQueryHookResult = ReturnType<typeof useTenantByIdLazyQuery>;
export type TenantByIdQueryResult = Apollo.QueryResult<TenantByIdQuery, TenantByIdQueryVariables>;
export const TenantFilteredDocument = gql`
    query TenantFiltered($isEnabled: Boolean, $search: String, $sort: SortFindManyTenantInput!, $page: Int!, $perPage: Int!) {
  getFilteredTenants(
    isEnabled: $isEnabled
    search: $search
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      _id
      external_id
      name
      date_created
      domain
      enabled
      users {
        _id
        first_name
        last_name
        role
      }
      vendors {
        _id
        date_created
        shop_name
        shop_slug
        enabled
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTenantFilteredQuery__
 *
 * To run a query within a React component, call `useTenantFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantFilteredQuery({
 *   variables: {
 *      isEnabled: // value for 'isEnabled'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTenantFilteredQuery(baseOptions: Apollo.QueryHookOptions<TenantFilteredQuery, TenantFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantFilteredQuery, TenantFilteredQueryVariables>(TenantFilteredDocument, options);
      }
export function useTenantFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantFilteredQuery, TenantFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantFilteredQuery, TenantFilteredQueryVariables>(TenantFilteredDocument, options);
        }
export type TenantFilteredQueryHookResult = ReturnType<typeof useTenantFilteredQuery>;
export type TenantFilteredLazyQueryHookResult = ReturnType<typeof useTenantFilteredLazyQuery>;
export type TenantFilteredQueryResult = Apollo.QueryResult<TenantFilteredQuery, TenantFilteredQueryVariables>;
export const TenantPaginationDocument = gql`
    query TenantPagination($sort: SortFindManyTenantInput!, $filter: FilterFindManyTenantInput!, $page: Int!, $perPage: Int!) {
  tenantPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      external_id
      name
      date_created
      domain
      enabled
      _id
      users {
        first_name
        last_name
        role
        _id
      }
      vendors {
        date_created
        shop_name
        shop_slug
        enabled
        _id
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTenantPaginationQuery__
 *
 * To run a query within a React component, call `useTenantPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTenantPaginationQuery(baseOptions: Apollo.QueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
      }
export function useTenantPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
        }
export type TenantPaginationQueryHookResult = ReturnType<typeof useTenantPaginationQuery>;
export type TenantPaginationLazyQueryHookResult = ReturnType<typeof useTenantPaginationLazyQuery>;
export type TenantPaginationQueryResult = Apollo.QueryResult<TenantPaginationQuery, TenantPaginationQueryVariables>;
export const BuyerJobCutsheetByIdDocument = gql`
    query BuyerJobCutsheetById($jobId: MongoID!) {
  processorSchedulingById(_id: $jobId) {
    _id
    animalHeads {
      _id
      cutsheetInformation {
        _id
        cutsheet {
          _id
          name
          type
          pricePerPound
          primalCuts {
            ...PrimalCutFragment
          }
          selectedSpecifications
          extras {
            ...ExtrasFragment
          }
          trim {
            ...TrimFragment
          }
          notes
        }
        contactUser {
          _id
        }
      }
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useBuyerJobCutsheetByIdQuery__
 *
 * To run a query within a React component, call `useBuyerJobCutsheetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerJobCutsheetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerJobCutsheetByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBuyerJobCutsheetByIdQuery(baseOptions: Apollo.QueryHookOptions<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>(BuyerJobCutsheetByIdDocument, options);
      }
export function useBuyerJobCutsheetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>(BuyerJobCutsheetByIdDocument, options);
        }
export type BuyerJobCutsheetByIdQueryHookResult = ReturnType<typeof useBuyerJobCutsheetByIdQuery>;
export type BuyerJobCutsheetByIdLazyQueryHookResult = ReturnType<typeof useBuyerJobCutsheetByIdLazyQuery>;
export type BuyerJobCutsheetByIdQueryResult = Apollo.QueryResult<BuyerJobCutsheetByIdQuery, BuyerJobCutsheetByIdQueryVariables>;
export const CalculateProcessorCapacityAllSpeciesDocument = gql`
    query CalculateProcessorCapacityAllSpecies($vendorId: String!, $startDate: String!, $endDate: String!, $dateFormat: String, $groupFormat: String) {
  calculateProcessorCapacityAllSpecies(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
    dateFormat: $dateFormat
    groupFormat: $groupFormat
  ) {
    spotGroups
    totalSpots
    hasAvailableSpots
    bySpecies
  }
}
    `;

/**
 * __useCalculateProcessorCapacityAllSpeciesQuery__
 *
 * To run a query within a React component, call `useCalculateProcessorCapacityAllSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateProcessorCapacityAllSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateProcessorCapacityAllSpeciesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateFormat: // value for 'dateFormat'
 *      groupFormat: // value for 'groupFormat'
 *   },
 * });
 */
export function useCalculateProcessorCapacityAllSpeciesQuery(baseOptions: Apollo.QueryHookOptions<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>(CalculateProcessorCapacityAllSpeciesDocument, options);
      }
export function useCalculateProcessorCapacityAllSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>(CalculateProcessorCapacityAllSpeciesDocument, options);
        }
export type CalculateProcessorCapacityAllSpeciesQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityAllSpeciesQuery>;
export type CalculateProcessorCapacityAllSpeciesLazyQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityAllSpeciesLazyQuery>;
export type CalculateProcessorCapacityAllSpeciesQueryResult = Apollo.QueryResult<CalculateProcessorCapacityAllSpeciesQuery, CalculateProcessorCapacityAllSpeciesQueryVariables>;
export const CalculateProcessorCapacityDocument = gql`
    query CalculateProcessorCapacity($vendorId: String!, $selectedAnimalSpecies: String!, $startDate: String!, $endDate: String!, $dateFormat: String, $groupFormat: String) {
  calculateProcessorCapacity(
    vendorId: $vendorId
    selectedAnimalSpecies: $selectedAnimalSpecies
    startDate: $startDate
    endDate: $endDate
    dateFormat: $dateFormat
    groupFormat: $groupFormat
  ) {
    spotGroups
    totalSpots
    hasAvailableSpots
  }
}
    `;

/**
 * __useCalculateProcessorCapacityQuery__
 *
 * To run a query within a React component, call `useCalculateProcessorCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateProcessorCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateProcessorCapacityQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      selectedAnimalSpecies: // value for 'selectedAnimalSpecies'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateFormat: // value for 'dateFormat'
 *      groupFormat: // value for 'groupFormat'
 *   },
 * });
 */
export function useCalculateProcessorCapacityQuery(baseOptions: Apollo.QueryHookOptions<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>(CalculateProcessorCapacityDocument, options);
      }
export function useCalculateProcessorCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>(CalculateProcessorCapacityDocument, options);
        }
export type CalculateProcessorCapacityQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityQuery>;
export type CalculateProcessorCapacityLazyQueryHookResult = ReturnType<typeof useCalculateProcessorCapacityLazyQuery>;
export type CalculateProcessorCapacityQueryResult = Apollo.QueryResult<CalculateProcessorCapacityQuery, CalculateProcessorCapacityQueryVariables>;
export const CancellationReasonManyDocument = gql`
    query cancellationReasonMany($filter: FilterFindManyCancellationReasonInput, $sort: SortFindManyCancellationReasonInput) {
  cancellationReasonMany(filter: $filter, sort: $sort) {
    reason
    index
    isEnabled
    _id
  }
}
    `;

/**
 * __useCancellationReasonManyQuery__
 *
 * To run a query within a React component, call `useCancellationReasonManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCancellationReasonManyQuery(baseOptions?: Apollo.QueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
      }
export function useCancellationReasonManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
        }
export type CancellationReasonManyQueryHookResult = ReturnType<typeof useCancellationReasonManyQuery>;
export type CancellationReasonManyLazyQueryHookResult = ReturnType<typeof useCancellationReasonManyLazyQuery>;
export type CancellationReasonManyQueryResult = Apollo.QueryResult<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>;
export const CsvImportJobStatusDocument = gql`
    query CsvImportJobStatus($jobId: String!) {
  csvImportJobStatus(jobId: $jobId) {
    jobId
    type
    status
    totalRows
    validRows
    invalidRows
    processedCount
    successCount
    failureCount
    failures {
      row
      error
    }
    s3Keys
    deletedRows
    validationErrors {
      row
      errorMessages
      warningMessages
    }
    createdAt
    completedAt
  }
}
    `;

/**
 * __useCsvImportJobStatusQuery__
 *
 * To run a query within a React component, call `useCsvImportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvImportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvImportJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCsvImportJobStatusQuery(baseOptions: Apollo.QueryHookOptions<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>(CsvImportJobStatusDocument, options);
      }
export function useCsvImportJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>(CsvImportJobStatusDocument, options);
        }
export type CsvImportJobStatusQueryHookResult = ReturnType<typeof useCsvImportJobStatusQuery>;
export type CsvImportJobStatusLazyQueryHookResult = ReturnType<typeof useCsvImportJobStatusLazyQuery>;
export type CsvImportJobStatusQueryResult = Apollo.QueryResult<CsvImportJobStatusQuery, CsvImportJobStatusQueryVariables>;
export const CsvImportJobsDocument = gql`
    query CsvImportJobs($tenantId: String!, $vendorId: String, $limit: Int, $skip: Int) {
  csvImportJobs(
    tenantId: $tenantId
    vendorId: $vendorId
    limit: $limit
    skip: $skip
  ) {
    jobs {
      jobId
      type
      status
      totalRows
      validRows
      invalidRows
      processedCount
      successCount
      failureCount
      s3Keys
      createdAt
      completedAt
      cancelledAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useCsvImportJobsQuery__
 *
 * To run a query within a React component, call `useCsvImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvImportJobsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      vendorId: // value for 'vendorId'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCsvImportJobsQuery(baseOptions: Apollo.QueryHookOptions<CsvImportJobsQuery, CsvImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvImportJobsQuery, CsvImportJobsQueryVariables>(CsvImportJobsDocument, options);
      }
export function useCsvImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvImportJobsQuery, CsvImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvImportJobsQuery, CsvImportJobsQueryVariables>(CsvImportJobsDocument, options);
        }
export type CsvImportJobsQueryHookResult = ReturnType<typeof useCsvImportJobsQuery>;
export type CsvImportJobsLazyQueryHookResult = ReturnType<typeof useCsvImportJobsLazyQuery>;
export type CsvImportJobsQueryResult = Apollo.QueryResult<CsvImportJobsQuery, CsvImportJobsQueryVariables>;
export const CutsheetQuestionnaireResponseSearchDocument = gql`
    query CutsheetQuestionnaireResponseSearch($vendorId: MongoID, $userId: MongoID, $questionnaireId: MongoID, $capabilitySetId: MongoID, $type: [EnumCutsheetQuestionnaireResponseType], $includeDeleted: Boolean, $query: String, $sort: SortFindManyCutsheetQuestionnaireResponseInput!, $page: Int!, $perPage: Int!) {
  cutsheetQuestionnaireResponseSearch(
    vendorId: $vendorId
    userId: $userId
    questionnaireId: $questionnaireId
    capabilitySetId: $capabilitySetId
    type: $type
    includeDeleted: $includeDeleted
    query: $query
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    items {
      _id
      name
      notes
      type
      createdAt
      questionnaire
      questionnaireName
      user
      userFullName
    }
    count
    pageInfo {
      currentPage
      perPage
      itemCount
      pageCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponseSearchQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponseSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponseSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      userId: // value for 'userId'
 *      questionnaireId: // value for 'questionnaireId'
 *      capabilitySetId: // value for 'capabilitySetId'
 *      type: // value for 'type'
 *      includeDeleted: // value for 'includeDeleted'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseSearchQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>(CutsheetQuestionnaireResponseSearchDocument, options);
      }
export function useCutsheetQuestionnaireResponseSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>(CutsheetQuestionnaireResponseSearchDocument, options);
        }
export type CutsheetQuestionnaireResponseSearchQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSearchQuery>;
export type CutsheetQuestionnaireResponseSearchLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseSearchLazyQuery>;
export type CutsheetQuestionnaireResponseSearchQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponseSearchQuery, CutsheetQuestionnaireResponseSearchQueryVariables>;
export const CutsheetAssignmentRuleSetByCapabilityIdDocument = gql`
    query CutsheetAssignmentRuleSetByCapabilityId($capabilityId: MongoID!) {
  cutsheetAssignmentRuleSetByCapabilityId(capabilityId: $capabilityId) {
    ...CutsheetAssignmentRuleSetFragment
  }
}
    ${CutsheetAssignmentRuleSetFragmentFragmentDoc}`;

/**
 * __useCutsheetAssignmentRuleSetByCapabilityIdQuery__
 *
 * To run a query within a React component, call `useCutsheetAssignmentRuleSetByCapabilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetAssignmentRuleSetByCapabilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetAssignmentRuleSetByCapabilityIdQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetAssignmentRuleSetByCapabilityIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>(CutsheetAssignmentRuleSetByCapabilityIdDocument, options);
      }
export function useCutsheetAssignmentRuleSetByCapabilityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>(CutsheetAssignmentRuleSetByCapabilityIdDocument, options);
        }
export type CutsheetAssignmentRuleSetByCapabilityIdQueryHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetByCapabilityIdQuery>;
export type CutsheetAssignmentRuleSetByCapabilityIdLazyQueryHookResult = ReturnType<typeof useCutsheetAssignmentRuleSetByCapabilityIdLazyQuery>;
export type CutsheetAssignmentRuleSetByCapabilityIdQueryResult = Apollo.QueryResult<CutsheetAssignmentRuleSetByCapabilityIdQuery, CutsheetAssignmentRuleSetByCapabilityIdQueryVariables>;
export const CutsheetCapabilityByIdDocument = gql`
    query CutsheetCapabilityById($id: MongoID!) {
  CutsheetCapabilityById(_id: $id) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetCapabilityByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>(CutsheetCapabilityByIdDocument, options);
      }
export function useCutsheetCapabilityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>(CutsheetCapabilityByIdDocument, options);
        }
export type CutsheetCapabilityByIdQueryHookResult = ReturnType<typeof useCutsheetCapabilityByIdQuery>;
export type CutsheetCapabilityByIdLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityByIdLazyQuery>;
export type CutsheetCapabilityByIdQueryResult = Apollo.QueryResult<CutsheetCapabilityByIdQuery, CutsheetCapabilityByIdQueryVariables>;
export const CutsheetCapabilityManyDocument = gql`
    query CutsheetCapabilityMany($vendorId: MongoID!, $species: String, $isActive: Boolean) {
  CutsheetCapabilityByVendorAndAnimal(
    vendorId: $vendorId
    species: $species
    isActive: $isActive
  ) {
    ...CutsheetCapabilityFragment
  }
}
    ${CutsheetCapabilityFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityManyQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      species: // value for 'species'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>(CutsheetCapabilityManyDocument, options);
      }
export function useCutsheetCapabilityManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>(CutsheetCapabilityManyDocument, options);
        }
export type CutsheetCapabilityManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityManyQuery>;
export type CutsheetCapabilityManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityManyLazyQuery>;
export type CutsheetCapabilityManyQueryResult = Apollo.QueryResult<CutsheetCapabilityManyQuery, CutsheetCapabilityManyQueryVariables>;
export const CutsheetCapabilityOptionsByIdsDocument = gql`
    query CutsheetCapabilityOptionsByIds($ids: [MongoID!]!) {
  cutsheetCapabilityOptionByIds(_ids: $ids) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityOptionsByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityOptionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityOptionsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>(CutsheetCapabilityOptionsByIdsDocument, options);
      }
export function useCutsheetCapabilityOptionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>(CutsheetCapabilityOptionsByIdsDocument, options);
        }
export type CutsheetCapabilityOptionsByIdsQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsByIdsQuery>;
export type CutsheetCapabilityOptionsByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsByIdsLazyQuery>;
export type CutsheetCapabilityOptionsByIdsQueryResult = Apollo.QueryResult<CutsheetCapabilityOptionsByIdsQuery, CutsheetCapabilityOptionsByIdsQueryVariables>;
export const CutsheetCapabilityOptionsManyDocument = gql`
    query CutsheetCapabilityOptionsMany($capabilityId: MongoID!, $isActive: Boolean, $optionType: String) {
  cutsheetCapabilityOptionsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
    optionType: $optionType
  ) {
    ...CutsheetCapabilityOptionFragment
  }
}
    ${CutsheetCapabilityOptionFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityOptionsManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityOptionsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityOptionsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityOptionsManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *      optionType: // value for 'optionType'
 *   },
 * });
 */
export function useCutsheetCapabilityOptionsManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>(CutsheetCapabilityOptionsManyDocument, options);
      }
export function useCutsheetCapabilityOptionsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>(CutsheetCapabilityOptionsManyDocument, options);
        }
export type CutsheetCapabilityOptionsManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsManyQuery>;
export type CutsheetCapabilityOptionsManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityOptionsManyLazyQuery>;
export type CutsheetCapabilityOptionsManyQueryResult = Apollo.QueryResult<CutsheetCapabilityOptionsManyQuery, CutsheetCapabilityOptionsManyQueryVariables>;
export const CutsheetCapabilityCutManyDocument = gql`
    query CutsheetCapabilityCutMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetCutsByVendorAndAnimal(capabilityId: $capabilityId, isActive: $isActive) {
    ...CutsheetCapabilityCutFragment
  }
}
    ${CutsheetCapabilityCutFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityCutManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityCutManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityCutManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityCutManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityCutManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>(CutsheetCapabilityCutManyDocument, options);
      }
export function useCutsheetCapabilityCutManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>(CutsheetCapabilityCutManyDocument, options);
        }
export type CutsheetCapabilityCutManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityCutManyQuery>;
export type CutsheetCapabilityCutManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityCutManyLazyQuery>;
export type CutsheetCapabilityCutManyQueryResult = Apollo.QueryResult<CutsheetCapabilityCutManyQuery, CutsheetCapabilityCutManyQueryVariables>;
export const CutsheetCapabilityExtraManyDocument = gql`
    query CutsheetCapabilityExtraMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetExtrasByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilityExtraFragment
  }
}
    ${CutsheetCapabilityExtraFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityExtraManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityExtraManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityExtraManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityExtraManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityExtraManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>(CutsheetCapabilityExtraManyDocument, options);
      }
export function useCutsheetCapabilityExtraManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>(CutsheetCapabilityExtraManyDocument, options);
        }
export type CutsheetCapabilityExtraManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityExtraManyQuery>;
export type CutsheetCapabilityExtraManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityExtraManyLazyQuery>;
export type CutsheetCapabilityExtraManyQueryResult = Apollo.QueryResult<CutsheetCapabilityExtraManyQuery, CutsheetCapabilityExtraManyQueryVariables>;
export const CutsheetCapabilityGroupManyDocument = gql`
    query CutsheetCapabilityGroupMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetGroupsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilityGroupFragment
  }
}
    ${CutsheetCapabilityGroupFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilityGroupManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityGroupManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityGroupManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>(CutsheetCapabilityGroupManyDocument, options);
      }
export function useCutsheetCapabilityGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>(CutsheetCapabilityGroupManyDocument, options);
        }
export type CutsheetCapabilityGroupManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityGroupManyQuery>;
export type CutsheetCapabilityGroupManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityGroupManyLazyQuery>;
export type CutsheetCapabilityGroupManyQueryResult = Apollo.QueryResult<CutsheetCapabilityGroupManyQuery, CutsheetCapabilityGroupManyQueryVariables>;
export const CutsheetLegacyCapabilityDataDocument = gql`
    query CutsheetLegacyCapabilityData($capabilityId: MongoID!) {
  CutsheetLegacyCapabilityData(capabilityId: $capabilityId) {
    inspectionLevel
    cuts {
      _id
      name
      primalName
    }
    trims {
      name
    }
    extras {
      name
    }
    specifications {
      name
    }
  }
}
    `;

/**
 * __useCutsheetLegacyCapabilityDataQuery__
 *
 * To run a query within a React component, call `useCutsheetLegacyCapabilityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetLegacyCapabilityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetLegacyCapabilityDataQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *   },
 * });
 */
export function useCutsheetLegacyCapabilityDataQuery(baseOptions: Apollo.QueryHookOptions<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>(CutsheetLegacyCapabilityDataDocument, options);
      }
export function useCutsheetLegacyCapabilityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>(CutsheetLegacyCapabilityDataDocument, options);
        }
export type CutsheetLegacyCapabilityDataQueryHookResult = ReturnType<typeof useCutsheetLegacyCapabilityDataQuery>;
export type CutsheetLegacyCapabilityDataLazyQueryHookResult = ReturnType<typeof useCutsheetLegacyCapabilityDataLazyQuery>;
export type CutsheetLegacyCapabilityDataQueryResult = Apollo.QueryResult<CutsheetLegacyCapabilityDataQuery, CutsheetLegacyCapabilityDataQueryVariables>;
export const CutsheetQuestionnaireByIdDocument = gql`
    query CutsheetQuestionnaireById($id: MongoID!) {
  cutsheetQuestionnaireById(_id: $id) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>(CutsheetQuestionnaireByIdDocument, options);
      }
export function useCutsheetQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>(CutsheetQuestionnaireByIdDocument, options);
        }
export type CutsheetQuestionnaireByIdQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireByIdQuery>;
export type CutsheetQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireByIdLazyQuery>;
export type CutsheetQuestionnaireByIdQueryResult = Apollo.QueryResult<CutsheetQuestionnaireByIdQuery, CutsheetQuestionnaireByIdQueryVariables>;
export const CutsheetQuestionnaireManyDocument = gql`
    query CutsheetQuestionnaireMany($capabilityId: MongoID!, $status: String, $includeArchived: Boolean) {
  cutsheetQuestionnairesByVendorAndAnimal(
    capabilityId: $capabilityId
    status: $status
    includeArchived: $includeArchived
  ) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnaireManyQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      status: // value for 'status'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useCutsheetQuestionnaireManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>(CutsheetQuestionnaireManyDocument, options);
      }
export function useCutsheetQuestionnaireManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>(CutsheetQuestionnaireManyDocument, options);
        }
export type CutsheetQuestionnaireManyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireManyQuery>;
export type CutsheetQuestionnaireManyLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireManyLazyQuery>;
export type CutsheetQuestionnaireManyQueryResult = Apollo.QueryResult<CutsheetQuestionnaireManyQuery, CutsheetQuestionnaireManyQueryVariables>;
export const CutsheetQuestionnaireResponseByIdDocument = gql`
    query CutsheetQuestionnaireResponseById($_id: MongoID!) {
  cutsheetQuestionnaireResponseById(_id: $_id) {
    _id
    name
    notes
    type
    questionnaire
    capabilitySet
    createdAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponseByIdQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponseByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponseByIdQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>(CutsheetQuestionnaireResponseByIdDocument, options);
      }
export function useCutsheetQuestionnaireResponseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>(CutsheetQuestionnaireResponseByIdDocument, options);
        }
export type CutsheetQuestionnaireResponseByIdQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseByIdQuery>;
export type CutsheetQuestionnaireResponseByIdLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponseByIdLazyQuery>;
export type CutsheetQuestionnaireResponseByIdQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponseByIdQuery, CutsheetQuestionnaireResponseByIdQueryVariables>;
export const CutsheetQuestionnaireResponsesByUserDocument = gql`
    query CutsheetQuestionnaireResponsesByUser($userId: MongoID!, $questionnaireId: MongoID) {
  cutsheetQuestionnaireResponsesByUser(
    userId: $userId
    questionnaireId: $questionnaireId
  ) {
    _id
    name
    questionnaire
    capabilitySet
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
      specifications {
        specification
        type
        value
      }
    }
    trimSelections {
      type
      trim {
        optionId
        rank
        quantity
        percentage
        specifications {
          specification
          type
          value
        }
      }
    }
    specifications {
      specification
      type
      value
    }
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponsesByUserQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponsesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponsesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponsesByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      questionnaireId: // value for 'questionnaireId'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponsesByUserQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>(CutsheetQuestionnaireResponsesByUserDocument, options);
      }
export function useCutsheetQuestionnaireResponsesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>(CutsheetQuestionnaireResponsesByUserDocument, options);
        }
export type CutsheetQuestionnaireResponsesByUserQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByUserQuery>;
export type CutsheetQuestionnaireResponsesByUserLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByUserLazyQuery>;
export type CutsheetQuestionnaireResponsesByUserQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponsesByUserQuery, CutsheetQuestionnaireResponsesByUserQueryVariables>;
export const CutsheetQuestionnaireResponsesByVendorDocument = gql`
    query CutsheetQuestionnaireResponsesByVendor($vendorId: MongoID!) {
  cutsheetQuestionnaireResponsesByVendor(vendorId: $vendorId) {
    _id
    name
    type
    pricePerPound
    notes
    createdAt
    updatedAt
    selectedCuts {
      optionId
    }
    trimSelections {
      type
      trim {
        optionId
      }
    }
    questionnaire
    user
  }
}
    `;

/**
 * __useCutsheetQuestionnaireResponsesByVendorQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnaireResponsesByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnaireResponsesByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnaireResponsesByVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCutsheetQuestionnaireResponsesByVendorQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>(CutsheetQuestionnaireResponsesByVendorDocument, options);
      }
export function useCutsheetQuestionnaireResponsesByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>(CutsheetQuestionnaireResponsesByVendorDocument, options);
        }
export type CutsheetQuestionnaireResponsesByVendorQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByVendorQuery>;
export type CutsheetQuestionnaireResponsesByVendorLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnaireResponsesByVendorLazyQuery>;
export type CutsheetQuestionnaireResponsesByVendorQueryResult = Apollo.QueryResult<CutsheetQuestionnaireResponsesByVendorQuery, CutsheetQuestionnaireResponsesByVendorQueryVariables>;
export const CutsheetQuestionnairesByIdsDocument = gql`
    query CutsheetQuestionnairesByIds($ids: [MongoID!]!) {
  cutsheetQuestionnaireByIds(_ids: $ids) {
    ...CutsheetQuestionnaireFragment
  }
}
    ${CutsheetQuestionnaireFragmentFragmentDoc}`;

/**
 * __useCutsheetQuestionnairesByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnairesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnairesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnairesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetQuestionnairesByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>(CutsheetQuestionnairesByIdsDocument, options);
      }
export function useCutsheetQuestionnairesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>(CutsheetQuestionnairesByIdsDocument, options);
        }
export type CutsheetQuestionnairesByIdsQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByIdsQuery>;
export type CutsheetQuestionnairesByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByIdsLazyQuery>;
export type CutsheetQuestionnairesByIdsQueryResult = Apollo.QueryResult<CutsheetQuestionnairesByIdsQuery, CutsheetQuestionnairesByIdsQueryVariables>;
export const CutsheetQuestionnairesByVendorDocument = gql`
    query CutsheetQuestionnairesByVendor($vendorId: MongoID!) {
  cutsheetQuestionnairesByVendor(vendorId: $vendorId) {
    _id
    name
    status
    capabilityId
  }
}
    `;

/**
 * __useCutsheetQuestionnairesByVendorQuery__
 *
 * To run a query within a React component, call `useCutsheetQuestionnairesByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetQuestionnairesByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetQuestionnairesByVendorQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useCutsheetQuestionnairesByVendorQuery(baseOptions: Apollo.QueryHookOptions<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>(CutsheetQuestionnairesByVendorDocument, options);
      }
export function useCutsheetQuestionnairesByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>(CutsheetQuestionnairesByVendorDocument, options);
        }
export type CutsheetQuestionnairesByVendorQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByVendorQuery>;
export type CutsheetQuestionnairesByVendorLazyQueryHookResult = ReturnType<typeof useCutsheetQuestionnairesByVendorLazyQuery>;
export type CutsheetQuestionnairesByVendorQueryResult = Apollo.QueryResult<CutsheetQuestionnairesByVendorQuery, CutsheetQuestionnairesByVendorQueryVariables>;
export const CutsheetCapabilitySpecificationManyDocument = gql`
    query CutsheetCapabilitySpecificationMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetSpecificationsByVendorAndAnimal(
    capabilityId: $capabilityId
    isActive: $isActive
  ) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;

/**
 * __useCutsheetCapabilitySpecificationManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilitySpecificationManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilitySpecificationManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilitySpecificationManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilitySpecificationManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>(CutsheetCapabilitySpecificationManyDocument, options);
      }
export function useCutsheetCapabilitySpecificationManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>(CutsheetCapabilitySpecificationManyDocument, options);
        }
export type CutsheetCapabilitySpecificationManyQueryHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationManyQuery>;
export type CutsheetCapabilitySpecificationManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilitySpecificationManyLazyQuery>;
export type CutsheetCapabilitySpecificationManyQueryResult = Apollo.QueryResult<CutsheetCapabilitySpecificationManyQuery, CutsheetCapabilitySpecificationManyQueryVariables>;
export const CutsheetCapabilityTrimManyDocument = gql`
    query CutsheetCapabilityTrimMany($capabilityId: MongoID!, $isActive: Boolean) {
  cutsheetTrimByVendorAndAnimal(capabilityId: $capabilityId, isActive: $isActive) {
    ...CutsheetCapabilityTrimFragmentV2
  }
}
    ${CutsheetCapabilityTrimFragmentV2FragmentDoc}`;

/**
 * __useCutsheetCapabilityTrimManyQuery__
 *
 * To run a query within a React component, call `useCutsheetCapabilityTrimManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCapabilityTrimManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetCapabilityTrimManyQuery({
 *   variables: {
 *      capabilityId: // value for 'capabilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCutsheetCapabilityTrimManyQuery(baseOptions: Apollo.QueryHookOptions<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>(CutsheetCapabilityTrimManyDocument, options);
      }
export function useCutsheetCapabilityTrimManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>(CutsheetCapabilityTrimManyDocument, options);
        }
export type CutsheetCapabilityTrimManyQueryHookResult = ReturnType<typeof useCutsheetCapabilityTrimManyQuery>;
export type CutsheetCapabilityTrimManyLazyQueryHookResult = ReturnType<typeof useCutsheetCapabilityTrimManyLazyQuery>;
export type CutsheetCapabilityTrimManyQueryResult = Apollo.QueryResult<CutsheetCapabilityTrimManyQuery, CutsheetCapabilityTrimManyQueryVariables>;
export const CutsheetSearchDocument = gql`
    query CutsheetSearch($vendorId: MongoID, $buyerId: MongoID, $userId: MongoID, $type: [EnumCutsheetType], $includeDeleted: Boolean, $species: EnumCutsheetAnimalSpecies, $inspectionLevel: EnumCutsheetInspectionLevels, $query: String, $sort: SortFindManyCutsheetInput!, $page: Int!, $perPage: Int!) {
  cutsheetSearch(
    vendorId: $vendorId
    buyerId: $buyerId
    userId: $userId
    type: $type
    includeDeleted: $includeDeleted
    species: $species
    inspectionLevel: $inspectionLevel
    query: $query
    sort: $sort
    page: $page
    perPage: $perPage
  ) {
    items {
      ...CutsheetFragment
      lastUsedDate
    }
    count
    pageInfo {
      currentPage
      perPage
      itemCount
      pageCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;

/**
 * __useCutsheetSearchQuery__
 *
 * To run a query within a React component, call `useCutsheetSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetSearchQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      includeDeleted: // value for 'includeDeleted'
 *      species: // value for 'species'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetSearchQuery(baseOptions: Apollo.QueryHookOptions<CutsheetSearchQuery, CutsheetSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetSearchQuery, CutsheetSearchQueryVariables>(CutsheetSearchDocument, options);
      }
export function useCutsheetSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetSearchQuery, CutsheetSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetSearchQuery, CutsheetSearchQueryVariables>(CutsheetSearchDocument, options);
        }
export type CutsheetSearchQueryHookResult = ReturnType<typeof useCutsheetSearchQuery>;
export type CutsheetSearchLazyQueryHookResult = ReturnType<typeof useCutsheetSearchLazyQuery>;
export type CutsheetSearchQueryResult = Apollo.QueryResult<CutsheetSearchQuery, CutsheetSearchQueryVariables>;
export const CutsheetPaginationDocument = gql`
    query CutsheetPagination($sort: SortFindManyCutsheetInput!, $filter: FilterFindManyCutsheetInput!, $page: Int!, $perPage: Int!) {
  cutsheetPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...CutsheetFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;

/**
 * __useCutsheetPaginationQuery__
 *
 * To run a query within a React component, call `useCutsheetPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetPaginationQuery(baseOptions: Apollo.QueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
      }
export function useCutsheetPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
        }
export type CutsheetPaginationQueryHookResult = ReturnType<typeof useCutsheetPaginationQuery>;
export type CutsheetPaginationLazyQueryHookResult = ReturnType<typeof useCutsheetPaginationLazyQuery>;
export type CutsheetPaginationQueryResult = Apollo.QueryResult<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>;
export const CutsheetSpecificationByIdsDocument = gql`
    query CutsheetSpecificationByIds($ids: [MongoID!]!) {
  cutsheetSpecificationByIds(_ids: $ids) {
    ...CutsheetCapabilitySpecificationFragment
  }
}
    ${CutsheetCapabilitySpecificationFragmentFragmentDoc}`;

/**
 * __useCutsheetSpecificationByIdsQuery__
 *
 * To run a query within a React component, call `useCutsheetSpecificationByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSpecificationByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetSpecificationByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCutsheetSpecificationByIdsQuery(baseOptions: Apollo.QueryHookOptions<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>(CutsheetSpecificationByIdsDocument, options);
      }
export function useCutsheetSpecificationByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>(CutsheetSpecificationByIdsDocument, options);
        }
export type CutsheetSpecificationByIdsQueryHookResult = ReturnType<typeof useCutsheetSpecificationByIdsQuery>;
export type CutsheetSpecificationByIdsLazyQueryHookResult = ReturnType<typeof useCutsheetSpecificationByIdsLazyQuery>;
export type CutsheetSpecificationByIdsQueryResult = Apollo.QueryResult<CutsheetSpecificationByIdsQuery, CutsheetSpecificationByIdsQueryVariables>;
export const GetPublicHolidaysDocument = gql`
    query GetPublicHolidays($year: Int, $start: String, $end: String, $country: String, $lang: String) {
  getPublicHolidays(
    year: $year
    start: $start
    end: $end
    country: $country
    lang: $lang
  ) {
    holidays {
      name
      date
      type
      country
      lang
    }
    meta {
      country
      lang
      start
      end
      count
    }
  }
}
    `;

/**
 * __useGetPublicHolidaysQuery__
 *
 * To run a query within a React component, call `useGetPublicHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicHolidaysQuery({
 *   variables: {
 *      year: // value for 'year'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      country: // value for 'country'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetPublicHolidaysQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>(GetPublicHolidaysDocument, options);
      }
export function useGetPublicHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>(GetPublicHolidaysDocument, options);
        }
export type GetPublicHolidaysQueryHookResult = ReturnType<typeof useGetPublicHolidaysQuery>;
export type GetPublicHolidaysLazyQueryHookResult = ReturnType<typeof useGetPublicHolidaysLazyQuery>;
export type GetPublicHolidaysQueryResult = Apollo.QueryResult<GetPublicHolidaysQuery, GetPublicHolidaysQueryVariables>;
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($documentType: String!, $documentId: MongoID!, $page: Int, $perPage: Int) {
  getAuditLogs(
    documentType: $documentType
    documentId: $documentId
    page: $page
    perPage: $perPage
  ) {
    total
    logs {
      _id
      documentId
      documentType
      actorId
      actor {
        first_name
        last_name
        picture_url
      }
      createdAt
      updatedAt
      changes {
        path
        from
        to
      }
    }
  }
}
    `;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      documentId: // value for 'documentId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetCustomerSummaryDetailsDocument = gql`
    query GetCustomerSummaryDetails($customerId: MongoID!, $vendorId: MongoID!) {
  getCustomerSummaryDetails(customerId: $customerId, vendorId: $vendorId) {
    jobSummary {
      inProgressCount
      needsApprovalCount
      completedCount
      cancelledCount
      firstJobDate
      lastJobDate
    }
    linkedProducer {
      _id
      first_name
      last_name
      email
      company
      phone
    }
    customerCount
  }
}
    `;

/**
 * __useGetCustomerSummaryDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerSummaryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSummaryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSummaryDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useGetCustomerSummaryDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>(GetCustomerSummaryDetailsDocument, options);
      }
export function useGetCustomerSummaryDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>(GetCustomerSummaryDetailsDocument, options);
        }
export type GetCustomerSummaryDetailsQueryHookResult = ReturnType<typeof useGetCustomerSummaryDetailsQuery>;
export type GetCustomerSummaryDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerSummaryDetailsLazyQuery>;
export type GetCustomerSummaryDetailsQueryResult = Apollo.QueryResult<GetCustomerSummaryDetailsQuery, GetCustomerSummaryDetailsQueryVariables>;
export const IntegrationOneDocument = gql`
    query IntegrationOne($filter: FilterFindOneIntegrationInput) {
  integrationOne(filter: $filter) {
    _id
    name
    config
  }
}
    `;

/**
 * __useIntegrationOneQuery__
 *
 * To run a query within a React component, call `useIntegrationOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationOneQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
      }
export function useIntegrationOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
        }
export type IntegrationOneQueryHookResult = ReturnType<typeof useIntegrationOneQuery>;
export type IntegrationOneLazyQueryHookResult = ReturnType<typeof useIntegrationOneLazyQuery>;
export type IntegrationOneQueryResult = Apollo.QueryResult<IntegrationOneQuery, IntegrationOneQueryVariables>;
export const InvoiceByIdDocument = gql`
    query invoiceById($id: MongoID!) {
  invoiceById(_id: $id) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
      }
export function useInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
        }
export type InvoiceByIdQueryHookResult = ReturnType<typeof useInvoiceByIdQuery>;
export type InvoiceByIdLazyQueryHookResult = ReturnType<typeof useInvoiceByIdLazyQuery>;
export type InvoiceByIdQueryResult = Apollo.QueryResult<InvoiceByIdQuery, InvoiceByIdQueryVariables>;
export const SearchInvoicesDocument = gql`
    query SearchInvoices($type: String!, $sort: SortFindManyInvoiceInput!, $page: Int!, $perPage: Int!, $search: String, $status: [String!]) {
  searchInvoices(
    type: $type
    sort: $sort
    page: $page
    perPage: $perPage
    search: $search
    status: $status
  ) {
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    count
    items {
      ...InvoiceFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useSearchInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvoicesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSearchInvoicesQuery(baseOptions: Apollo.QueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
      }
export function useSearchInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
        }
export type SearchInvoicesQueryHookResult = ReturnType<typeof useSearchInvoicesQuery>;
export type SearchInvoicesLazyQueryHookResult = ReturnType<typeof useSearchInvoicesLazyQuery>;
export type SearchInvoicesQueryResult = Apollo.QueryResult<SearchInvoicesQuery, SearchInvoicesQueryVariables>;
export const MessagesByChatRoomDocument = gql`
    query MessagesByChatRoom($chatRoomId: MongoID!, $page: Int!, $perPage: Int!) {
  messagesByChatRoom(chatRoomId: $chatRoomId, page: $page, perPage: $perPage) {
    count
    items {
      ...ChatMessageFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ChatMessageFragmentFragmentDoc}`;

/**
 * __useMessagesByChatRoomQuery__
 *
 * To run a query within a React component, call `useMessagesByChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByChatRoomQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMessagesByChatRoomQuery(baseOptions: Apollo.QueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
      }
export function useMessagesByChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
        }
export type MessagesByChatRoomQueryHookResult = ReturnType<typeof useMessagesByChatRoomQuery>;
export type MessagesByChatRoomLazyQueryHookResult = ReturnType<typeof useMessagesByChatRoomLazyQuery>;
export type MessagesByChatRoomQueryResult = Apollo.QueryResult<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>;
export const MyChatRoomsDocument = gql`
    query MyChatRooms($customerId: MongoID, $page: Int!, $perPage: Int!) {
  myChatRooms(customerId: $customerId, page: $page, perPage: $perPage) {
    count
    items {
      ...ChatRoomFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ChatRoomFragmentFragmentDoc}`;

/**
 * __useMyChatRoomsQuery__
 *
 * To run a query within a React component, call `useMyChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChatRoomsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyChatRoomsQuery(baseOptions: Apollo.QueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
      }
export function useMyChatRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
        }
export type MyChatRoomsQueryHookResult = ReturnType<typeof useMyChatRoomsQuery>;
export type MyChatRoomsLazyQueryHookResult = ReturnType<typeof useMyChatRoomsLazyQuery>;
export type MyChatRoomsQueryResult = Apollo.QueryResult<MyChatRoomsQuery, MyChatRoomsQueryVariables>;
export const NotePaginationDocument = gql`
    query NotePagination($sort: SortFindManyNoteInput!, $filter: FilterFindManyNoteInput!, $page: Int!, $perPage: Int!) {
  notePagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...NoteFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useNotePaginationQuery__
 *
 * To run a query within a React component, call `useNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotePaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotePaginationQuery(baseOptions: Apollo.QueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
      }
export function useNotePaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
        }
export type NotePaginationQueryHookResult = ReturnType<typeof useNotePaginationQuery>;
export type NotePaginationLazyQueryHookResult = ReturnType<typeof useNotePaginationLazyQuery>;
export type NotePaginationQueryResult = Apollo.QueryResult<NotePaginationQuery, NotePaginationQueryVariables>;
export const NotificationSettingsByVendorIdDocument = gql`
    query NotificationSettingsByVendorId($vendorId: MongoID!, $page: Int!, $perPage: Int!) {
  findNotificationSettingsByVendorId(
    vendorId: $vendorId
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...NotificationSettingFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsByVendorIdQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationSettingsByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
      }
export function useNotificationSettingsByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
        }
export type NotificationSettingsByVendorIdQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdQuery>;
export type NotificationSettingsByVendorIdLazyQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdLazyQuery>;
export type NotificationSettingsByVendorIdQueryResult = Apollo.QueryResult<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>;
export const NotificationSettingsOneDocument = gql`
    query NotificationSettingsOne($filter: FilterFindOneNotificationSettingInput) {
  notificationSettingsOne(filter: $filter) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsOneQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationSettingsOneQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
      }
export function useNotificationSettingsOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
        }
export type NotificationSettingsOneQueryHookResult = ReturnType<typeof useNotificationSettingsOneQuery>;
export type NotificationSettingsOneLazyQueryHookResult = ReturnType<typeof useNotificationSettingsOneLazyQuery>;
export type NotificationSettingsOneQueryResult = Apollo.QueryResult<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>;
export const NotificationsByJobIdDocument = gql`
    query NotificationsByJobId($jobId: MongoID!, $page: Int!, $perPage: Int!) {
  findNotificationsByJobId(jobId: $jobId, page: $page, perPage: $perPage) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      notificationType
      type
      sentTo
      sentOn
      user {
        _id
        first_name
        last_name
        company
        email
        phone
      }
      errorMessage {
        message
        code
      }
    }
  }
}
    `;

/**
 * __useNotificationsByJobIdQuery__
 *
 * To run a query within a React component, call `useNotificationsByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsByJobIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>(NotificationsByJobIdDocument, options);
      }
export function useNotificationsByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>(NotificationsByJobIdDocument, options);
        }
export type NotificationsByJobIdQueryHookResult = ReturnType<typeof useNotificationsByJobIdQuery>;
export type NotificationsByJobIdLazyQueryHookResult = ReturnType<typeof useNotificationsByJobIdLazyQuery>;
export type NotificationsByJobIdQueryResult = Apollo.QueryResult<NotificationsByJobIdQuery, NotificationsByJobIdQueryVariables>;
export const NotificationsByUserIdDocument = gql`
    query NotificationsByUserId($userId: MongoID!, $page: Int!, $perPage: Int!) {
  notificationPagination(
    filter: {user: $userId}
    sort: _ID_DESC
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      notificationType
      type
      sentTo
      sentOn
      user {
        _id
        first_name
        last_name
        company
        email
        phone
      }
      errorMessage {
        message
        code
      }
    }
  }
}
    `;

/**
 * __useNotificationsByUserIdQuery__
 *
 * To run a query within a React component, call `useNotificationsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>(NotificationsByUserIdDocument, options);
      }
export function useNotificationsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>(NotificationsByUserIdDocument, options);
        }
export type NotificationsByUserIdQueryHookResult = ReturnType<typeof useNotificationsByUserIdQuery>;
export type NotificationsByUserIdLazyQueryHookResult = ReturnType<typeof useNotificationsByUserIdLazyQuery>;
export type NotificationsByUserIdQueryResult = Apollo.QueryResult<NotificationsByUserIdQuery, NotificationsByUserIdQueryVariables>;
export const PrimalCutBlockerManyDocument = gql`
    query PrimalCutBlockerMany($filter: FilterFindManyPrimalCutBlockerInput!, $skip: Int, $limit: Int) {
  primalCutBlockerMany(filter: $filter, skip: $skip, limit: $limit) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;

/**
 * __usePrimalCutBlockerManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutBlockerManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutBlockerManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutBlockerManyQuery(baseOptions: Apollo.QueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
      }
export function usePrimalCutBlockerManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
        }
export type PrimalCutBlockerManyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyQuery>;
export type PrimalCutBlockerManyLazyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyLazyQuery>;
export type PrimalCutBlockerManyQueryResult = Apollo.QueryResult<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>;
export const PrimalCutManyDocument = gql`
    query PrimalCutMany($filter: FilterFindManyPrimalCutInput) {
  primalCutMany(filter: $filter) {
    name
    cutType {
      name
      _id
    }
    order
    _id
    isDeleted
    primal {
      name
      order
      _id
      group {
        processorSettings
        isDefault
        animalSpecies
        inspectionLevel
        name
        order
        _id
      }
    }
  }
}
    `;

/**
 * __usePrimalCutManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrimalCutManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
      }
export function usePrimalCutManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
        }
export type PrimalCutManyQueryHookResult = ReturnType<typeof usePrimalCutManyQuery>;
export type PrimalCutManyLazyQueryHookResult = ReturnType<typeof usePrimalCutManyLazyQuery>;
export type PrimalCutManyQueryResult = Apollo.QueryResult<PrimalCutManyQuery, PrimalCutManyQueryVariables>;
export const PrimalCutTypeManyDocument = gql`
    query PrimalCutTypeMany($filter: FilterFindManyPrimalCutTypeInput, $skip: Int, $limit: Int) {
  primalCutTypeMany(filter: $filter, skip: $skip, limit: $limit) {
    _id
    name
    isDeleted
    animalSpecies
    processorSettings
  }
}
    `;

/**
 * __usePrimalCutTypeManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutTypeManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutTypeManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutTypeManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
      }
export function usePrimalCutTypeManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
        }
export type PrimalCutTypeManyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyQuery>;
export type PrimalCutTypeManyLazyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyLazyQuery>;
export type PrimalCutTypeManyQueryResult = Apollo.QueryResult<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>;
export const PrimalGroupManyDocument = gql`
    query PrimalGroupMany($filter: FilterFindManyPrimalGroupInput, $sort: SortFindManyPrimalGroupInput) {
  primalGroupMany(filter: $filter, sort: $sort) {
    processorSettings
    isDefault
    animalSpecies
    inspectionLevel
    name
    order
    isDeleted
    primals {
      isDeleted
      cuts {
        isDeleted
        name
        description
        cutType {
          name
          _id
        }
        order
        _id
      }
      order
      name
      description
      _id
    }
    _id
  }
}
    `;

/**
 * __usePrimalGroupManyQuery__
 *
 * To run a query within a React component, call `usePrimalGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalGroupManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePrimalGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
      }
export function usePrimalGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
        }
export type PrimalGroupManyQueryHookResult = ReturnType<typeof usePrimalGroupManyQuery>;
export type PrimalGroupManyLazyQueryHookResult = ReturnType<typeof usePrimalGroupManyLazyQuery>;
export type PrimalGroupManyQueryResult = Apollo.QueryResult<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>;
export const ProcessingPartnersDocument = gql`
    query processingPartners {
  processingPartners {
    _id
    isEnabled
    enabledAnimals
    vendor {
      _id
      shop_name
      address {
        city
        state
      }
      tenant {
        name
        picture_url
      }
    }
    slug
  }
}
    `;

/**
 * __useProcessingPartnersQuery__
 *
 * To run a query within a React component, call `useProcessingPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessingPartnersQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
      }
export function useProcessingPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
        }
export type ProcessingPartnersQueryHookResult = ReturnType<typeof useProcessingPartnersQuery>;
export type ProcessingPartnersLazyQueryHookResult = ReturnType<typeof useProcessingPartnersLazyQuery>;
export type ProcessingPartnersQueryResult = Apollo.QueryResult<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>;
export const ProcessorCustomerByIdDocument = gql`
    query ProcessorCustomerById($id: MongoID!) {
  userById(_id: $id) {
    first_name
    last_name
    email
    phone
    enabled
    company
    _id
    relationships {
      type
      vendorId
      producerId
    }
    address {
      address_1
      address_2
      city
      state
      postcode
      country
    }
  }
}
    `;

/**
 * __useProcessorCustomerByIdQuery__
 *
 * To run a query within a React component, call `useProcessorCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessorCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
      }
export function useProcessorCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
        }
export type ProcessorCustomerByIdQueryHookResult = ReturnType<typeof useProcessorCustomerByIdQuery>;
export type ProcessorCustomerByIdLazyQueryHookResult = ReturnType<typeof useProcessorCustomerByIdLazyQuery>;
export type ProcessorCustomerByIdQueryResult = Apollo.QueryResult<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>;
export const ProcessorCustomersPaginationDocument = gql`
    query processorCustomersPagination($page: Int!, $perPage: Int!, $search: String, $sort: SortFindManyUserInput!, $vendorId: MongoID!, $producerId: MongoID, $relationshipType: String, $status: String) {
  getProcessorCustomers(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    vendorId: $vendorId
    producerId: $producerId
    relationshipType: $relationshipType
    status: $status
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      first_name
      last_name
      email
      phone
      company
      _id
      address {
        address_1
        address_2
        city
        state
        postcode
      }
      relationships {
        vendorId
        producerId
        type
      }
      status
    }
  }
}
    `;

/**
 * __useProcessorCustomersPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorCustomersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomersPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *      producerId: // value for 'producerId'
 *      relationshipType: // value for 'relationshipType'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useProcessorCustomersPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
      }
export function useProcessorCustomersPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
        }
export type ProcessorCustomersPaginationQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationQuery>;
export type ProcessorCustomersPaginationLazyQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationLazyQuery>;
export type ProcessorCustomersPaginationQueryResult = Apollo.QueryResult<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>;
export const ProcessorNotificationPaginationDocument = gql`
    query processorNotificationPagination($sort: SortFindManyProcessorNotificationInput!, $filter: FilterFindManyProcessorNotificationInput!, $page: Int!, $perPage: Int!) {
  processorNotificationPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      vendor
      notificationType
      type
      sentTo
      sentOn
      errorMessage
    }
  }
}
    `;

/**
 * __useProcessorNotificationPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorNotificationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorNotificationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorNotificationPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorNotificationPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
      }
export function useProcessorNotificationPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
        }
export type ProcessorNotificationPaginationQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationQuery>;
export type ProcessorNotificationPaginationLazyQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationLazyQuery>;
export type ProcessorNotificationPaginationQueryResult = Apollo.QueryResult<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>;
export const ProcessorSchedulingByIdDocument = gql`
    query ProcessorSchedulingById($id: MongoID!, $includeCutsheetInformation: Boolean = false) {
  processorSchedulingById(_id: $id) {
    vendor {
      shop_name
      address {
        first_name
        last_name
        address_1
        address_2
        city
        state
        postcode
        email
        phone
        _id
      }
    }
    dropoffDate
    dropoffDateStr
    status
    statusLastUpdated
    animalSpecies
    headCount
    refundDeadlineDays
    requestedBy {
      _id
      first_name
      last_name
      phone
      email
      phone
    }
    deposit {
      amount
    }
    animalHeads {
      _id
      splitType
      producerIdentifier
      inspectionLevel
      isHangingWeightPerSide
      hangingWeightSideA
      hangingWeightSideB
      hangingWeight
      liveWeight
      grade
      yield
      tracking
      publicId
      cutsheetInformation @include(if: $includeCutsheetInformation) {
        cutsheet {
          ...CutsheetFragment
        }
        questionnaire
        questionnaireResponse {
          _id
          name
          type
          pricePerPound
          createdAt
          capabilitySet
          questionnaire
          selectedCuts {
            optionId
            specifications {
              specification
              type
              value
            }
          }
          trimSelections {
            type
            trim {
              optionId
              quantity
              percentage
              rank
              specifications {
                specification
                type
                value
              }
            }
          }
          extraSelections {
            extras {
              optionId
              quantity
              specifications {
                specification
                type
                value
              }
            }
          }
        }
        splitPart
        quantity
        notes
        locked
        yield {
          _id
          capabilityOptionId
          label
          weightLbs
          itemCount
          packageCount
          packageIdentifier
        }
        contactUser {
          _id
          email
          first_name
          last_name
          phone
          company
        }
        _id
      }
      isKillAndChill
    }
    linkedInvoices {
      ...InvoiceFragment
    }
    _id
  }
}
    ${CutsheetFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingByIdQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCutsheetInformation: // value for 'includeCutsheetInformation'
 *   },
 * });
 */
export function useProcessorSchedulingByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
      }
export function useProcessorSchedulingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
        }
export type ProcessorSchedulingByIdQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdQuery>;
export type ProcessorSchedulingByIdLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdLazyQuery>;
export type ProcessorSchedulingByIdQueryResult = Apollo.QueryResult<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>;
export const ProcessorSchedulingCalendarDocument = gql`
    query ProcessorSchedulingCalendar($vendorId: MongoID!, $startDate: Date!, $endDate: Date!, $filter: FilterFindManyProcessorSchedulingInput) {
  getProcessorSchedulingCalendar(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    ...ProcessorSchedulingCalendarFragment
  }
}
    ${ProcessorSchedulingCalendarFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingCalendarQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingCalendarQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProcessorSchedulingCalendarQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
      }
export function useProcessorSchedulingCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
        }
export type ProcessorSchedulingCalendarQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarQuery>;
export type ProcessorSchedulingCalendarLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarLazyQuery>;
export type ProcessorSchedulingCalendarQueryResult = Apollo.QueryResult<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>;
export const ProcessorSchedulingFilteredDocument = gql`
    query processorSchedulingFiltered($page: Int!, $perPage: Int!, $searchByContact: String, $sort: SortFindManyProcessorSchedulingInput!, $statusFilter: [String!], $vendorId: MongoID!, $animalSpecies: [String!], $missingCutsheets: Boolean) {
  getFilteredProcessorScheduling(
    page: $page
    perPage: $perPage
    searchByContact: $searchByContact
    sort: $sort
    statusFilter: $statusFilter
    vendorId: $vendorId
    animalSpecies: $animalSpecies
    missingCutsheets: $missingCutsheets
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingFilteredQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingFilteredQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      searchByContact: // value for 'searchByContact'
 *      sort: // value for 'sort'
 *      statusFilter: // value for 'statusFilter'
 *      vendorId: // value for 'vendorId'
 *      animalSpecies: // value for 'animalSpecies'
 *      missingCutsheets: // value for 'missingCutsheets'
 *   },
 * });
 */
export function useProcessorSchedulingFilteredQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
      }
export function useProcessorSchedulingFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
        }
export type ProcessorSchedulingFilteredQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredQuery>;
export type ProcessorSchedulingFilteredLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredLazyQuery>;
export type ProcessorSchedulingFilteredQueryResult = Apollo.QueryResult<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>;
export const ProcessorSchedulingManyDocument = gql`
    query processorSchedulingMany($filter: FilterFindManyProcessorSchedulingInput, $skip: Int, $limit: Int) {
  processorSchedulingMany(filter: $filter, skip: $skip, limit: $limit) {
    ...ProcessorSchedulingSlimFragment
    jobId
    vendor {
      _id
    }
    requestedBy {
      _id
      first_name
      last_name
      company
    }
    dropoffDate
    status
    statusLastUpdated
    animalSpecies
    headCount
    linkedInvoices {
      ...InvoiceFragment
    }
    animalHeads {
      _id
      publicId
      inspectionLevel
      tracking
      hangingWeight
      hangingWeightSideA
      hangingWeightSideB
      killDate
      cutDate
      producerIdentifier
      cutsheetInformation {
        _id
        cutsheet {
          _id
        }
      }
    }
  }
}
    ${ProcessorSchedulingSlimFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingManyQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProcessorSchedulingManyQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
      }
export function useProcessorSchedulingManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
        }
export type ProcessorSchedulingManyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyQuery>;
export type ProcessorSchedulingManyLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyLazyQuery>;
export type ProcessorSchedulingManyQueryResult = Apollo.QueryResult<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>;
export const ProcessorSchedulingPaginationDocument = gql`
    query ProcessorSchedulingPagination($sort: SortFindManyProcessorSchedulingInput!, $filter: FilterFindManyProcessorSchedulingInput!, $page: Int!, $perPage: Int!) {
  processorSchedulingPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      vendor {
        _id
        shop_name
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
            extras {
              ...ExtrasFragment
            }
            trim {
              ...TrimFragment
            }
          }
          splitPart
          quantity
          notes
          locked
          questionnaire
          questionnaireResponse {
            _id
            name
            notes
          }
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
        isKillAndChill
      }
    }
  }
}
    ${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorSchedulingPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
      }
export function useProcessorSchedulingPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
        }
export type ProcessorSchedulingPaginationQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationQuery>;
export type ProcessorSchedulingPaginationLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationLazyQuery>;
export type ProcessorSchedulingPaginationQueryResult = Apollo.QueryResult<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>;
export const ProcessorSchedulingWithMissingCutsheetsDocument = gql`
    query processorSchedulingWithMissingCutsheets($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID, $customerId: MongoID) {
  findProcessorSchedulingsWithMissingCutsheets(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
    customerId: $customerId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingCutsheetsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingCutsheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingCutsheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingCutsheetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingCutsheetsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
      }
export function useProcessorSchedulingWithMissingCutsheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
        }
export type ProcessorSchedulingWithMissingCutsheetsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsQuery>;
export type ProcessorSchedulingWithMissingCutsheetsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsLazyQuery>;
export type ProcessorSchedulingWithMissingCutsheetsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>;
export const ProcessorSchedulingWithMissingHangingWeightsDocument = gql`
    query processorSchedulingWithMissingHangingWeights($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID!) {
  findProcessorSchedulingsWithMissingHangingWeights(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingHangingWeightsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingHangingWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingHangingWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingHangingWeightsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingHangingWeightsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
      }
export function useProcessorSchedulingWithMissingHangingWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
        }
export type ProcessorSchedulingWithMissingHangingWeightsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsLazyQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>;
export const ProcessorSchedulingsByUserIdDocument = gql`
    query ProcessorSchedulingsByUserId($userId: MongoID!, $page: Int!, $perPage: Int!) {
  processorSchedulingPagination(
    filter: {requestedBy: $userId}
    sort: _ID_DESC
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      jobId
      status
      source
      createdAt
      dropoffDate
      vendor {
        _id
        shop_name
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingsByUserIdQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorSchedulingsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>(ProcessorSchedulingsByUserIdDocument, options);
      }
export function useProcessorSchedulingsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>(ProcessorSchedulingsByUserIdDocument, options);
        }
export type ProcessorSchedulingsByUserIdQueryHookResult = ReturnType<typeof useProcessorSchedulingsByUserIdQuery>;
export type ProcessorSchedulingsByUserIdLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingsByUserIdLazyQuery>;
export type ProcessorSchedulingsByUserIdQueryResult = Apollo.QueryResult<ProcessorSchedulingsByUserIdQuery, ProcessorSchedulingsByUserIdQueryVariables>;
export const ProducerJobByIdDocument = gql`
    query ProducerJobById($id: MongoID!) {
  processorSchedulingById(_id: $id) {
    _id
    jobId
    status
    statusLastUpdated
    dropoffDate
    dropoffDateStr
    animalSpecies
    headCount
    blockTitle
    requestedBy {
      _id
    }
    vendor {
      _id
      shop_name
      address {
        email
        phone
      }
    }
    animalHeads {
      _id
      splitType
      questionnaire
      publicId
      inspectionLevel
      killDate
      cutDate
      tracking
      hangingWeight
      hangingWeightSideA
      hangingWeightSideB
      isHangingWeightPerSide
      producerIdentifier
      cutsheetInformation {
        _id
        splitPart
        locked
        questionnaire
        yield {
          _id
          capabilityOptionId
          label
          weightLbs
          itemCount
          packageCount
          packageIdentifier
        }
        questionnaireResponse {
          _id
          name
          notes
          questionnaire
          type
          pricePerPound
          selectedCuts {
            optionId
            specifications {
              specification
              type
              value
            }
          }
          trimSelections {
            type
            trim {
              optionId
              quantity
              percentage
              rank
              specifications {
                specification
                type
                value
              }
            }
          }
          extraSelections {
            extras {
              optionId
              quantity
              specifications {
                specification
                type
                value
              }
            }
          }
        }
        cutsheet {
          _id
          name
          type
          pricePerPound
          primalCuts {
            ...PrimalCutFragment
          }
          selectedSpecifications
          extras {
            ...ExtrasFragment
          }
          trim {
            ...TrimFragment
          }
          notes
        }
        contactUser {
          _id
          first_name
          last_name
          email
          phone
          relationships {
            vendorId
            producerId
            type
          }
        }
      }
    }
    hasCutsheetNeededNotification
    notificationHistory {
      _id
      type
      sentTo
      user {
        _id
      }
    }
    processorSettings {
      _id
      animalSettings {
        species
        splitTypes
      }
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useProducerJobByIdQuery__
 *
 * To run a query within a React component, call `useProducerJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerJobByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProducerJobByIdQuery(baseOptions: Apollo.QueryHookOptions<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>(ProducerJobByIdDocument, options);
      }
export function useProducerJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>(ProducerJobByIdDocument, options);
        }
export type ProducerJobByIdQueryHookResult = ReturnType<typeof useProducerJobByIdQuery>;
export type ProducerJobByIdLazyQueryHookResult = ReturnType<typeof useProducerJobByIdLazyQuery>;
export type ProducerJobByIdQueryResult = Apollo.QueryResult<ProducerJobByIdQuery, ProducerJobByIdQueryVariables>;
export const ProducersByVendorIdDocument = gql`
    query ProducersByVendorId($vendorId: MongoID!, $search: String) {
  searchCustomers(
    vendorId: $vendorId
    search: $search
    relationshipType: "producer"
  ) {
    _id
    first_name
    last_name
    email
    company
    phone
  }
}
    `;

/**
 * __useProducersByVendorIdQuery__
 *
 * To run a query within a React component, call `useProducersByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducersByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducersByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProducersByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>(ProducersByVendorIdDocument, options);
      }
export function useProducersByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>(ProducersByVendorIdDocument, options);
        }
export type ProducersByVendorIdQueryHookResult = ReturnType<typeof useProducersByVendorIdQuery>;
export type ProducersByVendorIdLazyQueryHookResult = ReturnType<typeof useProducersByVendorIdLazyQuery>;
export type ProducersByVendorIdQueryResult = Apollo.QueryResult<ProducersByVendorIdQuery, ProducersByVendorIdQueryVariables>;
export const RenderNotificationEmailPreviewDocument = gql`
    query RenderNotificationEmailPreview($content: String!, $vendorName: String!, $logoUrl: String, $subject: String!, $trigger: String) {
  renderNotificationEmailPreview(
    content: $content
    vendorName: $vendorName
    logoUrl: $logoUrl
    subject: $subject
    trigger: $trigger
  ) {
    html
  }
}
    `;

/**
 * __useRenderNotificationEmailPreviewQuery__
 *
 * To run a query within a React component, call `useRenderNotificationEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderNotificationEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderNotificationEmailPreviewQuery({
 *   variables: {
 *      content: // value for 'content'
 *      vendorName: // value for 'vendorName'
 *      logoUrl: // value for 'logoUrl'
 *      subject: // value for 'subject'
 *      trigger: // value for 'trigger'
 *   },
 * });
 */
export function useRenderNotificationEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>(RenderNotificationEmailPreviewDocument, options);
      }
export function useRenderNotificationEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>(RenderNotificationEmailPreviewDocument, options);
        }
export type RenderNotificationEmailPreviewQueryHookResult = ReturnType<typeof useRenderNotificationEmailPreviewQuery>;
export type RenderNotificationEmailPreviewLazyQueryHookResult = ReturnType<typeof useRenderNotificationEmailPreviewLazyQuery>;
export type RenderNotificationEmailPreviewQueryResult = Apollo.QueryResult<RenderNotificationEmailPreviewQuery, RenderNotificationEmailPreviewQueryVariables>;
export const GetFinancialReportingConfigDocument = gql`
    query GetFinancialReportingConfig($filter: FilterFindOneFinancialReportingConfigInput) {
  financialReportingConfigOne(filter: $filter) {
    _id
    vendor
    animalConfigurations {
      species
      expectedThroughput
      maxCapacity
      processingCost
      revenue
      averageHangingWeight
    }
    overheadCosts {
      name
      amount
      frequency
    }
    timeConfiguration {
      timePerNotification
      timePerCutsheet
      timePerBooking
      baseDigitalSavings
      hourlyRate
    }
    monthlyModifiers {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    dateAnchor
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFinancialReportingConfigQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportingConfigQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFinancialReportingConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>(GetFinancialReportingConfigDocument, options);
      }
export function useGetFinancialReportingConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>(GetFinancialReportingConfigDocument, options);
        }
export type GetFinancialReportingConfigQueryHookResult = ReturnType<typeof useGetFinancialReportingConfigQuery>;
export type GetFinancialReportingConfigLazyQueryHookResult = ReturnType<typeof useGetFinancialReportingConfigLazyQuery>;
export type GetFinancialReportingConfigQueryResult = Apollo.QueryResult<GetFinancialReportingConfigQuery, GetFinancialReportingConfigQueryVariables>;
export const FinancialReportingConfigUpsertDocument = gql`
    mutation FinancialReportingConfigUpsert($record: FinancialReportingConfigUpsertInput!) {
  financialReportingConfigUpsert(record: $record) {
    _id
    vendor
    animalConfigurations {
      species
      expectedThroughput
      maxCapacity
      processingCost
      revenue
      averageHangingWeight
    }
    overheadCosts {
      name
      amount
      frequency
    }
    timeConfiguration {
      timePerNotification
      timePerCutsheet
      timePerBooking
      baseDigitalSavings
      hourlyRate
    }
    monthlyModifiers {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
    dateAnchor
    createdAt
    updatedAt
  }
}
    `;
export type FinancialReportingConfigUpsertMutationFn = Apollo.MutationFunction<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>;

/**
 * __useFinancialReportingConfigUpsertMutation__
 *
 * To run a mutation, you first call `useFinancialReportingConfigUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialReportingConfigUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialReportingConfigUpsertMutation, { data, loading, error }] = useFinancialReportingConfigUpsertMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFinancialReportingConfigUpsertMutation(baseOptions?: Apollo.MutationHookOptions<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>(FinancialReportingConfigUpsertDocument, options);
      }
export type FinancialReportingConfigUpsertMutationHookResult = ReturnType<typeof useFinancialReportingConfigUpsertMutation>;
export type FinancialReportingConfigUpsertMutationResult = Apollo.MutationResult<FinancialReportingConfigUpsertMutation>;
export type FinancialReportingConfigUpsertMutationOptions = Apollo.BaseMutationOptions<FinancialReportingConfigUpsertMutation, FinancialReportingConfigUpsertMutationVariables>;
export const GetFinancialReportingMetricsDocument = gql`
    query GetFinancialReportingMetrics($startDate: String, $endDate: String, $dateAnchor: String, $comparisonType: ComparisonType) {
  financialReportingMetrics(
    startDate: $startDate
    endDate: $endDate
    dateAnchor: $dateAnchor
    comparisonType: $comparisonType
  )
}
    `;

/**
 * __useGetFinancialReportingMetricsQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportingMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportingMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportingMetricsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      dateAnchor: // value for 'dateAnchor'
 *      comparisonType: // value for 'comparisonType'
 *   },
 * });
 */
export function useGetFinancialReportingMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>(GetFinancialReportingMetricsDocument, options);
      }
export function useGetFinancialReportingMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>(GetFinancialReportingMetricsDocument, options);
        }
export type GetFinancialReportingMetricsQueryHookResult = ReturnType<typeof useGetFinancialReportingMetricsQuery>;
export type GetFinancialReportingMetricsLazyQueryHookResult = ReturnType<typeof useGetFinancialReportingMetricsLazyQuery>;
export type GetFinancialReportingMetricsQueryResult = Apollo.QueryResult<GetFinancialReportingMetricsQuery, GetFinancialReportingMetricsQueryVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($vendorId: MongoID!, $producerId: MongoID, $relationshipType: String, $search: String) {
  searchCustomers(
    vendorId: $vendorId
    producerId: $producerId
    relationshipType: $relationshipType
    search: $search
  ) {
    _id
    first_name
    last_name
    email
    company
    phone
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      producerId: // value for 'producerId'
 *      relationshipType: // value for 'relationshipType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const StateManyDocument = gql`
    query StateMany {
  stateMany(sort: STATE_ASC) {
    name
    code
    _id
  }
}
    `;

/**
 * __useStateManyQuery__
 *
 * To run a query within a React component, call `useStateManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateManyQuery(baseOptions?: Apollo.QueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
      }
export function useStateManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
        }
export type StateManyQueryHookResult = ReturnType<typeof useStateManyQuery>;
export type StateManyLazyQueryHookResult = ReturnType<typeof useStateManyLazyQuery>;
export type StateManyQueryResult = Apollo.QueryResult<StateManyQuery, StateManyQueryVariables>;
export const UserSettingsByUserIdDocument = gql`
    query UserSettingsByUserId($userId: MongoID!) {
  userSettingsByUserId(userId: $userId) {
    settings {
      calendar {
        dateConfiguration
        calendarView
        showAllEvents
      }
    }
  }
}
    `;

/**
 * __useUserSettingsByUserIdQuery__
 *
 * To run a query within a React component, call `useUserSettingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSettingsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
      }
export function useUserSettingsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
        }
export type UserSettingsByUserIdQueryHookResult = ReturnType<typeof useUserSettingsByUserIdQuery>;
export type UserSettingsByUserIdLazyQueryHookResult = ReturnType<typeof useUserSettingsByUserIdLazyQuery>;
export type UserSettingsByUserIdQueryResult = Apollo.QueryResult<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>;
export const UserTenantVendorDocument = gql`
    query UserTenantVendor {
  userTenantVendor {
    ...UserFragment
    intercomWebToken
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserTenantVendorQuery__
 *
 * To run a query within a React component, call `useUserTenantVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTenantVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTenantVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTenantVendorQuery(baseOptions?: Apollo.QueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
      }
export function useUserTenantVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
        }
export type UserTenantVendorQueryHookResult = ReturnType<typeof useUserTenantVendorQuery>;
export type UserTenantVendorLazyQueryHookResult = ReturnType<typeof useUserTenantVendorLazyQuery>;
export type UserTenantVendorQueryResult = Apollo.QueryResult<UserTenantVendorQuery, UserTenantVendorQueryVariables>;
export const VendorListDocument = gql`
    query VendorList($startDate: String!, $endDate: String!) {
  vendorList(startDate: $startDate, endDate: $endDate) {
    _id
    shop_name
    tenant {
      name
    }
  }
}
    `;

/**
 * __useVendorListQuery__
 *
 * To run a query within a React component, call `useVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorListQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useVendorListQuery(baseOptions: Apollo.QueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
      }
export function useVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
        }
export type VendorListQueryHookResult = ReturnType<typeof useVendorListQuery>;
export type VendorListLazyQueryHookResult = ReturnType<typeof useVendorListLazyQuery>;
export type VendorListQueryResult = Apollo.QueryResult<VendorListQuery, VendorListQueryVariables>;
export const ProcessingJobByIdDocument = gql`
    query ProcessingJobById($jobId: MongoID!, $includeProcessorSettings: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    ...ProcessorSchedulingFragment
    processorSettings @include(if: $includeProcessorSettings) {
      _id
      enabledAnimalSplits
      animalSettings {
        species
        inspectionLevels
        splitTypes
      }
      killAndChillSettings {
        species
        isEnabled
        pricePerHead
      }
    }
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;

/**
 * __useProcessingJobByIdQuery__
 *
 * To run a query within a React component, call `useProcessingJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingJobByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      includeProcessorSettings: // value for 'includeProcessorSettings'
 *   },
 * });
 */
export function useProcessingJobByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
      }
export function useProcessingJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
        }
export type ProcessingJobByIdQueryHookResult = ReturnType<typeof useProcessingJobByIdQuery>;
export type ProcessingJobByIdLazyQueryHookResult = ReturnType<typeof useProcessingJobByIdLazyQuery>;
export type ProcessingJobByIdQueryResult = Apollo.QueryResult<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>;
export const WaitlistByVendorIdDocument = gql`
    query WaitlistByVendorId($vendorId: MongoID!) {
  waitlistByVendorId(vendorId: $vendorId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;

/**
 * __useWaitlistByVendorIdQuery__
 *
 * To run a query within a React component, call `useWaitlistByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useWaitlistByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
      }
export function useWaitlistByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
        }
export type WaitlistByVendorIdQueryHookResult = ReturnType<typeof useWaitlistByVendorIdQuery>;
export type WaitlistByVendorIdLazyQueryHookResult = ReturnType<typeof useWaitlistByVendorIdLazyQuery>;
export type WaitlistByVendorIdQueryResult = Apollo.QueryResult<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>;